export const mockResponse = {
  campaignId: '23888',
  headline: 'xxxxx',
  fromOriginHeaderText: null,
  termsAndConditions: 'xxxxx',
  campaignContentPaginationInfo: {
    hasMoreContentPages: true,
    __typename: 'CampaignContentPaginationInfo',
  },
  description: {
    short: 'xxxxx',
    long: 'xxxxx',
    __typename: 'CampaignDescriptions',
  },
  productTypes: ['Hotel'],
  recommendedType: 'OFFERS',
  offers: [
    {
      __typename: 'HotelOfferItem',
      name: 'Grand Park City Hall (SG Clean)',
      image: {
        description: 'Grand Park City Hall (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/900000/893000/892942/22d5e049_b.jpg',
        __typename: 'Image',
      },
      description:
        "Located in Downtown Singapore, this luxury hotel is steps from Civil Defence Heritage Gallery, Singapore Philatelic Museum, and Peranakan Museum. Raffles City and Saint Andrew's Cathedral are also within 10 minutes. City Hall Station is only a 5-minute walk and Bras Basah Station is 8 minutes. ",
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.3/5',
      guestReviewRatingQualifierText: 'Excellent',
      guestReviewCount: '(703 reviews)',
      vipMessage: 'VIP Access',
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£848',
          qualifierText: 'for 4 nights',
          disclaimerText:"Standard rate on our site, provided by the property and based on your search, before all discounts and rewards applied.",
          allyText: 'Price was £1,157 for 4 nights, Price is now £848 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: {
          value: '£1,157',
          __typename: 'OfferPrice',
        },
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/892942/2022-08-26/2022-08-30',
          text: 'Click for more information on Grand Park City Hall (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'PARKROYAL COLLECTION Marina Bay, Singapore (SG Clean)',
      image: {
        description: 'PARKROYAL COLLECTION Marina Bay, Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/330000/328800/328749/503c0031_b.jpg',
        __typename: 'Image',
      },
      description:
        'This family-friendly Singapore hotel is located in the entertainment district, within a 10-minute walk of Marina Square and Suntec City. Singapore Flyer and Singapore City Hall are also within 15 minutes. Esplanade Station is 5 minutes by foot and Promena Station is 8 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.2/5',
      guestReviewRatingQualifierText: 'Very good',
      guestReviewCount: '(990 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£992',
          qualifierText: 'for 4 nights',
          disclaimerText:
            'Prices displayed include promotional discounts referred to – Discounts are applied to the standard rate on our site of selected hotels, as determined and supplied by the hotels (excluding applicable taxes and other fees).',
          allyText: 'Price was £1,288 for 4 nights, Price is now £992 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: {
          value: '£1,288',
          __typename: 'OfferPrice',
        },
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/328749/2022-08-26/2022-08-30',
          text: 'Click for more information on PARKROYAL COLLECTION Marina Bay, Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'Regent Singapore (SG Clean)',
      image: {
        description: 'Regent Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/30000/22000/21906/97c4c1e4_b.jpg',
        __typename: 'Image',
      },
      description:
        'This family-friendly Singapore hotel is located in the business district, within a 10-minute walk of Tanglin Mall and Orchard Road. Singapore Botanic Gardens and Robertson Quay are also within 2 mi (3 km). Newton Station is 22 minutes by foot. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.6/5',
      guestReviewRatingQualifierText: 'Wonderful',
      guestReviewCount: '(989 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£1,019',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,019 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/21906/2022-08-26/2022-08-30',
          text: 'Click for more information on Regent Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'PARKROYAL COLLECTION Pickering, Singapore (SG Clean)',
      image: {
        description: 'PARKROYAL COLLECTION Pickering, Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/6000000/5410000/5400400/5400381/eafdf271_b.jpg',
        __typename: 'Image',
      },
      description:
        'Located in Downtown Singapore, this luxury hotel is within a 15-minute walk of Chinatown Point, Raffles Place, and Singapore City Hall. Clarke Quay Central and Club Street are also within 2 mi (3 km). Clarke Quay Station is only a 4-minute walk and Chinatown Station is 6 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.5/5',
      guestReviewRatingQualifierText: 'Excellent',
      guestReviewCount: '(986 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£1,242',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,242 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/5400381/2022-08-26/2022-08-30',
          text: 'Click for more information on PARKROYAL COLLECTION Pickering, Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'Pan Pacific Singapore (SG Clean)',
      image: {
        description: 'Pan Pacific Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/10000/6600/6594/a22a1011_b.jpg',
        __typename: 'Image',
      },
      description:
        'This family-friendly Singapore hotel is located in the entertainment district, within a 10-minute walk of Marina Square and Suntec City. Gardens by the Bay and Orchard Road are also within 1 mi (2 km). Promena Station is 5 minutes by foot and Esplanade Station is 6 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.6/5',
      guestReviewRatingQualifierText: 'Wonderful',
      guestReviewCount: '(978 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£1,291',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,291 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/6594/2022-08-26/2022-08-30',
          text: 'Click for more information on Pan Pacific Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'The Fullerton Hotel Singapore (SG Clean)',
      image: {
        description: 'The Fullerton Hotel Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/900000/893000/892940/9dd4f2cf_b.jpg',
        __typename: 'Image',
      },
      description:
        'Located in Downtown Singapore, this luxury hotel is within a 5-minute walk of Cavenagh Bridge and Raffles Place. Marina Bay Sands Skypark and Marina Bay Sands Casino are also within 1 mi (2 km). Raffles Place Station is only a 4-minute walk and Clarke Quay Station is 12 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.7/5',
      guestReviewRatingQualifierText: 'Exceptional',
      guestReviewCount: '(988 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: null,
      lodgingOffer: {
        price: {
          value: '£1,400',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,400 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/892940/2022-08-26/2022-08-30',
          text: 'Click for more information on The Fullerton Hotel Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'Grand Park City Hall (SG Clean)',
      image: {
        description: 'Grand Park City Hall (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/900000/893000/892942/22d5e049_b.jpg',
        __typename: 'Image',
      },
      description:
        "Located in Downtown Singapore, this luxury hotel is steps from Civil Defence Heritage Gallery, Singapore Philatelic Museum, and Peranakan Museum. Raffles City and Saint Andrew's Cathedral are also within 10 minutes. City Hall Station is only a 5-minute walk and Bras Basah Station is 8 minutes. ",
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.3/5',
      guestReviewRatingQualifierText: 'Excellent',
      guestReviewCount: '(703 reviews)',
      vipMessage: 'VIP Access',
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£848',
          qualifierText: 'for 4 nights',
          disclaimerText:
            'Prices displayed include promotional discounts referred to – Discounts are applied to the standard rate on our site of selected hotels, as determined and supplied by the hotels (excluding applicable taxes and other fees).',
          allyText: 'Price was £1,157 for 4 nights, Price is now £848 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: {
          value: '£1,157',
          __typename: 'OfferPrice',
        },
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/892942/2022-08-26/2022-08-30',
          text: 'Click for more information on Grand Park City Hall (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'PARKROYAL COLLECTION Marina Bay, Singapore (SG Clean)',
      image: {
        description: 'PARKROYAL COLLECTION Marina Bay, Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/330000/328800/328749/503c0031_b.jpg',
        __typename: 'Image',
      },
      description:
        'This family-friendly Singapore hotel is located in the entertainment district, within a 10-minute walk of Marina Square and Suntec City. Singapore Flyer and Singapore City Hall are also within 15 minutes. Esplanade Station is 5 minutes by foot and Promena Station is 8 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.2/5',
      guestReviewRatingQualifierText: 'Very good',
      guestReviewCount: '(990 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£992',
          qualifierText: 'for 4 nights',
          disclaimerText:
            'Prices displayed include promotional discounts referred to – Discounts are applied to the standard rate on our site of selected hotels, as determined and supplied by the hotels (excluding applicable taxes and other fees).',
          allyText: 'Price was £1,288 for 4 nights, Price is now £992 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: {
          value: '£1,288',
          __typename: 'OfferPrice',
        },
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/328749/2022-08-26/2022-08-30',
          text: 'Click for more information on PARKROYAL COLLECTION Marina Bay, Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'Regent Singapore (SG Clean)',
      image: {
        description: 'Regent Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/30000/22000/21906/97c4c1e4_b.jpg',
        __typename: 'Image',
      },
      description:
        'This family-friendly Singapore hotel is located in the business district, within a 10-minute walk of Tanglin Mall and Orchard Road. Singapore Botanic Gardens and Robertson Quay are also within 2 mi (3 km). Newton Station is 22 minutes by foot. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.6/5',
      guestReviewRatingQualifierText: 'Wonderful',
      guestReviewCount: '(989 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£1,019',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,019 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/21906/2022-08-26/2022-08-30',
          text: 'Click for more information on Regent Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'PARKROYAL COLLECTION Pickering, Singapore (SG Clean)',
      image: {
        description: 'PARKROYAL COLLECTION Pickering, Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/6000000/5410000/5400400/5400381/eafdf271_b.jpg',
        __typename: 'Image',
      },
      description:
        'Located in Downtown Singapore, this luxury hotel is within a 15-minute walk of Chinatown Point, Raffles Place, and Singapore City Hall. Clarke Quay Central and Club Street are also within 2 mi (3 km). Clarke Quay Station is only a 4-minute walk and Chinatown Station is 6 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.5/5',
      guestReviewRatingQualifierText: 'Excellent',
      guestReviewCount: '(986 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£1,242',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,242 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/5400381/2022-08-26/2022-08-30',
          text: 'Click for more information on PARKROYAL COLLECTION Pickering, Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'Pan Pacific Singapore (SG Clean)',
      image: {
        description: 'Pan Pacific Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/10000/6600/6594/a22a1011_b.jpg',
        __typename: 'Image',
      },
      description:
        'This family-friendly Singapore hotel is located in the entertainment district, within a 10-minute walk of Marina Square and Suntec City. Gardens by the Bay and Orchard Road are also within 1 mi (2 km). Promena Station is 5 minutes by foot and Esplanade Station is 6 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.6/5',
      guestReviewRatingQualifierText: 'Wonderful',
      guestReviewCount: '(978 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£1,291',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,291 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/6594/2022-08-26/2022-08-30',
          text: 'Click for more information on Pan Pacific Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'The Fullerton Hotel Singapore (SG Clean)',
      image: {
        description: 'The Fullerton Hotel Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/900000/893000/892940/9dd4f2cf_b.jpg',
        __typename: 'Image',
      },
      description:
        'Located in Downtown Singapore, this luxury hotel is within a 5-minute walk of Cavenagh Bridge and Raffles Place. Marina Bay Sands Skypark and Marina Bay Sands Casino are also within 1 mi (2 km). Raffles Place Station is only a 4-minute walk and Clarke Quay Station is 12 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.7/5',
      guestReviewRatingQualifierText: 'Exceptional',
      guestReviewCount: '(988 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: null,
      lodgingOffer: {
        price: {
          value: '£1,400',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,400 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/892940/2022-08-26/2022-08-30',
          text: 'Click for more information on The Fullerton Hotel Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'Grand Park City Hall (SG Clean)',
      image: {
        description: 'Grand Park City Hall (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/900000/893000/892942/22d5e049_b.jpg',
        __typename: 'Image',
      },
      description:
        "Located in Downtown Singapore, this luxury hotel is steps from Civil Defence Heritage Gallery, Singapore Philatelic Museum, and Peranakan Museum. Raffles City and Saint Andrew's Cathedral are also within 10 minutes. City Hall Station is only a 5-minute walk and Bras Basah Station is 8 minutes. ",
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.3/5',
      guestReviewRatingQualifierText: 'Excellent',
      guestReviewCount: '(703 reviews)',
      vipMessage: 'VIP Access',
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£848',
          qualifierText: 'for 4 nights',
          disclaimerText:
            'Prices displayed include promotional discounts referred to – Discounts are applied to the standard rate on our site of selected hotels, as determined and supplied by the hotels (excluding applicable taxes and other fees).',
          allyText: 'Price was £1,157 for 4 nights, Price is now £848 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: {
          value: '£1,157',
          __typename: 'OfferPrice',
        },
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/892942/2022-08-26/2022-08-30',
          text: 'Click for more information on Grand Park City Hall (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'PARKROYAL COLLECTION Marina Bay, Singapore (SG Clean)',
      image: {
        description: 'PARKROYAL COLLECTION Marina Bay, Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/330000/328800/328749/503c0031_b.jpg',
        __typename: 'Image',
      },
      description:
        'This family-friendly Singapore hotel is located in the entertainment district, within a 10-minute walk of Marina Square and Suntec City. Singapore Flyer and Singapore City Hall are also within 15 minutes. Esplanade Station is 5 minutes by foot and Promena Station is 8 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.2/5',
      guestReviewRatingQualifierText: 'Very good',
      guestReviewCount: '(990 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£992',
          qualifierText: 'for 4 nights',
          disclaimerText:
            'Prices displayed include promotional discounts referred to – Discounts are applied to the standard rate on our site of selected hotels, as determined and supplied by the hotels (excluding applicable taxes and other fees).',
          allyText: 'Price was £1,288 for 4 nights, Price is now £992 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: {
          value: '£1,288',
          __typename: 'OfferPrice',
        },
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/328749/2022-08-26/2022-08-30',
          text: 'Click for more information on PARKROYAL COLLECTION Marina Bay, Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'Regent Singapore (SG Clean)',
      image: {
        description: 'Regent Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/30000/22000/21906/97c4c1e4_b.jpg',
        __typename: 'Image',
      },
      description:
        'This family-friendly Singapore hotel is located in the business district, within a 10-minute walk of Tanglin Mall and Orchard Road. Singapore Botanic Gardens and Robertson Quay are also within 2 mi (3 km). Newton Station is 22 minutes by foot. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.6/5',
      guestReviewRatingQualifierText: 'Wonderful',
      guestReviewCount: '(989 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£1,019',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,019 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/21906/2022-08-26/2022-08-30',
          text: 'Click for more information on Regent Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'PARKROYAL COLLECTION Pickering, Singapore (SG Clean)',
      image: {
        description: 'PARKROYAL COLLECTION Pickering, Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/6000000/5410000/5400400/5400381/eafdf271_b.jpg',
        __typename: 'Image',
      },
      description:
        'Located in Downtown Singapore, this luxury hotel is within a 15-minute walk of Chinatown Point, Raffles Place, and Singapore City Hall. Clarke Quay Central and Club Street are also within 2 mi (3 km). Clarke Quay Station is only a 4-minute walk and Chinatown Station is 6 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.5/5',
      guestReviewRatingQualifierText: 'Excellent',
      guestReviewCount: '(986 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£1,242',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,242 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/5400381/2022-08-26/2022-08-30',
          text: 'Click for more information on PARKROYAL COLLECTION Pickering, Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'Pan Pacific Singapore (SG Clean)',
      image: {
        description: 'Pan Pacific Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/10000/6600/6594/a22a1011_b.jpg',
        __typename: 'Image',
      },
      description:
        'This family-friendly Singapore hotel is located in the entertainment district, within a 10-minute walk of Marina Square and Suntec City. Gardens by the Bay and Orchard Road are also within 1 mi (2 km). Promena Station is 5 minutes by foot and Esplanade Station is 6 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.6/5',
      guestReviewRatingQualifierText: 'Wonderful',
      guestReviewCount: '(978 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£1,291',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,291 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/6594/2022-08-26/2022-08-30',
          text: 'Click for more information on Pan Pacific Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'The Fullerton Hotel Singapore (SG Clean)',
      image: {
        description: 'The Fullerton Hotel Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/900000/893000/892940/9dd4f2cf_b.jpg',
        __typename: 'Image',
      },
      description:
        'Located in Downtown Singapore, this luxury hotel is within a 5-minute walk of Cavenagh Bridge and Raffles Place. Marina Bay Sands Skypark and Marina Bay Sands Casino are also within 1 mi (2 km). Raffles Place Station is only a 4-minute walk and Clarke Quay Station is 12 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.7/5',
      guestReviewRatingQualifierText: 'Exceptional',
      guestReviewCount: '(988 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: null,
      lodgingOffer: {
        price: {
          value: '£1,400',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,400 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/892940/2022-08-26/2022-08-30',
          text: 'Click for more information on The Fullerton Hotel Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'Grand Park City Hall (SG Clean)',
      image: {
        description: 'Grand Park City Hall (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/900000/893000/892942/22d5e049_b.jpg',
        __typename: 'Image',
      },
      description:
        "Located in Downtown Singapore, this luxury hotel is steps from Civil Defence Heritage Gallery, Singapore Philatelic Museum, and Peranakan Museum. Raffles City and Saint Andrew's Cathedral are also within 10 minutes. City Hall Station is only a 5-minute walk and Bras Basah Station is 8 minutes. ",
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.3/5',
      guestReviewRatingQualifierText: 'Excellent',
      guestReviewCount: '(703 reviews)',
      vipMessage: 'VIP Access',
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£848',
          qualifierText: 'for 4 nights',
          disclaimerText:
            'Prices displayed include promotional discounts referred to – Discounts are applied to the standard rate on our site of selected hotels, as determined and supplied by the hotels (excluding applicable taxes and other fees).',
          allyText: 'Price was £1,157 for 4 nights, Price is now £848 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: {
          value: '£1,157',
          __typename: 'OfferPrice',
        },
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/892942/2022-08-26/2022-08-30',
          text: 'Click for more information on Grand Park City Hall (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'PARKROYAL COLLECTION Marina Bay, Singapore (SG Clean)',
      image: {
        description: 'PARKROYAL COLLECTION Marina Bay, Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/330000/328800/328749/503c0031_b.jpg',
        __typename: 'Image',
      },
      description:
        'This family-friendly Singapore hotel is located in the entertainment district, within a 10-minute walk of Marina Square and Suntec City. Singapore Flyer and Singapore City Hall are also within 15 minutes. Esplanade Station is 5 minutes by foot and Promena Station is 8 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.2/5',
      guestReviewRatingQualifierText: 'Very good',
      guestReviewCount: '(990 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£992',
          qualifierText: 'for 4 nights',
          disclaimerText:
            'Prices displayed include promotional discounts referred to – Discounts are applied to the standard rate on our site of selected hotels, as determined and supplied by the hotels (excluding applicable taxes and other fees).',
          allyText: 'Price was £1,288 for 4 nights, Price is now £992 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: {
          value: '£1,288',
          __typename: 'OfferPrice',
        },
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/328749/2022-08-26/2022-08-30',
          text: 'Click for more information on PARKROYAL COLLECTION Marina Bay, Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'Regent Singapore (SG Clean)',
      image: {
        description: 'Regent Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/30000/22000/21906/97c4c1e4_b.jpg',
        __typename: 'Image',
      },
      description:
        'This family-friendly Singapore hotel is located in the business district, within a 10-minute walk of Tanglin Mall and Orchard Road. Singapore Botanic Gardens and Robertson Quay are also within 2 mi (3 km). Newton Station is 22 minutes by foot. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.6/5',
      guestReviewRatingQualifierText: 'Wonderful',
      guestReviewCount: '(989 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£1,019',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,019 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/21906/2022-08-26/2022-08-30',
          text: 'Click for more information on Regent Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'PARKROYAL COLLECTION Pickering, Singapore (SG Clean)',
      image: {
        description: 'PARKROYAL COLLECTION Pickering, Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/6000000/5410000/5400400/5400381/eafdf271_b.jpg',
        __typename: 'Image',
      },
      description:
        'Located in Downtown Singapore, this luxury hotel is within a 15-minute walk of Chinatown Point, Raffles Place, and Singapore City Hall. Clarke Quay Central and Club Street are also within 2 mi (3 km). Clarke Quay Station is only a 4-minute walk and Chinatown Station is 6 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.5/5',
      guestReviewRatingQualifierText: 'Excellent',
      guestReviewCount: '(986 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£1,242',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,242 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/5400381/2022-08-26/2022-08-30',
          text: 'Click for more information on PARKROYAL COLLECTION Pickering, Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'Pan Pacific Singapore (SG Clean)',
      image: {
        description: 'Pan Pacific Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/10000/6600/6594/a22a1011_b.jpg',
        __typename: 'Image',
      },
      description:
        'This family-friendly Singapore hotel is located in the entertainment district, within a 10-minute walk of Marina Square and Suntec City. Gardens by the Bay and Orchard Road are also within 1 mi (2 km). Promena Station is 5 minutes by foot and Esplanade Station is 6 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.6/5',
      guestReviewRatingQualifierText: 'Wonderful',
      guestReviewCount: '(978 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: null,
        signInUrl: null,
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '£1,291',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,291 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/6594/2022-08-26/2022-08-30',
          text: 'Click for more information on Pan Pacific Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'The Fullerton Hotel Singapore (SG Clean)',
      image: {
        description: 'The Fullerton Hotel Singapore (SG Clean)',
        url: 'https://images.trvl-media.com/hotels/1000000/900000/893000/892940/9dd4f2cf_b.jpg',
        __typename: 'Image',
      },
      description:
        'Located in Downtown Singapore, this luxury hotel is within a 5-minute walk of Cavenagh Bridge and Raffles Place. Marina Bay Sands Skypark and Marina Bay Sands Casino are also within 1 mi (2 km). Raffles Place Station is only a 4-minute walk and Clarke Quay Station is 12 minutes. ',
      secondaryContent: null,
      location: 'Singapore',
      starRating: 5,
      guestReviewRating: '4.7/5',
      guestReviewRatingQualifierText: 'Exceptional',
      guestReviewCount: '(988 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: null,
      lodgingOffer: {
        price: {
          value: '£1,400',
          qualifierText: 'for 4 nights',
          disclaimerText: '',
          allyText: 'Price is £1,400 for 4 nights',
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/go/hotel/info/892940/2022-08-26/2022-08-30',
          text: 'Click for more information on The Fullerton Hotel Singapore (SG Clean) and other hotels in Singapore',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Fri, 26 Aug - Tue, 30 Aug',
    },
  ],
  __typename: 'CampaignDetail',
};

export const mockResponseLondon = {
  campaignId: '26488',
  headline: 'London',
  fromOriginHeaderText: null,
  termsAndConditions: 'xxx',
  campaignContentPaginationInfo: {
    hasMoreContentPages: true,
    __typename: 'CampaignContentPaginationInfo',
  },
  description: {
    short: 'xxx',
    long: 'xxx',
    __typename: 'CampaignDescriptions',
  },
  productTypes: ['Hotel'],
  recommendedType: 'OFFERS',
  offers: [
    {
      __typename: 'HotelOfferItem',
      name: 'Baglioni Hotel London - The Leading Hotels of the World',
      image: {
        description: 'Baglioni Hotel London - The Leading Hotels of the World',
        url: 'https://images.trvl-media.com/hotels/1000000/30000/23600/23515/d98057e2_b.jpg',
        __typename: 'Image',
      },
      description:
        'This family-friendly London hotel is located in the historical district, within a 10-minute walk of Kensington High Street and Hyde Park. Royal Albert Hall and Natural History Museum are also within 2 mi (3 km). High Street Kensington Station is 8 minutes by foot and Gloucester Road Underground Station is 10 minutes. ',
      secondaryContent: null,
      location: 'London',
      starRating: 5,
      guestReviewRating: '4.6/5',
      guestReviewRatingQualifierText: 'Wonderful',
      guestReviewCount: '(255 reviews)',
      vipMessage: 'VIP Access',
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: 'Sign in to see Member Price',
        signInUrl: {
          value:
            'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-10-16%2F2022-10-18%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D23515%26sort%3DmemberDeals%26mctc%3D2',
          relativePath:
            '/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-10-16%2F2022-10-18%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D23515%26sort%3DmemberDeals%26mctc%3D2',
          __typename: 'HttpURI',
        },
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '',
          qualifierText: '',
          disclaimerText: '',
          allyText: null,
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-10-16%2F2022-10-18%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D23515%26sort%3DmemberDeals%26mctc%3D2',
          text: 'Sign in to see Member Price',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Sun, 16 Oct - Tue, 18 Oct',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'The Crown London',
      image: {
        description: 'The Crown London',
        url: 'https://images.trvl-media.com/hotels/1000000/970000/969800/969760/7bc2d2d8_b.jpg',
        __typename: 'Image',
      },
      description:
        'Located in Cricklewood, this eco-friendly hotel is 2 mi (3.2 km) from Brent Cross Shopping Centre and within 6 mi (10 km) of ZSL London Zoo and Oxford Street. Madame Tussauds Wax Museum and Camden Lock Market are also within 6 mi (10 km). Cricklewood Station is only a 4-minute walk and Willesden Green Underground Station is 12 minutes. ',
      secondaryContent: null,
      location: 'London',
      starRating: 4,
      guestReviewRating: '3.9/5',
      guestReviewRatingQualifierText: 'Good',
      guestReviewCount: '(989 reviews)',
      vipMessage: 'VIP Access',
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: 'Sign in to see Member Price',
        signInUrl: {
          value:
            'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-10-31%2F2022-11-02%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D969760%26sort%3DmemberDeals%26mctc%3D2',
          relativePath:
            '/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-10-31%2F2022-11-02%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D969760%26sort%3DmemberDeals%26mctc%3D2',
          __typename: 'HttpURI',
        },
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '',
          qualifierText: '',
          disclaimerText: '',
          allyText: null,
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-10-31%2F2022-11-02%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D969760%26sort%3DmemberDeals%26mctc%3D2',
          text: 'Sign in to see Member Price',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Mon, 31 Oct - Wed, 2 Nov',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'Radisson Blu Edwardian Heathrow Hotel & Conference Centre, London',
      image: {
        description: 'Radisson Blu Edwardian Heathrow Hotel & Conference Centre, London',
        url: 'https://images.trvl-media.com/hotels/1000000/20000/12400/12391/c33adebe_b.jpg',
        __typename: 'Image',
      },
      description:
        'Located in Heathrow Villages, this spa hotel is 2.1 mi (3.4 km) from London Motor Museum and within 9 mi (15 km) of Osterley Park and House and Royal Botanic Gardens, Kew. Windsor Castle and Eton College are also within 12 mi (20 km). Heathrow Terminals 2 & 3 Underground Station is 12 minutes by foot and Heathrow Terminals 2 & 3 Station is 14 minutes. ',
      secondaryContent: null,
      location: 'London',
      starRating: 4,
      guestReviewRating: '4.1/5',
      guestReviewRatingQualifierText: 'Very good',
      guestReviewCount: '(1018 reviews)',
      vipMessage: 'VIP Access',
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: 'Sign in to see Member Price',
        signInUrl: {
          value:
            'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-12-03%2F2022-12-05%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D12391%26sort%3DmemberDeals%26mctc%3D2',
          relativePath:
            '/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-12-03%2F2022-12-05%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D12391%26sort%3DmemberDeals%26mctc%3D2',
          __typename: 'HttpURI',
        },
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '',
          qualifierText: '',
          disclaimerText: '',
          allyText: null,
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-12-03%2F2022-12-05%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D12391%26sort%3DmemberDeals%26mctc%3D2',
          text: 'Sign in to see Member Price',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Sat, 3 Dec - Mon, 5 Dec',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'The Royal National Hotel',
      image: {
        description: 'The Royal National Hotel',
        url: 'https://images.trvl-media.com/hotels/1000000/60000/55100/55001/a5fd739d_b.jpg',
        __typename: 'Image',
      },
      description:
        'Located in London City Centre, this eco-friendly hotel is within a 10-minute walk of University College London and The British Museum. Oxford Street and Leicester Square are also within 1 mi (2 km). Russell Square Underground Station is only a 3-minute walk and Euston Underground Station is 9 minutes. ',
      secondaryContent: null,
      location: 'London',
      starRating: 4,
      guestReviewRating: '3.8/5',
      guestReviewRatingQualifierText: 'Good',
      guestReviewCount: '(3134 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: 'Sign in to see Member Price',
        signInUrl: {
          value:
            'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-10-16%2F2022-10-18%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D55001%26sort%3DmemberDeals%26mctc%3D2',
          relativePath:
            '/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-10-16%2F2022-10-18%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D55001%26sort%3DmemberDeals%26mctc%3D2',
          __typename: 'HttpURI',
        },
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '',
          qualifierText: '',
          disclaimerText: '',
          allyText: null,
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-10-16%2F2022-10-18%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D55001%26sort%3DmemberDeals%26mctc%3D2',
          text: 'Sign in to see Member Price',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Sun, 16 Oct - Tue, 18 Oct',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'Bedford Hotel',
      image: {
        description: 'Bedford Hotel',
        url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54993/9b9bf97e_b.jpg',
        __typename: 'Image',
      },
      description:
        'Located in London City Centre, this hotel is within a 10-minute walk of Russell Square, The British Museum, and Oxford Street. Piccadilly Circus and Trafalgar Square are also within 1 mi (2 km). Russell Square Underground Station is only a 4-minute walk and Holborn Underground Station is 6 minutes. ',
      secondaryContent: null,
      location: 'London',
      starRating: 4,
      guestReviewRating: '4.3/5',
      guestReviewRatingQualifierText: 'Very good',
      guestReviewCount: '(945 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: 'Sign in to see Member Price',
        signInUrl: {
          value:
            'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-12-04%2F2022-12-06%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D54993%26sort%3DmemberDeals%26mctc%3D2',
          relativePath:
            '/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-12-04%2F2022-12-06%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D54993%26sort%3DmemberDeals%26mctc%3D2',
          __typename: 'HttpURI',
        },
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '',
          qualifierText: '',
          disclaimerText: '',
          allyText: null,
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-12-04%2F2022-12-06%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D54993%26sort%3DmemberDeals%26mctc%3D2',
          text: 'Sign in to see Member Price',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Sun, 4 Dec - Tue, 6 Dec',
    },
    {
      __typename: 'HotelOfferItem',
      name: 'La Suite West - Hyde Park',
      image: {
        description: 'La Suite West - Hyde Park',
        url: 'https://images.trvl-media.com/hotels/6000000/5220000/5211000/5210931/72f90ea2_b.jpg',
        __typename: 'Image',
      },
      description:
        'Located in London City Centre, this boutique hotel is within a 15-minute walk of Kensington Gardens and Hyde Park. Royal Albert Hall and Marble Arch are also within 2 mi (3 km). Bayswater Underground Station is only a 2-minute walk and Queensway Underground Station is 4 minutes. ',
      secondaryContent: null,
      location: 'London',
      starRating: 4,
      guestReviewRating: '4.0/5',
      guestReviewRatingQualifierText: 'Good',
      guestReviewCount: '(762 reviews)',
      vipMessage: null,
      freeCancellationMessage: null,
      badge: null,
      discountBadge: null,
      mod: {
        modTagText: null,
        modAvailabilityText: 'Member Price available',
        modSignInText: 'Sign in to see Member Price',
        signInUrl: {
          value:
            'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-11-16%2F2022-11-18%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D5210931%26sort%3DmemberDeals%26mctc%3D2',
          relativePath:
            '/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-11-16%2F2022-11-18%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D5210931%26sort%3DmemberDeals%26mctc%3D2',
          __typename: 'HttpURI',
        },
        __typename: 'MODItem',
      },
      lodgingOffer: {
        price: {
          value: '',
          qualifierText: '',
          disclaimerText: '',
          allyText: null,
          __typename: 'OfferPrice',
        },
        strikeThroughPrice: null,
        actionLink: {
          href: 'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2Fgo%2Fhotel%2Fsearch%2FDestination%2F2022-11-16%2F2022-11-18%3FSearchType%3DDestination%26CityName%3DLondon%26RegionId%3D178279%26selected%3D5210931%26sort%3DmemberDeals%26mctc%3D2',
          text: 'Sign in to see Member Price',
          __typename: 'OfferActionLink',
        },
        __typename: 'OfferData',
      },
      dates: 'Wed, 16 Nov - Fri, 18 Nov',
    },
  ],
  __typename: 'CampaignDetail',
};

export const mockResponsePropertySearch = {
  data: {
    propertySearch: {
      searchCriteria: {
        propertyShopOptions: {
          points: 'SHOP_WITH_POINTS',
          typeaheadRegionType: null,
          __typename: 'PropertyShopOptions',
        },
        dateRange: {
          checkInDate: {
            year: 2022,
            month: 8,
            day: 18,
            __typename: 'Date',
          },
          checkOutDate: {
            year: 2022,
            month: 8,
            day: 19,
            __typename: 'Date',
          },
          __typename: 'PropertyDateRange',
        },
        destination: {
          regionId: '178279',
          regionName: 'London (and vicinity), England, United Kingdom',
          __typename: 'Destination',
        },
        searchIntent: {
          theme: '',
          userIntent: '',
          semdtl: '',
          __typename: 'SearchIntent',
        },
        sort: 'RECOMMENDED',
        filters: {
          accessibility: [],
          amenities: null,
          bedroomFilter: [],
          commissionTiers: null,
          agencyBusinessModels: null,
          deals: null,
          paymentType: [],
          poi: null,
          priceBuckets: [0, 300],
          propertyName: null,
          propertyStyles: null,
          reviewScore: null,
          starList: null,
          structureTypes: [],
          stayTypes: null,
          travelerType: null,
          mealPlan: null,
          cleaningAndSafetyPractices: null,
          __typename: 'PropertySearchFilters',
        },
        __typename: 'SearchCriteria',
      },
      sortAndFilter: {
        defaults: {
          sort: 'RECOMMENDED',
          regionId: '178279',
          __typename: 'SortAndFilterDefaults',
        },
        selected: {
          priceFilterPills: null,
          star: '',
          __typename: 'SortAndFilterSelected',
        },
        options: {
          accessibilityLabel: 'Results updated,filtered by London (and vicinity)',
          appliedFilterCount: 1,
          sortAndFilter: [
            {
              selected: false,
              isRange: false,
              label: 'Sort by',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'sort',
              title: 'sort',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 3,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'Sort by recommended',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Recommended',
                  value: 'recommended',
                  optionValue: 'RECOMMENDED',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Sort by price',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Price',
                  value: 'price',
                  optionValue: 'PRICE_LOW_TO_HIGH',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Sort by distance from city centre',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Distance from city centre',
                  value: 'distance',
                  optionValue: 'DISTANCE',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Sort by guest rating + our choices',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Guest rating + our choices',
                  value: 'guestRating',
                  optionValue: 'REVIEW',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Sort by price + our choices',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Price + our choices',
                  value: 'priceRelevant',
                  optionValue: 'PRICE_RELEVANT',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Sort by property class',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Property class',
                  value: 'starRating',
                  optionValue: 'PROPERTY_CLASS',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Search by property name',
              max: null,
              min: null,
              placeholder: 'e.g. Best Western',
              step: null,
              subLabel: null,
              name: 'hotelName',
              title: 'hotelName',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 3,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Popular filters',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'popularFilter',
              title: 'popularFilter',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 10,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'Spa',
                  ariaLabel: null,
                  description: null,
                  icon: 'spa',
                  isSelected: false,
                  label: 'Spa',
                  value: 'spa',
                  optionValue: 'SPA_ON_SITE',
                  range: null,
                  filterType: 'amenities',
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Free airport shuttle',
                  ariaLabel: null,
                  description: null,
                  icon: 'airport_shuttle',
                  isSelected: false,
                  label: 'Free airport shuttle',
                  value: 'freeAirportTransport',
                  optionValue: 'FREE_AIRPORT_TRANSPORTATION',
                  range: null,
                  filterType: 'amenities',
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Bed & breakfast',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Bed & breakfast',
                  value: 'bedBreakfast',
                  optionValue: 'BED_AND_BREAKFAST',
                  range: null,
                  filterType: 'lodging',
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'All-inclusive',
                  ariaLabel: null,
                  description: null,
                  icon: 'all_inclusive',
                  isSelected: false,
                  label: 'All-inclusive',
                  value: 'allInclusive',
                  optionValue: 'ALL_INCLUSIVE',
                  range: null,
                  filterType: 'mealPlan',
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Breakfast included',
                  ariaLabel: null,
                  description: null,
                  icon: 'free_breakfast',
                  isSelected: false,
                  label: 'Breakfast included',
                  value: 'breakfast',
                  optionValue: 'FREE_BREAKFAST',
                  range: null,
                  filterType: 'mealPlan',
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: true,
              label: 'Total price',
              max: null,
              min: null,
              placeholder: null,
              step: 1,
              subLabel: '£',
              name: 'price',
              title: 'price',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 10,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'Less than £50',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Less than £50',
                  value: '0',
                  optionValue: '0',
                  range: {
                    min: null,
                    max: 50,
                    __typename: 'FilterOptionRange',
                  },
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: '£50 to £100',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: '£50 to £100',
                  value: '1',
                  optionValue: '1',
                  range: {
                    min: 50,
                    max: 100,
                    __typename: 'FilterOptionRange',
                  },
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: '£100 to £150',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: '£100 to £150',
                  value: '2',
                  optionValue: '2',
                  range: {
                    min: 100,
                    max: 150,
                    __typename: 'FilterOptionRange',
                  },
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: '£150 to £225',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: '£150 to £225',
                  value: '3',
                  optionValue: '3',
                  range: {
                    min: 150,
                    max: 225,
                    __typename: 'FilterOptionRange',
                  },
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Greater than £225',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Greater than £225',
                  value: '4',
                  optionValue: '4',
                  range: {
                    min: 225,
                    max: null,
                    __typename: 'FilterOptionRange',
                  },
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Guest rating',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'guestRating',
              title: 'guestRating',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 10,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'Any',
                  ariaLabel: 'Any',
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Any',
                  value: '',
                  optionValue: '',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Guest rating 4.5+',
                  ariaLabel: 'Guest rating 4.5+',
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Wonderful 4.5+',
                  value: '45',
                  optionValue: '45',
                  range: {
                    min: 4.5,
                    max: 5,
                    __typename: 'FilterOptionRange',
                  },
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Guest rating 4+',
                  ariaLabel: 'Guest rating 4+',
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Very good 4+',
                  value: '40',
                  optionValue: '40',
                  range: {
                    min: 4,
                    max: 5,
                    __typename: 'FilterOptionRange',
                  },
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Guest rating 3.5+',
                  ariaLabel: 'Guest rating 3.5+',
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Good 3.5+',
                  value: '35',
                  optionValue: '35',
                  range: {
                    min: 3.5,
                    max: 5,
                    __typename: 'FilterOptionRange',
                  },
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Property class',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'star',
              title: 'star',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 10,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: '1 star',
                  ariaLabel: '1 star',
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: '1★',
                  value: '10',
                  optionValue: '10',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: '2 star',
                  ariaLabel: '2 star',
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: '2★',
                  value: '20',
                  optionValue: '20',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: '3 star',
                  ariaLabel: '3 star',
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: '3★',
                  value: '30',
                  optionValue: '30',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: '4 star',
                  ariaLabel: '4 star',
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: '4★',
                  value: '40',
                  optionValue: '40',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: '5 star',
                  ariaLabel: '5 star',
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: '5★',
                  value: '50',
                  optionValue: '50',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Payment type',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'paymentType',
              title: 'paymentType',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 3,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'Fully refundable',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Fully refundable',
                  value: 'freeCancellation',
                  optionValue: 'FREE_CANCELLATION',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Reserve now, pay later',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Reserve now, pay later',
                  value: 'payLater',
                  optionValue: 'PAY_LATER',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Property type',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'lodging',
              title: 'lodging',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 3,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'Bed & breakfast',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Bed & breakfast',
                  value: 'bedBreakfast',
                  optionValue: 'BED_AND_BREAKFAST',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Castle',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Castle',
                  value: 'castle',
                  optionValue: 'CASTLE',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Apart-hotel',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Apart-hotel',
                  value: 'apartHotel',
                  optionValue: 'APART_HOTEL',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Apartment',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Apartment',
                  value: 'apartment',
                  optionValue: 'APARTMENT',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Hostal (Budget Hotel)',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Hostal (Budget Hotel)',
                  value: 'hostal',
                  optionValue: 'HOSTAL',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Villa',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Villa',
                  value: 'villa',
                  optionValue: 'VILLA',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Condominium resort',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Condominium resort',
                  value: 'condoResort',
                  optionValue: 'CONDO_RESORT',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Condo',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Condo',
                  value: 'condo',
                  optionValue: 'CONDO',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Area',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'regionId',
              title: 'neighborhood',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 3,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'London (and vicinity)',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: true,
                  label: 'London (and vicinity)',
                  value: '178279',
                  optionValue: '178279',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'The City of London',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'The City of London',
                  value: '800056',
                  optionValue: '800056',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Notting Hill',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Notting Hill',
                  value: '601720',
                  optionValue: '601720',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Canary Wharf',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Canary Wharf',
                  value: '179523',
                  optionValue: '179523',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'City of Westminster',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'City of Westminster',
                  value: '179536',
                  optionValue: '179536',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Wimbledon',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Wimbledon',
                  value: '179539',
                  optionValue: '179539',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Victoria',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Victoria',
                  value: '800051',
                  optionValue: '800051',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Kensington',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Kensington',
                  value: '6054501',
                  optionValue: '6054501',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'London Paddington Station',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'London Paddington Station',
                  value: '6189104',
                  optionValue: '6189104',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Paddington',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Paddington',
                  value: '800049',
                  optionValue: '800049',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Soho',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Soho',
                  value: '6054504',
                  optionValue: '6054504',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Kings Cross St. Pancras',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Kings Cross St. Pancras',
                  value: '6047476',
                  optionValue: '6047476',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Mayfair',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Mayfair',
                  value: '6054503',
                  optionValue: '6054503',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Greenwich',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Greenwich',
                  value: '5827',
                  optionValue: '5827',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Covent Garden',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Covent Garden',
                  value: '553248625846408347',
                  optionValue: '553248625846408347',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Stratford',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Stratford',
                  value: '6144705',
                  optionValue: '6144705',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'London City Centre',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'London City Centre',
                  value: '6195474',
                  optionValue: '6195474',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Camden Town',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Camden Town',
                  value: '179518',
                  optionValue: '179518',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Chelsea',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Chelsea',
                  value: '6054502',
                  optionValue: '6054502',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'London (LHR-Heathrow)',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'London (LHR-Heathrow)',
                  value: '5392460',
                  optionValue: '5392460',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Popular locations',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'poi',
              title: 'poi',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 3,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'Hyde Park',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Hyde Park',
                  value: '51.506855,-0.163681:507738',
                  optionValue: '51.506855,-0.163681:507738',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'O2 Arena',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'O2 Arena',
                  value: '51.501131,0.002606:6057080',
                  optionValue: '51.501131,0.002606:6057080',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Tower Bridge',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Tower Bridge',
                  value: '51.50561,-0.07523:508419',
                  optionValue: '51.50561,-0.07523:508419',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Buckingham Palace',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Buckingham Palace',
                  value: '51.50207,-0.14018:501516',
                  optionValue: '51.50207,-0.14018:501516',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Wembley Stadium',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Wembley Stadium',
                  value: '51.557417,-0.280864:501565',
                  optionValue: '51.557417,-0.280864:501565',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Big Ben',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Big Ben',
                  value: '51.500756,-0.124548:6060186',
                  optionValue: '51.500756,-0.124548:6060186',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Tower of London',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Tower of London',
                  value: '51.508334,-0.075978:501521',
                  optionValue: '51.508334,-0.075978:501521',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Piccadilly Circus',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Piccadilly Circus',
                  value: '51.509874,-0.13426:508415',
                  optionValue: '51.509874,-0.13426:508415',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'The British Museum',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'The British Museum',
                  value: '51.518419,-0.12575:501529',
                  optionValue: '51.518419,-0.12575:501529',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Trafalgar Square',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Trafalgar Square',
                  value: '51.508524,-0.128247:508420',
                  optionValue: '51.508524,-0.128247:508420',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'London Eye',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'London Eye',
                  value: '51.503332,-0.119418:6047451',
                  optionValue: '51.503332,-0.119418:6047451',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'London Bridge',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'London Bridge',
                  value: '51.50787,-0.08772:508412',
                  optionValue: '51.50787,-0.08772:508412',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'The Shard',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'The Shard',
                  value: '51.504231,-0.086851:6273936',
                  optionValue: '51.504231,-0.086851:6273936',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: "St. Paul's Cathedral",
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: "St. Paul's Cathedral",
                  value: '51.513669,-0.100058:501558',
                  optionValue: '51.513669,-0.100058:501558',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Westfield London Shopping Centre',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Westfield London Shopping Centre',
                  value: '51.50684,-0.224563:6159434',
                  optionValue: '51.50684,-0.224563:6159434',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Oxford Street',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Oxford Street',
                  value: '51.515121,-0.143717:6144897',
                  optionValue: '51.515121,-0.143717:6144897',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Leicester Square',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Leicester Square',
                  value: '51.51063,-0.13073:508411',
                  optionValue: '51.51063,-0.13073:508411',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Marble Arch',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Marble Arch',
                  value: '51.513465,-0.158993:508413',
                  optionValue: '51.513465,-0.158993:508413',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Natural History Museum',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Natural History Museum',
                  value: '51.495873,-0.176346:501537',
                  optionValue: '51.495873,-0.176346:501537',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'ExCeL Exhibition Centre',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'ExCeL Exhibition Centre',
                  value: '51.508125,0.029794:6046590',
                  optionValue: '51.508125,0.029794:6046590',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Meal plans available',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'mealPlan',
              title: 'mealPlan',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 3,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'Breakfast included',
                  ariaLabel: null,
                  description: null,
                  icon: 'free_breakfast',
                  isSelected: false,
                  label: 'Breakfast included',
                  value: 'freeBreakfast',
                  optionValue: 'FREE_BREAKFAST',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Lunch included',
                  ariaLabel: null,
                  description: null,
                  icon: 'half_board',
                  isSelected: false,
                  label: 'Lunch included',
                  value: 'halfBoard',
                  optionValue: 'HALF_BOARD',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Dinner included',
                  ariaLabel: null,
                  description: null,
                  icon: 'full_board',
                  isSelected: false,
                  label: 'Dinner included',
                  value: 'fullBoard',
                  optionValue: 'FULL_BOARD',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'All-inclusive',
                  ariaLabel: null,
                  description: null,
                  icon: 'all_inclusive',
                  isSelected: false,
                  label: 'All-inclusive',
                  value: 'allInclusive',
                  optionValue: 'ALL_INCLUSIVE',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Amenities',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'amenities',
              title: 'amenities',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 3,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'Spa',
                  ariaLabel: null,
                  description: null,
                  icon: 'spa',
                  isSelected: false,
                  label: 'Spa',
                  value: 'spa',
                  optionValue: 'SPA_ON_SITE',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Free airport shuttle',
                  ariaLabel: null,
                  description: null,
                  icon: 'airport_shuttle',
                  isSelected: false,
                  label: 'Free airport shuttle',
                  value: 'freeAirportTransport',
                  optionValue: 'FREE_AIRPORT_TRANSPORTATION',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Pool',
                  ariaLabel: null,
                  description: null,
                  icon: 'pool',
                  isSelected: false,
                  label: 'Pool',
                  value: 'pool',
                  optionValue: 'POOL',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Hot tub',
                  ariaLabel: null,
                  description: null,
                  icon: 'hot_tub',
                  isSelected: false,
                  label: 'Hot tub',
                  value: 'hotTub',
                  optionValue: 'HOT_TUB',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Free WiFi',
                  ariaLabel: null,
                  description: null,
                  icon: 'wifi',
                  isSelected: false,
                  label: 'Free WiFi',
                  value: 'highSpeedInternet',
                  optionValue: 'WIFI',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Air conditioned',
                  ariaLabel: null,
                  description: null,
                  icon: 'ac_unit',
                  isSelected: false,
                  label: 'Air conditioned',
                  value: 'airConditioning',
                  optionValue: 'AIR_CONDITIONING',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Gym',
                  ariaLabel: null,
                  description: null,
                  icon: 'fitness_center',
                  isSelected: false,
                  label: 'Gym',
                  value: 'fitnessEquip',
                  optionValue: 'GYM',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Kitchen',
                  ariaLabel: null,
                  description: null,
                  icon: 'kitchen',
                  isSelected: false,
                  label: 'Kitchen',
                  value: 'kitchenKitchenette',
                  optionValue: 'KITCHEN_KITCHENETTE',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Water park',
                  ariaLabel: null,
                  description: null,
                  icon: 'check',
                  isSelected: false,
                  label: 'Water park',
                  value: 'waterPark',
                  optionValue: 'WATER_PARK',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Cots',
                  ariaLabel: null,
                  description: null,
                  icon: 'bedding__crib',
                  isSelected: false,
                  label: 'Cots',
                  value: 'crib',
                  optionValue: 'CRIB',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Sea view',
                  ariaLabel: null,
                  description: null,
                  icon: 'water',
                  isSelected: false,
                  label: 'Sea view',
                  value: 'oceanView',
                  optionValue: 'OCEAN_VIEW',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Casino',
                  ariaLabel: null,
                  description: null,
                  icon: 'casino',
                  isSelected: false,
                  label: 'Casino',
                  value: 'casino',
                  optionValue: 'CASINO',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Washer and dryer',
                  ariaLabel: null,
                  description: null,
                  icon: 'local_laundry_service',
                  isSelected: false,
                  label: 'Washer and dryer',
                  value: 'washerDryer',
                  optionValue: 'WASHER_DRYER',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Restaurant',
                  ariaLabel: null,
                  description: null,
                  icon: 'local_dining',
                  isSelected: false,
                  label: 'Restaurant',
                  value: 'restaurantInHotel',
                  optionValue: 'RESTAURANT_IN_HOTEL',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Parking',
                  ariaLabel: null,
                  description: null,
                  icon: 'local_parking',
                  isSelected: false,
                  label: 'Parking',
                  value: 'parking',
                  optionValue: 'PARKING',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Electric car charging station',
                  ariaLabel: null,
                  description: null,
                  icon: 'check',
                  isSelected: false,
                  label: 'Electric car charging station',
                  value: 'electricCar',
                  optionValue: 'ELECTRIC_CAR',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Outdoor space',
                  ariaLabel: null,
                  description: null,
                  icon: 'balcony',
                  isSelected: false,
                  label: 'Outdoor space',
                  value: 'balconyOrTerrace',
                  optionValue: 'BALCONY_OR_TERRACE',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Pet-friendly',
                  ariaLabel: null,
                  description: null,
                  icon: 'pets',
                  isSelected: false,
                  label: 'Pet-friendly',
                  value: 'petsAllowed',
                  optionValue: 'PETS',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Expedia Rewards',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'rewards',
              title: 'rewards',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 3,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'VIP Access properties',
                  ariaLabel: null,
                  description: 'Top-rated stays with member perks',
                  icon: null,
                  isSelected: false,
                  label: 'VIP Access properties',
                  value: 'VIP',
                  optionValue: 'VIP',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Member Prices',
                  ariaLabel: null,
                  description: 'Get instant savings when you become a member',
                  icon: null,
                  isSelected: false,
                  label: 'Member Prices',
                  value: 'MEMBER_ONLY',
                  optionValue: 'MEMBER_ONLY',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Accessibility',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'accessibility',
              title: 'accessibility',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 3,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'Wheelchair-accessible parking',
                  ariaLabel: null,
                  description: null,
                  icon: 'accessible',
                  isSelected: false,
                  label: 'Wheelchair-accessible parking',
                  value: 'handicapParking',
                  optionValue: 'ACCESSIBLE_PARKING',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Lift',
                  ariaLabel: null,
                  description: null,
                  icon: 'accessible',
                  isSelected: false,
                  label: 'Lift',
                  value: 'elevator',
                  optionValue: 'ELEVATOR',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Accessible bathroom',
                  ariaLabel: null,
                  description: null,
                  icon: 'accessible',
                  isSelected: false,
                  label: 'Accessible bathroom',
                  value: 'accessibleBathroom',
                  optionValue: 'ACCESSIBLE_BATHROOM',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Roll-in shower',
                  ariaLabel: null,
                  description: null,
                  icon: 'accessible',
                  isSelected: false,
                  label: 'Roll-in shower',
                  value: 'rollInShower',
                  optionValue: 'ROLL_IN_SHOWER',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'In-room accessibility',
                  ariaLabel: null,
                  description: null,
                  icon: 'accessible',
                  isSelected: false,
                  label: 'In-room accessibility',
                  value: 'inRoomAccessible',
                  optionValue: 'IN_ROOM_ACCESSIBLE',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Service animals allowed',
                  ariaLabel: null,
                  description: null,
                  icon: 'accessible',
                  isSelected: false,
                  label: 'Service animals allowed',
                  value: 'serviceAnimals',
                  optionValue: 'SERVICE_ANIMAL',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Stair-free path to entrance',
                  ariaLabel: null,
                  description: null,
                  icon: 'accessible',
                  isSelected: false,
                  label: 'Stair-free path to entrance',
                  value: 'stairFreePath',
                  optionValue: 'STAIR_FREE_PATH',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Sign language-capable staff',
                  ariaLabel: null,
                  description: null,
                  icon: 'accessible',
                  isSelected: false,
                  label: 'Sign language-capable staff',
                  value: 'signLanguage',
                  optionValue: 'SIGN_LANGUAGE_INTERPRETER',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Traveller experience',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'travelerType',
              title: 'travelerType',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 3,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'LGBTQ welcoming',
                  ariaLabel: null,
                  description: 'See properties that pledge to make all guests feel safe, welcome and respected.',
                  icon: null,
                  isSelected: false,
                  label: 'LGBTQ welcoming',
                  value: 'LGBT',
                  optionValue: 'LGBT',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Business-friendly',
                  ariaLabel: null,
                  description: 'See properties with amenities to help you work comfortably, like WiFi and breakfast.',
                  icon: null,
                  isSelected: false,
                  label: 'Business-friendly',
                  value: 'BUSINESS',
                  optionValue: 'BUSINESS',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
                {
                  selectedLabel: 'Family-friendly',
                  ariaLabel: null,
                  description:
                    'See properties that include family essentials like in-room conveniences and activities for the kids.',
                  icon: null,
                  isSelected: false,
                  label: 'Family-friendly',
                  value: 'FAMILY',
                  optionValue: 'FAMILY',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
            {
              selected: false,
              isRange: false,
              label: 'Availability',
              max: null,
              min: null,
              placeholder: null,
              step: null,
              subLabel: null,
              name: 'availableFilter',
              title: 'availableFilter',
              hiddenThreshold: null,
              showListOptions: {
                seeMoreLabel: 'See more',
                seeLessLabel: 'See less',
                hiddenThreshold: 3,
                __typename: 'ExpandoPeekOptions',
              },
              dropdownOptions: null,
              options: [
                {
                  selectedLabel: 'Only show available properties',
                  ariaLabel: null,
                  description: null,
                  icon: null,
                  isSelected: false,
                  label: 'Only show available properties',
                  value: 'showAvailableOnly',
                  optionValue: 'showAvailableOnly',
                  range: null,
                  filterType: null,
                  __typename: 'OptionViewModel',
                },
              ],
              __typename: 'FilterViewModel',
            },
          ],
          __typename: 'SortAndFilterViewModel',
        },
        __typename: 'SortAndFilter',
      },
      propertySearchListings: [
        {
          __typename: 'Property',
          id: '1886693',
          name: 'Mama Shelter London - Shoreditch',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/2000000/1890000/1886700/1886693/e5d79757_b.jpg',
              __typename: 'Image',
            },
            fallbackImage: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/2000000/1890000/1886700/1886693/6294462e.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: null,
            tertiary: {
              text: 'Ad',
              theme_temp: 'PROMOTED',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£133',
                      accessibilityLabel: 'The price is £133',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£133',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£133',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.4,
            localizedScore: '4.4',
            total: 265,
            localizedTotal: '265 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.4 / 5 (265 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.4 out of 5 Excellent (265 reviews)',
              value: '4.4/5 Excellent (265 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Mama-Shelter-London-Shoreditch.h1886693.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316609&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=3000662715&trackingData=AAAAEND7eEvejxDq0pN7hdIHduopiP54tSM7tmSqJiij51f8_vV9Z4vJPOGC0qBAZS2GUsgVaaUmFnd-CtzQV8ivj9NOn75BtBdQZYwrOipA1aLsE_ntX8Orp3s6_ifxb7KcZQcK6KgB1k1mkQ65fVzzG3wjsLtXTIvZnVkjLsoLASl8nNiY0MyuVQL9dhVQVWuxKS680k__9N3XJVC4bIkocFsVLyB2qp7Y7TMnmxgLOdjF6_fniSQ0hzKSh0szrPRePVyU8cHCzmcy_Cfh0jd7EyjLYZ2Nj9EJrtvHHS3KAHGJurT7D9vpjQM5MlOrFXNwb07MvXmfbmCK5e1RY6oKkI6DFYy1cZCzHp7Ywz_UDP6-exTXsfeKj6sJNT4G2lysmfobKd9Wpr9eV3IO9w0iaIXR1_r4EckwPFg9WKPCPYQNsTEIrCeIO3ub117BGqD9qWEKSP7_a2iiB8rxiTvSqVlyixc8QLfqKtitN1J-cHYrw2J_gy_xzss11jomrztJQrzFA830dMDGALHWC9sumDr307jc-HRlyYkU-ZDAAEwH0cm8nZYK1zoWpXDIv1xcFUoxyhPeQqpRz6Vm7NtQnNxZfgySj-eeTBNfJJttSFKqEogvFme84s9vsDEFtGp7PCOMAKGe0S5_5kZoaUI4Tzpvrf0Fr_f6e4IMHfBM8nZki2a6nfhPg-oBJUtpucYcFz8xJWJhNHLxGrtydpVp9_Zh-LzhbshVgjOFIVRmb77lBPGt-yj_QahAV7wuL-0ZMETlvEk4co3G1ODQ1WjtrTBIVTkswd_9DC0jv966UCRHAejdXLTADiF1mOLGHrjXtCsOJP8HJC6cN-TdwET3rzmgNnHubCW7oPLNS7-HTTcvW_br0EcVpCej4i91fKacIT_uNNhphu7xNJfUziv73EzYb4OMyA4Mo9PAJY6W9b5aDr5RaSX4SDiY3eJydTFhbcdX1v_a90vWF0t5X_1MtoNVTBJejHpuMvnaLFSGEic0SuSdAZjFuMDNcuV2kTSdnkEXsd4O62zHQG4qgYli_RbI5c3HO2EahhSdj0itOLclr8GOmHXfG6IFi32Vwoqjf16dDrEP8LoLc9hjNXQrnSU9r6yQRoIC3XbVvgHTcjLQeb5-w25kEQKd3bAcJB-Dng%3D%3D&rank=1&testVersionOverride=Buttercup&slots=HSR_A&position=1&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=133&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=213009440&selectedRatePlan=381216465',
              relativePath:
                '/London-Hotels-Mama-Shelter-London-Shoreditch.h1886693.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316609&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=3000662715&trackingData=AAAAEND7eEvejxDq0pN7hdIHduopiP54tSM7tmSqJiij51f8_vV9Z4vJPOGC0qBAZS2GUsgVaaUmFnd-CtzQV8ivj9NOn75BtBdQZYwrOipA1aLsE_ntX8Orp3s6_ifxb7KcZQcK6KgB1k1mkQ65fVzzG3wjsLtXTIvZnVkjLsoLASl8nNiY0MyuVQL9dhVQVWuxKS680k__9N3XJVC4bIkocFsVLyB2qp7Y7TMnmxgLOdjF6_fniSQ0hzKSh0szrPRePVyU8cHCzmcy_Cfh0jd7EyjLYZ2Nj9EJrtvHHS3KAHGJurT7D9vpjQM5MlOrFXNwb07MvXmfbmCK5e1RY6oKkI6DFYy1cZCzHp7Ywz_UDP6-exTXsfeKj6sJNT4G2lysmfobKd9Wpr9eV3IO9w0iaIXR1_r4EckwPFg9WKPCPYQNsTEIrCeIO3ub117BGqD9qWEKSP7_a2iiB8rxiTvSqVlyixc8QLfqKtitN1J-cHYrw2J_gy_xzss11jomrztJQrzFA830dMDGALHWC9sumDr307jc-HRlyYkU-ZDAAEwH0cm8nZYK1zoWpXDIv1xcFUoxyhPeQqpRz6Vm7NtQnNxZfgySj-eeTBNfJJttSFKqEogvFme84s9vsDEFtGp7PCOMAKGe0S5_5kZoaUI4Tzpvrf0Fr_f6e4IMHfBM8nZki2a6nfhPg-oBJUtpucYcFz8xJWJhNHLxGrtydpVp9_Zh-LzhbshVgjOFIVRmb77lBPGt-yj_QahAV7wuL-0ZMETlvEk4co3G1ODQ1WjtrTBIVTkswd_9DC0jv966UCRHAejdXLTADiF1mOLGHrjXtCsOJP8HJC6cN-TdwET3rzmgNnHubCW7oPLNS7-HTTcvW_br0EcVpCej4i91fKacIT_uNNhphu7xNJfUziv73EzYb4OMyA4Mo9PAJY6W9b5aDr5RaSX4SDiY3eJydTFhbcdX1v_a90vWF0t5X_1MtoNVTBJejHpuMvnaLFSGEic0SuSdAZjFuMDNcuV2kTSdnkEXsd4O62zHQG4qgYli_RbI5c3HO2EahhSdj0itOLclr8GOmHXfG6IFi32Vwoqjf16dDrEP8LoLc9hjNXQrnSU9r6yQRoIC3XbVvgHTcjLQeb5-w25kEQKd3bAcJB-Dng%3D%3D&rank=1&testVersionOverride=Buttercup&slots=HSR_A&position=1&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=133&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=213009440&selectedRatePlan=381216465',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:1',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: {
            id: '239228',
            clickRedirectTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/ClRedirect?testVersionOverride=Buttercup&destinationUrl=&rank=1&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEND7eEvejxDq0pN7hdIHduopiP54tSM7tmSqJiij51f8_vV9Z4vJPOGC0qBAZS2GUsgVaaUmFnd-CtzQV8ivj9NOn75BtBdQZYwrOipA1aLsE_ntX8Orp3s6_ifxb7KcZQcK6KgB1k1mkQ65fVzzG3wjsLtXTIvZnVkjLsoLASl8nNiY0MyuVQL9dhVQVWuxKS680k__9N3XJVC4bIkocFsVLyB2qp7Y7TMnmxgLOdjF6_fniSQ0hzKSh0szrPRePVyU8cHCzmcy_Cfh0jd7EyjLYZ2Nj9EJrtvHHS3KAHGJurT7D9vpjQM5MlOrFXNwb07MvXmfbmCK5e1RY6oKkI6DFYy1cZCzHp7Ywz_UDP6-exTXsfeKj6sJNT4G2lysmfobKd9Wpr9eV3IO9w0iaIXR1_r4EckwPFg9WKPCPYQNsTEIrCeIO3ub117BGqD9qWEKSP7_a2iiB8rxiTvSqVlyixc8QLfqKtitN1J-cHYrw2J_gy_xzss11jomrztJQrzFA830dMDGALHWC9sumDr307jc-HRlyYkU-ZDAAEwH0cm8nZYK1zoWpXDIv1xcFUoxyhPeQqpRz6Vm7NtQnNxZfgySj-eeTBNfJJttSFKqEogvFme84s9vsDEFtGp7PCOMAKGe0S5_5kZoaUI4Tzpvrf0Fr_f6e4IMHfBM8nZki2a6nfhPg-oBJUtpucYcFz8xJWJhNHLxGrtydpVp9_Zh-LzhbshVgjOFIVRmb77lBPGt-yj_QahAV7wuL-0ZMETlvEk4co3G1ODQ1WjtrTBIVTkswd_9DC0jv966UCRHAejdXLTADiF1mOLGHrjXtCsOJP8HJC6cN-TdwET3rzmgNnHubCW7oPLNS7-HTTcvW_br0EcVpCej4i91fKacIT_uNNhphu7xNJfUziv73EzYb4OMyA4Mo9PAJY6W9b5aDr5RaSX4SDiY3eJydTFhbcdX1v_a90vWF0t5X_1MtoNVTBJejHpuMvnaLFSGEic0SuSdAZjFuMDNcuV2kTSdnkEXsd4O62zHQG4qgYli_RbI5c3HO2EahhSdj0itOLclr8GOmHXfG6IFi32Vwoqjf16dDrEP8LoLc9hjNXQrnSU9r6yQRoIC3XbVvgHTcjLQeb5-w25kEQKd3bAcJB-Dng==&slots=HSR_A&position=1&beaconIssued=2022-08-10T13:48:35',
            clickTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Cl?testVersionOverride=Buttercup&rank=1&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEND7eEvejxDq0pN7hdIHduopiP54tSM7tmSqJiij51f8_vV9Z4vJPOGC0qBAZS2GUsgVaaUmFnd-CtzQV8ivj9NOn75BtBdQZYwrOipA1aLsE_ntX8Orp3s6_ifxb7KcZQcK6KgB1k1mkQ65fVzzG3wjsLtXTIvZnVkjLsoLASl8nNiY0MyuVQL9dhVQVWuxKS680k__9N3XJVC4bIkocFsVLyB2qp7Y7TMnmxgLOdjF6_fniSQ0hzKSh0szrPRePVyU8cHCzmcy_Cfh0jd7EyjLYZ2Nj9EJrtvHHS3KAHGJurT7D9vpjQM5MlOrFXNwb07MvXmfbmCK5e1RY6oKkI6DFYy1cZCzHp7Ywz_UDP6-exTXsfeKj6sJNT4G2lysmfobKd9Wpr9eV3IO9w0iaIXR1_r4EckwPFg9WKPCPYQNsTEIrCeIO3ub117BGqD9qWEKSP7_a2iiB8rxiTvSqVlyixc8QLfqKtitN1J-cHYrw2J_gy_xzss11jomrztJQrzFA830dMDGALHWC9sumDr307jc-HRlyYkU-ZDAAEwH0cm8nZYK1zoWpXDIv1xcFUoxyhPeQqpRz6Vm7NtQnNxZfgySj-eeTBNfJJttSFKqEogvFme84s9vsDEFtGp7PCOMAKGe0S5_5kZoaUI4Tzpvrf0Fr_f6e4IMHfBM8nZki2a6nfhPg-oBJUtpucYcFz8xJWJhNHLxGrtydpVp9_Zh-LzhbshVgjOFIVRmb77lBPGt-yj_QahAV7wuL-0ZMETlvEk4co3G1ODQ1WjtrTBIVTkswd_9DC0jv966UCRHAejdXLTADiF1mOLGHrjXtCsOJP8HJC6cN-TdwET3rzmgNnHubCW7oPLNS7-HTTcvW_br0EcVpCej4i91fKacIT_uNNhphu7xNJfUziv73EzYb4OMyA4Mo9PAJY6W9b5aDr5RaSX4SDiY3eJydTFhbcdX1v_a90vWF0t5X_1MtoNVTBJejHpuMvnaLFSGEic0SuSdAZjFuMDNcuV2kTSdnkEXsd4O62zHQG4qgYli_RbI5c3HO2EahhSdj0itOLclr8GOmHXfG6IFi32Vwoqjf16dDrEP8LoLc9hjNXQrnSU9r6yQRoIC3XbVvgHTcjLQeb5-w25kEQKd3bAcJB-Dng==&slots=HSR_A&position=1&beaconIssued=2022-08-10T13:48:35',
            details:
              'Close to the all the great Shoreditch and Hackney venues for great food and music, with hidden East London gems on the doorstep.',
            detailsHeadline: '4 star lifestyle hotel in Shoreditch',
            hotelImage:
              'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/2000000/1890000/1886700/1886693/e5d79757_b.jpg',
            impressionTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Impr?testVersionOverride=Buttercup&rank=1&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEND7eEvejxDq0pN7hdIHduopiP54tSM7tmSqJiij51f8_vV9Z4vJPOGC0qBAZS2GUsgVaaUmFnd-CtzQV8ivj9NOn75BtBdQZYwrOipA1aLsE_ntX8Orp3s6_ifxb7KcZQcK6KgB1k1mkQ65fVzzG3wjsLtXTIvZnVkjLsoLASl8nNiY0MyuVQL9dhVQVWuxKS680k__9N3XJVC4bIkocFsVLyB2qp7Y7TMnmxgLOdjF6_fniSQ0hzKSh0szrPRePVyU8cHCzmcy_Cfh0jd7EyjLYZ2Nj9EJrtvHHS3KAHGJurT7D9vpjQM5MlOrFXNwb07MvXmfbmCK5e1RY6oKkI6DFYy1cZCzHp7Ywz_UDP6-exTXsfeKj6sJNT4G2lysmfobKd9Wpr9eV3IO9w0iaIXR1_r4EckwPFg9WKPCPYQNsTEIrCeIO3ub117BGqD9qWEKSP7_a2iiB8rxiTvSqVlyixc8QLfqKtitN1J-cHYrw2J_gy_xzss11jomrztJQrzFA830dMDGALHWC9sumDr307jc-HRlyYkU-ZDAAEwH0cm8nZYK1zoWpXDIv1xcFUoxyhPeQqpRz6Vm7NtQnNxZfgySj-eeTBNfJJttSFKqEogvFme84s9vsDEFtGp7PCOMAKGe0S5_5kZoaUI4Tzpvrf0Fr_f6e4IMHfBM8nZki2a6nfhPg-oBJUtpucYcFz8xJWJhNHLxGrtydpVp9_Zh-LzhbshVgjOFIVRmb77lBPGt-yj_QahAV7wuL-0ZMETlvEk4co3G1ODQ1WjtrTBIVTkswd_9DC0jv966UCRHAejdXLTADiF1mOLGHrjXtCsOJP8HJC6cN-TdwET3rzmgNnHubCW7oPLNS7-HTTcvW_br0EcVpCej4i91fKacIT_uNNhphu7xNJfUziv73EzYb4OMyA4Mo9PAJY6W9b5aDr5RaSX4SDiY3eJydTFhbcdX1v_a90vWF0t5X_1MtoNVTBJejHpuMvnaLFSGEic0SuSdAZjFuMDNcuV2kTSdnkEXsd4O62zHQG4qgYli_RbI5c3HO2EahhSdj0itOLclr8GOmHXfG6IFi32Vwoqjf16dDrEP8LoLc9hjNXQrnSU9r6yQRoIC3XbVvgHTcjLQeb5-w25kEQKd3bAcJB-Dng==&slots=HSR_A&position=1&beaconIssued=2022-08-10T13:48:35',
            trackingData:
              'AAAAEND7eEvejxDq0pN7hdIHduopiP54tSM7tmSqJiij51f8_vV9Z4vJPOGC0qBAZS2GUsgVaaUmFnd-CtzQV8ivj9NOn75BtBdQZYwrOipA1aLsE_ntX8Orp3s6_ifxb7KcZQcK6KgB1k1mkQ65fVzzG3wjsLtXTIvZnVkjLsoLASl8nNiY0MyuVQL9dhVQVWuxKS680k__9N3XJVC4bIkocFsVLyB2qp7Y7TMnmxgLOdjF6_fniSQ0hzKSh0szrPRePVyU8cHCzmcy_Cfh0jd7EyjLYZ2Nj9EJrtvHHS3KAHGJurT7D9vpjQM5MlOrFXNwb07MvXmfbmCK5e1RY6oKkI6DFYy1cZCzHp7Ywz_UDP6-exTXsfeKj6sJNT4G2lysmfobKd9Wpr9eV3IO9w0iaIXR1_r4EckwPFg9WKPCPYQNsTEIrCeIO3ub117BGqD9qWEKSP7_a2iiB8rxiTvSqVlyixc8QLfqKtitN1J-cHYrw2J_gy_xzss11jomrztJQrzFA830dMDGALHWC9sumDr307jc-HRlyYkU-ZDAAEwH0cm8nZYK1zoWpXDIv1xcFUoxyhPeQqpRz6Vm7NtQnNxZfgySj-eeTBNfJJttSFKqEogvFme84s9vsDEFtGp7PCOMAKGe0S5_5kZoaUI4Tzpvrf0Fr_f6e4IMHfBM8nZki2a6nfhPg-oBJUtpucYcFz8xJWJhNHLxGrtydpVp9_Zh-LzhbshVgjOFIVRmb77lBPGt-yj_QahAV7wuL-0ZMETlvEk4co3G1ODQ1WjtrTBIVTkswd_9DC0jv966UCRHAejdXLTADiF1mOLGHrjXtCsOJP8HJC6cN-TdwET3rzmgNnHubCW7oPLNS7-HTTcvW_br0EcVpCej4i91fKacIT_uNNhphu7xNJfUziv73EzYb4OMyA4Mo9PAJY6W9b5aDr5RaSX4SDiY3eJydTFhbcdX1v_a90vWF0t5X_1MtoNVTBJejHpuMvnaLFSGEic0SuSdAZjFuMDNcuV2kTSdnkEXsd4O62zHQG4qgYli_RbI5c3HO2EahhSdj0itOLclr8GOmHXfG6IFi32Vwoqjf16dDrEP8LoLc9hjNXQrnSU9r6yQRoIC3XbVvgHTcjLQeb5-w25kEQKd3bAcJB-Dng==',
            brand: null,
            clickRedirectLinkoffTrackingUrl: null,
            logo: null,
            lotagline: null,
            rating: '0',
            slots: 'HSR_A',
            vanityUrl: null,
            rank: '1',
            position: '1',
            __typename: 'SponsoredListing',
          },
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Mama Shelter London - Shoreditch',
            images: [
              {
                image: {
                  url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/2000000/1890000/1886700/1886693/e5d79757_b.jpg',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1890000/1886700/1886693/6294462e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                imageId: '527544060',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1890000/1886700/1886693/f1d1bf5d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '530636136',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1890000/1886700/1886693/9bc404bb.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '527543914',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1890000/1886700/1886693/55d20e84.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '530636469',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£133',
            type: 'HOTEL',
            latLong: {
              latitude: 51.531908,
              longitude: -0.062005,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/1886693',
            removeUrl: '/api/ucs/shortlist/remove/1886693',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '1886693',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '62769',
          name: 'Tavistock Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/70000/62800/62769/bfa2cf87_b.jpg',
              __typename: 'Image',
            },
            fallbackImage: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/70000/62800/62769/6556032b.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: {
              text: 'Ad',
              theme_temp: 'PROMOTED',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£130',
                      accessibilityLabel: 'The price is £130',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£130',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£130',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.7,
            localizedScore: '3.7',
            total: 187,
            localizedTotal: '187 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.7 / 5 (187 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.7 out of 5 Good (187 reviews)',
              value: '3.7/5 Good (187 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Tavistock-Hotel.h62769.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316609&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6251519&trackingData=AAAAEBoTNXngQr8VG7Vj3Oow9jtteqco0Me0sfZ-9_rdWE97bGWBDHtmkUX9s3nZTPZrFmgpidRhuK7RjvGoUxGDerAydnYRG6nRf0Sy1u2WybDNbZYNQxtGu1FOU2g-yWyOko_YxcbBvXrPaU1p78Mzd8Cfb7dWDWK6E_HL9oH9BUp3tHPy-wW4EsiUpDj74hZNLiTFA34q2NUbGrcQkO8NFkX63ZPUQgDso87koEewELGuPRDMCpFuh-dT8NvwRBmmRqclzfDeglDZk24bIyaOtsbPuM_oAm4qr_mW6kk6B2CtTRrbu0PqGxqi-thhokJGft4jh7sPrcQhvf7GQ_UUw9PY8p3a8yIwZK-WSBLZDmqfAA54FmFRnBd0NjpAgmOHHYTsEfNdlOiFXi9JP5oiELtpCCtWPuvrv9ODoXVl1FEkVJQq26o6hPoIWZ3WLk4akgJOZy4SroAPdPGCXQ0mHlUTvCn2D3bd9YhkORp_gTzOBi2SppJCQNRT_UZjEi005VaJslh6axMlRw_JynunwQfJWOp9-zY9h6ZA3xUy6FEpfE8smHNkBLN31YR0UYURXsOcJKADX1Hxo_Kfq5qTDALbtkYYV8Vy28-lXZXb1_K539hcug0TJKRHfxKwPof8cVm6_KgecmVlBJi8z7Fpkc854edhpqoHkuedW9qWrurSQeGpqDPeaWbHZSyZ9KKKzT3BOz_utpzFcgK_CGND_TwMUedlu3Is7htJA-aIihTtYGCd43BGxlrNvM969pLrsal9HGZv8NDXrSTXpFI-7G4o8TB-YLF5yxbmfq3Ki7ouitc1r0POWMw3vYcT35q6KPPQ6t6uq781gPrUVc-MzeFkxZ8M0A7rNanCSqA88yOazl_Vrul6VOWJtnp21Jd1xtgEeffMRnLnGAEiuD4eJJjGdlrjjJulmJh_AcIoBi2ASiWeGqnYdqqou44abL5kgr-fdFKXgRa695GRJqx2E1oK8XqvxUf74R-ZKw3bF4C_J3IrsxQuBwVAD_51AiROyZ1AbmGlA8IZbd4xEbleqVWERmXk_sLe38LagjNw_6xzmjiVAnQGK4i-Ut_cEmMr2elsnPj0yFDTOYm8IFIe8w203RZdKFoARFX4OApGGXHWUXQedEy0dp4eYND4kOtbJyYls9uMj281NWlEkKq0XP0%3D&rank=2&testVersionOverride=Buttercup&slots=HSR_AA&position=2&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=130&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=316416664&selectedRatePlan=386002739',
              relativePath:
                '/London-Hotels-Tavistock-Hotel.h62769.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316609&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6251519&trackingData=AAAAEBoTNXngQr8VG7Vj3Oow9jtteqco0Me0sfZ-9_rdWE97bGWBDHtmkUX9s3nZTPZrFmgpidRhuK7RjvGoUxGDerAydnYRG6nRf0Sy1u2WybDNbZYNQxtGu1FOU2g-yWyOko_YxcbBvXrPaU1p78Mzd8Cfb7dWDWK6E_HL9oH9BUp3tHPy-wW4EsiUpDj74hZNLiTFA34q2NUbGrcQkO8NFkX63ZPUQgDso87koEewELGuPRDMCpFuh-dT8NvwRBmmRqclzfDeglDZk24bIyaOtsbPuM_oAm4qr_mW6kk6B2CtTRrbu0PqGxqi-thhokJGft4jh7sPrcQhvf7GQ_UUw9PY8p3a8yIwZK-WSBLZDmqfAA54FmFRnBd0NjpAgmOHHYTsEfNdlOiFXi9JP5oiELtpCCtWPuvrv9ODoXVl1FEkVJQq26o6hPoIWZ3WLk4akgJOZy4SroAPdPGCXQ0mHlUTvCn2D3bd9YhkORp_gTzOBi2SppJCQNRT_UZjEi005VaJslh6axMlRw_JynunwQfJWOp9-zY9h6ZA3xUy6FEpfE8smHNkBLN31YR0UYURXsOcJKADX1Hxo_Kfq5qTDALbtkYYV8Vy28-lXZXb1_K539hcug0TJKRHfxKwPof8cVm6_KgecmVlBJi8z7Fpkc854edhpqoHkuedW9qWrurSQeGpqDPeaWbHZSyZ9KKKzT3BOz_utpzFcgK_CGND_TwMUedlu3Is7htJA-aIihTtYGCd43BGxlrNvM969pLrsal9HGZv8NDXrSTXpFI-7G4o8TB-YLF5yxbmfq3Ki7ouitc1r0POWMw3vYcT35q6KPPQ6t6uq781gPrUVc-MzeFkxZ8M0A7rNanCSqA88yOazl_Vrul6VOWJtnp21Jd1xtgEeffMRnLnGAEiuD4eJJjGdlrjjJulmJh_AcIoBi2ASiWeGqnYdqqou44abL5kgr-fdFKXgRa695GRJqx2E1oK8XqvxUf74R-ZKw3bF4C_J3IrsxQuBwVAD_51AiROyZ1AbmGlA8IZbd4xEbleqVWERmXk_sLe38LagjNw_6xzmjiVAnQGK4i-Ut_cEmMr2elsnPj0yFDTOYm8IFIe8w203RZdKFoARFX4OApGGXHWUXQedEy0dp4eYND4kOtbJyYls9uMj281NWlEkKq0XP0%3D&rank=2&testVersionOverride=Buttercup&slots=HSR_AA&position=2&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=130&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=316416664&selectedRatePlan=386002739',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:2',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: {
            id: '675067',
            clickRedirectTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/ClRedirect?testVersionOverride=Buttercup&destinationUrl=&rank=2&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEBoTNXngQr8VG7Vj3Oow9jtteqco0Me0sfZ-9_rdWE97bGWBDHtmkUX9s3nZTPZrFmgpidRhuK7RjvGoUxGDerAydnYRG6nRf0Sy1u2WybDNbZYNQxtGu1FOU2g-yWyOko_YxcbBvXrPaU1p78Mzd8Cfb7dWDWK6E_HL9oH9BUp3tHPy-wW4EsiUpDj74hZNLiTFA34q2NUbGrcQkO8NFkX63ZPUQgDso87koEewELGuPRDMCpFuh-dT8NvwRBmmRqclzfDeglDZk24bIyaOtsbPuM_oAm4qr_mW6kk6B2CtTRrbu0PqGxqi-thhokJGft4jh7sPrcQhvf7GQ_UUw9PY8p3a8yIwZK-WSBLZDmqfAA54FmFRnBd0NjpAgmOHHYTsEfNdlOiFXi9JP5oiELtpCCtWPuvrv9ODoXVl1FEkVJQq26o6hPoIWZ3WLk4akgJOZy4SroAPdPGCXQ0mHlUTvCn2D3bd9YhkORp_gTzOBi2SppJCQNRT_UZjEi005VaJslh6axMlRw_JynunwQfJWOp9-zY9h6ZA3xUy6FEpfE8smHNkBLN31YR0UYURXsOcJKADX1Hxo_Kfq5qTDALbtkYYV8Vy28-lXZXb1_K539hcug0TJKRHfxKwPof8cVm6_KgecmVlBJi8z7Fpkc854edhpqoHkuedW9qWrurSQeGpqDPeaWbHZSyZ9KKKzT3BOz_utpzFcgK_CGND_TwMUedlu3Is7htJA-aIihTtYGCd43BGxlrNvM969pLrsal9HGZv8NDXrSTXpFI-7G4o8TB-YLF5yxbmfq3Ki7ouitc1r0POWMw3vYcT35q6KPPQ6t6uq781gPrUVc-MzeFkxZ8M0A7rNanCSqA88yOazl_Vrul6VOWJtnp21Jd1xtgEeffMRnLnGAEiuD4eJJjGdlrjjJulmJh_AcIoBi2ASiWeGqnYdqqou44abL5kgr-fdFKXgRa695GRJqx2E1oK8XqvxUf74R-ZKw3bF4C_J3IrsxQuBwVAD_51AiROyZ1AbmGlA8IZbd4xEbleqVWERmXk_sLe38LagjNw_6xzmjiVAnQGK4i-Ut_cEmMr2elsnPj0yFDTOYm8IFIe8w203RZdKFoARFX4OApGGXHWUXQedEy0dp4eYND4kOtbJyYls9uMj281NWlEkKq0XP0=&slots=HSR_AA&position=2&beaconIssued=2022-08-10T13:48:35',
            clickTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Cl?testVersionOverride=Buttercup&rank=2&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEBoTNXngQr8VG7Vj3Oow9jtteqco0Me0sfZ-9_rdWE97bGWBDHtmkUX9s3nZTPZrFmgpidRhuK7RjvGoUxGDerAydnYRG6nRf0Sy1u2WybDNbZYNQxtGu1FOU2g-yWyOko_YxcbBvXrPaU1p78Mzd8Cfb7dWDWK6E_HL9oH9BUp3tHPy-wW4EsiUpDj74hZNLiTFA34q2NUbGrcQkO8NFkX63ZPUQgDso87koEewELGuPRDMCpFuh-dT8NvwRBmmRqclzfDeglDZk24bIyaOtsbPuM_oAm4qr_mW6kk6B2CtTRrbu0PqGxqi-thhokJGft4jh7sPrcQhvf7GQ_UUw9PY8p3a8yIwZK-WSBLZDmqfAA54FmFRnBd0NjpAgmOHHYTsEfNdlOiFXi9JP5oiELtpCCtWPuvrv9ODoXVl1FEkVJQq26o6hPoIWZ3WLk4akgJOZy4SroAPdPGCXQ0mHlUTvCn2D3bd9YhkORp_gTzOBi2SppJCQNRT_UZjEi005VaJslh6axMlRw_JynunwQfJWOp9-zY9h6ZA3xUy6FEpfE8smHNkBLN31YR0UYURXsOcJKADX1Hxo_Kfq5qTDALbtkYYV8Vy28-lXZXb1_K539hcug0TJKRHfxKwPof8cVm6_KgecmVlBJi8z7Fpkc854edhpqoHkuedW9qWrurSQeGpqDPeaWbHZSyZ9KKKzT3BOz_utpzFcgK_CGND_TwMUedlu3Is7htJA-aIihTtYGCd43BGxlrNvM969pLrsal9HGZv8NDXrSTXpFI-7G4o8TB-YLF5yxbmfq3Ki7ouitc1r0POWMw3vYcT35q6KPPQ6t6uq781gPrUVc-MzeFkxZ8M0A7rNanCSqA88yOazl_Vrul6VOWJtnp21Jd1xtgEeffMRnLnGAEiuD4eJJjGdlrjjJulmJh_AcIoBi2ASiWeGqnYdqqou44abL5kgr-fdFKXgRa695GRJqx2E1oK8XqvxUf74R-ZKw3bF4C_J3IrsxQuBwVAD_51AiROyZ1AbmGlA8IZbd4xEbleqVWERmXk_sLe38LagjNw_6xzmjiVAnQGK4i-Ut_cEmMr2elsnPj0yFDTOYm8IFIe8w203RZdKFoARFX4OApGGXHWUXQedEy0dp4eYND4kOtbJyYls9uMj281NWlEkKq0XP0=&slots=HSR_AA&position=2&beaconIssued=2022-08-10T13:48:35',
            details:
              'With touches of Art Deco elegance, Tavistock offers great value for money and is perfectly located for business or leisure travell',
            detailsHeadline: 'Historic Central London hotel',
            hotelImage:
              'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/70000/62800/62769/bfa2cf87_b.jpg',
            impressionTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Impr?testVersionOverride=Buttercup&rank=2&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEBoTNXngQr8VG7Vj3Oow9jtteqco0Me0sfZ-9_rdWE97bGWBDHtmkUX9s3nZTPZrFmgpidRhuK7RjvGoUxGDerAydnYRG6nRf0Sy1u2WybDNbZYNQxtGu1FOU2g-yWyOko_YxcbBvXrPaU1p78Mzd8Cfb7dWDWK6E_HL9oH9BUp3tHPy-wW4EsiUpDj74hZNLiTFA34q2NUbGrcQkO8NFkX63ZPUQgDso87koEewELGuPRDMCpFuh-dT8NvwRBmmRqclzfDeglDZk24bIyaOtsbPuM_oAm4qr_mW6kk6B2CtTRrbu0PqGxqi-thhokJGft4jh7sPrcQhvf7GQ_UUw9PY8p3a8yIwZK-WSBLZDmqfAA54FmFRnBd0NjpAgmOHHYTsEfNdlOiFXi9JP5oiELtpCCtWPuvrv9ODoXVl1FEkVJQq26o6hPoIWZ3WLk4akgJOZy4SroAPdPGCXQ0mHlUTvCn2D3bd9YhkORp_gTzOBi2SppJCQNRT_UZjEi005VaJslh6axMlRw_JynunwQfJWOp9-zY9h6ZA3xUy6FEpfE8smHNkBLN31YR0UYURXsOcJKADX1Hxo_Kfq5qTDALbtkYYV8Vy28-lXZXb1_K539hcug0TJKRHfxKwPof8cVm6_KgecmVlBJi8z7Fpkc854edhpqoHkuedW9qWrurSQeGpqDPeaWbHZSyZ9KKKzT3BOz_utpzFcgK_CGND_TwMUedlu3Is7htJA-aIihTtYGCd43BGxlrNvM969pLrsal9HGZv8NDXrSTXpFI-7G4o8TB-YLF5yxbmfq3Ki7ouitc1r0POWMw3vYcT35q6KPPQ6t6uq781gPrUVc-MzeFkxZ8M0A7rNanCSqA88yOazl_Vrul6VOWJtnp21Jd1xtgEeffMRnLnGAEiuD4eJJjGdlrjjJulmJh_AcIoBi2ASiWeGqnYdqqou44abL5kgr-fdFKXgRa695GRJqx2E1oK8XqvxUf74R-ZKw3bF4C_J3IrsxQuBwVAD_51AiROyZ1AbmGlA8IZbd4xEbleqVWERmXk_sLe38LagjNw_6xzmjiVAnQGK4i-Ut_cEmMr2elsnPj0yFDTOYm8IFIe8w203RZdKFoARFX4OApGGXHWUXQedEy0dp4eYND4kOtbJyYls9uMj281NWlEkKq0XP0=&slots=HSR_AA&position=2&beaconIssued=2022-08-10T13:48:35',
            trackingData:
              'AAAAEBoTNXngQr8VG7Vj3Oow9jtteqco0Me0sfZ-9_rdWE97bGWBDHtmkUX9s3nZTPZrFmgpidRhuK7RjvGoUxGDerAydnYRG6nRf0Sy1u2WybDNbZYNQxtGu1FOU2g-yWyOko_YxcbBvXrPaU1p78Mzd8Cfb7dWDWK6E_HL9oH9BUp3tHPy-wW4EsiUpDj74hZNLiTFA34q2NUbGrcQkO8NFkX63ZPUQgDso87koEewELGuPRDMCpFuh-dT8NvwRBmmRqclzfDeglDZk24bIyaOtsbPuM_oAm4qr_mW6kk6B2CtTRrbu0PqGxqi-thhokJGft4jh7sPrcQhvf7GQ_UUw9PY8p3a8yIwZK-WSBLZDmqfAA54FmFRnBd0NjpAgmOHHYTsEfNdlOiFXi9JP5oiELtpCCtWPuvrv9ODoXVl1FEkVJQq26o6hPoIWZ3WLk4akgJOZy4SroAPdPGCXQ0mHlUTvCn2D3bd9YhkORp_gTzOBi2SppJCQNRT_UZjEi005VaJslh6axMlRw_JynunwQfJWOp9-zY9h6ZA3xUy6FEpfE8smHNkBLN31YR0UYURXsOcJKADX1Hxo_Kfq5qTDALbtkYYV8Vy28-lXZXb1_K539hcug0TJKRHfxKwPof8cVm6_KgecmVlBJi8z7Fpkc854edhpqoHkuedW9qWrurSQeGpqDPeaWbHZSyZ9KKKzT3BOz_utpzFcgK_CGND_TwMUedlu3Is7htJA-aIihTtYGCd43BGxlrNvM969pLrsal9HGZv8NDXrSTXpFI-7G4o8TB-YLF5yxbmfq3Ki7ouitc1r0POWMw3vYcT35q6KPPQ6t6uq781gPrUVc-MzeFkxZ8M0A7rNanCSqA88yOazl_Vrul6VOWJtnp21Jd1xtgEeffMRnLnGAEiuD4eJJjGdlrjjJulmJh_AcIoBi2ASiWeGqnYdqqou44abL5kgr-fdFKXgRa695GRJqx2E1oK8XqvxUf74R-ZKw3bF4C_J3IrsxQuBwVAD_51AiROyZ1AbmGlA8IZbd4xEbleqVWERmXk_sLe38LagjNw_6xzmjiVAnQGK4i-Ut_cEmMr2elsnPj0yFDTOYm8IFIe8w203RZdKFoARFX4OApGGXHWUXQedEy0dp4eYND4kOtbJyYls9uMj281NWlEkKq0XP0=',
            brand: null,
            clickRedirectLinkoffTrackingUrl: null,
            logo: null,
            lotagline: null,
            rating: '0',
            slots: 'HSR_AA',
            vanityUrl: null,
            rank: '2',
            position: '2',
            __typename: 'SponsoredListing',
          },
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Tavistock Hotel',
            images: [
              {
                image: {
                  url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/70000/62800/62769/bfa2cf87_b.jpg',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: {
                  url: 'https://images.trvl-media.com/hotels/1000000/70000/62800/62769/6556032b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                imageId: '458609800',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/70000/62800/62769/e5ab6ae7.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '458609016',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/70000/62800/62769/87991f70.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '654968702',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/70000/62800/62769/fa91ec20.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '458609960',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£130',
            type: 'HOTEL',
            latLong: {
              latitude: 51.524088,
              longitude: -0.128768,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/62769',
            removeUrl: '/api/ucs/shortlist/remove/62769',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '62769',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: {
            actionDetails: {
              name: 'EXTERNAL_LINK',
              __typename: 'ActionDetails',
            },
            icon: {
              description: '',
              id: 'chevron_right',
              __typename: 'Icon',
            },
            linkUrl:
              'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2FHotel-Search%3FregionId%3D178279%26destination%3DLondon%2B%2528and%2Bvicinity%2529%252C%2BEngland%252C%2BUnited%2BKingdom%26startDate%3D2022-08-18%26endDate%3D2022-08-19%26adults%3D2%26children%3D%26sort%3DRECOMMENDED%26semdtl%3D%26userIntent%3D%26price%3D0%26price%3D300%26selected%3D62769',
            referrerId: ':LodgingCard.SignIn:2',
            text: 'Sign in for Member Price',
            __typename: 'MessagingAction',
          },
        },
        {
          __typename: 'Property',
          id: '46218383',
          name: 'Radisson RED Hotel London Heathrow',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/47000000/46220000/46218400/46218383/1c38feb5_b.jpg',
              __typename: 'Image',
            },
            fallbackImage: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/47000000/46220000/46218400/46218383/8372523d.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: null,
            tertiary: {
              text: 'Ad',
              theme_temp: 'PROMOTED',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£160',
                      accessibilityLabel: 'The price is £160',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£160',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£160',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.9,
            localizedScore: '3.9',
            total: 119,
            localizedTotal: '119 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.9 / 5 (119 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.9 out of 5 Good (119 reviews)',
              value: '3.9/5 Good (119 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Radisson-RED-Hotel-London-Heathrow.h46218383.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316609&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=3000662662&trackingData=AAAAEBpjGLZPjhEITu6WWORp43A0RB8evV1vZroPYqHWVqD78Mf0Z_lBSty7GzZ78bq5cJhibUAvDGzeO3Vum4ME6AeuZkCMrIH578NxCzugOOMw7Wn5-IENx166q8DDWc4UVxeM260_msIxrTT-v8IOChmTQJ9BezRE-6ydzatngE8GqbgKqf3FSRGDEw588_kyAkeFu7tVSexYGCSc-CsId_03WUwjSjVoBsYkSAuozh6F5pMWXQbWLxeKcMXpe_mi4iLoQA-C901VHm_K0yVwboLFtcqcEQ-xAauPEP8mpIL1ZpIm7yuoBN6wVUCk7ChEl8hw43hnjt_COvOjTi7tE6qUYpUCkTN9-hLRWiFdaygqx8d8zgbeN9lQzWcO7o6uM6hugn_B9qamnwtvCdG0ENZLkKzozLGBowLoQbqh5gHcTK0G_RypdogaU_2V3U7HVRKFwln9AbX-Vwe8DkYQy9W3M464MEepc-wd6QJnTBJx_2oWPva6z3DJ27pOjV8Nzwhs8Iy7qRufy9Dxc-BV7Sm7b_f2Vk4bA64vz-FCY2qR3oapxtbxvJESNPGFKlfvVMj0No_EEzqW6o9WSsr5EcggYUNd4yG--uaYueZfislxfuSZW_CAZP3YZ-EPS-Sg4xe90gasA2aiA9foSYa_svWocJ6EyNfw4R22fZ8u7sqeT2zpShp_5TqUVF2tBXbWA7zR_JVCZ2I8aRbaKv3AOOkWlI5q8T3fHN9prVV79wdWKlLBabvPua20QfeOfS3GBtRO7hR5IoMtA6-Xokd2DFbgdM06R2DdWxFI9EbwtrFo-j7dhwcWcCgCSXz_3pM7gG-FFUjdIypd-sltB_Cog4vOZpDG4XgoHk-npzum7_b7cqeKuYItVwZdwB_Iw6T61U6GeOmA-0lCI6Dets8gteJlShI9RrGxg-vWcFBBoVEPCRkc4pIbEzSyxXW3CtGZxc-Y7woRp0Jl9ifhUEVanwUtePITaVn0pjpEdw_SxKuB4QEqkFG9mnCv9zC4gakJMLtZ9ZC-p9fyBwkmSosmW8SdUoBoHKJY1OKuuubnGNepjG0AcQ_iFFBLKpgppIyzznquc7yBnYdvOZF6r6FRGXLE7UcOrGXrJ9ij4QIcwkGs6CkzPxyczGbLGT8HNxe1SA%3D%3D&rank=3&testVersionOverride=Buttercup&slots=HSR_DYN&position=3&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=160&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314026223&selectedRatePlan=381118200',
              relativePath:
                '/London-Hotels-Radisson-RED-Hotel-London-Heathrow.h46218383.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316609&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=3000662662&trackingData=AAAAEBpjGLZPjhEITu6WWORp43A0RB8evV1vZroPYqHWVqD78Mf0Z_lBSty7GzZ78bq5cJhibUAvDGzeO3Vum4ME6AeuZkCMrIH578NxCzugOOMw7Wn5-IENx166q8DDWc4UVxeM260_msIxrTT-v8IOChmTQJ9BezRE-6ydzatngE8GqbgKqf3FSRGDEw588_kyAkeFu7tVSexYGCSc-CsId_03WUwjSjVoBsYkSAuozh6F5pMWXQbWLxeKcMXpe_mi4iLoQA-C901VHm_K0yVwboLFtcqcEQ-xAauPEP8mpIL1ZpIm7yuoBN6wVUCk7ChEl8hw43hnjt_COvOjTi7tE6qUYpUCkTN9-hLRWiFdaygqx8d8zgbeN9lQzWcO7o6uM6hugn_B9qamnwtvCdG0ENZLkKzozLGBowLoQbqh5gHcTK0G_RypdogaU_2V3U7HVRKFwln9AbX-Vwe8DkYQy9W3M464MEepc-wd6QJnTBJx_2oWPva6z3DJ27pOjV8Nzwhs8Iy7qRufy9Dxc-BV7Sm7b_f2Vk4bA64vz-FCY2qR3oapxtbxvJESNPGFKlfvVMj0No_EEzqW6o9WSsr5EcggYUNd4yG--uaYueZfislxfuSZW_CAZP3YZ-EPS-Sg4xe90gasA2aiA9foSYa_svWocJ6EyNfw4R22fZ8u7sqeT2zpShp_5TqUVF2tBXbWA7zR_JVCZ2I8aRbaKv3AOOkWlI5q8T3fHN9prVV79wdWKlLBabvPua20QfeOfS3GBtRO7hR5IoMtA6-Xokd2DFbgdM06R2DdWxFI9EbwtrFo-j7dhwcWcCgCSXz_3pM7gG-FFUjdIypd-sltB_Cog4vOZpDG4XgoHk-npzum7_b7cqeKuYItVwZdwB_Iw6T61U6GeOmA-0lCI6Dets8gteJlShI9RrGxg-vWcFBBoVEPCRkc4pIbEzSyxXW3CtGZxc-Y7woRp0Jl9ifhUEVanwUtePITaVn0pjpEdw_SxKuB4QEqkFG9mnCv9zC4gakJMLtZ9ZC-p9fyBwkmSosmW8SdUoBoHKJY1OKuuubnGNepjG0AcQ_iFFBLKpgppIyzznquc7yBnYdvOZF6r6FRGXLE7UcOrGXrJ9ij4QIcwkGs6CkzPxyczGbLGT8HNxe1SA%3D%3D&rank=3&testVersionOverride=Buttercup&slots=HSR_DYN&position=3&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=160&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314026223&selectedRatePlan=381118200',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:3',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: {
            id: '668433',
            clickRedirectTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/ClRedirect?testVersionOverride=Buttercup&destinationUrl=&rank=3&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEBpjGLZPjhEITu6WWORp43A0RB8evV1vZroPYqHWVqD78Mf0Z_lBSty7GzZ78bq5cJhibUAvDGzeO3Vum4ME6AeuZkCMrIH578NxCzugOOMw7Wn5-IENx166q8DDWc4UVxeM260_msIxrTT-v8IOChmTQJ9BezRE-6ydzatngE8GqbgKqf3FSRGDEw588_kyAkeFu7tVSexYGCSc-CsId_03WUwjSjVoBsYkSAuozh6F5pMWXQbWLxeKcMXpe_mi4iLoQA-C901VHm_K0yVwboLFtcqcEQ-xAauPEP8mpIL1ZpIm7yuoBN6wVUCk7ChEl8hw43hnjt_COvOjTi7tE6qUYpUCkTN9-hLRWiFdaygqx8d8zgbeN9lQzWcO7o6uM6hugn_B9qamnwtvCdG0ENZLkKzozLGBowLoQbqh5gHcTK0G_RypdogaU_2V3U7HVRKFwln9AbX-Vwe8DkYQy9W3M464MEepc-wd6QJnTBJx_2oWPva6z3DJ27pOjV8Nzwhs8Iy7qRufy9Dxc-BV7Sm7b_f2Vk4bA64vz-FCY2qR3oapxtbxvJESNPGFKlfvVMj0No_EEzqW6o9WSsr5EcggYUNd4yG--uaYueZfislxfuSZW_CAZP3YZ-EPS-Sg4xe90gasA2aiA9foSYa_svWocJ6EyNfw4R22fZ8u7sqeT2zpShp_5TqUVF2tBXbWA7zR_JVCZ2I8aRbaKv3AOOkWlI5q8T3fHN9prVV79wdWKlLBabvPua20QfeOfS3GBtRO7hR5IoMtA6-Xokd2DFbgdM06R2DdWxFI9EbwtrFo-j7dhwcWcCgCSXz_3pM7gG-FFUjdIypd-sltB_Cog4vOZpDG4XgoHk-npzum7_b7cqeKuYItVwZdwB_Iw6T61U6GeOmA-0lCI6Dets8gteJlShI9RrGxg-vWcFBBoVEPCRkc4pIbEzSyxXW3CtGZxc-Y7woRp0Jl9ifhUEVanwUtePITaVn0pjpEdw_SxKuB4QEqkFG9mnCv9zC4gakJMLtZ9ZC-p9fyBwkmSosmW8SdUoBoHKJY1OKuuubnGNepjG0AcQ_iFFBLKpgppIyzznquc7yBnYdvOZF6r6FRGXLE7UcOrGXrJ9ij4QIcwkGs6CkzPxyczGbLGT8HNxe1SA==&slots=HSR_DYN&position=3&beaconIssued=2022-08-10T13:48:35',
            clickTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Cl?testVersionOverride=Buttercup&rank=3&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEBpjGLZPjhEITu6WWORp43A0RB8evV1vZroPYqHWVqD78Mf0Z_lBSty7GzZ78bq5cJhibUAvDGzeO3Vum4ME6AeuZkCMrIH578NxCzugOOMw7Wn5-IENx166q8DDWc4UVxeM260_msIxrTT-v8IOChmTQJ9BezRE-6ydzatngE8GqbgKqf3FSRGDEw588_kyAkeFu7tVSexYGCSc-CsId_03WUwjSjVoBsYkSAuozh6F5pMWXQbWLxeKcMXpe_mi4iLoQA-C901VHm_K0yVwboLFtcqcEQ-xAauPEP8mpIL1ZpIm7yuoBN6wVUCk7ChEl8hw43hnjt_COvOjTi7tE6qUYpUCkTN9-hLRWiFdaygqx8d8zgbeN9lQzWcO7o6uM6hugn_B9qamnwtvCdG0ENZLkKzozLGBowLoQbqh5gHcTK0G_RypdogaU_2V3U7HVRKFwln9AbX-Vwe8DkYQy9W3M464MEepc-wd6QJnTBJx_2oWPva6z3DJ27pOjV8Nzwhs8Iy7qRufy9Dxc-BV7Sm7b_f2Vk4bA64vz-FCY2qR3oapxtbxvJESNPGFKlfvVMj0No_EEzqW6o9WSsr5EcggYUNd4yG--uaYueZfislxfuSZW_CAZP3YZ-EPS-Sg4xe90gasA2aiA9foSYa_svWocJ6EyNfw4R22fZ8u7sqeT2zpShp_5TqUVF2tBXbWA7zR_JVCZ2I8aRbaKv3AOOkWlI5q8T3fHN9prVV79wdWKlLBabvPua20QfeOfS3GBtRO7hR5IoMtA6-Xokd2DFbgdM06R2DdWxFI9EbwtrFo-j7dhwcWcCgCSXz_3pM7gG-FFUjdIypd-sltB_Cog4vOZpDG4XgoHk-npzum7_b7cqeKuYItVwZdwB_Iw6T61U6GeOmA-0lCI6Dets8gteJlShI9RrGxg-vWcFBBoVEPCRkc4pIbEzSyxXW3CtGZxc-Y7woRp0Jl9ifhUEVanwUtePITaVn0pjpEdw_SxKuB4QEqkFG9mnCv9zC4gakJMLtZ9ZC-p9fyBwkmSosmW8SdUoBoHKJY1OKuuubnGNepjG0AcQ_iFFBLKpgppIyzznquc7yBnYdvOZF6r6FRGXLE7UcOrGXrJ9ij4QIcwkGs6CkzPxyczGbLGT8HNxe1SA==&slots=HSR_DYN&position=3&beaconIssued=2022-08-10T13:48:35',
            details:
              "New brand for London Heathrow, Radisson RED Heathrow welcome you to experience this fabulous property, including ICON'S bar & Pace",
            detailsHeadline: 'Bright Lights RED Mini',
            hotelImage:
              'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/47000000/46220000/46218400/46218383/1c38feb5_b.jpg',
            impressionTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Impr?testVersionOverride=Buttercup&rank=3&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEBpjGLZPjhEITu6WWORp43A0RB8evV1vZroPYqHWVqD78Mf0Z_lBSty7GzZ78bq5cJhibUAvDGzeO3Vum4ME6AeuZkCMrIH578NxCzugOOMw7Wn5-IENx166q8DDWc4UVxeM260_msIxrTT-v8IOChmTQJ9BezRE-6ydzatngE8GqbgKqf3FSRGDEw588_kyAkeFu7tVSexYGCSc-CsId_03WUwjSjVoBsYkSAuozh6F5pMWXQbWLxeKcMXpe_mi4iLoQA-C901VHm_K0yVwboLFtcqcEQ-xAauPEP8mpIL1ZpIm7yuoBN6wVUCk7ChEl8hw43hnjt_COvOjTi7tE6qUYpUCkTN9-hLRWiFdaygqx8d8zgbeN9lQzWcO7o6uM6hugn_B9qamnwtvCdG0ENZLkKzozLGBowLoQbqh5gHcTK0G_RypdogaU_2V3U7HVRKFwln9AbX-Vwe8DkYQy9W3M464MEepc-wd6QJnTBJx_2oWPva6z3DJ27pOjV8Nzwhs8Iy7qRufy9Dxc-BV7Sm7b_f2Vk4bA64vz-FCY2qR3oapxtbxvJESNPGFKlfvVMj0No_EEzqW6o9WSsr5EcggYUNd4yG--uaYueZfislxfuSZW_CAZP3YZ-EPS-Sg4xe90gasA2aiA9foSYa_svWocJ6EyNfw4R22fZ8u7sqeT2zpShp_5TqUVF2tBXbWA7zR_JVCZ2I8aRbaKv3AOOkWlI5q8T3fHN9prVV79wdWKlLBabvPua20QfeOfS3GBtRO7hR5IoMtA6-Xokd2DFbgdM06R2DdWxFI9EbwtrFo-j7dhwcWcCgCSXz_3pM7gG-FFUjdIypd-sltB_Cog4vOZpDG4XgoHk-npzum7_b7cqeKuYItVwZdwB_Iw6T61U6GeOmA-0lCI6Dets8gteJlShI9RrGxg-vWcFBBoVEPCRkc4pIbEzSyxXW3CtGZxc-Y7woRp0Jl9ifhUEVanwUtePITaVn0pjpEdw_SxKuB4QEqkFG9mnCv9zC4gakJMLtZ9ZC-p9fyBwkmSosmW8SdUoBoHKJY1OKuuubnGNepjG0AcQ_iFFBLKpgppIyzznquc7yBnYdvOZF6r6FRGXLE7UcOrGXrJ9ij4QIcwkGs6CkzPxyczGbLGT8HNxe1SA==&slots=HSR_DYN&position=3&beaconIssued=2022-08-10T13:48:35',
            trackingData:
              'AAAAEBpjGLZPjhEITu6WWORp43A0RB8evV1vZroPYqHWVqD78Mf0Z_lBSty7GzZ78bq5cJhibUAvDGzeO3Vum4ME6AeuZkCMrIH578NxCzugOOMw7Wn5-IENx166q8DDWc4UVxeM260_msIxrTT-v8IOChmTQJ9BezRE-6ydzatngE8GqbgKqf3FSRGDEw588_kyAkeFu7tVSexYGCSc-CsId_03WUwjSjVoBsYkSAuozh6F5pMWXQbWLxeKcMXpe_mi4iLoQA-C901VHm_K0yVwboLFtcqcEQ-xAauPEP8mpIL1ZpIm7yuoBN6wVUCk7ChEl8hw43hnjt_COvOjTi7tE6qUYpUCkTN9-hLRWiFdaygqx8d8zgbeN9lQzWcO7o6uM6hugn_B9qamnwtvCdG0ENZLkKzozLGBowLoQbqh5gHcTK0G_RypdogaU_2V3U7HVRKFwln9AbX-Vwe8DkYQy9W3M464MEepc-wd6QJnTBJx_2oWPva6z3DJ27pOjV8Nzwhs8Iy7qRufy9Dxc-BV7Sm7b_f2Vk4bA64vz-FCY2qR3oapxtbxvJESNPGFKlfvVMj0No_EEzqW6o9WSsr5EcggYUNd4yG--uaYueZfislxfuSZW_CAZP3YZ-EPS-Sg4xe90gasA2aiA9foSYa_svWocJ6EyNfw4R22fZ8u7sqeT2zpShp_5TqUVF2tBXbWA7zR_JVCZ2I8aRbaKv3AOOkWlI5q8T3fHN9prVV79wdWKlLBabvPua20QfeOfS3GBtRO7hR5IoMtA6-Xokd2DFbgdM06R2DdWxFI9EbwtrFo-j7dhwcWcCgCSXz_3pM7gG-FFUjdIypd-sltB_Cog4vOZpDG4XgoHk-npzum7_b7cqeKuYItVwZdwB_Iw6T61U6GeOmA-0lCI6Dets8gteJlShI9RrGxg-vWcFBBoVEPCRkc4pIbEzSyxXW3CtGZxc-Y7woRp0Jl9ifhUEVanwUtePITaVn0pjpEdw_SxKuB4QEqkFG9mnCv9zC4gakJMLtZ9ZC-p9fyBwkmSosmW8SdUoBoHKJY1OKuuubnGNepjG0AcQ_iFFBLKpgppIyzznquc7yBnYdvOZF6r6FRGXLE7UcOrGXrJ9ij4QIcwkGs6CkzPxyczGbLGT8HNxe1SA==',
            brand: null,
            clickRedirectLinkoffTrackingUrl: null,
            logo: null,
            lotagline: null,
            rating: '0',
            slots: 'HSR_DYN',
            vanityUrl: null,
            rank: '3',
            position: '3',
            __typename: 'SponsoredListing',
          },
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Radisson RED Hotel London Heathrow',
            images: [
              {
                image: {
                  url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/47000000/46220000/46218400/46218383/1c38feb5_b.jpg',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: {
                  url: 'https://images.trvl-media.com/hotels/47000000/46220000/46218400/46218383/8372523d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                imageId: '638874977',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/47000000/46220000/46218400/46218383/71c5648b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Indoor pool',
                  __typename: 'Image',
                },
                subjectId: 30002,
                fallbackImage: null,
                imageId: '458299812',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/47000000/46220000/46218400/46218383/262871e9.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '556821666',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/47000000/46220000/46218400/46218383/78601c68.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '638874970',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£160',
            type: 'HOTEL',
            latLong: {
              latitude: 51.482587,
              longitude: -0.450547,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'West Drayton',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/46218383',
            removeUrl: '/api/ucs/shortlist/remove/46218383',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '46218383',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'MessageResult',
          title: {
            text: 'You could be seeing lower prices',
            icon: null,
            mark: {
              description: 'You could be seeing lower prices',
              id: 'mod_exp',
              __typename: 'LodgingMark',
            },
            illustration: null,
            theme: null,
            __typename: 'MessagingResultTitle',
          },
          subtitle: {
            text: 'With member prices, you could save 10% or more right now on thousands of properties.',
            icon: null,
            mark: null,
            illustration: null,
            theme: null,
            __typename: 'MessagingResultTitle',
          },
          action: {
            primary: {
              actionDetails: null,
              linkUrl:
                'https://www.expedia.co.uk/user/createaccount?uurl=e3id%3Dredr%26rurl%3D%2FHotel-Search%3FregionId%3D178279%26destination%3DLondon%2B%2528and%2Bvicinity%2529%252C%2BEngland%252C%2BUnited%2BKingdom%26startDate%3D2022-08-18%26endDate%3D2022-08-19%26adults%3D2%26children%3D%26sort%3DRECOMMENDED%26semdtl%3D%26userIntent%3D%26price%3D0%26price%3D300&fromheader=true',
              referrerId: ':LoginCard.CreateAccount',
              text: "Sign up, it's free",
              __typename: 'MessagingAction',
            },
            secondary: {
              actionDetails: null,
              linkUrl:
                'https://www.expedia.co.uk/user/signin?uurl=e3id%3Dredr%26rurl%3D%2FHotel-Search%3FregionId%3D178279%26destination%3DLondon%2B%2528and%2Bvicinity%2529%252C%2BEngland%252C%2BUnited%2BKingdom%26startDate%3D2022-08-18%26endDate%3D2022-08-19%26adults%3D2%26children%3D%26sort%3DRECOMMENDED%26semdtl%3D%26userIntent%3D%26price%3D0%26price%3D300',
              referrerId: ':LoginCard.SignIn',
              text: 'Sign in',
              __typename: 'MessagingAction',
            },
            __typename: 'MessagingResultAction',
          },
          index: 3,
          type: 'LOGIN',
          content: [],
        },
        {
          __typename: 'Property',
          id: '470865',
          name: 'St Martins Lane London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/480000/470900/470865/c77aa178_b.jpg',
              __typename: 'Image',
            },
            fallbackImage: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/480000/470900/470865/e285b716.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: '35% off',
              theme_temp: 'DEAL_GENERIC',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            tertiary: {
              text: 'Ad',
              theme_temp: 'PROMOTED',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'STRIKEOUT',
                    price: {
                      formatted: '£428',
                      accessibilityLabel: 'The price was £428',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: {
                      content: [
                        'This price is the standard rate on our site as provided by the property based on your search.',
                      ],
                      primaryUIButton: {
                        accessibility: null,
                        primary: 'Close',
                        __typename: 'UIPrimaryButton',
                      },
                      __typename: 'LodgingPlainDialog',
                    },
                  },
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£278',
                      accessibilityLabel: 'The price is £278',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£278',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: {
              formatted: '£428',
              __typename: 'Money',
            },
            disclaimer: {
              value: 'This price is the standard rate on our site as provided by the property based on your search.',
              __typename: 'LodgingPlainMessage',
            },
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£278',
                  __typename: 'Money',
                },
                strikeOut: {
                  formatted: '£428',
                  __typename: 'Money',
                },
                loyaltyPrice: null,
                disclaimer: {
                  value:
                    'This price is the standard rate on our site as provided by the property based on your search.',
                  __typename: 'LodgingPlainMessage',
                },
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.6,
            localizedScore: '4.6',
            total: 1002,
            localizedTotal: '1,002 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.6 / 5 (1,002 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.6 out of 5 Wonderful (1,002 reviews)',
              value: '4.6/5 Wonderful (1,002 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-St-Martins-Lane-London.h470865.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316612&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179536&trackingData=AAAAEC9W4F1SX4sb0P61LD5x9PBwu3Ewem2oBzl-w1SsUuxK4f9pu_38CP9Bu5eAMNCPBP-j36jfMoH7xhjTDzJx5P5ysYeD8vUFrTwhbgvzrrLjH3XCJNBXgspcmYFglRiUqSGjsuOZ0p-HlTT9i5WvbqLzqAztDsgz6iU6Mr0Vq0vZd1H8Mciei7T19RxlYoCEnnpvToPNBbO9x6zoUst1YjB-GQwyiXeyf0IRt87TnWSDLv47tJxgxxo7PU6IAes1CP0E9sVezXADr2_87ZYa0do0KZ4k1G3_0bhN5EZ-oGqvfbQpj5HwlTgwVAAXpBuN6KXeRSHAcXBKVMT0wAJljQe5Bda5y3ZCTEqfkpy2AgkSTWgvVpoFF8P3tabumLy5qP5qR-2OjqPSAuYhkKkY1CRPY9AY6shGLpUtGx7o4jGMOBq46e3BnkGqmpSKGTTwphGCemBDZg2HGVWPAJpTBILj1AcDgGv38kS6aqM0J4e7rTU-rHv_U9RqgtnR-JP0L2gAOV0LdtTd0cAsqtR5m7fqakgUnuibMKXTMYorSXhtXTyaO7oJq-MZf2owMtS868iwEUBCVS1uB3JMXAUiptxEQH8l4owk7JaXfHVvBqefFSvx7IPlKpEoTFeVtLQQ1Pn55ptnOvY39qN4BXZdp-an0X0zwftI6AXU8FGNWf3mPH_bo4QgUYcITpPl_UAXrBEHDjZ1gV7z1H8O0zkQyfQMceJ7wP8H0FWQPn1qmiij4IcIlvIdQ6W8hfUvpX9u9uD3mekjN1ogV5HuF49_FEpP7jpE3CwnImV2ulu-HlaaeScJlRLHOk2yb2U668BUW958AaVeL4BQeWBICkNVeAGO29CfFt-YTpjBJ9StDevK-ESAZ2kMYiR4fiRtRpemQ3PLwmJSGtLQ5BKtrYdApbaWwH4OLD2J00ALzhjU-7rKxBi-3ZFZsfMRmSEoPQViTx2_zeKaanQjLRstbH-yEcwD3lumCEupUB4tsB6pJDTKS0TbkUxJn3G9LvZC54PGDVZZKahCkY2loAPPE6b94ffq5phFIepA8uu4YugZCXI2wLfRdlyY1E3ZSUpx3M7piEZTTzM6lQYIBYqJSHNPPmkVY-w5x6hMFdbLov9IerJADMG1TYXVJGPuFiFL7Dwukz9OnsuklH-I2YZjyRY9mFc%3D&rank=4&testVersionOverride=Buttercup&slots=HSR_AB&position=4&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=278&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200722341&selectedRatePlan=206981671',
              relativePath:
                '/London-Hotels-St-Martins-Lane-London.h470865.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316612&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179536&trackingData=AAAAEC9W4F1SX4sb0P61LD5x9PBwu3Ewem2oBzl-w1SsUuxK4f9pu_38CP9Bu5eAMNCPBP-j36jfMoH7xhjTDzJx5P5ysYeD8vUFrTwhbgvzrrLjH3XCJNBXgspcmYFglRiUqSGjsuOZ0p-HlTT9i5WvbqLzqAztDsgz6iU6Mr0Vq0vZd1H8Mciei7T19RxlYoCEnnpvToPNBbO9x6zoUst1YjB-GQwyiXeyf0IRt87TnWSDLv47tJxgxxo7PU6IAes1CP0E9sVezXADr2_87ZYa0do0KZ4k1G3_0bhN5EZ-oGqvfbQpj5HwlTgwVAAXpBuN6KXeRSHAcXBKVMT0wAJljQe5Bda5y3ZCTEqfkpy2AgkSTWgvVpoFF8P3tabumLy5qP5qR-2OjqPSAuYhkKkY1CRPY9AY6shGLpUtGx7o4jGMOBq46e3BnkGqmpSKGTTwphGCemBDZg2HGVWPAJpTBILj1AcDgGv38kS6aqM0J4e7rTU-rHv_U9RqgtnR-JP0L2gAOV0LdtTd0cAsqtR5m7fqakgUnuibMKXTMYorSXhtXTyaO7oJq-MZf2owMtS868iwEUBCVS1uB3JMXAUiptxEQH8l4owk7JaXfHVvBqefFSvx7IPlKpEoTFeVtLQQ1Pn55ptnOvY39qN4BXZdp-an0X0zwftI6AXU8FGNWf3mPH_bo4QgUYcITpPl_UAXrBEHDjZ1gV7z1H8O0zkQyfQMceJ7wP8H0FWQPn1qmiij4IcIlvIdQ6W8hfUvpX9u9uD3mekjN1ogV5HuF49_FEpP7jpE3CwnImV2ulu-HlaaeScJlRLHOk2yb2U668BUW958AaVeL4BQeWBICkNVeAGO29CfFt-YTpjBJ9StDevK-ESAZ2kMYiR4fiRtRpemQ3PLwmJSGtLQ5BKtrYdApbaWwH4OLD2J00ALzhjU-7rKxBi-3ZFZsfMRmSEoPQViTx2_zeKaanQjLRstbH-yEcwD3lumCEupUB4tsB6pJDTKS0TbkUxJn3G9LvZC54PGDVZZKahCkY2loAPPE6b94ffq5phFIepA8uu4YugZCXI2wLfRdlyY1E3ZSUpx3M7piEZTTzM6lQYIBYqJSHNPPmkVY-w5x6hMFdbLov9IerJADMG1TYXVJGPuFiFL7Dwukz9OnsuklH-I2YZjyRY9mFc%3D&rank=4&testVersionOverride=Buttercup&slots=HSR_AB&position=4&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=278&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200722341&selectedRatePlan=206981671',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:4',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: {
            id: '682020',
            clickRedirectTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/ClRedirect?testVersionOverride=Buttercup&destinationUrl=&rank=4&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEC9W4F1SX4sb0P61LD5x9PBwu3Ewem2oBzl-w1SsUuxK4f9pu_38CP9Bu5eAMNCPBP-j36jfMoH7xhjTDzJx5P5ysYeD8vUFrTwhbgvzrrLjH3XCJNBXgspcmYFglRiUqSGjsuOZ0p-HlTT9i5WvbqLzqAztDsgz6iU6Mr0Vq0vZd1H8Mciei7T19RxlYoCEnnpvToPNBbO9x6zoUst1YjB-GQwyiXeyf0IRt87TnWSDLv47tJxgxxo7PU6IAes1CP0E9sVezXADr2_87ZYa0do0KZ4k1G3_0bhN5EZ-oGqvfbQpj5HwlTgwVAAXpBuN6KXeRSHAcXBKVMT0wAJljQe5Bda5y3ZCTEqfkpy2AgkSTWgvVpoFF8P3tabumLy5qP5qR-2OjqPSAuYhkKkY1CRPY9AY6shGLpUtGx7o4jGMOBq46e3BnkGqmpSKGTTwphGCemBDZg2HGVWPAJpTBILj1AcDgGv38kS6aqM0J4e7rTU-rHv_U9RqgtnR-JP0L2gAOV0LdtTd0cAsqtR5m7fqakgUnuibMKXTMYorSXhtXTyaO7oJq-MZf2owMtS868iwEUBCVS1uB3JMXAUiptxEQH8l4owk7JaXfHVvBqefFSvx7IPlKpEoTFeVtLQQ1Pn55ptnOvY39qN4BXZdp-an0X0zwftI6AXU8FGNWf3mPH_bo4QgUYcITpPl_UAXrBEHDjZ1gV7z1H8O0zkQyfQMceJ7wP8H0FWQPn1qmiij4IcIlvIdQ6W8hfUvpX9u9uD3mekjN1ogV5HuF49_FEpP7jpE3CwnImV2ulu-HlaaeScJlRLHOk2yb2U668BUW958AaVeL4BQeWBICkNVeAGO29CfFt-YTpjBJ9StDevK-ESAZ2kMYiR4fiRtRpemQ3PLwmJSGtLQ5BKtrYdApbaWwH4OLD2J00ALzhjU-7rKxBi-3ZFZsfMRmSEoPQViTx2_zeKaanQjLRstbH-yEcwD3lumCEupUB4tsB6pJDTKS0TbkUxJn3G9LvZC54PGDVZZKahCkY2loAPPE6b94ffq5phFIepA8uu4YugZCXI2wLfRdlyY1E3ZSUpx3M7piEZTTzM6lQYIBYqJSHNPPmkVY-w5x6hMFdbLov9IerJADMG1TYXVJGPuFiFL7Dwukz9OnsuklH-I2YZjyRY9mFc=&slots=HSR_AB&position=4&beaconIssued=2022-08-10T13:48:35',
            clickTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Cl?testVersionOverride=Buttercup&rank=4&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEC9W4F1SX4sb0P61LD5x9PBwu3Ewem2oBzl-w1SsUuxK4f9pu_38CP9Bu5eAMNCPBP-j36jfMoH7xhjTDzJx5P5ysYeD8vUFrTwhbgvzrrLjH3XCJNBXgspcmYFglRiUqSGjsuOZ0p-HlTT9i5WvbqLzqAztDsgz6iU6Mr0Vq0vZd1H8Mciei7T19RxlYoCEnnpvToPNBbO9x6zoUst1YjB-GQwyiXeyf0IRt87TnWSDLv47tJxgxxo7PU6IAes1CP0E9sVezXADr2_87ZYa0do0KZ4k1G3_0bhN5EZ-oGqvfbQpj5HwlTgwVAAXpBuN6KXeRSHAcXBKVMT0wAJljQe5Bda5y3ZCTEqfkpy2AgkSTWgvVpoFF8P3tabumLy5qP5qR-2OjqPSAuYhkKkY1CRPY9AY6shGLpUtGx7o4jGMOBq46e3BnkGqmpSKGTTwphGCemBDZg2HGVWPAJpTBILj1AcDgGv38kS6aqM0J4e7rTU-rHv_U9RqgtnR-JP0L2gAOV0LdtTd0cAsqtR5m7fqakgUnuibMKXTMYorSXhtXTyaO7oJq-MZf2owMtS868iwEUBCVS1uB3JMXAUiptxEQH8l4owk7JaXfHVvBqefFSvx7IPlKpEoTFeVtLQQ1Pn55ptnOvY39qN4BXZdp-an0X0zwftI6AXU8FGNWf3mPH_bo4QgUYcITpPl_UAXrBEHDjZ1gV7z1H8O0zkQyfQMceJ7wP8H0FWQPn1qmiij4IcIlvIdQ6W8hfUvpX9u9uD3mekjN1ogV5HuF49_FEpP7jpE3CwnImV2ulu-HlaaeScJlRLHOk2yb2U668BUW958AaVeL4BQeWBICkNVeAGO29CfFt-YTpjBJ9StDevK-ESAZ2kMYiR4fiRtRpemQ3PLwmJSGtLQ5BKtrYdApbaWwH4OLD2J00ALzhjU-7rKxBi-3ZFZsfMRmSEoPQViTx2_zeKaanQjLRstbH-yEcwD3lumCEupUB4tsB6pJDTKS0TbkUxJn3G9LvZC54PGDVZZKahCkY2loAPPE6b94ffq5phFIepA8uu4YugZCXI2wLfRdlyY1E3ZSUpx3M7piEZTTzM6lQYIBYqJSHNPPmkVY-w5x6hMFdbLov9IerJADMG1TYXVJGPuFiFL7Dwukz9OnsuklH-I2YZjyRY9mFc=&slots=HSR_AB&position=4&beaconIssued=2022-08-10T13:48:35',
            details:
              'Indulge in luxury from the very heart of London, in a surrealist wonderland with floor-to-ceiling windows in every room',
            detailsHeadline: '5 star Hotel in Covent Garden',
            hotelImage:
              'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/480000/470900/470865/c77aa178_b.jpg',
            impressionTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Impr?testVersionOverride=Buttercup&rank=4&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEC9W4F1SX4sb0P61LD5x9PBwu3Ewem2oBzl-w1SsUuxK4f9pu_38CP9Bu5eAMNCPBP-j36jfMoH7xhjTDzJx5P5ysYeD8vUFrTwhbgvzrrLjH3XCJNBXgspcmYFglRiUqSGjsuOZ0p-HlTT9i5WvbqLzqAztDsgz6iU6Mr0Vq0vZd1H8Mciei7T19RxlYoCEnnpvToPNBbO9x6zoUst1YjB-GQwyiXeyf0IRt87TnWSDLv47tJxgxxo7PU6IAes1CP0E9sVezXADr2_87ZYa0do0KZ4k1G3_0bhN5EZ-oGqvfbQpj5HwlTgwVAAXpBuN6KXeRSHAcXBKVMT0wAJljQe5Bda5y3ZCTEqfkpy2AgkSTWgvVpoFF8P3tabumLy5qP5qR-2OjqPSAuYhkKkY1CRPY9AY6shGLpUtGx7o4jGMOBq46e3BnkGqmpSKGTTwphGCemBDZg2HGVWPAJpTBILj1AcDgGv38kS6aqM0J4e7rTU-rHv_U9RqgtnR-JP0L2gAOV0LdtTd0cAsqtR5m7fqakgUnuibMKXTMYorSXhtXTyaO7oJq-MZf2owMtS868iwEUBCVS1uB3JMXAUiptxEQH8l4owk7JaXfHVvBqefFSvx7IPlKpEoTFeVtLQQ1Pn55ptnOvY39qN4BXZdp-an0X0zwftI6AXU8FGNWf3mPH_bo4QgUYcITpPl_UAXrBEHDjZ1gV7z1H8O0zkQyfQMceJ7wP8H0FWQPn1qmiij4IcIlvIdQ6W8hfUvpX9u9uD3mekjN1ogV5HuF49_FEpP7jpE3CwnImV2ulu-HlaaeScJlRLHOk2yb2U668BUW958AaVeL4BQeWBICkNVeAGO29CfFt-YTpjBJ9StDevK-ESAZ2kMYiR4fiRtRpemQ3PLwmJSGtLQ5BKtrYdApbaWwH4OLD2J00ALzhjU-7rKxBi-3ZFZsfMRmSEoPQViTx2_zeKaanQjLRstbH-yEcwD3lumCEupUB4tsB6pJDTKS0TbkUxJn3G9LvZC54PGDVZZKahCkY2loAPPE6b94ffq5phFIepA8uu4YugZCXI2wLfRdlyY1E3ZSUpx3M7piEZTTzM6lQYIBYqJSHNPPmkVY-w5x6hMFdbLov9IerJADMG1TYXVJGPuFiFL7Dwukz9OnsuklH-I2YZjyRY9mFc=&slots=HSR_AB&position=4&beaconIssued=2022-08-10T13:48:35',
            trackingData:
              'AAAAEC9W4F1SX4sb0P61LD5x9PBwu3Ewem2oBzl-w1SsUuxK4f9pu_38CP9Bu5eAMNCPBP-j36jfMoH7xhjTDzJx5P5ysYeD8vUFrTwhbgvzrrLjH3XCJNBXgspcmYFglRiUqSGjsuOZ0p-HlTT9i5WvbqLzqAztDsgz6iU6Mr0Vq0vZd1H8Mciei7T19RxlYoCEnnpvToPNBbO9x6zoUst1YjB-GQwyiXeyf0IRt87TnWSDLv47tJxgxxo7PU6IAes1CP0E9sVezXADr2_87ZYa0do0KZ4k1G3_0bhN5EZ-oGqvfbQpj5HwlTgwVAAXpBuN6KXeRSHAcXBKVMT0wAJljQe5Bda5y3ZCTEqfkpy2AgkSTWgvVpoFF8P3tabumLy5qP5qR-2OjqPSAuYhkKkY1CRPY9AY6shGLpUtGx7o4jGMOBq46e3BnkGqmpSKGTTwphGCemBDZg2HGVWPAJpTBILj1AcDgGv38kS6aqM0J4e7rTU-rHv_U9RqgtnR-JP0L2gAOV0LdtTd0cAsqtR5m7fqakgUnuibMKXTMYorSXhtXTyaO7oJq-MZf2owMtS868iwEUBCVS1uB3JMXAUiptxEQH8l4owk7JaXfHVvBqefFSvx7IPlKpEoTFeVtLQQ1Pn55ptnOvY39qN4BXZdp-an0X0zwftI6AXU8FGNWf3mPH_bo4QgUYcITpPl_UAXrBEHDjZ1gV7z1H8O0zkQyfQMceJ7wP8H0FWQPn1qmiij4IcIlvIdQ6W8hfUvpX9u9uD3mekjN1ogV5HuF49_FEpP7jpE3CwnImV2ulu-HlaaeScJlRLHOk2yb2U668BUW958AaVeL4BQeWBICkNVeAGO29CfFt-YTpjBJ9StDevK-ESAZ2kMYiR4fiRtRpemQ3PLwmJSGtLQ5BKtrYdApbaWwH4OLD2J00ALzhjU-7rKxBi-3ZFZsfMRmSEoPQViTx2_zeKaanQjLRstbH-yEcwD3lumCEupUB4tsB6pJDTKS0TbkUxJn3G9LvZC54PGDVZZKahCkY2loAPPE6b94ffq5phFIepA8uu4YugZCXI2wLfRdlyY1E3ZSUpx3M7piEZTTzM6lQYIBYqJSHNPPmkVY-w5x6hMFdbLov9IerJADMG1TYXVJGPuFiFL7Dwukz9OnsuklH-I2YZjyRY9mFc=',
            brand: null,
            clickRedirectLinkoffTrackingUrl: null,
            logo: null,
            lotagline: null,
            rating: '0',
            slots: 'HSR_AB',
            vanityUrl: null,
            rank: '4',
            position: '4',
            __typename: 'SponsoredListing',
          },
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for St Martins Lane London',
            images: [
              {
                image: {
                  url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/480000/470900/470865/c77aa178_b.jpg',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: {
                  url: 'https://images.trvl-media.com/hotels/1000000/480000/470900/470865/e285b716.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                imageId: '22317130',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/480000/470900/470865/ce051663.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Property entrance',
                  __typename: 'Image',
                },
                subjectId: 91002,
                fallbackImage: null,
                imageId: '21165487',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/480000/470900/470865/2b66574f.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '22317051',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/480000/470900/470865/4d43d4f6.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '21165433',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£278',
            type: 'HOTEL',
            latLong: {
              latitude: 51.510409,
              longitude: -0.12697,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'City of Westminster',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/470865',
            removeUrl: '/api/ucs/shortlist/remove/470865',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '470865',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '55001',
          name: 'The Royal National Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/60000/55100/55001/ba45ba93_b.jpg',
              __typename: 'Image',
            },
            fallbackImage: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/60000/55100/55001/a5fd739d.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: {
              text: 'Ad',
              theme_temp: 'PROMOTED',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£135',
                      accessibilityLabel: 'The price is £135',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£135',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£135',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.8,
            localizedScore: '3.8',
            total: 2732,
            localizedTotal: '2,732 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.8 / 5 (2,732 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.8 out of 5 Good (2,732 reviews)',
              value: '3.8/5 Good (2,732 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Royal-National-Hotel.h55001.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316612&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&trackingData=AAAAEBrvM0KPdsSuup1dAzt0zgcV05Hq0RYX--1ml-whPveq0ohYEvtsv0nb_aMddkRvIZ8ma6OCF3CwYJt4FpnXEqcrZ5fHCx9ux0l3J_WZZs91ivTleCjnykV9df4LZ-3jEh08ZHFdA6y3yKDzk-by9UER0XuLhdgSb0lyIX8s3F2Kj_07cNIbBKt0rHibM4loste7YBJAbkMSE8_6EucBcGEwiVJDZm6ZkHppnQxprogVJ13ef_1KgGC8UCpNKJGU0Ftl5EBUwiT4dpsSicVjSwSp9kifMBPFuRrce4Tvtj4C6lTkTpz07H-U25yU_9xyJwO3sKqyMyxj-dAqtfntmfRb3o6kE6mSao312TjyiFhZ2BUEr_yeFSaSrXuvaMMVV8H8NrL1hm3e6WVgOv-f4By7ZF1xtFgRvPxKU7jFf9HCNx-vMFlU1nw0elhmeWx6rMB4T5qoj9GaNedqYB1UhVldNKE7a6IUdIpFVek1GQZ5Vr_0fwzQ4D2yBJMhxyKy7ulsjEYOOeVhiHSas93CagKELTj6s7NmIi7SjufHnUBkHHzGy08JeG2IX5PpEd1rL6uN4T0Dm3b95vOeJBbxWzVZTshaRERSwQuD0OWB5iZOKFHLRZNHpXhIcyBOs_VJ9XCZvtSSoKn1CJPKDxMc-Iu0h26jl-i6dmYp34RGqkMpHisthSUY744cMkyzWNW4bX5jktT8AJDJCccRT0gpAelM30pZFRvb0ROsxNPMlOp1-8BDGBJWdFEIiWrqaUJvLlMShrOojl9FqKYqOeYLf1we4Jt4stoeff31r9i8NRmEpeAi6uTXqe3NiQaqNsaIm94Tlb4sF8ZxFtdCR7QB6MJryfAECZvG6NYyiSylW4zJ0uXQ1pGdIIXjAuVQOea7nu3kc4ziILkuxpKn_B-O1eOePrEczuhWV3zRY6Bc1Ha-gmzS8SZSffSQZitKkE-oTh7VITQ3QQaS2GZPyFsOKGwlfOhiItfGL6HGByfKJtiNcumDB2EHW6T9DdfedYCP58QaQRZLFwiCvH05ARakUf6tLDYUe-lTCCt4xm2IJDOLOZcfVdkpAB0N1LQKLAZIQK9EyeYMh1d1HpKypZKq5Ifh5VZ_-OSloaJZ8bGL1uDQDTvGfnrjxnYorsxOpKtxzziTwGYGpmW5CEiwKd0gafY%3D&rank=5&testVersionOverride=Buttercup&slots=HSR_AC&position=5&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=135&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=219370986&selectedRatePlan=385204614',
              relativePath:
                '/London-Hotels-The-Royal-National-Hotel.h55001.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316612&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&trackingData=AAAAEBrvM0KPdsSuup1dAzt0zgcV05Hq0RYX--1ml-whPveq0ohYEvtsv0nb_aMddkRvIZ8ma6OCF3CwYJt4FpnXEqcrZ5fHCx9ux0l3J_WZZs91ivTleCjnykV9df4LZ-3jEh08ZHFdA6y3yKDzk-by9UER0XuLhdgSb0lyIX8s3F2Kj_07cNIbBKt0rHibM4loste7YBJAbkMSE8_6EucBcGEwiVJDZm6ZkHppnQxprogVJ13ef_1KgGC8UCpNKJGU0Ftl5EBUwiT4dpsSicVjSwSp9kifMBPFuRrce4Tvtj4C6lTkTpz07H-U25yU_9xyJwO3sKqyMyxj-dAqtfntmfRb3o6kE6mSao312TjyiFhZ2BUEr_yeFSaSrXuvaMMVV8H8NrL1hm3e6WVgOv-f4By7ZF1xtFgRvPxKU7jFf9HCNx-vMFlU1nw0elhmeWx6rMB4T5qoj9GaNedqYB1UhVldNKE7a6IUdIpFVek1GQZ5Vr_0fwzQ4D2yBJMhxyKy7ulsjEYOOeVhiHSas93CagKELTj6s7NmIi7SjufHnUBkHHzGy08JeG2IX5PpEd1rL6uN4T0Dm3b95vOeJBbxWzVZTshaRERSwQuD0OWB5iZOKFHLRZNHpXhIcyBOs_VJ9XCZvtSSoKn1CJPKDxMc-Iu0h26jl-i6dmYp34RGqkMpHisthSUY744cMkyzWNW4bX5jktT8AJDJCccRT0gpAelM30pZFRvb0ROsxNPMlOp1-8BDGBJWdFEIiWrqaUJvLlMShrOojl9FqKYqOeYLf1we4Jt4stoeff31r9i8NRmEpeAi6uTXqe3NiQaqNsaIm94Tlb4sF8ZxFtdCR7QB6MJryfAECZvG6NYyiSylW4zJ0uXQ1pGdIIXjAuVQOea7nu3kc4ziILkuxpKn_B-O1eOePrEczuhWV3zRY6Bc1Ha-gmzS8SZSffSQZitKkE-oTh7VITQ3QQaS2GZPyFsOKGwlfOhiItfGL6HGByfKJtiNcumDB2EHW6T9DdfedYCP58QaQRZLFwiCvH05ARakUf6tLDYUe-lTCCt4xm2IJDOLOZcfVdkpAB0N1LQKLAZIQK9EyeYMh1d1HpKypZKq5Ifh5VZ_-OSloaJZ8bGL1uDQDTvGfnrjxnYorsxOpKtxzziTwGYGpmW5CEiwKd0gafY%3D&rank=5&testVersionOverride=Buttercup&slots=HSR_AC&position=5&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=135&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=219370986&selectedRatePlan=385204614',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:5',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: {
            id: '682072',
            clickRedirectTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/ClRedirect?testVersionOverride=Buttercup&destinationUrl=&rank=5&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEBrvM0KPdsSuup1dAzt0zgcV05Hq0RYX--1ml-whPveq0ohYEvtsv0nb_aMddkRvIZ8ma6OCF3CwYJt4FpnXEqcrZ5fHCx9ux0l3J_WZZs91ivTleCjnykV9df4LZ-3jEh08ZHFdA6y3yKDzk-by9UER0XuLhdgSb0lyIX8s3F2Kj_07cNIbBKt0rHibM4loste7YBJAbkMSE8_6EucBcGEwiVJDZm6ZkHppnQxprogVJ13ef_1KgGC8UCpNKJGU0Ftl5EBUwiT4dpsSicVjSwSp9kifMBPFuRrce4Tvtj4C6lTkTpz07H-U25yU_9xyJwO3sKqyMyxj-dAqtfntmfRb3o6kE6mSao312TjyiFhZ2BUEr_yeFSaSrXuvaMMVV8H8NrL1hm3e6WVgOv-f4By7ZF1xtFgRvPxKU7jFf9HCNx-vMFlU1nw0elhmeWx6rMB4T5qoj9GaNedqYB1UhVldNKE7a6IUdIpFVek1GQZ5Vr_0fwzQ4D2yBJMhxyKy7ulsjEYOOeVhiHSas93CagKELTj6s7NmIi7SjufHnUBkHHzGy08JeG2IX5PpEd1rL6uN4T0Dm3b95vOeJBbxWzVZTshaRERSwQuD0OWB5iZOKFHLRZNHpXhIcyBOs_VJ9XCZvtSSoKn1CJPKDxMc-Iu0h26jl-i6dmYp34RGqkMpHisthSUY744cMkyzWNW4bX5jktT8AJDJCccRT0gpAelM30pZFRvb0ROsxNPMlOp1-8BDGBJWdFEIiWrqaUJvLlMShrOojl9FqKYqOeYLf1we4Jt4stoeff31r9i8NRmEpeAi6uTXqe3NiQaqNsaIm94Tlb4sF8ZxFtdCR7QB6MJryfAECZvG6NYyiSylW4zJ0uXQ1pGdIIXjAuVQOea7nu3kc4ziILkuxpKn_B-O1eOePrEczuhWV3zRY6Bc1Ha-gmzS8SZSffSQZitKkE-oTh7VITQ3QQaS2GZPyFsOKGwlfOhiItfGL6HGByfKJtiNcumDB2EHW6T9DdfedYCP58QaQRZLFwiCvH05ARakUf6tLDYUe-lTCCt4xm2IJDOLOZcfVdkpAB0N1LQKLAZIQK9EyeYMh1d1HpKypZKq5Ifh5VZ_-OSloaJZ8bGL1uDQDTvGfnrjxnYorsxOpKtxzziTwGYGpmW5CEiwKd0gafY=&slots=HSR_AC&position=5&beaconIssued=2022-08-10T13:48:35',
            clickTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Cl?testVersionOverride=Buttercup&rank=5&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEBrvM0KPdsSuup1dAzt0zgcV05Hq0RYX--1ml-whPveq0ohYEvtsv0nb_aMddkRvIZ8ma6OCF3CwYJt4FpnXEqcrZ5fHCx9ux0l3J_WZZs91ivTleCjnykV9df4LZ-3jEh08ZHFdA6y3yKDzk-by9UER0XuLhdgSb0lyIX8s3F2Kj_07cNIbBKt0rHibM4loste7YBJAbkMSE8_6EucBcGEwiVJDZm6ZkHppnQxprogVJ13ef_1KgGC8UCpNKJGU0Ftl5EBUwiT4dpsSicVjSwSp9kifMBPFuRrce4Tvtj4C6lTkTpz07H-U25yU_9xyJwO3sKqyMyxj-dAqtfntmfRb3o6kE6mSao312TjyiFhZ2BUEr_yeFSaSrXuvaMMVV8H8NrL1hm3e6WVgOv-f4By7ZF1xtFgRvPxKU7jFf9HCNx-vMFlU1nw0elhmeWx6rMB4T5qoj9GaNedqYB1UhVldNKE7a6IUdIpFVek1GQZ5Vr_0fwzQ4D2yBJMhxyKy7ulsjEYOOeVhiHSas93CagKELTj6s7NmIi7SjufHnUBkHHzGy08JeG2IX5PpEd1rL6uN4T0Dm3b95vOeJBbxWzVZTshaRERSwQuD0OWB5iZOKFHLRZNHpXhIcyBOs_VJ9XCZvtSSoKn1CJPKDxMc-Iu0h26jl-i6dmYp34RGqkMpHisthSUY744cMkyzWNW4bX5jktT8AJDJCccRT0gpAelM30pZFRvb0ROsxNPMlOp1-8BDGBJWdFEIiWrqaUJvLlMShrOojl9FqKYqOeYLf1we4Jt4stoeff31r9i8NRmEpeAi6uTXqe3NiQaqNsaIm94Tlb4sF8ZxFtdCR7QB6MJryfAECZvG6NYyiSylW4zJ0uXQ1pGdIIXjAuVQOea7nu3kc4ziILkuxpKn_B-O1eOePrEczuhWV3zRY6Bc1Ha-gmzS8SZSffSQZitKkE-oTh7VITQ3QQaS2GZPyFsOKGwlfOhiItfGL6HGByfKJtiNcumDB2EHW6T9DdfedYCP58QaQRZLFwiCvH05ARakUf6tLDYUe-lTCCt4xm2IJDOLOZcfVdkpAB0N1LQKLAZIQK9EyeYMh1d1HpKypZKq5Ifh5VZ_-OSloaJZ8bGL1uDQDTvGfnrjxnYorsxOpKtxzziTwGYGpmW5CEiwKd0gafY=&slots=HSR_AC&position=5&beaconIssued=2022-08-10T13:48:35',
            details:
              'Lively hotel with rooms to suit all occasions, from leisure to business. Extensive drinking & dining options, plus onsite parking.',
            detailsHeadline: 'Central London hotel near Kings Cross',
            hotelImage:
              'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/60000/55100/55001/ba45ba93_b.jpg',
            impressionTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Impr?testVersionOverride=Buttercup&rank=5&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEBrvM0KPdsSuup1dAzt0zgcV05Hq0RYX--1ml-whPveq0ohYEvtsv0nb_aMddkRvIZ8ma6OCF3CwYJt4FpnXEqcrZ5fHCx9ux0l3J_WZZs91ivTleCjnykV9df4LZ-3jEh08ZHFdA6y3yKDzk-by9UER0XuLhdgSb0lyIX8s3F2Kj_07cNIbBKt0rHibM4loste7YBJAbkMSE8_6EucBcGEwiVJDZm6ZkHppnQxprogVJ13ef_1KgGC8UCpNKJGU0Ftl5EBUwiT4dpsSicVjSwSp9kifMBPFuRrce4Tvtj4C6lTkTpz07H-U25yU_9xyJwO3sKqyMyxj-dAqtfntmfRb3o6kE6mSao312TjyiFhZ2BUEr_yeFSaSrXuvaMMVV8H8NrL1hm3e6WVgOv-f4By7ZF1xtFgRvPxKU7jFf9HCNx-vMFlU1nw0elhmeWx6rMB4T5qoj9GaNedqYB1UhVldNKE7a6IUdIpFVek1GQZ5Vr_0fwzQ4D2yBJMhxyKy7ulsjEYOOeVhiHSas93CagKELTj6s7NmIi7SjufHnUBkHHzGy08JeG2IX5PpEd1rL6uN4T0Dm3b95vOeJBbxWzVZTshaRERSwQuD0OWB5iZOKFHLRZNHpXhIcyBOs_VJ9XCZvtSSoKn1CJPKDxMc-Iu0h26jl-i6dmYp34RGqkMpHisthSUY744cMkyzWNW4bX5jktT8AJDJCccRT0gpAelM30pZFRvb0ROsxNPMlOp1-8BDGBJWdFEIiWrqaUJvLlMShrOojl9FqKYqOeYLf1we4Jt4stoeff31r9i8NRmEpeAi6uTXqe3NiQaqNsaIm94Tlb4sF8ZxFtdCR7QB6MJryfAECZvG6NYyiSylW4zJ0uXQ1pGdIIXjAuVQOea7nu3kc4ziILkuxpKn_B-O1eOePrEczuhWV3zRY6Bc1Ha-gmzS8SZSffSQZitKkE-oTh7VITQ3QQaS2GZPyFsOKGwlfOhiItfGL6HGByfKJtiNcumDB2EHW6T9DdfedYCP58QaQRZLFwiCvH05ARakUf6tLDYUe-lTCCt4xm2IJDOLOZcfVdkpAB0N1LQKLAZIQK9EyeYMh1d1HpKypZKq5Ifh5VZ_-OSloaJZ8bGL1uDQDTvGfnrjxnYorsxOpKtxzziTwGYGpmW5CEiwKd0gafY=&slots=HSR_AC&position=5&beaconIssued=2022-08-10T13:48:35',
            trackingData:
              'AAAAEBrvM0KPdsSuup1dAzt0zgcV05Hq0RYX--1ml-whPveq0ohYEvtsv0nb_aMddkRvIZ8ma6OCF3CwYJt4FpnXEqcrZ5fHCx9ux0l3J_WZZs91ivTleCjnykV9df4LZ-3jEh08ZHFdA6y3yKDzk-by9UER0XuLhdgSb0lyIX8s3F2Kj_07cNIbBKt0rHibM4loste7YBJAbkMSE8_6EucBcGEwiVJDZm6ZkHppnQxprogVJ13ef_1KgGC8UCpNKJGU0Ftl5EBUwiT4dpsSicVjSwSp9kifMBPFuRrce4Tvtj4C6lTkTpz07H-U25yU_9xyJwO3sKqyMyxj-dAqtfntmfRb3o6kE6mSao312TjyiFhZ2BUEr_yeFSaSrXuvaMMVV8H8NrL1hm3e6WVgOv-f4By7ZF1xtFgRvPxKU7jFf9HCNx-vMFlU1nw0elhmeWx6rMB4T5qoj9GaNedqYB1UhVldNKE7a6IUdIpFVek1GQZ5Vr_0fwzQ4D2yBJMhxyKy7ulsjEYOOeVhiHSas93CagKELTj6s7NmIi7SjufHnUBkHHzGy08JeG2IX5PpEd1rL6uN4T0Dm3b95vOeJBbxWzVZTshaRERSwQuD0OWB5iZOKFHLRZNHpXhIcyBOs_VJ9XCZvtSSoKn1CJPKDxMc-Iu0h26jl-i6dmYp34RGqkMpHisthSUY744cMkyzWNW4bX5jktT8AJDJCccRT0gpAelM30pZFRvb0ROsxNPMlOp1-8BDGBJWdFEIiWrqaUJvLlMShrOojl9FqKYqOeYLf1we4Jt4stoeff31r9i8NRmEpeAi6uTXqe3NiQaqNsaIm94Tlb4sF8ZxFtdCR7QB6MJryfAECZvG6NYyiSylW4zJ0uXQ1pGdIIXjAuVQOea7nu3kc4ziILkuxpKn_B-O1eOePrEczuhWV3zRY6Bc1Ha-gmzS8SZSffSQZitKkE-oTh7VITQ3QQaS2GZPyFsOKGwlfOhiItfGL6HGByfKJtiNcumDB2EHW6T9DdfedYCP58QaQRZLFwiCvH05ARakUf6tLDYUe-lTCCt4xm2IJDOLOZcfVdkpAB0N1LQKLAZIQK9EyeYMh1d1HpKypZKq5Ifh5VZ_-OSloaJZ8bGL1uDQDTvGfnrjxnYorsxOpKtxzziTwGYGpmW5CEiwKd0gafY=',
            brand: null,
            clickRedirectLinkoffTrackingUrl: null,
            logo: null,
            lotagline: null,
            rating: '0',
            slots: 'HSR_AC',
            vanityUrl: null,
            rank: '5',
            position: '5',
            __typename: 'SponsoredListing',
          },
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Royal National Hotel',
            images: [
              {
                image: {
                  url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/60000/55100/55001/ba45ba93_b.jpg',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55100/55001/a5fd739d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                imageId: '449705165',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55100/55001/84b106b4.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '601909108',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55100/55001/bd610ea5.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '442641073',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55100/55001/0b58ec05.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Breakfast area',
                  __typename: 'Image',
                },
                subjectId: 81001,
                fallbackImage: null,
                imageId: '442611144',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£135',
            type: 'HOTEL',
            latLong: {
              latitude: 51.523494,
              longitude: -0.127265,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/55001',
            removeUrl: '/api/ucs/shortlist/remove/55001',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '55001',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '3113039',
          name: 'Park Plaza Westminster Bridge London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/4000000/3120000/3113100/3113039/13f5a247.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£269',
                      accessibilityLabel: 'The price is £269',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£269',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£269',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.2,
            localizedScore: '4.2',
            total: 2088,
            localizedTotal: '2,088 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.2 / 5 (2,088 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.2 out of 5 Very good (2,088 reviews)',
              value: '4.2/5 Very good (2,088 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Park-Plaza-Westminster-Bridge-London.h3113039.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316612&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6054506&price=0%2C300&sort=RECOMMENDED&top_dp=269&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314307436&selectedRatePlan=382950044',
              relativePath:
                '/London-Hotels-Park-Plaza-Westminster-Bridge-London.h3113039.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316612&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6054506&price=0%2C300&sort=RECOMMENDED&top_dp=269&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314307436&selectedRatePlan=382950044',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:6',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Park Plaza Westminster Bridge London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/4000000/3120000/3113100/3113039/13f5a247.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '481690163',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/4000000/3120000/3113100/3113039/a92de415.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '377083888',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/4000000/3120000/3113100/3113039/4c9542a4.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Indoor pool',
                  __typename: 'Image',
                },
                subjectId: 30002,
                fallbackImage: null,
                imageId: '377084052',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/4000000/3120000/3113100/3113039/75cf72e1.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '377585679',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£269',
            type: 'HOTEL',
            latLong: {
              latitude: 51.501108,
              longitude: -0.117331,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/3113039',
            removeUrl: '/api/ucs/shortlist/remove/3113039',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '3113039',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '179',
          name: 'The Strand Palace Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/10000/200/179/ac85c784.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: null,
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£250',
                      accessibilityLabel: 'The price is £250',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£250',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£250',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.2,
            localizedScore: '4.2',
            total: 2102,
            localizedTotal: '2,102 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.2 / 5 (2,102 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.2 out of 5 Very good (2,102 reviews)',
              value: '4.2/5 Very good (2,102 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Strand-Palace-Hotel.h179.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316612&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179536&price=0%2C300&sort=RECOMMENDED&top_dp=250&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=210002712&selectedRatePlan=220014446',
              relativePath:
                '/London-Hotels-The-Strand-Palace-Hotel.h179.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316612&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179536&price=0%2C300&sort=RECOMMENDED&top_dp=250&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=210002712&selectedRatePlan=220014446',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:7',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Strand Palace Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/200/179/ac85c784.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '653975412',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/200/179/3e0796fa.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property',
                  __typename: 'Image',
                },
                subjectId: 91001,
                fallbackImage: null,
                imageId: '34075309',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/200/179/63199ad6.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '653974691',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/200/179/66f0f95f.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '437727370',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£250',
            type: 'HOTEL',
            latLong: {
              latitude: 51.510746,
              longitude: -0.120745,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'City of Westminster',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/179',
            removeUrl: '/api/ucs/shortlist/remove/179',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '179',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '12703815',
          name: 'Montcalm Royal London House - City Of London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/13000000/12710000/12703900/12703815/4bb2073b.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£216',
                      accessibilityLabel: 'The price is £216',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£216',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£216',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.4,
            localizedScore: '4.4',
            total: 1002,
            localizedTotal: '1,002 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.4 / 5 (1,002 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.4 out of 5 Excellent (1,002 reviews)',
              value: '4.4/5 Excellent (1,002 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Montcalm-Royal-London-House-City-Of-London.h12703815.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316611&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381624&price=0%2C300&sort=RECOMMENDED&top_dp=216&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201686370&selectedRatePlan=208435675',
              relativePath:
                '/London-Hotels-Montcalm-Royal-London-House-City-Of-London.h12703815.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316611&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381624&price=0%2C300&sort=RECOMMENDED&top_dp=216&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201686370&selectedRatePlan=208435675',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:8',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Montcalm Royal London House - City Of London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/13000000/12710000/12703900/12703815/4bb2073b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '530951060',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/13000000/12710000/12703900/12703815/31d17948.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property',
                  __typename: 'Image',
                },
                subjectId: 91001,
                fallbackImage: null,
                imageId: '45816821',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/13000000/12710000/12703900/12703815/7a637cf9.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Pool',
                  __typename: 'Image',
                },
                subjectId: 30000,
                fallbackImage: null,
                imageId: '530951062',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/13000000/12710000/12703900/12703815/27f27dd5.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '45816840',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£216',
            type: 'HOTEL',
            latLong: {
              latitude: 51.52171,
              longitude: -0.08583,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/12703815',
            removeUrl: '/api/ucs/shortlist/remove/12703815',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '12703815',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '55001',
          name: 'The Royal National Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/60000/55100/55001/a5fd739d.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£135',
                      accessibilityLabel: 'The price is £135',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£135',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£135',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.8,
            localizedScore: '3.8',
            total: 2732,
            localizedTotal: '2,732 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.8 / 5 (2,732 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.8 out of 5 Good (2,732 reviews)',
              value: '3.8/5 Good (2,732 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Royal-National-Hotel.h55001.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316614&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&price=0%2C300&sort=RECOMMENDED&top_dp=135&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=219370986&selectedRatePlan=385204614',
              relativePath:
                '/London-Hotels-The-Royal-National-Hotel.h55001.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316614&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&price=0%2C300&sort=RECOMMENDED&top_dp=135&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=219370986&selectedRatePlan=385204614',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:9',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Royal National Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55100/55001/a5fd739d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '449705165',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55100/55001/84b106b4.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '601909108',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55100/55001/bd610ea5.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '442641073',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55100/55001/0b58ec05.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Breakfast area',
                  __typename: 'Image',
                },
                subjectId: 81001,
                fallbackImage: null,
                imageId: '442611144',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£135',
            type: 'HOTEL',
            latLong: {
              latitude: 51.523494,
              longitude: -0.127265,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/55001',
            removeUrl: '/api/ucs/shortlist/remove/55001',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '55001',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '42297074',
          name: 'Zedwell Piccadilly',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/43000000/42300000/42297100/42297074/2eb374f4.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£133',
                      accessibilityLabel: 'The price is £133',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£133',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£133',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.9,
            localizedScore: '3.9',
            total: 1334,
            localizedTotal: '1,334 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.9 / 5 (1,334 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.9 out of 5 Good (1,334 reviews)',
              value: '3.9/5 Good (1,334 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Zedwell-Piccadilly-Trocadero.h42297074.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316613&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6054504&price=0%2C300&sort=RECOMMENDED&top_dp=133&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=315646345&selectedRatePlan=384270544',
              relativePath:
                '/London-Hotels-Zedwell-Piccadilly-Trocadero.h42297074.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316613&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6054504&price=0%2C300&sort=RECOMMENDED&top_dp=133&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=315646345&selectedRatePlan=384270544',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:10',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Zedwell Piccadilly',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/43000000/42300000/42297100/42297074/2eb374f4.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '701154262',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/43000000/42300000/42297100/42297074/b68fe944.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '115240031',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/43000000/42300000/42297100/42297074/32a56b0c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '701154343',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/43000000/42300000/42297100/42297074/c80ce833.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lobby',
                  __typename: 'Image',
                },
                subjectId: 10001,
                fallbackImage: null,
                imageId: '684972516',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£133',
            type: 'HOTEL',
            latLong: {
              latitude: 51.510115,
              longitude: -0.133079,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'Soho',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/42297074',
            removeUrl: '/api/ucs/shortlist/remove/42297074',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '42297074',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '83245150',
          name: 'City Sleeper at Royal National Hotel',
          propertyImage: {
            image: {
              description: 'Interior entrance',
              url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/84000000/83250000/83245200/83245150/9e09f4a7_b.jpg',
              __typename: 'Image',
            },
            fallbackImage: {
              description: 'Interior entrance',
              url: 'https://images.trvl-media.com/hotels/84000000/83250000/83245200/83245150/40aa6be7.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: {
              text: 'Ad',
              theme_temp: 'PROMOTED',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£165',
                      accessibilityLabel: 'The price is £165',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£165',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£165',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 0,
            localizedScore: null,
            total: 0,
            localizedTotal: null,
            superlative: null,
            localizedSubtitle: null,
            localizedSubtitleA11y: {
              accessibilityLabel: null,
              value: '',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-City-Sleeper-At-Royal-National-Hotel.h83245150.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316612&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&trackingData=AAAAELcKKDPRFJgrjB7o9tUvldWa5FDVjKTNrIK7CMqreub_zq22JXRf-EMEs49BwWQTCbmVNIlj0YBmfepf4U95nlinZogOuyzfBuyhrl2i3sxNucnNv7fhRIOYX0C0q2d3PVohqdDrQYVpCz8sOekGRuNlF-xjnTDZgWXXlEiqg5hgJHoDrtBWI0gnE_0iJDktH_MAOw_2_gXO_cLEYWXpeqpXpzR0kf9T3QR4ixIO6M4xiWU-e66IFd9e1iwJId2XF3mD9qPi8NORH12ThVW6KnFeA5UwXtBoTrR0tqNUryQqWFxCqKxdffgpXzfFEh-39Qrsokh0s414DRVKVvah0QWH2WkZmD7GDrcWIjsqYwJ9RZa0SVtoPdNby5drYFwua9eFwXEhlH8r0IwEa93UAedpdTP0AoOLhsM0wT72RTnYcHpnVO_dkbb0yeEwUAVRs1ZFbubft-Un1OgVA_eBQsuyvnFrrkK4-thHXVdAHqw8coZPfFXajiN7GAPoAA2-iBGLrrhMh7nRMOKylwaurl0pxhWijf4n5-g-PvHh29LgVD8eAe55gQFkk4vcTP_PeESptQhLyh4RQ70hXsJU-DOCHcY3vlK_YqY1sIhWq378NyLgPypvnu5k_frR5iq6AOdNmvB86j6gFAmd78VJzFeLIYxHnSkZLbhfY9-ivra8aXQ0ihivOX1ERIK2TpUGTpA5RqnlzqvAzFdZautb8QYPwc-UMR80laKoUL9p5bF5QUQcBNfXqwWcLADZ6c7JU8UkXDu4x0uydCxORb9fcv8u10p_leiDXBKv7RLzowUMgoMrAy6i9yEe5fnuriE1NlDnagQ-YCXzp6XOmOyFPYfE42eMX1-RVeGo7rZDntODORZQNuSxqv5K26H-_2AoAgXVZhqtn2zCSID0GxHfm0d0B2UEE6ROg9KKTMsv40qzcr2_AsNm3Ix_1ZxR_xqpRFnm25qfMspz5WaFOT8YROyd9Sc1MNDgckrhk_rxycmmNC8ZA6ZpdaRBnCU9XZoQzlyBd2A6dGMMHAYMx_KR0bJVPt33KFP3OucEhb9ez7Yn5kPvkplhoX6SgFUufjKfjx-EqStMEEOYo4rxH0oDG1lFXCHhaTqoraWDgMKT2HgYbdWDpVC_waF47yKVrDTsR14bxXu1sV1fWwVtobekfF0%3D&rank=6&testVersionOverride=Buttercup&slots=HSR_BA&position=11&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=165&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=319875468&selectedRatePlan=387063573',
              relativePath:
                '/London-Hotels-City-Sleeper-At-Royal-National-Hotel.h83245150.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316612&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&trackingData=AAAAELcKKDPRFJgrjB7o9tUvldWa5FDVjKTNrIK7CMqreub_zq22JXRf-EMEs49BwWQTCbmVNIlj0YBmfepf4U95nlinZogOuyzfBuyhrl2i3sxNucnNv7fhRIOYX0C0q2d3PVohqdDrQYVpCz8sOekGRuNlF-xjnTDZgWXXlEiqg5hgJHoDrtBWI0gnE_0iJDktH_MAOw_2_gXO_cLEYWXpeqpXpzR0kf9T3QR4ixIO6M4xiWU-e66IFd9e1iwJId2XF3mD9qPi8NORH12ThVW6KnFeA5UwXtBoTrR0tqNUryQqWFxCqKxdffgpXzfFEh-39Qrsokh0s414DRVKVvah0QWH2WkZmD7GDrcWIjsqYwJ9RZa0SVtoPdNby5drYFwua9eFwXEhlH8r0IwEa93UAedpdTP0AoOLhsM0wT72RTnYcHpnVO_dkbb0yeEwUAVRs1ZFbubft-Un1OgVA_eBQsuyvnFrrkK4-thHXVdAHqw8coZPfFXajiN7GAPoAA2-iBGLrrhMh7nRMOKylwaurl0pxhWijf4n5-g-PvHh29LgVD8eAe55gQFkk4vcTP_PeESptQhLyh4RQ70hXsJU-DOCHcY3vlK_YqY1sIhWq378NyLgPypvnu5k_frR5iq6AOdNmvB86j6gFAmd78VJzFeLIYxHnSkZLbhfY9-ivra8aXQ0ihivOX1ERIK2TpUGTpA5RqnlzqvAzFdZautb8QYPwc-UMR80laKoUL9p5bF5QUQcBNfXqwWcLADZ6c7JU8UkXDu4x0uydCxORb9fcv8u10p_leiDXBKv7RLzowUMgoMrAy6i9yEe5fnuriE1NlDnagQ-YCXzp6XOmOyFPYfE42eMX1-RVeGo7rZDntODORZQNuSxqv5K26H-_2AoAgXVZhqtn2zCSID0GxHfm0d0B2UEE6ROg9KKTMsv40qzcr2_AsNm3Ix_1ZxR_xqpRFnm25qfMspz5WaFOT8YROyd9Sc1MNDgckrhk_rxycmmNC8ZA6ZpdaRBnCU9XZoQzlyBd2A6dGMMHAYMx_KR0bJVPt33KFP3OucEhb9ez7Yn5kPvkplhoX6SgFUufjKfjx-EqStMEEOYo4rxH0oDG1lFXCHhaTqoraWDgMKT2HgYbdWDpVC_waF47yKVrDTsR14bxXu1sV1fWwVtobekfF0%3D&rank=6&testVersionOverride=Buttercup&slots=HSR_BA&position=11&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=165&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=319875468&selectedRatePlan=387063573',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:11',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: {
            id: '682035',
            clickRedirectTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/ClRedirect?testVersionOverride=Buttercup&destinationUrl=&rank=6&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAELcKKDPRFJgrjB7o9tUvldWa5FDVjKTNrIK7CMqreub_zq22JXRf-EMEs49BwWQTCbmVNIlj0YBmfepf4U95nlinZogOuyzfBuyhrl2i3sxNucnNv7fhRIOYX0C0q2d3PVohqdDrQYVpCz8sOekGRuNlF-xjnTDZgWXXlEiqg5hgJHoDrtBWI0gnE_0iJDktH_MAOw_2_gXO_cLEYWXpeqpXpzR0kf9T3QR4ixIO6M4xiWU-e66IFd9e1iwJId2XF3mD9qPi8NORH12ThVW6KnFeA5UwXtBoTrR0tqNUryQqWFxCqKxdffgpXzfFEh-39Qrsokh0s414DRVKVvah0QWH2WkZmD7GDrcWIjsqYwJ9RZa0SVtoPdNby5drYFwua9eFwXEhlH8r0IwEa93UAedpdTP0AoOLhsM0wT72RTnYcHpnVO_dkbb0yeEwUAVRs1ZFbubft-Un1OgVA_eBQsuyvnFrrkK4-thHXVdAHqw8coZPfFXajiN7GAPoAA2-iBGLrrhMh7nRMOKylwaurl0pxhWijf4n5-g-PvHh29LgVD8eAe55gQFkk4vcTP_PeESptQhLyh4RQ70hXsJU-DOCHcY3vlK_YqY1sIhWq378NyLgPypvnu5k_frR5iq6AOdNmvB86j6gFAmd78VJzFeLIYxHnSkZLbhfY9-ivra8aXQ0ihivOX1ERIK2TpUGTpA5RqnlzqvAzFdZautb8QYPwc-UMR80laKoUL9p5bF5QUQcBNfXqwWcLADZ6c7JU8UkXDu4x0uydCxORb9fcv8u10p_leiDXBKv7RLzowUMgoMrAy6i9yEe5fnuriE1NlDnagQ-YCXzp6XOmOyFPYfE42eMX1-RVeGo7rZDntODORZQNuSxqv5K26H-_2AoAgXVZhqtn2zCSID0GxHfm0d0B2UEE6ROg9KKTMsv40qzcr2_AsNm3Ix_1ZxR_xqpRFnm25qfMspz5WaFOT8YROyd9Sc1MNDgckrhk_rxycmmNC8ZA6ZpdaRBnCU9XZoQzlyBd2A6dGMMHAYMx_KR0bJVPt33KFP3OucEhb9ez7Yn5kPvkplhoX6SgFUufjKfjx-EqStMEEOYo4rxH0oDG1lFXCHhaTqoraWDgMKT2HgYbdWDpVC_waF47yKVrDTsR14bxXu1sV1fWwVtobekfF0=&slots=HSR_BA&position=11&beaconIssued=2022-08-10T13:48:35',
            clickTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Cl?testVersionOverride=Buttercup&rank=6&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAELcKKDPRFJgrjB7o9tUvldWa5FDVjKTNrIK7CMqreub_zq22JXRf-EMEs49BwWQTCbmVNIlj0YBmfepf4U95nlinZogOuyzfBuyhrl2i3sxNucnNv7fhRIOYX0C0q2d3PVohqdDrQYVpCz8sOekGRuNlF-xjnTDZgWXXlEiqg5hgJHoDrtBWI0gnE_0iJDktH_MAOw_2_gXO_cLEYWXpeqpXpzR0kf9T3QR4ixIO6M4xiWU-e66IFd9e1iwJId2XF3mD9qPi8NORH12ThVW6KnFeA5UwXtBoTrR0tqNUryQqWFxCqKxdffgpXzfFEh-39Qrsokh0s414DRVKVvah0QWH2WkZmD7GDrcWIjsqYwJ9RZa0SVtoPdNby5drYFwua9eFwXEhlH8r0IwEa93UAedpdTP0AoOLhsM0wT72RTnYcHpnVO_dkbb0yeEwUAVRs1ZFbubft-Un1OgVA_eBQsuyvnFrrkK4-thHXVdAHqw8coZPfFXajiN7GAPoAA2-iBGLrrhMh7nRMOKylwaurl0pxhWijf4n5-g-PvHh29LgVD8eAe55gQFkk4vcTP_PeESptQhLyh4RQ70hXsJU-DOCHcY3vlK_YqY1sIhWq378NyLgPypvnu5k_frR5iq6AOdNmvB86j6gFAmd78VJzFeLIYxHnSkZLbhfY9-ivra8aXQ0ihivOX1ERIK2TpUGTpA5RqnlzqvAzFdZautb8QYPwc-UMR80laKoUL9p5bF5QUQcBNfXqwWcLADZ6c7JU8UkXDu4x0uydCxORb9fcv8u10p_leiDXBKv7RLzowUMgoMrAy6i9yEe5fnuriE1NlDnagQ-YCXzp6XOmOyFPYfE42eMX1-RVeGo7rZDntODORZQNuSxqv5K26H-_2AoAgXVZhqtn2zCSID0GxHfm0d0B2UEE6ROg9KKTMsv40qzcr2_AsNm3Ix_1ZxR_xqpRFnm25qfMspz5WaFOT8YROyd9Sc1MNDgckrhk_rxycmmNC8ZA6ZpdaRBnCU9XZoQzlyBd2A6dGMMHAYMx_KR0bJVPt33KFP3OucEhb9ez7Yn5kPvkplhoX6SgFUufjKfjx-EqStMEEOYo4rxH0oDG1lFXCHhaTqoraWDgMKT2HgYbdWDpVC_waF47yKVrDTsR14bxXu1sV1fWwVtobekfF0=&slots=HSR_BA&position=11&beaconIssued=2022-08-10T13:48:35',
            details: null,
            detailsHeadline: null,
            hotelImage:
              'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/84000000/83250000/83245200/83245150/9e09f4a7_b.jpg',
            impressionTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Impr?testVersionOverride=Buttercup&rank=6&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAELcKKDPRFJgrjB7o9tUvldWa5FDVjKTNrIK7CMqreub_zq22JXRf-EMEs49BwWQTCbmVNIlj0YBmfepf4U95nlinZogOuyzfBuyhrl2i3sxNucnNv7fhRIOYX0C0q2d3PVohqdDrQYVpCz8sOekGRuNlF-xjnTDZgWXXlEiqg5hgJHoDrtBWI0gnE_0iJDktH_MAOw_2_gXO_cLEYWXpeqpXpzR0kf9T3QR4ixIO6M4xiWU-e66IFd9e1iwJId2XF3mD9qPi8NORH12ThVW6KnFeA5UwXtBoTrR0tqNUryQqWFxCqKxdffgpXzfFEh-39Qrsokh0s414DRVKVvah0QWH2WkZmD7GDrcWIjsqYwJ9RZa0SVtoPdNby5drYFwua9eFwXEhlH8r0IwEa93UAedpdTP0AoOLhsM0wT72RTnYcHpnVO_dkbb0yeEwUAVRs1ZFbubft-Un1OgVA_eBQsuyvnFrrkK4-thHXVdAHqw8coZPfFXajiN7GAPoAA2-iBGLrrhMh7nRMOKylwaurl0pxhWijf4n5-g-PvHh29LgVD8eAe55gQFkk4vcTP_PeESptQhLyh4RQ70hXsJU-DOCHcY3vlK_YqY1sIhWq378NyLgPypvnu5k_frR5iq6AOdNmvB86j6gFAmd78VJzFeLIYxHnSkZLbhfY9-ivra8aXQ0ihivOX1ERIK2TpUGTpA5RqnlzqvAzFdZautb8QYPwc-UMR80laKoUL9p5bF5QUQcBNfXqwWcLADZ6c7JU8UkXDu4x0uydCxORb9fcv8u10p_leiDXBKv7RLzowUMgoMrAy6i9yEe5fnuriE1NlDnagQ-YCXzp6XOmOyFPYfE42eMX1-RVeGo7rZDntODORZQNuSxqv5K26H-_2AoAgXVZhqtn2zCSID0GxHfm0d0B2UEE6ROg9KKTMsv40qzcr2_AsNm3Ix_1ZxR_xqpRFnm25qfMspz5WaFOT8YROyd9Sc1MNDgckrhk_rxycmmNC8ZA6ZpdaRBnCU9XZoQzlyBd2A6dGMMHAYMx_KR0bJVPt33KFP3OucEhb9ez7Yn5kPvkplhoX6SgFUufjKfjx-EqStMEEOYo4rxH0oDG1lFXCHhaTqoraWDgMKT2HgYbdWDpVC_waF47yKVrDTsR14bxXu1sV1fWwVtobekfF0=&slots=HSR_BA&position=11&beaconIssued=2022-08-10T13:48:35',
            trackingData:
              'AAAAELcKKDPRFJgrjB7o9tUvldWa5FDVjKTNrIK7CMqreub_zq22JXRf-EMEs49BwWQTCbmVNIlj0YBmfepf4U95nlinZogOuyzfBuyhrl2i3sxNucnNv7fhRIOYX0C0q2d3PVohqdDrQYVpCz8sOekGRuNlF-xjnTDZgWXXlEiqg5hgJHoDrtBWI0gnE_0iJDktH_MAOw_2_gXO_cLEYWXpeqpXpzR0kf9T3QR4ixIO6M4xiWU-e66IFd9e1iwJId2XF3mD9qPi8NORH12ThVW6KnFeA5UwXtBoTrR0tqNUryQqWFxCqKxdffgpXzfFEh-39Qrsokh0s414DRVKVvah0QWH2WkZmD7GDrcWIjsqYwJ9RZa0SVtoPdNby5drYFwua9eFwXEhlH8r0IwEa93UAedpdTP0AoOLhsM0wT72RTnYcHpnVO_dkbb0yeEwUAVRs1ZFbubft-Un1OgVA_eBQsuyvnFrrkK4-thHXVdAHqw8coZPfFXajiN7GAPoAA2-iBGLrrhMh7nRMOKylwaurl0pxhWijf4n5-g-PvHh29LgVD8eAe55gQFkk4vcTP_PeESptQhLyh4RQ70hXsJU-DOCHcY3vlK_YqY1sIhWq378NyLgPypvnu5k_frR5iq6AOdNmvB86j6gFAmd78VJzFeLIYxHnSkZLbhfY9-ivra8aXQ0ihivOX1ERIK2TpUGTpA5RqnlzqvAzFdZautb8QYPwc-UMR80laKoUL9p5bF5QUQcBNfXqwWcLADZ6c7JU8UkXDu4x0uydCxORb9fcv8u10p_leiDXBKv7RLzowUMgoMrAy6i9yEe5fnuriE1NlDnagQ-YCXzp6XOmOyFPYfE42eMX1-RVeGo7rZDntODORZQNuSxqv5K26H-_2AoAgXVZhqtn2zCSID0GxHfm0d0B2UEE6ROg9KKTMsv40qzcr2_AsNm3Ix_1ZxR_xqpRFnm25qfMspz5WaFOT8YROyd9Sc1MNDgckrhk_rxycmmNC8ZA6ZpdaRBnCU9XZoQzlyBd2A6dGMMHAYMx_KR0bJVPt33KFP3OucEhb9ez7Yn5kPvkplhoX6SgFUufjKfjx-EqStMEEOYo4rxH0oDG1lFXCHhaTqoraWDgMKT2HgYbdWDpVC_waF47yKVrDTsR14bxXu1sV1fWwVtobekfF0=',
            brand: null,
            clickRedirectLinkoffTrackingUrl: null,
            logo: null,
            lotagline: null,
            rating: '0',
            slots: 'HSR_BA',
            vanityUrl: null,
            rank: '6',
            position: '11',
            __typename: 'SponsoredListing',
          },
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for City Sleeper at Royal National Hotel',
            images: [
              {
                image: {
                  url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/84000000/83250000/83245200/83245150/9e09f4a7_b.jpg',
                  description: 'Property entrance',
                  __typename: 'Image',
                },
                subjectId: 91002,
                fallbackImage: {
                  url: 'https://images.trvl-media.com/hotels/84000000/83250000/83245200/83245150/fe3463bf.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Property entrance',
                  __typename: 'Image',
                },
                imageId: '701149613',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/84000000/83250000/83245200/83245150/bb40c463.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '701150929',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/84000000/83250000/83245200/83245150/1373ba47.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Breakfast area',
                  __typename: 'Image',
                },
                subjectId: 81001,
                fallbackImage: null,
                imageId: '701137911',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/84000000/83250000/83245200/83245150/85de5a67.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lobby sitting area',
                  __typename: 'Image',
                },
                subjectId: 10003,
                fallbackImage: null,
                imageId: '701149381',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£165',
            type: 'HOTEL',
            latLong: {
              latitude: 51.523469,
              longitude: -0.127314,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/83245150',
            removeUrl: '/api/ucs/shortlist/remove/83245150',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '83245150',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '34928032',
          name: 'The Standard London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/35000000/34930000/34928100/34928032/90875255.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£229',
                      accessibilityLabel: 'The price is £229',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£229',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£229',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.6,
            localizedScore: '4.6',
            total: 549,
            localizedTotal: '549 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.6 / 5 (549 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.6 out of 5 Wonderful (549 reviews)',
              value: '4.6/5 Wonderful (549 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Standard-London.h34928032.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316615&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6251519&price=0%2C300&sort=RECOMMENDED&top_dp=229&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=315833270&selectedRatePlan=386536369',
              relativePath:
                '/London-Hotels-The-Standard-London.h34928032.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316615&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6251519&price=0%2C300&sort=RECOMMENDED&top_dp=229&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=315833270&selectedRatePlan=386536369',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:12',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Standard London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/35000000/34930000/34928100/34928032/90875255.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '565159764',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/35000000/34930000/34928100/34928032/3b68637b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 91008,
                fallbackImage: null,
                imageId: '392271198',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/35000000/34930000/34928100/34928032/ffe90e9f.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 22007,
                fallbackImage: null,
                imageId: '638111449',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/35000000/34930000/34928100/34928032/b44a3ae1.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '377217927',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£229',
            type: 'HOTEL',
            latLong: {
              latitude: 51.529421,
              longitude: -0.124181,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/34928032',
            removeUrl: '/api/ucs/shortlist/remove/34928032',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '34928032',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '2479',
          name: 'The Tower Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/10000/2500/2479/3fe959ac.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: '25% off',
              theme_temp: 'DEAL_GENERIC',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'STRIKEOUT',
                    price: {
                      formatted: '£200',
                      accessibilityLabel: 'The price was £200',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: {
                      content: [
                        'This price is the standard rate on our site as provided by the property based on your search.',
                      ],
                      primaryUIButton: {
                        accessibility: null,
                        primary: 'Close',
                        __typename: 'UIPrimaryButton',
                      },
                      __typename: 'LodgingPlainDialog',
                    },
                  },
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£150',
                      accessibilityLabel: 'The price is £150',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£150',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: {
              formatted: '£200',
              __typename: 'Money',
            },
            disclaimer: {
              value: 'This price is the standard rate on our site as provided by the property based on your search.',
              __typename: 'LodgingPlainMessage',
            },
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£150',
                  __typename: 'Money',
                },
                strikeOut: {
                  formatted: '£200',
                  __typename: 'Money',
                },
                loyaltyPrice: null,
                disclaimer: {
                  value:
                    'This price is the standard rate on our site as provided by the property based on your search.',
                  __typename: 'LodgingPlainMessage',
                },
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.2,
            localizedScore: '4.2',
            total: 2786,
            localizedTotal: '2,786 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.2 / 5 (2,786 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.2 out of 5 Very good (2,786 reviews)',
              value: '4.2/5 Very good (2,786 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Tower-Hotel.h2479.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316614&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144911&price=0%2C300&sort=RECOMMENDED&top_dp=150&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201221682&selectedRatePlan=210436618',
              relativePath:
                '/London-Hotels-The-Tower-Hotel.h2479.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316614&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144911&price=0%2C300&sort=RECOMMENDED&top_dp=150&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201221682&selectedRatePlan=210436618',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:13',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Tower Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/2500/2479/3fe959ac.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '477866429',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/2500/2479/80611054.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Outdoor banquet area',
                  __typename: 'Image',
                },
                subjectId: 91012,
                fallbackImage: null,
                imageId: '549315500',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/2500/2479/9a1a973b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '449842061',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/2500/2479/43d7b4a0.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lounge',
                  __typename: 'Image',
                },
                subjectId: 82001,
                fallbackImage: null,
                imageId: '52145717',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£150',
            type: 'HOTEL',
            latLong: {
              latitude: 51.506436,
              longitude: -0.073804,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/2479',
            removeUrl: '/api/ucs/shortlist/remove/2479',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '2479',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '17684778',
          name: 'Dorsett City London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/18000000/17690000/17684800/17684778/5512de5d.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£185',
                      accessibilityLabel: 'The price is £185',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£185',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£185',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.3,
            localizedScore: '4.3',
            total: 1000,
            localizedTotal: '1,000 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.3 / 5 (1,000 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.3 out of 5 Excellent (1,000 reviews)',
              value: '4.3/5 Excellent (1,000 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Dorsett-City-London.h17684778.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316614&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383473&price=0%2C300&sort=RECOMMENDED&top_dp=185&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=202157656&selectedRatePlan=290350788',
              relativePath:
                '/London-Hotels-Dorsett-City-London.h17684778.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316614&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383473&price=0%2C300&sort=RECOMMENDED&top_dp=185&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=202157656&selectedRatePlan=290350788',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:14',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Dorsett City London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/18000000/17690000/17684800/17684778/5512de5d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '45039953',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/18000000/17690000/17684800/17684778/a9c181da.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 91008,
                fallbackImage: null,
                imageId: '76615433',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/18000000/17690000/17684800/17684778/af173989.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'View from room',
                  __typename: 'Image',
                },
                subjectId: 22013,
                fallbackImage: null,
                imageId: '59096533',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/18000000/17690000/17684800/17684778/ed21b57d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '48246104',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£185',
            type: 'HOTEL',
            latLong: {
              latitude: 51.51418,
              longitude: -0.07549,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/17684778',
            removeUrl: '/api/ucs/shortlist/remove/17684778',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '17684778',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '24000156',
          name: 'Assembly House Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/25000000/24010000/24000200/24000156/db90c1ca.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£204',
                      accessibilityLabel: 'The price is £204',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£204',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£204',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.1,
            localizedScore: '4.1',
            total: 1003,
            localizedTotal: '1,003 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.1 / 5 (1,003 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.1 out of 5 Very good (1,003 reviews)',
              value: '4.1/5 Very good (1,003 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Assembly-Hotel-London.h24000156.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316614&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6054504&price=0%2C300&sort=RECOMMENDED&top_dp=204&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=214549253&selectedRatePlan=383982849',
              relativePath:
                '/London-Hotels-Assembly-Hotel-London.h24000156.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316614&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6054504&price=0%2C300&sort=RECOMMENDED&top_dp=204&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=214549253&selectedRatePlan=383982849',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:15',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Assembly House Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/25000000/24010000/24000200/24000156/db90c1ca.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '375671654',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/25000000/24010000/24000200/24000156/37ed2729.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '675934971',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/25000000/24010000/24000200/24000156/cf94a9f4.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '393068203',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/25000000/24010000/24000200/24000156/5b4d1f8d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '664859928',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£204',
            type: 'HOTEL',
            latLong: {
              latitude: 51.51053,
              longitude: -0.12862,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'Soho',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/24000156',
            removeUrl: '/api/ucs/shortlist/remove/24000156',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '24000156',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '470865',
          name: 'St Martins Lane London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/480000/470900/470865/e285b716.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: '35% off',
              theme_temp: 'DEAL_GENERIC',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'STRIKEOUT',
                    price: {
                      formatted: '£428',
                      accessibilityLabel: 'The price was £428',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: {
                      content: [
                        'This price is the standard rate on our site as provided by the property based on your search.',
                      ],
                      primaryUIButton: {
                        accessibility: null,
                        primary: 'Close',
                        __typename: 'UIPrimaryButton',
                      },
                      __typename: 'LodgingPlainDialog',
                    },
                  },
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£278',
                      accessibilityLabel: 'The price is £278',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£278',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: {
              formatted: '£428',
              __typename: 'Money',
            },
            disclaimer: {
              value: 'This price is the standard rate on our site as provided by the property based on your search.',
              __typename: 'LodgingPlainMessage',
            },
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£278',
                  __typename: 'Money',
                },
                strikeOut: {
                  formatted: '£428',
                  __typename: 'Money',
                },
                loyaltyPrice: null,
                disclaimer: {
                  value:
                    'This price is the standard rate on our site as provided by the property based on your search.',
                  __typename: 'LodgingPlainMessage',
                },
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.6,
            localizedScore: '4.6',
            total: 1002,
            localizedTotal: '1,002 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.6 / 5 (1,002 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.6 out of 5 Wonderful (1,002 reviews)',
              value: '4.6/5 Wonderful (1,002 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-St-Martins-Lane-London.h470865.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316612&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179536&price=0%2C300&sort=RECOMMENDED&top_dp=278&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200722341&selectedRatePlan=206981671',
              relativePath:
                '/London-Hotels-St-Martins-Lane-London.h470865.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316612&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179536&price=0%2C300&sort=RECOMMENDED&top_dp=278&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200722341&selectedRatePlan=206981671',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:16',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for St Martins Lane London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/480000/470900/470865/e285b716.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '22317130',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/480000/470900/470865/ce051663.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Property entrance',
                  __typename: 'Image',
                },
                subjectId: 91002,
                fallbackImage: null,
                imageId: '21165487',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/480000/470900/470865/2b66574f.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '22317051',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/480000/470900/470865/4d43d4f6.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '21165433',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£278',
            type: 'HOTEL',
            latLong: {
              latitude: 51.510409,
              longitude: -0.12697,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'City of Westminster',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/470865',
            removeUrl: '/api/ucs/shortlist/remove/470865',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '470865',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '559690',
          name: "Club Quarters Hotel, St. Paul's",
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/560000/559700/559690/31a11b62.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£193',
                      accessibilityLabel: 'The price is £193',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£193',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£193',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4,
            localizedScore: '4.0',
            total: 997,
            localizedTotal: '997 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.0 / 5 (997 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.0 out of 5 Very good (997 reviews)',
              value: '4.0/5 Very good (997 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Club-Quarters-Hotel.h559690.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316613&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800056&price=0%2C300&sort=RECOMMENDED&top_dp=193&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200257620&selectedRatePlan=211015391',
              relativePath:
                '/London-Hotels-Club-Quarters-Hotel.h559690.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316613&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800056&price=0%2C300&sort=RECOMMENDED&top_dp=193&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200257620&selectedRatePlan=211015391',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:17',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: "Photo gallery for Club Quarters Hotel, St. Paul's",
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/560000/559700/559690/31a11b62.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '23391069',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/560000/559700/559690/65d2a06e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Property entrance',
                  __typename: 'Image',
                },
                subjectId: 91002,
                fallbackImage: null,
                imageId: '23391071',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/560000/559700/559690/b2174678.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '104635358',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/560000/559700/559690/77bfed1e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Restaurant',
                  __typename: 'Image',
                },
                subjectId: 81003,
                fallbackImage: null,
                imageId: '9702427',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£193',
            type: 'HOTEL',
            latLong: {
              latitude: 51.513811,
              longitude: -0.101267,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'The City of London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/559690',
            removeUrl: '/api/ucs/shortlist/remove/559690',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '559690',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '4190769',
          name: 'Leonardo Royal London Tower Bridge',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/5000000/4200000/4190800/4190769/947bd890.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£195',
                      accessibilityLabel: 'The price is £195',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£195',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£195',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.1,
            localizedScore: '4.1',
            total: 1428,
            localizedTotal: '1,428 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.1 / 5 (1,428 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.1 out of 5 Very good (1,428 reviews)',
              value: '4.1/5 Very good (1,428 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Leonardo-Royal-London-Tower-Bridge.h4190769.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316613&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144911&price=0%2C300&sort=RECOMMENDED&top_dp=195&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200075408&selectedRatePlan=204985816',
              relativePath:
                '/London-Hotels-Leonardo-Royal-London-Tower-Bridge.h4190769.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316613&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144911&price=0%2C300&sort=RECOMMENDED&top_dp=195&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200075408&selectedRatePlan=204985816',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:18',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
            {
              icon: 'hot_tub',
              name: 'Hot tub',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Leonardo Royal London Tower Bridge',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/5000000/4200000/4190800/4190769/947bd890.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '113681175',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/5000000/4200000/4190800/4190769/ff88ecc6.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Property entrance',
                  __typename: 'Image',
                },
                subjectId: 91002,
                fallbackImage: null,
                imageId: '614567718',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/5000000/4200000/4190800/4190769/c32d76d9.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Pool',
                  __typename: 'Image',
                },
                subjectId: 30000,
                fallbackImage: null,
                imageId: '90067353',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/5000000/4200000/4190800/4190769/167166f9.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '113684056',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£195',
            type: 'HOTEL',
            latLong: {
              latitude: 51.511687,
              longitude: -0.070848,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/4190769',
            removeUrl: '/api/ucs/shortlist/remove/4190769',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '4190769',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '14736047',
          name: 'citizenM Tower of London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/15000000/14740000/14736100/14736047/65678511.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£149',
                      accessibilityLabel: 'The price is £149',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£149',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£149',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.6,
            localizedScore: '4.6',
            total: 1000,
            localizedTotal: '1,000 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.6 / 5 (1,000 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.6 out of 5 Wonderful (1,000 reviews)',
              value: '4.6/5 Wonderful (1,000 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-CitizenM-Tower-Of-London.h14736047.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316615&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144911&price=0%2C300&sort=RECOMMENDED&top_dp=149&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201471701&selectedRatePlan=207349820',
              relativePath:
                '/London-Hotels-CitizenM-Tower-Of-London.h14736047.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316615&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144911&price=0%2C300&sort=RECOMMENDED&top_dp=149&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201471701&selectedRatePlan=207349820',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:19',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for citizenM Tower of London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/15000000/14740000/14736100/14736047/65678511.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '426805394',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/15000000/14740000/14736100/14736047/d34da7c2.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '426805398',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/15000000/14740000/14736100/14736047/7e8304e1.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'View from room',
                  __typename: 'Image',
                },
                subjectId: 22013,
                fallbackImage: null,
                imageId: '426805399',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/15000000/14740000/14736100/14736047/8a43a733.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lounge',
                  __typename: 'Image',
                },
                subjectId: 82001,
                fallbackImage: null,
                imageId: '425999026',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£149',
            type: 'HOTEL',
            latLong: {
              latitude: 51.51018,
              longitude: -0.076874,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/14736047',
            removeUrl: '/api/ucs/shortlist/remove/14736047',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '14736047',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '48296903',
          name: 'Yotel London City',
          propertyImage: {
            image: {
              description: 'Lobby',
              url: 'https://images.trvl-media.com/hotels/49000000/48300000/48297000/48296903/449f6b63.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'STRIKEOUT',
                    price: {
                      formatted: '£231',
                      accessibilityLabel: 'The price was £231',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: {
                      content: [
                        'This price is the standard rate on our site as provided by the property based on your search.',
                      ],
                      primaryUIButton: {
                        accessibility: null,
                        primary: 'Close',
                        __typename: 'UIPrimaryButton',
                      },
                      __typename: 'LodgingPlainDialog',
                    },
                  },
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£196',
                      accessibilityLabel: 'The price is £196',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£196',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: {
              formatted: '£231',
              __typename: 'Money',
            },
            disclaimer: {
              value: 'This price is the standard rate on our site as provided by the property based on your search.',
              __typename: 'LodgingPlainMessage',
            },
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£196',
                  __typename: 'Money',
                },
                strikeOut: {
                  formatted: '£231',
                  __typename: 'Money',
                },
                loyaltyPrice: null,
                disclaimer: {
                  value:
                    'This price is the standard rate on our site as provided by the property based on your search.',
                  __typename: 'LodgingPlainMessage',
                },
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.4,
            localizedScore: '4.4',
            total: 345,
            localizedTotal: '345 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.4 / 5 (345 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.4 out of 5 Excellent (345 reviews)',
              value: '4.4/5 Excellent (345 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-YOTEL-Clerkenwell.h48296903.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316615&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248634834708724&price=0%2C300&sort=RECOMMENDED&top_dp=196&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=229210418&selectedRatePlan=380087974',
              relativePath:
                '/London-Hotels-YOTEL-Clerkenwell.h48296903.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316615&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248634834708724&price=0%2C300&sort=RECOMMENDED&top_dp=196&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=229210418&selectedRatePlan=380087974',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:20',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Yotel London City',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/49000000/48300000/48297000/48296903/ae1a628c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '538253219',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/49000000/48300000/48297000/48296903/260f3c04.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '456845063',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/49000000/48300000/48297000/48296903/1cbe6fa1.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '456845055',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/49000000/48300000/48297000/48296903/6e653558.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Restaurant',
                  __typename: 'Image',
                },
                subjectId: 81003,
                fallbackImage: null,
                imageId: '456845057',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£196',
            type: 'HOTEL',
            latLong: {
              latitude: 51.522623,
              longitude: -0.104439,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/48296903',
            removeUrl: '/api/ucs/shortlist/remove/48296903',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '48296903',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '1584661',
          name: 'Club Quarters Hotel, Trafalgar Square',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/2000000/1590000/1584700/1584661/d578f5a0.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£272',
                      accessibilityLabel: 'The price is £272',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£272',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£272',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.3,
            localizedScore: '4.3',
            total: 1001,
            localizedTotal: '1,001 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.3 / 5 (1,001 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.3 out of 5 Excellent (1,001 reviews)',
              value: '4.3/5 Excellent (1,001 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Club-Quarters-Hotel.h1584661.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316615&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381276&price=0%2C300&sort=RECOMMENDED&top_dp=272&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200257637&selectedRatePlan=380053839',
              relativePath:
                '/London-Hotels-Club-Quarters-Hotel.h1584661.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316615&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381276&price=0%2C300&sort=RECOMMENDED&top_dp=272&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200257637&selectedRatePlan=380053839',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:21',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Club Quarters Hotel, Trafalgar Square',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1590000/1584700/1584661/d578f5a0.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '22867640',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1590000/1584700/1584661/a8957b9b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Property entrance',
                  __typename: 'Image',
                },
                subjectId: 91002,
                fallbackImage: null,
                imageId: '22867638',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1590000/1584700/1584661/33816a58.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '457973521',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1590000/1584700/1584661/d27502bc.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lounge',
                  __typename: 'Image',
                },
                subjectId: 82001,
                fallbackImage: null,
                imageId: '22867625',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£272',
            type: 'HOTEL',
            latLong: {
              latitude: 51.507118,
              longitude: -0.125892,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/1584661',
            removeUrl: '/api/ucs/shortlist/remove/1584661',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '1584661',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '1183908',
          name: 'Park Plaza London Riverbank',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/2000000/1190000/1184000/1183908/26afcf39.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£219',
                      accessibilityLabel: 'The price is £219',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£219',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£219',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.1,
            localizedScore: '4.1',
            total: 1059,
            localizedTotal: '1,059 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.1 / 5 (1,059 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.1 out of 5 Very good (1,059 reviews)',
              value: '4.1/5 Very good (1,059 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Park-Plaza-London-Riverbank.h1183908.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316616&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383189&price=0%2C300&sort=RECOMMENDED&top_dp=219&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314224549&selectedRatePlan=382707404',
              relativePath:
                '/London-Hotels-Park-Plaza-London-Riverbank.h1183908.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316616&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383189&price=0%2C300&sort=RECOMMENDED&top_dp=219&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314224549&selectedRatePlan=382707404',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:22',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Park Plaza London Riverbank',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1190000/1184000/1183908/26afcf39.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '379158093',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1190000/1184000/1183908/5c679583.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Pool',
                  __typename: 'Image',
                },
                subjectId: 30000,
                fallbackImage: null,
                imageId: '379158160',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1190000/1184000/1183908/dc9423e0.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '380313831',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1190000/1184000/1183908/5f80fc13.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '379158136',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£219',
            type: 'HOTEL',
            latLong: {
              latitude: 51.491633,
              longitude: -0.121676,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/1183908',
            removeUrl: '/api/ucs/shortlist/remove/1183908',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '1183908',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '9745',
          name: 'The Rembrandt',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/10000/9800/9745/01ad72c7.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: null,
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£258',
                      accessibilityLabel: 'The price is £258',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£258',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£258',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.4,
            localizedScore: '4.4',
            total: 1140,
            localizedTotal: '1,140 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.4 / 5 (1,140 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.4 out of 5 Excellent (1,140 reviews)',
              value: '4.4/5 Excellent (1,140 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Rembrandt.h9745.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316616&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382803&price=0%2C300&sort=RECOMMENDED&top_dp=258&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200256860&selectedRatePlan=206784180',
              relativePath:
                '/London-Hotels-The-Rembrandt.h9745.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316616&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382803&price=0%2C300&sort=RECOMMENDED&top_dp=258&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200256860&selectedRatePlan=206784180',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:23',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
            {
              icon: 'hot_tub',
              name: 'Hot tub',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Rembrandt',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/9800/9745/01ad72c7.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '39102763',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/9800/9745/4cef27bc.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property',
                  __typename: 'Image',
                },
                subjectId: 91001,
                fallbackImage: null,
                imageId: '54131687',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/9800/9745/e5a0fba3.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Indoor pool',
                  __typename: 'Image',
                },
                subjectId: 30002,
                fallbackImage: null,
                imageId: '46322330',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/9800/9745/19c6611a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '100773176',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£258',
            type: 'HOTEL',
            latLong: {
              latitude: 51.496203,
              longitude: -0.17054,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/9745',
            removeUrl: '/api/ucs/shortlist/remove/9745',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '9745',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '54987',
          name: 'Royal Garden Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54987/90cb3df0.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£300',
                      accessibilityLabel: 'The price is £300',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£300',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£300',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.5,
            localizedScore: '4.5',
            total: 998,
            localizedTotal: '998 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.5 / 5 (998 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.5 out of 5 Wonderful (998 reviews)',
              value: '4.5/5 Wonderful (998 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Royal-Garden-Hotel.h54987.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316616&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383066&price=0%2C300&sort=RECOMMENDED&top_dp=300&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=474260&selectedRatePlan=228249455',
              relativePath:
                '/London-Hotels-Royal-Garden-Hotel.h54987.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316616&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383066&price=0%2C300&sort=RECOMMENDED&top_dp=300&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=474260&selectedRatePlan=228249455',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:24',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Royal Garden Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54987/90cb3df0.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '606035864',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54987/293904b5.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '66452207',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54987/b4462b35.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '660055170',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54987/cda4f286.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '660054005',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£300',
            type: 'HOTEL',
            latLong: {
              latitude: 51.502392,
              longitude: -0.188608,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/54987',
            removeUrl: '/api/ucs/shortlist/remove/54987',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '54987',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '54995',
          name: 'The President Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54995/99ea1f96.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£150',
                      accessibilityLabel: 'The price is £150',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£150',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£150',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4,
            localizedScore: '4.0',
            total: 1365,
            localizedTotal: '1,365 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.0 / 5 (1,365 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.0 out of 5 Very good (1,365 reviews)',
              value: '4.0/5 Very good (1,365 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-President-Hotel.h54995.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316618&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&price=0%2C300&sort=RECOMMENDED&top_dp=150&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=232851588&selectedRatePlan=385819835',
              relativePath:
                '/London-Hotels-The-President-Hotel.h54995.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316618&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&price=0%2C300&sort=RECOMMENDED&top_dp=150&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=232851588&selectedRatePlan=385819835',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:25',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The President Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54995/99ea1f96.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '449705555',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54995/aefec877.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '449705689',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54995/c4b38786.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '449705770',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54995/421f05cc.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '449705632',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£150',
            type: 'HOTEL',
            latLong: {
              latitude: 51.522443,
              longitude: -0.124143,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/54995',
            removeUrl: '/api/ucs/shortlist/remove/54995',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '54995',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '559689',
          name: 'Club Quarters Hotel London City',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/560000/559700/559689/7dc5ea7b.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£181',
                      accessibilityLabel: 'The price is £181',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£181',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£181',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.1,
            localizedScore: '4.1',
            total: 1000,
            localizedTotal: '1,000 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.1 / 5 (1,000 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.1 out of 5 Very good (1,000 reviews)',
              value: '4.1/5 Very good (1,000 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Club-Quarters-Hotel.h559689.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316616&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383471&price=0%2C300&sort=RECOMMENDED&top_dp=181&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200257658&selectedRatePlan=211015375',
              relativePath:
                '/London-Hotels-Club-Quarters-Hotel.h559689.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316616&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383471&price=0%2C300&sort=RECOMMENDED&top_dp=181&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200257658&selectedRatePlan=211015375',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:26',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Club Quarters Hotel London City',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/560000/559700/559689/7dc5ea7b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '24476052',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/560000/559700/559689/143f1106.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '93899757',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/560000/559700/559689/b1b39054.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '467256472',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/560000/559700/559689/3677a5a8.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lounge',
                  __typename: 'Image',
                },
                subjectId: 82001,
                fallbackImage: null,
                imageId: '24476063',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£181',
            type: 'HOTEL',
            latLong: {
              latitude: 51.512791,
              longitude: -0.084514,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/559689',
            removeUrl: '/api/ucs/shortlist/remove/559689',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '559689',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '4735824',
          name: 'Club Quarters Hotel Covent Garden Holborn',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/5000000/4740000/4735900/4735824/b5e50a72.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£227',
                      accessibilityLabel: 'The price is £227',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£227',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£227',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.3,
            localizedScore: '4.3',
            total: 1000,
            localizedTotal: '1,000 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.3 / 5 (1,000 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.3 out of 5 Excellent (1,000 reviews)',
              value: '4.3/5 Excellent (1,000 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Club-Quarters-Lincolns-Inn-Fields.h4735824.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316617&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179519&price=0%2C300&sort=RECOMMENDED&top_dp=227&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200257728&selectedRatePlan=380146199',
              relativePath:
                '/London-Hotels-Club-Quarters-Lincolns-Inn-Fields.h4735824.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316617&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179519&price=0%2C300&sort=RECOMMENDED&top_dp=227&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200257728&selectedRatePlan=380146199',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:27',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Club Quarters Hotel Covent Garden Holborn',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/5000000/4740000/4735900/4735824/b5e50a72.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '22495179',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/5000000/4740000/4735900/4735824/4043eb47.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 91008,
                fallbackImage: null,
                imageId: '104635164',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/5000000/4740000/4735900/4735824/b71ee73f.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '31081154',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/5000000/4740000/4735900/4735824/1c31257d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '104635240',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£227',
            type: 'HOTEL',
            latLong: {
              latitude: 51.516124,
              longitude: -0.118218,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/4735824',
            removeUrl: '/api/ucs/shortlist/remove/4735824',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '4735824',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '530052',
          name: 'Leonardo Royal Hotel London City - Tower of London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/540000/530100/530052/1c9cba4b.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£189',
                      accessibilityLabel: 'The price is £189',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£189',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£189',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.1,
            localizedScore: '4.1',
            total: 1081,
            localizedTotal: '1,081 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.1 / 5 (1,081 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.1 out of 5 Very good (1,081 reviews)',
              value: '4.1/5 Very good (1,081 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Leonardo-Royal-London-City-Tower-Hill.h530052.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316616&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144911&price=0%2C300&sort=RECOMMENDED&top_dp=189&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=115806&selectedRatePlan=270855',
              relativePath:
                '/London-Hotels-Leonardo-Royal-London-City-Tower-Hill.h530052.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316616&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144911&price=0%2C300&sort=RECOMMENDED&top_dp=189&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=115806&selectedRatePlan=270855',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:28',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Leonardo Royal Hotel London City - Tower of London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/540000/530100/530052/1c9cba4b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '555038055',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/540000/530100/530052/2db02309.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '414835535',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/540000/530100/530052/f728d47b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Pool',
                  __typename: 'Image',
                },
                subjectId: 30000,
                fallbackImage: null,
                imageId: '555038043',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/540000/530100/530052/9ca656ae.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '460386774',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£189',
            type: 'HOTEL',
            latLong: {
              latitude: 51.510679,
              longitude: -0.076901,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/530052',
            removeUrl: '/api/ucs/shortlist/remove/530052',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '530052',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '1742184',
          name: 'Park Plaza County Hall London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/2000000/1750000/1742200/1742184/f0d10954.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£269',
                      accessibilityLabel: 'The price is £269',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£269',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£269',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.5,
            localizedScore: '4.5',
            total: 1183,
            localizedTotal: '1,183 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.5 / 5 (1,183 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.5 out of 5 Wonderful (1,183 reviews)',
              value: '4.5/5 Wonderful (1,183 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Park-Plaza-County-Hall-London.h1742184.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316617&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6054506&price=0%2C300&sort=RECOMMENDED&top_dp=269&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314307270&selectedRatePlan=382948121',
              relativePath:
                '/London-Hotels-Park-Plaza-County-Hall-London.h1742184.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316617&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6054506&price=0%2C300&sort=RECOMMENDED&top_dp=269&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314307270&selectedRatePlan=382948121',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:29',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Park Plaza County Hall London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1750000/1742200/1742184/f0d10954.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '376958171',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1750000/1742200/1742184/2b2d42e7.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 91008,
                fallbackImage: null,
                imageId: '17453588',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1750000/1742200/1742184/3dc4e2f0.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '376958420',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1750000/1742200/1742184/8a8aec80.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '9536856',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£269',
            type: 'HOTEL',
            latLong: {
              latitude: 51.501233,
              longitude: -0.116207,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/1742184',
            removeUrl: '/api/ucs/shortlist/remove/1742184',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '1742184',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '32872139',
          name: 'The Hoxton Southwark',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/33000000/32880000/32872200/32872139/915dd734.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£269',
                      accessibilityLabel: 'The price is £269',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£269',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£269',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.6,
            localizedScore: '4.6',
            total: 337,
            localizedTotal: '337 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.6 / 5 (337 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.6 out of 5 Wonderful (337 reviews)',
              value: '4.6/5 Wonderful (337 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Hoxton-Southwark.h32872139.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316620&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381681&price=0%2C300&sort=RECOMMENDED&top_dp=269&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=217854750&selectedRatePlan=272373007',
              relativePath:
                '/London-Hotels-The-Hoxton-Southwark.h32872139.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316620&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381681&price=0%2C300&sort=RECOMMENDED&top_dp=269&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=217854750&selectedRatePlan=272373007',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:30',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Hoxton Southwark',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/33000000/32880000/32872200/32872139/915dd734.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '498963254',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/33000000/32880000/32872200/32872139/44b79ec5.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '98257435',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/33000000/32880000/32872200/32872139/2bddd885.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '101005763',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/33000000/32880000/32872200/32872139/644fb2eb.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '503940918',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£269',
            type: 'HOTEL',
            latLong: {
              latitude: 51.505603,
              longitude: -0.104577,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/32872139',
            removeUrl: '/api/ucs/shortlist/remove/32872139',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '32872139',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '26145',
          name: 'Copthorne Tara Hotel London Kensington',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/30000/26200/26145/532e7515.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£110',
                      accessibilityLabel: 'The price is £110',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£110',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£110',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.6,
            localizedScore: '3.6',
            total: 1482,
            localizedTotal: '1,482 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.6 / 5 (1,482 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.6 out of 5 Good (1,482 reviews)',
              value: '3.6/5 Good (1,482 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Copthorne-Tara-Hotel-London-Kensington.h26145.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316617&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383075&price=0%2C300&sort=RECOMMENDED&top_dp=110&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200630673&selectedRatePlan=236134997',
              relativePath:
                '/London-Hotels-Copthorne-Tara-Hotel-London-Kensington.h26145.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316617&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383075&price=0%2C300&sort=RECOMMENDED&top_dp=110&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200630673&selectedRatePlan=236134997',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:31',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Copthorne Tara Hotel London Kensington',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/26200/26145/532e7515.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '388785569',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/26200/26145/1612a202.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 91008,
                fallbackImage: null,
                imageId: '388775005',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/26200/26145/2a2d3ef3.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 22007,
                fallbackImage: null,
                imageId: '533576590',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/26200/26145/89e20707.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '412356583',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£110',
            type: 'HOTEL',
            latLong: {
              latitude: 51.4991,
              longitude: -0.191641,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/26145',
            removeUrl: '/api/ucs/shortlist/remove/26145',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '26145',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '914179',
          name: 'The Westminster London, Curio Collection by Hilton',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/920000/914200/914179/50aae99b_b.jpg',
              __typename: 'Image',
            },
            fallbackImage: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/920000/914200/914179/a3283ce5.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: null,
            tertiary: {
              text: 'Ad',
              theme_temp: 'PROMOTED',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£237',
                      accessibilityLabel: 'The price is £237',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£237',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£237',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.2,
            localizedScore: '4.2',
            total: 258,
            localizedTotal: '258 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.2 / 5 (258 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.2 out of 5 Very good (258 reviews)',
              value: '4.2/5 Very good (258 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Westminster-London.h914179.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316621&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382341&trackingData=AAAAEHViam0wN1gC_aUatLlMIVr0Hej0diae6k89BVxHU8nxCSg2kW7SqRKAqN2HF46lct4ZYw-MfpblFtr4_vqIQ1BMCblD0ad7Vez50BCq--4g0o2XEQ6A24JV5FtfT9BM2itLP-FUSIcTTqM4zFUBrl27QQgkYaCVmbMnGfMGyBoGhY4t0PK6hen8dtwFb-vdysg2nCu0-yhEu-DkAysxCa1BrnYRrB7JcljmZqQAdvhgKV6t_RowtAhKL01kJ47cpCHHEqv59ga-uYTvuArE0yrIVXD7nmcSt0k3jatqvkuaC0lWMgmMF0ZtS0BlrzxF6NtwtlFAWySC2_ieUIZhWBup-hFJn0reF45LHWxBHtrVHIkRdcHmxZmaczXw9u4Y3-0LFE98c_ApIzJz69fRf-lR9J5UPp98YwcRcF0bZmWvgoaVZW8s35j6_8BI1mvPG-D_zITboY0gVeYPOoyG2ef_bupJcwpM3M2uksUrAj34uTyKeFpm3EWmfPc-R8NMl7yLLtp64bIst1gTZBIlwvCGL2NqD8DovtErCq_Z30Bhvv7N5UV8oOJN6ummAb5pqTQ1qtAlj2E0z6f_CNAycH15RKGeJsYbWbj736Xwk7qGKHRa3YIWWGfYMiAmAN8JbyQaupuqWvb0EQggbqtAfnx3tT7Xhjhrhc4iYlnDCRjTLOMU4ROnf5KAabLinVFDqwTQLINW9AjDPMH5zSeTiQ3mMEfVM3MdIZ4dOEyTd_i5gSY7IsJhq9-uXaiKhfcO7EgEXvDL_SqtFvN0EzS8NwfH0PxgkFddlxocoqXunIiy4JcsFIuiXKgk69HrzRDV-bZOXUyuoXgrJ4qaGZFY_Z6zcCn5xNXbW1wjmjAlRVK4NJu-dnpS4YlHEjL9TssUa0EOh3frhgJXvaSL_nSCE1pDEOAEu_gxDlk_M_HOht86aupaT_aD3iuqQ3bC_nMbbOVjUrATVmxsRnF7hSHKhct1ykFuvf4adSX0fjD2X7inKzZX8TDy1XI9Vnr6gbQY71g2x8I0Lw99E_tP1EQ3w8V7yvObBdJ1A1oqMLihOWFVy9e8otJmgPsqLCgcYN_LbL3wuU8VgqVDfXykpGuBTJYV5uTZcLQELXzlFkOltdxMHt7eLiIUxmVstujHIIIHHg%3D%3D&rank=7&testVersionOverride=Buttercup&slots=HSR_BB&position=32&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=237&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=219367784&selectedRatePlan=386611759',
              relativePath:
                '/London-Hotels-The-Westminster-London.h914179.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316621&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382341&trackingData=AAAAEHViam0wN1gC_aUatLlMIVr0Hej0diae6k89BVxHU8nxCSg2kW7SqRKAqN2HF46lct4ZYw-MfpblFtr4_vqIQ1BMCblD0ad7Vez50BCq--4g0o2XEQ6A24JV5FtfT9BM2itLP-FUSIcTTqM4zFUBrl27QQgkYaCVmbMnGfMGyBoGhY4t0PK6hen8dtwFb-vdysg2nCu0-yhEu-DkAysxCa1BrnYRrB7JcljmZqQAdvhgKV6t_RowtAhKL01kJ47cpCHHEqv59ga-uYTvuArE0yrIVXD7nmcSt0k3jatqvkuaC0lWMgmMF0ZtS0BlrzxF6NtwtlFAWySC2_ieUIZhWBup-hFJn0reF45LHWxBHtrVHIkRdcHmxZmaczXw9u4Y3-0LFE98c_ApIzJz69fRf-lR9J5UPp98YwcRcF0bZmWvgoaVZW8s35j6_8BI1mvPG-D_zITboY0gVeYPOoyG2ef_bupJcwpM3M2uksUrAj34uTyKeFpm3EWmfPc-R8NMl7yLLtp64bIst1gTZBIlwvCGL2NqD8DovtErCq_Z30Bhvv7N5UV8oOJN6ummAb5pqTQ1qtAlj2E0z6f_CNAycH15RKGeJsYbWbj736Xwk7qGKHRa3YIWWGfYMiAmAN8JbyQaupuqWvb0EQggbqtAfnx3tT7Xhjhrhc4iYlnDCRjTLOMU4ROnf5KAabLinVFDqwTQLINW9AjDPMH5zSeTiQ3mMEfVM3MdIZ4dOEyTd_i5gSY7IsJhq9-uXaiKhfcO7EgEXvDL_SqtFvN0EzS8NwfH0PxgkFddlxocoqXunIiy4JcsFIuiXKgk69HrzRDV-bZOXUyuoXgrJ4qaGZFY_Z6zcCn5xNXbW1wjmjAlRVK4NJu-dnpS4YlHEjL9TssUa0EOh3frhgJXvaSL_nSCE1pDEOAEu_gxDlk_M_HOht86aupaT_aD3iuqQ3bC_nMbbOVjUrATVmxsRnF7hSHKhct1ykFuvf4adSX0fjD2X7inKzZX8TDy1XI9Vnr6gbQY71g2x8I0Lw99E_tP1EQ3w8V7yvObBdJ1A1oqMLihOWFVy9e8otJmgPsqLCgcYN_LbL3wuU8VgqVDfXykpGuBTJYV5uTZcLQELXzlFkOltdxMHt7eLiIUxmVstujHIIIHHg%3D%3D&rank=7&testVersionOverride=Buttercup&slots=HSR_BB&position=32&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=237&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=219367784&selectedRatePlan=386611759',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:32',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: {
            id: '666847',
            clickRedirectTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/ClRedirect?testVersionOverride=Buttercup&destinationUrl=&rank=7&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEHViam0wN1gC_aUatLlMIVr0Hej0diae6k89BVxHU8nxCSg2kW7SqRKAqN2HF46lct4ZYw-MfpblFtr4_vqIQ1BMCblD0ad7Vez50BCq--4g0o2XEQ6A24JV5FtfT9BM2itLP-FUSIcTTqM4zFUBrl27QQgkYaCVmbMnGfMGyBoGhY4t0PK6hen8dtwFb-vdysg2nCu0-yhEu-DkAysxCa1BrnYRrB7JcljmZqQAdvhgKV6t_RowtAhKL01kJ47cpCHHEqv59ga-uYTvuArE0yrIVXD7nmcSt0k3jatqvkuaC0lWMgmMF0ZtS0BlrzxF6NtwtlFAWySC2_ieUIZhWBup-hFJn0reF45LHWxBHtrVHIkRdcHmxZmaczXw9u4Y3-0LFE98c_ApIzJz69fRf-lR9J5UPp98YwcRcF0bZmWvgoaVZW8s35j6_8BI1mvPG-D_zITboY0gVeYPOoyG2ef_bupJcwpM3M2uksUrAj34uTyKeFpm3EWmfPc-R8NMl7yLLtp64bIst1gTZBIlwvCGL2NqD8DovtErCq_Z30Bhvv7N5UV8oOJN6ummAb5pqTQ1qtAlj2E0z6f_CNAycH15RKGeJsYbWbj736Xwk7qGKHRa3YIWWGfYMiAmAN8JbyQaupuqWvb0EQggbqtAfnx3tT7Xhjhrhc4iYlnDCRjTLOMU4ROnf5KAabLinVFDqwTQLINW9AjDPMH5zSeTiQ3mMEfVM3MdIZ4dOEyTd_i5gSY7IsJhq9-uXaiKhfcO7EgEXvDL_SqtFvN0EzS8NwfH0PxgkFddlxocoqXunIiy4JcsFIuiXKgk69HrzRDV-bZOXUyuoXgrJ4qaGZFY_Z6zcCn5xNXbW1wjmjAlRVK4NJu-dnpS4YlHEjL9TssUa0EOh3frhgJXvaSL_nSCE1pDEOAEu_gxDlk_M_HOht86aupaT_aD3iuqQ3bC_nMbbOVjUrATVmxsRnF7hSHKhct1ykFuvf4adSX0fjD2X7inKzZX8TDy1XI9Vnr6gbQY71g2x8I0Lw99E_tP1EQ3w8V7yvObBdJ1A1oqMLihOWFVy9e8otJmgPsqLCgcYN_LbL3wuU8VgqVDfXykpGuBTJYV5uTZcLQELXzlFkOltdxMHt7eLiIUxmVstujHIIIHHg==&slots=HSR_BB&position=32&beaconIssued=2022-08-10T13:48:35',
            clickTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Cl?testVersionOverride=Buttercup&rank=7&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEHViam0wN1gC_aUatLlMIVr0Hej0diae6k89BVxHU8nxCSg2kW7SqRKAqN2HF46lct4ZYw-MfpblFtr4_vqIQ1BMCblD0ad7Vez50BCq--4g0o2XEQ6A24JV5FtfT9BM2itLP-FUSIcTTqM4zFUBrl27QQgkYaCVmbMnGfMGyBoGhY4t0PK6hen8dtwFb-vdysg2nCu0-yhEu-DkAysxCa1BrnYRrB7JcljmZqQAdvhgKV6t_RowtAhKL01kJ47cpCHHEqv59ga-uYTvuArE0yrIVXD7nmcSt0k3jatqvkuaC0lWMgmMF0ZtS0BlrzxF6NtwtlFAWySC2_ieUIZhWBup-hFJn0reF45LHWxBHtrVHIkRdcHmxZmaczXw9u4Y3-0LFE98c_ApIzJz69fRf-lR9J5UPp98YwcRcF0bZmWvgoaVZW8s35j6_8BI1mvPG-D_zITboY0gVeYPOoyG2ef_bupJcwpM3M2uksUrAj34uTyKeFpm3EWmfPc-R8NMl7yLLtp64bIst1gTZBIlwvCGL2NqD8DovtErCq_Z30Bhvv7N5UV8oOJN6ummAb5pqTQ1qtAlj2E0z6f_CNAycH15RKGeJsYbWbj736Xwk7qGKHRa3YIWWGfYMiAmAN8JbyQaupuqWvb0EQggbqtAfnx3tT7Xhjhrhc4iYlnDCRjTLOMU4ROnf5KAabLinVFDqwTQLINW9AjDPMH5zSeTiQ3mMEfVM3MdIZ4dOEyTd_i5gSY7IsJhq9-uXaiKhfcO7EgEXvDL_SqtFvN0EzS8NwfH0PxgkFddlxocoqXunIiy4JcsFIuiXKgk69HrzRDV-bZOXUyuoXgrJ4qaGZFY_Z6zcCn5xNXbW1wjmjAlRVK4NJu-dnpS4YlHEjL9TssUa0EOh3frhgJXvaSL_nSCE1pDEOAEu_gxDlk_M_HOht86aupaT_aD3iuqQ3bC_nMbbOVjUrATVmxsRnF7hSHKhct1ykFuvf4adSX0fjD2X7inKzZX8TDy1XI9Vnr6gbQY71g2x8I0Lw99E_tP1EQ3w8V7yvObBdJ1A1oqMLihOWFVy9e8otJmgPsqLCgcYN_LbL3wuU8VgqVDfXykpGuBTJYV5uTZcLQELXzlFkOltdxMHt7eLiIUxmVstujHIIIHHg==&slots=HSR_BB&position=32&beaconIssued=2022-08-10T13:48:35',
            details:
              'Stylish rooms near Buckingham Palace, Big Ben, and The Houses of Parliament. Free WiFi, Nespresso machine, luxury rain shower.',
            detailsHeadline: 'Hidden gem in the heart of Westminster ',
            hotelImage:
              'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/920000/914200/914179/50aae99b_b.jpg',
            impressionTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Impr?testVersionOverride=Buttercup&rank=7&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEHViam0wN1gC_aUatLlMIVr0Hej0diae6k89BVxHU8nxCSg2kW7SqRKAqN2HF46lct4ZYw-MfpblFtr4_vqIQ1BMCblD0ad7Vez50BCq--4g0o2XEQ6A24JV5FtfT9BM2itLP-FUSIcTTqM4zFUBrl27QQgkYaCVmbMnGfMGyBoGhY4t0PK6hen8dtwFb-vdysg2nCu0-yhEu-DkAysxCa1BrnYRrB7JcljmZqQAdvhgKV6t_RowtAhKL01kJ47cpCHHEqv59ga-uYTvuArE0yrIVXD7nmcSt0k3jatqvkuaC0lWMgmMF0ZtS0BlrzxF6NtwtlFAWySC2_ieUIZhWBup-hFJn0reF45LHWxBHtrVHIkRdcHmxZmaczXw9u4Y3-0LFE98c_ApIzJz69fRf-lR9J5UPp98YwcRcF0bZmWvgoaVZW8s35j6_8BI1mvPG-D_zITboY0gVeYPOoyG2ef_bupJcwpM3M2uksUrAj34uTyKeFpm3EWmfPc-R8NMl7yLLtp64bIst1gTZBIlwvCGL2NqD8DovtErCq_Z30Bhvv7N5UV8oOJN6ummAb5pqTQ1qtAlj2E0z6f_CNAycH15RKGeJsYbWbj736Xwk7qGKHRa3YIWWGfYMiAmAN8JbyQaupuqWvb0EQggbqtAfnx3tT7Xhjhrhc4iYlnDCRjTLOMU4ROnf5KAabLinVFDqwTQLINW9AjDPMH5zSeTiQ3mMEfVM3MdIZ4dOEyTd_i5gSY7IsJhq9-uXaiKhfcO7EgEXvDL_SqtFvN0EzS8NwfH0PxgkFddlxocoqXunIiy4JcsFIuiXKgk69HrzRDV-bZOXUyuoXgrJ4qaGZFY_Z6zcCn5xNXbW1wjmjAlRVK4NJu-dnpS4YlHEjL9TssUa0EOh3frhgJXvaSL_nSCE1pDEOAEu_gxDlk_M_HOht86aupaT_aD3iuqQ3bC_nMbbOVjUrATVmxsRnF7hSHKhct1ykFuvf4adSX0fjD2X7inKzZX8TDy1XI9Vnr6gbQY71g2x8I0Lw99E_tP1EQ3w8V7yvObBdJ1A1oqMLihOWFVy9e8otJmgPsqLCgcYN_LbL3wuU8VgqVDfXykpGuBTJYV5uTZcLQELXzlFkOltdxMHt7eLiIUxmVstujHIIIHHg==&slots=HSR_BB&position=32&beaconIssued=2022-08-10T13:48:35',
            trackingData:
              'AAAAEHViam0wN1gC_aUatLlMIVr0Hej0diae6k89BVxHU8nxCSg2kW7SqRKAqN2HF46lct4ZYw-MfpblFtr4_vqIQ1BMCblD0ad7Vez50BCq--4g0o2XEQ6A24JV5FtfT9BM2itLP-FUSIcTTqM4zFUBrl27QQgkYaCVmbMnGfMGyBoGhY4t0PK6hen8dtwFb-vdysg2nCu0-yhEu-DkAysxCa1BrnYRrB7JcljmZqQAdvhgKV6t_RowtAhKL01kJ47cpCHHEqv59ga-uYTvuArE0yrIVXD7nmcSt0k3jatqvkuaC0lWMgmMF0ZtS0BlrzxF6NtwtlFAWySC2_ieUIZhWBup-hFJn0reF45LHWxBHtrVHIkRdcHmxZmaczXw9u4Y3-0LFE98c_ApIzJz69fRf-lR9J5UPp98YwcRcF0bZmWvgoaVZW8s35j6_8BI1mvPG-D_zITboY0gVeYPOoyG2ef_bupJcwpM3M2uksUrAj34uTyKeFpm3EWmfPc-R8NMl7yLLtp64bIst1gTZBIlwvCGL2NqD8DovtErCq_Z30Bhvv7N5UV8oOJN6ummAb5pqTQ1qtAlj2E0z6f_CNAycH15RKGeJsYbWbj736Xwk7qGKHRa3YIWWGfYMiAmAN8JbyQaupuqWvb0EQggbqtAfnx3tT7Xhjhrhc4iYlnDCRjTLOMU4ROnf5KAabLinVFDqwTQLINW9AjDPMH5zSeTiQ3mMEfVM3MdIZ4dOEyTd_i5gSY7IsJhq9-uXaiKhfcO7EgEXvDL_SqtFvN0EzS8NwfH0PxgkFddlxocoqXunIiy4JcsFIuiXKgk69HrzRDV-bZOXUyuoXgrJ4qaGZFY_Z6zcCn5xNXbW1wjmjAlRVK4NJu-dnpS4YlHEjL9TssUa0EOh3frhgJXvaSL_nSCE1pDEOAEu_gxDlk_M_HOht86aupaT_aD3iuqQ3bC_nMbbOVjUrATVmxsRnF7hSHKhct1ykFuvf4adSX0fjD2X7inKzZX8TDy1XI9Vnr6gbQY71g2x8I0Lw99E_tP1EQ3w8V7yvObBdJ1A1oqMLihOWFVy9e8otJmgPsqLCgcYN_LbL3wuU8VgqVDfXykpGuBTJYV5uTZcLQELXzlFkOltdxMHt7eLiIUxmVstujHIIIHHg==',
            brand: null,
            clickRedirectLinkoffTrackingUrl: null,
            logo: null,
            lotagline: null,
            rating: '0',
            slots: 'HSR_BB',
            vanityUrl: null,
            rank: '7',
            position: '32',
            __typename: 'SponsoredListing',
          },
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Westminster London, Curio Collection by Hilton',
            images: [
              {
                image: {
                  url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/920000/914200/914179/50aae99b_b.jpg',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: {
                  url: 'https://images.trvl-media.com/hotels/1000000/920000/914200/914179/a3283ce5.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                imageId: '555357696',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/920000/914200/914179/9f5219e3.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '572683600',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/920000/914200/914179/8eb0eb0a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '555386504',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/920000/914200/914179/49835d10.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '604526807',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£237',
            type: 'HOTEL',
            latLong: {
              latitude: 51.493261,
              longitude: -0.127276,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/914179',
            removeUrl: '/api/ucs/shortlist/remove/914179',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '914179',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '54995',
          name: 'The President Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/60000/55000/54995/fe44d15f_b.jpg',
              __typename: 'Image',
            },
            fallbackImage: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54995/99ea1f96.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: {
              text: 'Ad',
              theme_temp: 'PROMOTED',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£150',
                      accessibilityLabel: 'The price is £150',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£150',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£150',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4,
            localizedScore: '4.0',
            total: 1365,
            localizedTotal: '1,365 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.0 / 5 (1,365 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.0 out of 5 Very good (1,365 reviews)',
              value: '4.0/5 Very good (1,365 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-President-Hotel.h54995.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316618&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&trackingData=AAAAEAlTb5kCorBiz6HQQ93DYlebe-lcnl1LbKGH60NT_odpItXWIMgHV8cruA3qcSTf-U26qEYsYYyMN3dnLkZLnmviA21ji5_Pe1QARv4CbIh3NfcyGw6Dd-MB9q7PNu9CmJdXkhdCZdQx41G5IVfd2uDhU_Jjua_9YjenF8xOOJyGr43FIq1jIY2DgYVH5hSaTMBG7MmHTz4ib_oXFPnXTuWEhd9XoJrO6ylrfiAavKFOa0CSjjVTGcK6UPpKhfaLG07nHfB83HgF1xx2bbMSpVRcl8TuVKrb2qkjizrwCG7veIHHi0oKASas7KEQ032cvlaoWoNy_OBjsyfBJaZXLp-cdoMNVkCi-QlQAOBfDirYSJ-eR1TQG_lcawkSJ7e7lzDxUv2r6iXRKsXhPuaZBJIk64iBlUreVIEqrm23cMgYC4Gf8VZgLZpRLyq9oK24UjfnMHxbnQIA0MbHjJCOELvD7FsfucB7aQA_bjZ5mRMYc_3Oemfbufu77cWywPFn0ZeZ-s70ZRE63fZz2OxIopejxyOSqxyTMXS3PWwksm3W2gEM131RYuWMdG1jfFnuL3PZ8RUU9o14NOrZJO1gVGj5VeZdL4ggYhQJdcZfM0y9TIoOjZH3Vh6ccmLvDxDEmbnD35TfnDg4IEzzJ0TvocDE_S2rXhyEQxgqCOLzy7a1GGI8dotrEDJIp6vCxW9cEUtu8zXuFkWK4Y9lzVhj5yFPtrKUGmLZ2syUpd14xDRxC4f8bw-ZoFdyd-6lg0ZVozeNS9Xzz-XgEjdd9gW5QMx6uyDteeqrcCkSkuR4P3YO8FCzIrfbmjFVsOdjHntGKqY3Bc7tNkl8VE8IofqkvvYjPmxjcO353gTKVZhOVUY50HBc3U9Q-gurUB-zmVjlTuhnHTzSqPlsjSwWg4AenRNvq7nT4DI2UY_wbgPsCgqrRCnBw-pec6TZQx_SMbzxkE3grICmFK5UgBw4e5CafGfytY1_tkpI2Wac0xQvqD3ZbR4yeCg4J8Lea2JGhrWfcmzCtq1fltykDTjxuaOX31x7_eTZYyECGY_yKZl7sHfCmg00viAEhWifVFZCwOYJwLM3mNB4gz2g7gN5yweErIC5Gs5LUssOpYD7L7Sf8BzA7UrmeUKHd516OcMyeizt7Z_R-Zf3vJgSdudi6G69VN0%3D&rank=8&testVersionOverride=Buttercup&slots=HSR_CA&position=33&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=150&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=232851588&selectedRatePlan=385819835',
              relativePath:
                '/London-Hotels-The-President-Hotel.h54995.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316618&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&trackingData=AAAAEAlTb5kCorBiz6HQQ93DYlebe-lcnl1LbKGH60NT_odpItXWIMgHV8cruA3qcSTf-U26qEYsYYyMN3dnLkZLnmviA21ji5_Pe1QARv4CbIh3NfcyGw6Dd-MB9q7PNu9CmJdXkhdCZdQx41G5IVfd2uDhU_Jjua_9YjenF8xOOJyGr43FIq1jIY2DgYVH5hSaTMBG7MmHTz4ib_oXFPnXTuWEhd9XoJrO6ylrfiAavKFOa0CSjjVTGcK6UPpKhfaLG07nHfB83HgF1xx2bbMSpVRcl8TuVKrb2qkjizrwCG7veIHHi0oKASas7KEQ032cvlaoWoNy_OBjsyfBJaZXLp-cdoMNVkCi-QlQAOBfDirYSJ-eR1TQG_lcawkSJ7e7lzDxUv2r6iXRKsXhPuaZBJIk64iBlUreVIEqrm23cMgYC4Gf8VZgLZpRLyq9oK24UjfnMHxbnQIA0MbHjJCOELvD7FsfucB7aQA_bjZ5mRMYc_3Oemfbufu77cWywPFn0ZeZ-s70ZRE63fZz2OxIopejxyOSqxyTMXS3PWwksm3W2gEM131RYuWMdG1jfFnuL3PZ8RUU9o14NOrZJO1gVGj5VeZdL4ggYhQJdcZfM0y9TIoOjZH3Vh6ccmLvDxDEmbnD35TfnDg4IEzzJ0TvocDE_S2rXhyEQxgqCOLzy7a1GGI8dotrEDJIp6vCxW9cEUtu8zXuFkWK4Y9lzVhj5yFPtrKUGmLZ2syUpd14xDRxC4f8bw-ZoFdyd-6lg0ZVozeNS9Xzz-XgEjdd9gW5QMx6uyDteeqrcCkSkuR4P3YO8FCzIrfbmjFVsOdjHntGKqY3Bc7tNkl8VE8IofqkvvYjPmxjcO353gTKVZhOVUY50HBc3U9Q-gurUB-zmVjlTuhnHTzSqPlsjSwWg4AenRNvq7nT4DI2UY_wbgPsCgqrRCnBw-pec6TZQx_SMbzxkE3grICmFK5UgBw4e5CafGfytY1_tkpI2Wac0xQvqD3ZbR4yeCg4J8Lea2JGhrWfcmzCtq1fltykDTjxuaOX31x7_eTZYyECGY_yKZl7sHfCmg00viAEhWifVFZCwOYJwLM3mNB4gz2g7gN5yweErIC5Gs5LUssOpYD7L7Sf8BzA7UrmeUKHd516OcMyeizt7Z_R-Zf3vJgSdudi6G69VN0%3D&rank=8&testVersionOverride=Buttercup&slots=HSR_CA&position=33&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=150&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=232851588&selectedRatePlan=385819835',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:33',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: {
            id: '653526',
            clickRedirectTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/ClRedirect?testVersionOverride=Buttercup&destinationUrl=&rank=8&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEAlTb5kCorBiz6HQQ93DYlebe-lcnl1LbKGH60NT_odpItXWIMgHV8cruA3qcSTf-U26qEYsYYyMN3dnLkZLnmviA21ji5_Pe1QARv4CbIh3NfcyGw6Dd-MB9q7PNu9CmJdXkhdCZdQx41G5IVfd2uDhU_Jjua_9YjenF8xOOJyGr43FIq1jIY2DgYVH5hSaTMBG7MmHTz4ib_oXFPnXTuWEhd9XoJrO6ylrfiAavKFOa0CSjjVTGcK6UPpKhfaLG07nHfB83HgF1xx2bbMSpVRcl8TuVKrb2qkjizrwCG7veIHHi0oKASas7KEQ032cvlaoWoNy_OBjsyfBJaZXLp-cdoMNVkCi-QlQAOBfDirYSJ-eR1TQG_lcawkSJ7e7lzDxUv2r6iXRKsXhPuaZBJIk64iBlUreVIEqrm23cMgYC4Gf8VZgLZpRLyq9oK24UjfnMHxbnQIA0MbHjJCOELvD7FsfucB7aQA_bjZ5mRMYc_3Oemfbufu77cWywPFn0ZeZ-s70ZRE63fZz2OxIopejxyOSqxyTMXS3PWwksm3W2gEM131RYuWMdG1jfFnuL3PZ8RUU9o14NOrZJO1gVGj5VeZdL4ggYhQJdcZfM0y9TIoOjZH3Vh6ccmLvDxDEmbnD35TfnDg4IEzzJ0TvocDE_S2rXhyEQxgqCOLzy7a1GGI8dotrEDJIp6vCxW9cEUtu8zXuFkWK4Y9lzVhj5yFPtrKUGmLZ2syUpd14xDRxC4f8bw-ZoFdyd-6lg0ZVozeNS9Xzz-XgEjdd9gW5QMx6uyDteeqrcCkSkuR4P3YO8FCzIrfbmjFVsOdjHntGKqY3Bc7tNkl8VE8IofqkvvYjPmxjcO353gTKVZhOVUY50HBc3U9Q-gurUB-zmVjlTuhnHTzSqPlsjSwWg4AenRNvq7nT4DI2UY_wbgPsCgqrRCnBw-pec6TZQx_SMbzxkE3grICmFK5UgBw4e5CafGfytY1_tkpI2Wac0xQvqD3ZbR4yeCg4J8Lea2JGhrWfcmzCtq1fltykDTjxuaOX31x7_eTZYyECGY_yKZl7sHfCmg00viAEhWifVFZCwOYJwLM3mNB4gz2g7gN5yweErIC5Gs5LUssOpYD7L7Sf8BzA7UrmeUKHd516OcMyeizt7Z_R-Zf3vJgSdudi6G69VN0=&slots=HSR_CA&position=33&beaconIssued=2022-08-10T13:48:35',
            clickTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Cl?testVersionOverride=Buttercup&rank=8&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEAlTb5kCorBiz6HQQ93DYlebe-lcnl1LbKGH60NT_odpItXWIMgHV8cruA3qcSTf-U26qEYsYYyMN3dnLkZLnmviA21ji5_Pe1QARv4CbIh3NfcyGw6Dd-MB9q7PNu9CmJdXkhdCZdQx41G5IVfd2uDhU_Jjua_9YjenF8xOOJyGr43FIq1jIY2DgYVH5hSaTMBG7MmHTz4ib_oXFPnXTuWEhd9XoJrO6ylrfiAavKFOa0CSjjVTGcK6UPpKhfaLG07nHfB83HgF1xx2bbMSpVRcl8TuVKrb2qkjizrwCG7veIHHi0oKASas7KEQ032cvlaoWoNy_OBjsyfBJaZXLp-cdoMNVkCi-QlQAOBfDirYSJ-eR1TQG_lcawkSJ7e7lzDxUv2r6iXRKsXhPuaZBJIk64iBlUreVIEqrm23cMgYC4Gf8VZgLZpRLyq9oK24UjfnMHxbnQIA0MbHjJCOELvD7FsfucB7aQA_bjZ5mRMYc_3Oemfbufu77cWywPFn0ZeZ-s70ZRE63fZz2OxIopejxyOSqxyTMXS3PWwksm3W2gEM131RYuWMdG1jfFnuL3PZ8RUU9o14NOrZJO1gVGj5VeZdL4ggYhQJdcZfM0y9TIoOjZH3Vh6ccmLvDxDEmbnD35TfnDg4IEzzJ0TvocDE_S2rXhyEQxgqCOLzy7a1GGI8dotrEDJIp6vCxW9cEUtu8zXuFkWK4Y9lzVhj5yFPtrKUGmLZ2syUpd14xDRxC4f8bw-ZoFdyd-6lg0ZVozeNS9Xzz-XgEjdd9gW5QMx6uyDteeqrcCkSkuR4P3YO8FCzIrfbmjFVsOdjHntGKqY3Bc7tNkl8VE8IofqkvvYjPmxjcO353gTKVZhOVUY50HBc3U9Q-gurUB-zmVjlTuhnHTzSqPlsjSwWg4AenRNvq7nT4DI2UY_wbgPsCgqrRCnBw-pec6TZQx_SMbzxkE3grICmFK5UgBw4e5CafGfytY1_tkpI2Wac0xQvqD3ZbR4yeCg4J8Lea2JGhrWfcmzCtq1fltykDTjxuaOX31x7_eTZYyECGY_yKZl7sHfCmg00viAEhWifVFZCwOYJwLM3mNB4gz2g7gN5yweErIC5Gs5LUssOpYD7L7Sf8BzA7UrmeUKHd516OcMyeizt7Z_R-Zf3vJgSdudi6G69VN0=&slots=HSR_CA&position=33&beaconIssued=2022-08-10T13:48:35',
            details:
              'A classic hotel perfect for business or leisure, within easy walking distance to Oxford Street, Covent Garden and Kings Cross.',
            detailsHeadline: 'Stay in the heart of central London',
            hotelImage:
              'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/60000/55000/54995/fe44d15f_b.jpg',
            impressionTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Impr?testVersionOverride=Buttercup&rank=8&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEAlTb5kCorBiz6HQQ93DYlebe-lcnl1LbKGH60NT_odpItXWIMgHV8cruA3qcSTf-U26qEYsYYyMN3dnLkZLnmviA21ji5_Pe1QARv4CbIh3NfcyGw6Dd-MB9q7PNu9CmJdXkhdCZdQx41G5IVfd2uDhU_Jjua_9YjenF8xOOJyGr43FIq1jIY2DgYVH5hSaTMBG7MmHTz4ib_oXFPnXTuWEhd9XoJrO6ylrfiAavKFOa0CSjjVTGcK6UPpKhfaLG07nHfB83HgF1xx2bbMSpVRcl8TuVKrb2qkjizrwCG7veIHHi0oKASas7KEQ032cvlaoWoNy_OBjsyfBJaZXLp-cdoMNVkCi-QlQAOBfDirYSJ-eR1TQG_lcawkSJ7e7lzDxUv2r6iXRKsXhPuaZBJIk64iBlUreVIEqrm23cMgYC4Gf8VZgLZpRLyq9oK24UjfnMHxbnQIA0MbHjJCOELvD7FsfucB7aQA_bjZ5mRMYc_3Oemfbufu77cWywPFn0ZeZ-s70ZRE63fZz2OxIopejxyOSqxyTMXS3PWwksm3W2gEM131RYuWMdG1jfFnuL3PZ8RUU9o14NOrZJO1gVGj5VeZdL4ggYhQJdcZfM0y9TIoOjZH3Vh6ccmLvDxDEmbnD35TfnDg4IEzzJ0TvocDE_S2rXhyEQxgqCOLzy7a1GGI8dotrEDJIp6vCxW9cEUtu8zXuFkWK4Y9lzVhj5yFPtrKUGmLZ2syUpd14xDRxC4f8bw-ZoFdyd-6lg0ZVozeNS9Xzz-XgEjdd9gW5QMx6uyDteeqrcCkSkuR4P3YO8FCzIrfbmjFVsOdjHntGKqY3Bc7tNkl8VE8IofqkvvYjPmxjcO353gTKVZhOVUY50HBc3U9Q-gurUB-zmVjlTuhnHTzSqPlsjSwWg4AenRNvq7nT4DI2UY_wbgPsCgqrRCnBw-pec6TZQx_SMbzxkE3grICmFK5UgBw4e5CafGfytY1_tkpI2Wac0xQvqD3ZbR4yeCg4J8Lea2JGhrWfcmzCtq1fltykDTjxuaOX31x7_eTZYyECGY_yKZl7sHfCmg00viAEhWifVFZCwOYJwLM3mNB4gz2g7gN5yweErIC5Gs5LUssOpYD7L7Sf8BzA7UrmeUKHd516OcMyeizt7Z_R-Zf3vJgSdudi6G69VN0=&slots=HSR_CA&position=33&beaconIssued=2022-08-10T13:48:35',
            trackingData:
              'AAAAEAlTb5kCorBiz6HQQ93DYlebe-lcnl1LbKGH60NT_odpItXWIMgHV8cruA3qcSTf-U26qEYsYYyMN3dnLkZLnmviA21ji5_Pe1QARv4CbIh3NfcyGw6Dd-MB9q7PNu9CmJdXkhdCZdQx41G5IVfd2uDhU_Jjua_9YjenF8xOOJyGr43FIq1jIY2DgYVH5hSaTMBG7MmHTz4ib_oXFPnXTuWEhd9XoJrO6ylrfiAavKFOa0CSjjVTGcK6UPpKhfaLG07nHfB83HgF1xx2bbMSpVRcl8TuVKrb2qkjizrwCG7veIHHi0oKASas7KEQ032cvlaoWoNy_OBjsyfBJaZXLp-cdoMNVkCi-QlQAOBfDirYSJ-eR1TQG_lcawkSJ7e7lzDxUv2r6iXRKsXhPuaZBJIk64iBlUreVIEqrm23cMgYC4Gf8VZgLZpRLyq9oK24UjfnMHxbnQIA0MbHjJCOELvD7FsfucB7aQA_bjZ5mRMYc_3Oemfbufu77cWywPFn0ZeZ-s70ZRE63fZz2OxIopejxyOSqxyTMXS3PWwksm3W2gEM131RYuWMdG1jfFnuL3PZ8RUU9o14NOrZJO1gVGj5VeZdL4ggYhQJdcZfM0y9TIoOjZH3Vh6ccmLvDxDEmbnD35TfnDg4IEzzJ0TvocDE_S2rXhyEQxgqCOLzy7a1GGI8dotrEDJIp6vCxW9cEUtu8zXuFkWK4Y9lzVhj5yFPtrKUGmLZ2syUpd14xDRxC4f8bw-ZoFdyd-6lg0ZVozeNS9Xzz-XgEjdd9gW5QMx6uyDteeqrcCkSkuR4P3YO8FCzIrfbmjFVsOdjHntGKqY3Bc7tNkl8VE8IofqkvvYjPmxjcO353gTKVZhOVUY50HBc3U9Q-gurUB-zmVjlTuhnHTzSqPlsjSwWg4AenRNvq7nT4DI2UY_wbgPsCgqrRCnBw-pec6TZQx_SMbzxkE3grICmFK5UgBw4e5CafGfytY1_tkpI2Wac0xQvqD3ZbR4yeCg4J8Lea2JGhrWfcmzCtq1fltykDTjxuaOX31x7_eTZYyECGY_yKZl7sHfCmg00viAEhWifVFZCwOYJwLM3mNB4gz2g7gN5yweErIC5Gs5LUssOpYD7L7Sf8BzA7UrmeUKHd516OcMyeizt7Z_R-Zf3vJgSdudi6G69VN0=',
            brand: null,
            clickRedirectLinkoffTrackingUrl: null,
            logo: null,
            lotagline: null,
            rating: '0',
            slots: 'HSR_CA',
            vanityUrl: null,
            rank: '8',
            position: '33',
            __typename: 'SponsoredListing',
          },
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The President Hotel',
            images: [
              {
                image: {
                  url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/60000/55000/54995/fe44d15f_b.jpg',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54995/99ea1f96.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                imageId: '449705555',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54995/aefec877.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '449705689',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54995/c4b38786.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '449705770',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54995/421f05cc.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '449705632',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£150',
            type: 'HOTEL',
            latLong: {
              latitude: 51.522443,
              longitude: -0.124143,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/54995',
            removeUrl: '/api/ucs/shortlist/remove/54995',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '54995',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '1524786',
          name: 'The Hoxton Shoreditch',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/2000000/1530000/1524800/1524786/a19e018d.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£249',
                      accessibilityLabel: 'The price is £249',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£249',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£249',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.5,
            localizedScore: '4.5',
            total: 576,
            localizedTotal: '576 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.5 / 5 (576 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.5 out of 5 Wonderful (576 reviews)',
              value: '4.5/5 Wonderful (576 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Hoxton-Shoreditch.h1524786.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316621&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179542&price=0%2C300&sort=RECOMMENDED&top_dp=249&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=218109952&selectedRatePlan=274029405',
              relativePath:
                '/London-Hotels-The-Hoxton-Shoreditch.h1524786.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316621&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179542&price=0%2C300&sort=RECOMMENDED&top_dp=249&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=218109952&selectedRatePlan=274029405',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:34',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Hoxton Shoreditch',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1530000/1524800/1524786/a19e018d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '61803748',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1530000/1524800/1524786/918c618a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Property entrance',
                  __typename: 'Image',
                },
                subjectId: 91002,
                fallbackImage: null,
                imageId: '61802820',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1530000/1524800/1524786/ffd4d9ac.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '61802605',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1530000/1524800/1524786/bb37b4d4.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '61802929',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£249',
            type: 'HOTEL',
            latLong: {
              latitude: 51.52557,
              longitude: -0.08289,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/1524786',
            removeUrl: '/api/ucs/shortlist/remove/1524786',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '1524786',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '4836998',
          name: 'Apex Temple Court Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/5000000/4840000/4837000/4836998/195075a4.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: '21% off',
              theme_temp: 'DEAL_GENERIC',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'STRIKEOUT',
                    price: {
                      formatted: '£221',
                      accessibilityLabel: 'The price was £221',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: {
                      content: [
                        'This price is the standard rate on our site as provided by the property based on your search.',
                      ],
                      primaryUIButton: {
                        accessibility: null,
                        primary: 'Close',
                        __typename: 'UIPrimaryButton',
                      },
                      __typename: 'LodgingPlainDialog',
                    },
                  },
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£175',
                      accessibilityLabel: 'The price is £175',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£175',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: {
              formatted: '£221',
              __typename: 'Money',
            },
            disclaimer: {
              value: 'This price is the standard rate on our site as provided by the property based on your search.',
              __typename: 'LodgingPlainMessage',
            },
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£175',
                  __typename: 'Money',
                },
                strikeOut: {
                  formatted: '£221',
                  __typename: 'Money',
                },
                loyaltyPrice: null,
                disclaimer: {
                  value:
                    'This price is the standard rate on our site as provided by the property based on your search.',
                  __typename: 'LodgingPlainMessage',
                },
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.7,
            localizedScore: '4.7',
            total: 1003,
            localizedTotal: '1,003 reviews',
            superlative: 'Exceptional',
            localizedSubtitle: '4.7 / 5 (1,003 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.7 out of 5 Exceptional (1,003 reviews)',
              value: '4.7/5 Exceptional (1,003 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Apex-Temple-Court-Hotel.h4836998.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316618&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248634838840661&price=0%2C300&sort=RECOMMENDED&top_dp=175&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200354459&selectedRatePlan=204565613',
              relativePath:
                '/London-Hotels-Apex-Temple-Court-Hotel.h4836998.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316618&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248634838840661&price=0%2C300&sort=RECOMMENDED&top_dp=175&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200354459&selectedRatePlan=204565613',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:35',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Apex Temple Court Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/5000000/4840000/4837000/4836998/195075a4.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '458622237',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/5000000/4840000/4837000/4836998/584ba5c8.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Courtyard',
                  __typename: 'Image',
                },
                subjectId: 91006,
                fallbackImage: null,
                imageId: '78649723',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/5000000/4840000/4837000/4836998/aa0c3d0f.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Living room',
                  __typename: 'Image',
                },
                subjectId: 22006,
                fallbackImage: null,
                imageId: '16422091',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/5000000/4840000/4837000/4836998/b0880bb5.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '388171855',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£175',
            type: 'HOTEL',
            latLong: {
              latitude: 51.513617,
              longitude: -0.108428,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/4836998',
            removeUrl: '/api/ucs/shortlist/remove/4836998',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '4836998',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '614',
          name: 'St Giles Hotel - London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/10000/700/614/046d2fde.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£175',
                      accessibilityLabel: 'The price is £175',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£175',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£175',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.8,
            localizedScore: '3.8',
            total: 2180,
            localizedTotal: '2,180 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.8 / 5 (2,180 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.8 out of 5 Good (2,180 reviews)',
              value: '3.8/5 Good (2,180 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-St-Giles-London-A-St-Giles-Hotel.h614.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316618&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144889&price=0%2C300&sort=RECOMMENDED&top_dp=175&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=219004134&selectedRatePlan=280015653',
              relativePath:
                '/London-Hotels-St-Giles-London-A-St-Giles-Hotel.h614.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316618&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144889&price=0%2C300&sort=RECOMMENDED&top_dp=175&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=219004134&selectedRatePlan=280015653',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:36',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for St Giles Hotel - London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/700/614/046d2fde.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '67671253',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/700/614/73ea43ed.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '683789868',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/700/614/60ea8b88.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Living area',
                  __typename: 'Image',
                },
                subjectId: 22005,
                fallbackImage: null,
                imageId: '417371510',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/700/614/f28d3379.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '16146410',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£175',
            type: 'HOTEL',
            latLong: {
              latitude: 51.517612,
              longitude: -0.130687,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/614',
            removeUrl: '/api/ucs/shortlist/remove/614',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '614',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '83096424',
          name: 'Tribe London Canary Wharf',
          propertyImage: {
            image: {
              description: 'Reception',
              url: 'https://images.trvl-media.com/hotels/84000000/83100000/83096500/83096424/0505933a.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£143',
                      accessibilityLabel: 'The price is £143',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£143',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£143',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 5,
            localizedScore: '5.0',
            total: 1,
            localizedTotal: '1 review',
            superlative: 'Exceptional',
            localizedSubtitle: '5.0 / 5 (1 review)',
            localizedSubtitleA11y: {
              accessibilityLabel: '5.0 out of 5 Exceptional (1 review)',
              value: '5.0/5 Exceptional (1 review)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Tribe-London-Canary-Wharf.h83096424.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316622&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179523&price=0%2C300&sort=RECOMMENDED&top_dp=143&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=319606094&selectedRatePlan=387021768',
              relativePath:
                '/London-Hotels-Tribe-London-Canary-Wharf.h83096424.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316622&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179523&price=0%2C300&sort=RECOMMENDED&top_dp=143&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=319606094&selectedRatePlan=387021768',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:37',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Tribe London Canary Wharf',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/84000000/83100000/83096500/83096424/c0fb36f4.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property',
                  __typename: 'Image',
                },
                subjectId: 91001,
                fallbackImage: null,
                imageId: '700714034',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/84000000/83100000/83096500/83096424/df7d67b9.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '699497313',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/84000000/83100000/83096500/83096424/659ed3ca.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '700713958',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/84000000/83100000/83096500/83096424/5749cfac.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Restaurant',
                  __typename: 'Image',
                },
                subjectId: 81003,
                fallbackImage: null,
                imageId: '700295326',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£143',
            type: 'HOTEL',
            latLong: {
              latitude: 51.503285,
              longitude: -0.013102,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'Canary Wharf',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/83096424',
            removeUrl: '/api/ucs/shortlist/remove/83096424',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '83096424',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '428403',
          name: 'Corus Hyde Park Hotel',
          propertyImage: {
            image: {
              description: 'Lobby',
              url: 'https://images.trvl-media.com/hotels/1000000/430000/428500/428403/8e736d15.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: '11% off',
              theme_temp: 'DEAL_GENERIC',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'STRIKEOUT',
                    price: {
                      formatted: '£155',
                      accessibilityLabel: 'The price was £155',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: {
                      content: [
                        'This price is the standard rate on our site as provided by the property based on your search.',
                      ],
                      primaryUIButton: {
                        accessibility: null,
                        primary: 'Close',
                        __typename: 'UIPrimaryButton',
                      },
                      __typename: 'LodgingPlainDialog',
                    },
                  },
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£139',
                      accessibilityLabel: 'The price is £139',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£139',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: {
              formatted: '£155',
              __typename: 'Money',
            },
            disclaimer: {
              value: 'This price is the standard rate on our site as provided by the property based on your search.',
              __typename: 'LodgingPlainMessage',
            },
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£139',
                  __typename: 'Money',
                },
                strikeOut: {
                  formatted: '£155',
                  __typename: 'Money',
                },
                loyaltyPrice: null,
                disclaimer: {
                  value:
                    'This price is the standard rate on our site as provided by the property based on your search.',
                  __typename: 'LodgingPlainMessage',
                },
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.7,
            localizedScore: '3.7',
            total: 1001,
            localizedTotal: '1,001 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.7 / 5 (1,001 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.7 out of 5 Good (1,001 reviews)',
              value: '3.7/5 Good (1,001 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Corus-Hyde-Park-Hotel.h428403.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316620&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382417&price=0%2C300&sort=RECOMMENDED&top_dp=139&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200318591&selectedRatePlan=232312119',
              relativePath:
                '/London-Hotels-Corus-Hyde-Park-Hotel.h428403.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316620&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382417&price=0%2C300&sort=RECOMMENDED&top_dp=139&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200318591&selectedRatePlan=232312119',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:38',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Corus Hyde Park Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/430000/428500/428403/43dcbc4d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property – evening/night',
                  __typename: 'Image',
                },
                subjectId: 91003,
                fallbackImage: null,
                imageId: '5457376',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/430000/428500/428403/a62af5b8.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '442636892',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/430000/428500/428403/d0e67cc2.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '474759213',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/430000/428500/428403/39981500.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Restaurant',
                  __typename: 'Image',
                },
                subjectId: 81003,
                fallbackImage: null,
                imageId: '23007263',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£139',
            type: 'HOTEL',
            latLong: {
              latitude: 51.511745,
              longitude: -0.177514,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/428403',
            removeUrl: '/api/ucs/shortlist/remove/428403',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '428403',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '5173526',
          name: 'Point A Hotel London Kings Cross – St Pancras',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/6000000/5180000/5173600/5173526/a3320b56.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£166',
                      accessibilityLabel: 'The price is £166',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£166',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£166',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4,
            localizedScore: '4.0',
            total: 1253,
            localizedTotal: '1,253 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.0 / 5 (1,253 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.0 out of 5 Very good (1,253 reviews)',
              value: '4.0/5 Very good (1,253 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Point-A-Hotel-London-Kings-Cross-St-Pancras.h5173526.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316619&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381570&price=0%2C300&sort=RECOMMENDED&top_dp=166&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201898569&selectedRatePlan=209647248',
              relativePath:
                '/London-Hotels-Point-A-Hotel-London-Kings-Cross-St-Pancras.h5173526.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316619&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381570&price=0%2C300&sort=RECOMMENDED&top_dp=166&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201898569&selectedRatePlan=209647248',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:39',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Point A Hotel London Kings Cross – St Pancras',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5180000/5173600/5173526/a3320b56.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '287853518',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5180000/5173600/5173526/c669150e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '701334048',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5180000/5173600/5173526/4f78eb4a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '242781749',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5180000/5173600/5173526/b3600ac2.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Breakfast area',
                  __typename: 'Image',
                },
                subjectId: 81001,
                fallbackImage: null,
                imageId: '74380656',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£166',
            type: 'HOTEL',
            latLong: {
              latitude: 51.528819,
              longitude: -0.119651,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/5173526',
            removeUrl: '/api/ucs/shortlist/remove/5173526',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '5173526',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '523228',
          name: 'Millennium Gloucester Hotel London Kensington',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/530000/523300/523228/e569f6c1.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: null,
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£141',
                      accessibilityLabel: 'The price is £141',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£141',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£141',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.6,
            localizedScore: '3.6',
            total: 1002,
            localizedTotal: '1,002 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.6 / 5 (1,002 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.6 out of 5 Good (1,002 reviews)',
              value: '3.6/5 Good (1,002 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Millennium-Gloucester-Hotel-London-Kensington.h523228.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316620&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382947&price=0%2C300&sort=RECOMMENDED&top_dp=141&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=212713758&selectedRatePlan=238241690',
              relativePath:
                '/London-Hotels-Millennium-Gloucester-Hotel-London-Kensington.h523228.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316620&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382947&price=0%2C300&sort=RECOMMENDED&top_dp=141&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=212713758&selectedRatePlan=238241690',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:40',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Millennium Gloucester Hotel London Kensington',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/530000/523300/523228/e569f6c1.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '383268721',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/530000/523300/523228/63a005ce.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '471237190',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/530000/523300/523228/9ff05b24.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '87003811',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/530000/523300/523228/c57de6a3.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lounge',
                  __typename: 'Image',
                },
                subjectId: 82001,
                fallbackImage: null,
                imageId: '11819018',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£141',
            type: 'HOTEL',
            latLong: {
              latitude: 51.493228,
              longitude: -0.182924,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/523228',
            removeUrl: '/api/ucs/shortlist/remove/523228',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '523228',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '15118004',
          name: 'Park Plaza London Waterloo',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/16000000/15120000/15118100/15118004/78679519.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£219',
                      accessibilityLabel: 'The price is £219',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£219',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£219',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.3,
            localizedScore: '4.3',
            total: 1142,
            localizedTotal: '1,142 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.3 / 5 (1,142 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.3 out of 5 Excellent (1,142 reviews)',
              value: '4.3/5 Excellent (1,142 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Park-Plaza-London-Waterloo.h15118004.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316620&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383002&price=0%2C300&sort=RECOMMENDED&top_dp=219&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314307245&selectedRatePlan=382947881',
              relativePath:
                '/London-Hotels-Park-Plaza-London-Waterloo.h15118004.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316620&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383002&price=0%2C300&sort=RECOMMENDED&top_dp=219&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314307245&selectedRatePlan=382947881',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:41',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Park Plaza London Waterloo',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/16000000/15120000/15118100/15118004/78679519.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '377083477',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/16000000/15120000/15118100/15118004/3b13bc7e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 91008,
                fallbackImage: null,
                imageId: '377083483',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/16000000/15120000/15118100/15118004/6162c7a9.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Pool',
                  __typename: 'Image',
                },
                subjectId: 30000,
                fallbackImage: null,
                imageId: '377083568',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/16000000/15120000/15118100/15118004/1cafd04b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '377083603',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£219',
            type: 'HOTEL',
            latLong: {
              latitude: 51.497941,
              longitude: -0.11317,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/15118004',
            removeUrl: '/api/ucs/shortlist/remove/15118004',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '15118004',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '579374',
          name: 'NYX Hotel London Holborn by Leonardo Hotels',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/580000/579400/579374/fafdb9a8.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£279',
                      accessibilityLabel: 'The price is £279',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£279',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£279',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.4,
            localizedScore: '4.4',
            total: 333,
            localizedTotal: '333 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.4 / 5 (333 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.4 out of 5 Excellent (333 reviews)',
              value: '4.4/5 Excellent (333 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-NYX-Hotel-London-Holborn-By-Leonardo-Hotels.h579374.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316619&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179519&price=0%2C300&sort=RECOMMENDED&top_dp=279&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=450754&selectedRatePlan=382654239',
              relativePath:
                '/London-Hotels-NYX-Hotel-London-Holborn-By-Leonardo-Hotels.h579374.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316619&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179519&price=0%2C300&sort=RECOMMENDED&top_dp=279&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=450754&selectedRatePlan=382654239',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:42',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for NYX Hotel London Holborn by Leonardo Hotels',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/580000/579400/579374/fafdb9a8.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '555030372',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/580000/579400/579374/a8bd9c4e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '460381788',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/580000/579400/579374/9d539e76.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Pool',
                  __typename: 'Image',
                },
                subjectId: 30000,
                fallbackImage: null,
                imageId: '555030381',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/580000/579400/579374/900f4eb0.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '438688741',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£279',
            type: 'HOTEL',
            latLong: {
              latitude: 51.519111,
              longitude: -0.121075,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/579374',
            removeUrl: '/api/ucs/shortlist/remove/579374',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '579374',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '16534146',
          name: 'Victory House Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/17000000/16540000/16534200/16534146/3eecea6a.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£206',
                      accessibilityLabel: 'The price is £206',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£206',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£206',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.1,
            localizedScore: '4.1',
            total: 661,
            localizedTotal: '661 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.1 / 5 (661 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.1 out of 5 Very good (661 reviews)',
              value: '4.1/5 Very good (661 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Victory-House-London-Hotel.h16534146.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316619&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6004177&price=0%2C300&sort=RECOMMENDED&top_dp=206&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314179337&selectedRatePlan=384254746',
              relativePath:
                '/London-Hotels-Victory-House-London-Hotel.h16534146.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316619&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6004177&price=0%2C300&sort=RECOMMENDED&top_dp=206&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314179337&selectedRatePlan=384254746',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:43',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Victory House Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/17000000/16540000/16534200/16534146/3eecea6a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '702822917',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/17000000/16540000/16534200/16534146/0768e66a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property',
                  __typename: 'Image',
                },
                subjectId: 91001,
                fallbackImage: null,
                imageId: '424495824',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/17000000/16540000/16534200/16534146/9b165ee0.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '702823767',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/17000000/16540000/16534200/16534146/3f2b0162.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '702821449',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£206',
            type: 'HOTEL',
            latLong: {
              latitude: 51.51125,
              longitude: -0.12995,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/16534146',
            removeUrl: '/api/ucs/shortlist/remove/16534146',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '16534146',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '30455872',
          name: 'Clayton Hotel City of London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/31000000/30460000/30455900/30455872/w1500h878x0y4-fbf9dc7c.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: null,
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£189',
                      accessibilityLabel: 'The price is £189',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£189',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£189',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.5,
            localizedScore: '4.5',
            total: 1012,
            localizedTotal: '1,012 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.5 / 5 (1,012 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.5 out of 5 Wonderful (1,012 reviews)',
              value: '4.5/5 Wonderful (1,012 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Clayton-Hotel-City-Of-London.h30455872.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316629&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144915&price=0%2C300&sort=RECOMMENDED&top_dp=189&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=216921175&selectedRatePlan=266086935',
              relativePath:
                '/London-Hotels-Clayton-Hotel-City-Of-London.h30455872.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316629&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144915&price=0%2C300&sort=RECOMMENDED&top_dp=189&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=216921175&selectedRatePlan=266086935',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:44',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Clayton Hotel City of London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/31000000/30460000/30455900/30455872/w1500h878x0y4-fbf9dc7c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '676179866',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/31000000/30460000/30455900/30455872/bd6ae744.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property',
                  __typename: 'Image',
                },
                subjectId: 91001,
                fallbackImage: null,
                imageId: '398952301',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/31000000/30460000/30455900/30455872/d0abb2f1.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '398957287',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/31000000/30460000/30455900/30455872/df1fc313.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '647859313',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£189',
            type: 'HOTEL',
            latLong: {
              latitude: 51.514922,
              longitude: -0.071518,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/30455872',
            removeUrl: '/api/ucs/shortlist/remove/30455872',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '30455872',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '1457972',
          name: 'Leonardo Royal London St Paul’s',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/2000000/1460000/1458000/1457972/35d12fce.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£239',
                      accessibilityLabel: 'The price is £239',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£239',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£239',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.9,
            localizedScore: '3.9',
            total: 999,
            localizedTotal: '999 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.9 / 5 (999 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.9 out of 5 Good (999 reviews)',
              value: '3.9/5 Good (999 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Leonardo-Royal-London-St-Pauls.h1457972.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316624&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382189&price=0%2C300&sort=RECOMMENDED&top_dp=239&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=451542&selectedRatePlan=248116559',
              relativePath:
                '/London-Hotels-Leonardo-Royal-London-St-Pauls.h1457972.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316624&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382189&price=0%2C300&sort=RECOMMENDED&top_dp=239&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=451542&selectedRatePlan=248116559',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:45',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Leonardo Royal London St Paul’s',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1460000/1458000/1457972/35d12fce.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '674932718',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1460000/1458000/1457972/05d0c427.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '414836475',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1460000/1458000/1457972/4401329e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Pool',
                  __typename: 'Image',
                },
                subjectId: 30000,
                fallbackImage: null,
                imageId: '98548980',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1460000/1458000/1457972/b81395cc.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'View from room',
                  __typename: 'Image',
                },
                subjectId: 22013,
                fallbackImage: null,
                imageId: '678266613',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£239',
            type: 'HOTEL',
            latLong: {
              latitude: 51.51267,
              longitude: -0.099156,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/1457972',
            removeUrl: '/api/ucs/shortlist/remove/1457972',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '1457972',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '9789',
          name: 'Holiday Inn London - Kensington High St., an IHG Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/10000/9800/9789/c45818e1.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£159',
                      accessibilityLabel: 'The price is £159',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£159',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£159',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.7,
            localizedScore: '3.7',
            total: 1073,
            localizedTotal: '1,073 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.7 / 5 (1,073 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.7 out of 5 Good (1,073 reviews)',
              value: '3.7/5 Good (1,073 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Holiday-Inn-London-Kensington-High-St.h9789.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316624&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383075&price=0%2C300&sort=RECOMMENDED&top_dp=159&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201818041&selectedRatePlan=382761544',
              relativePath:
                '/London-Hotels-Holiday-Inn-London-Kensington-High-St.h9789.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316624&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383075&price=0%2C300&sort=RECOMMENDED&top_dp=159&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201818041&selectedRatePlan=382761544',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:46',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Holiday Inn London - Kensington High St., an IHG Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/9800/9789/c45818e1.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '76033853',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/9800/9789/9d4641bd.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Garden',
                  __typename: 'Image',
                },
                subjectId: 91005,
                fallbackImage: null,
                imageId: '581660452',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/9800/9789/ecc97def.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Pool',
                  __typename: 'Image',
                },
                subjectId: 30000,
                fallbackImage: null,
                imageId: '76033823',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/9800/9789/cba94198.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Balcony',
                  __typename: 'Image',
                },
                subjectId: 22008,
                fallbackImage: null,
                imageId: '76033948',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£159',
            type: 'HOTEL',
            latLong: {
              latitude: 51.498904,
              longitude: -0.192077,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/9789',
            removeUrl: '/api/ucs/shortlist/remove/9789',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '9789',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '523223',
          name: "The Bailey's Hotel London Kensington",
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/530000/523300/523223/1912b5e5.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£187',
                      accessibilityLabel: 'The price is £187',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£187',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£187',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.2,
            localizedScore: '4.2',
            total: 1001,
            localizedTotal: '1,001 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.2 / 5 (1,001 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.2 out of 5 Very good (1,001 reviews)',
              value: '4.2/5 Very good (1,001 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Baileys-Hotel-London.h523223.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316624&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382947&price=0%2C300&sort=RECOMMENDED&top_dp=187&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200632687&selectedRatePlan=240146843',
              relativePath:
                '/London-Hotels-The-Baileys-Hotel-London.h523223.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316624&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382947&price=0%2C300&sort=RECOMMENDED&top_dp=187&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200632687&selectedRatePlan=240146843',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:47',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: "Photo gallery for The Bailey's Hotel London Kensington",
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/530000/523300/523223/1912b5e5.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '37447291',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/530000/523300/523223/d8f204da.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '642605423',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/530000/523300/523223/c65ef5b5.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '372682641',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/530000/523300/523223/27baf8a2.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '37447292',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£187',
            type: 'HOTEL',
            latLong: {
              latitude: 51.49413,
              longitude: -0.182548,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/523223',
            removeUrl: '/api/ucs/shortlist/remove/523223',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '523223',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '21688',
          name: 'K+K Hotel George Kensington',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/30000/21700/21688/21594848.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£204',
                      accessibilityLabel: 'The price is £204',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£204',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£204',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.5,
            localizedScore: '4.5',
            total: 1002,
            localizedTotal: '1,002 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.5 / 5 (1,002 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.5 out of 5 Wonderful (1,002 reviews)',
              value: '4.5/5 Wonderful (1,002 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-KK-Hotel-George-Kensington.h21688.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316629&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248626912740751&price=0%2C300&sort=RECOMMENDED&top_dp=204&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=211511344&selectedRatePlan=230294006',
              relativePath:
                '/London-Hotels-KK-Hotel-George-Kensington.h21688.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316629&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248626912740751&price=0%2C300&sort=RECOMMENDED&top_dp=204&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=211511344&selectedRatePlan=230294006',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:48',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for K+K Hotel George Kensington',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/21700/21688/21594848.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '52593250',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/21700/21688/62d9469f.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Garden',
                  __typename: 'Image',
                },
                subjectId: 91005,
                fallbackImage: null,
                imageId: '78388729',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/21700/21688/e7567091.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '51952692',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/21700/21688/149d41a6.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '78388387',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£204',
            type: 'HOTEL',
            latLong: {
              latitude: 51.492416,
              longitude: -0.195174,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/21688',
            removeUrl: '/api/ucs/shortlist/remove/21688',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '21688',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '12649',
          name: 'Sheraton Skyline Hotel London Heathrow',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/20000/12700/12649/d3c41d71_b.jpg',
              __typename: 'Image',
            },
            fallbackImage: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/20000/12700/12649/cdca1b0b.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: null,
            tertiary: {
              text: 'Ad',
              theme_temp: 'PROMOTED',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£169',
                      accessibilityLabel: 'The price is £169',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£169',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£169',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.1,
            localizedScore: '4.1',
            total: 1001,
            localizedTotal: '1,001 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.1 / 5 (1,001 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.1 out of 5 Very good (1,001 reviews)',
              value: '4.1/5 Very good (1,001 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Sheraton-Skyline-Hotel-London-Heathrow.h12649.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316625&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248623058517182&trackingData=AAAAECMwoN3DlUQq35yJMrGRDTL-NnYNcnnU3IAka8MdwLTqo2KfQvJINJ651PstVRbfT-41Xfmqo_IlEM6X-TJP0HldWUG5GkMg25gZgEN-LrDB9hXNTJE6CrjQcy5L3dZ1Hs4xa85SwYf4sj4c3BTnC49u57KLn1irOW9MXNi5L_qVICBwV0fOcKlvQdiq5x1koQufvzfmcdCMiRX0TrNQnY59swNgIK4MKH_4qFt6PaAe4tFIUsCr5R-aEf8-5ecOagVeEZIof637epBRK_YQDNXPzg4qD9HA7GkZWzBVcr-TnBX9A_NduOwlXmT3eonxvGyODAec90vC1RuNbuDhjoMJ7BUb4OKpLZu9MuSvv202pb0p__dUjIRgNYKuCE695DRdrufkHOg1Gan__J_NzE8ZKu892u3WRe3jx8Q4HF4c6cJ93CmoE_n3YdiOj6j5wgckpt0fcALh6jYb9KMpfOvrqzUvaJdQGYnv-s5WzjSdoHRhakqH71yzaP5s-TL2i0sMObFPJGkHw_Y_8POBqrA82tmZOfTT8az8IUvSOY0RcEyrRnSIhFazN7mpjSpAs967GgRnPBgAiPeDz7-anAkleiPeLqHu0gjdLfJ-adFzCF7_6kBuGuaWxFyCr-ZInKo-pfIbqn31l6ynV_1H4uy_zlfRl63X4kJtuZi6kw1PAHD_rJDEF74nVY2Ml29HWNwMYvxc3iP9ONcVp79qy8nW5eL9A8GZeoi-M5KrawYK9S16c2DFzsooboJP8othiSj6hhIwj-fNTZvKdyxQ2X_DiqsF7jlF1aObcPsrGieOML3WknQB_zb_dNL0Gi7zFq7NE4nTyFkNqmRYTrtz7Itg9_U88JlhLLJSXfVp63Y66mk7tFUS7j7YUElqUw_UaqRQrZmzXQH3qsjtaTtK35QshfYi60dBplOB5Vq_KsGKtroHj2QMBKDyqfBS_82Kscoz728M0aQLCW5x4UvivZz88eSaEFBmDYfl1BsvnNyUIWF9xrh85eqRGLmeTQOO4UjWA68ox_TpEtu3O4wU5YBHw0sr99eu1OlF6q5BSYw-tymQDBrUmsvUueyi4ja6154ehsW4qcZUHrFDf5BKtCdcVTAcd_SK6nnv9ffxshJq2xfM0WfWBg5wVF4qKVQFKg%3D%3D&rank=9&testVersionOverride=Buttercup&slots=HSR_CB&position=49&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=169&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=210902295&selectedRatePlan=226202731',
              relativePath:
                '/London-Hotels-Sheraton-Skyline-Hotel-London-Heathrow.h12649.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316625&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248623058517182&trackingData=AAAAECMwoN3DlUQq35yJMrGRDTL-NnYNcnnU3IAka8MdwLTqo2KfQvJINJ651PstVRbfT-41Xfmqo_IlEM6X-TJP0HldWUG5GkMg25gZgEN-LrDB9hXNTJE6CrjQcy5L3dZ1Hs4xa85SwYf4sj4c3BTnC49u57KLn1irOW9MXNi5L_qVICBwV0fOcKlvQdiq5x1koQufvzfmcdCMiRX0TrNQnY59swNgIK4MKH_4qFt6PaAe4tFIUsCr5R-aEf8-5ecOagVeEZIof637epBRK_YQDNXPzg4qD9HA7GkZWzBVcr-TnBX9A_NduOwlXmT3eonxvGyODAec90vC1RuNbuDhjoMJ7BUb4OKpLZu9MuSvv202pb0p__dUjIRgNYKuCE695DRdrufkHOg1Gan__J_NzE8ZKu892u3WRe3jx8Q4HF4c6cJ93CmoE_n3YdiOj6j5wgckpt0fcALh6jYb9KMpfOvrqzUvaJdQGYnv-s5WzjSdoHRhakqH71yzaP5s-TL2i0sMObFPJGkHw_Y_8POBqrA82tmZOfTT8az8IUvSOY0RcEyrRnSIhFazN7mpjSpAs967GgRnPBgAiPeDz7-anAkleiPeLqHu0gjdLfJ-adFzCF7_6kBuGuaWxFyCr-ZInKo-pfIbqn31l6ynV_1H4uy_zlfRl63X4kJtuZi6kw1PAHD_rJDEF74nVY2Ml29HWNwMYvxc3iP9ONcVp79qy8nW5eL9A8GZeoi-M5KrawYK9S16c2DFzsooboJP8othiSj6hhIwj-fNTZvKdyxQ2X_DiqsF7jlF1aObcPsrGieOML3WknQB_zb_dNL0Gi7zFq7NE4nTyFkNqmRYTrtz7Itg9_U88JlhLLJSXfVp63Y66mk7tFUS7j7YUElqUw_UaqRQrZmzXQH3qsjtaTtK35QshfYi60dBplOB5Vq_KsGKtroHj2QMBKDyqfBS_82Kscoz728M0aQLCW5x4UvivZz88eSaEFBmDYfl1BsvnNyUIWF9xrh85eqRGLmeTQOO4UjWA68ox_TpEtu3O4wU5YBHw0sr99eu1OlF6q5BSYw-tymQDBrUmsvUueyi4ja6154ehsW4qcZUHrFDf5BKtCdcVTAcd_SK6nnv9ffxshJq2xfM0WfWBg5wVF4qKVQFKg%3D%3D&rank=9&testVersionOverride=Buttercup&slots=HSR_CB&position=49&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=169&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=210902295&selectedRatePlan=226202731',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:49',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: {
            id: '524800',
            clickRedirectTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/ClRedirect?testVersionOverride=Buttercup&destinationUrl=&rank=9&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAECMwoN3DlUQq35yJMrGRDTL-NnYNcnnU3IAka8MdwLTqo2KfQvJINJ651PstVRbfT-41Xfmqo_IlEM6X-TJP0HldWUG5GkMg25gZgEN-LrDB9hXNTJE6CrjQcy5L3dZ1Hs4xa85SwYf4sj4c3BTnC49u57KLn1irOW9MXNi5L_qVICBwV0fOcKlvQdiq5x1koQufvzfmcdCMiRX0TrNQnY59swNgIK4MKH_4qFt6PaAe4tFIUsCr5R-aEf8-5ecOagVeEZIof637epBRK_YQDNXPzg4qD9HA7GkZWzBVcr-TnBX9A_NduOwlXmT3eonxvGyODAec90vC1RuNbuDhjoMJ7BUb4OKpLZu9MuSvv202pb0p__dUjIRgNYKuCE695DRdrufkHOg1Gan__J_NzE8ZKu892u3WRe3jx8Q4HF4c6cJ93CmoE_n3YdiOj6j5wgckpt0fcALh6jYb9KMpfOvrqzUvaJdQGYnv-s5WzjSdoHRhakqH71yzaP5s-TL2i0sMObFPJGkHw_Y_8POBqrA82tmZOfTT8az8IUvSOY0RcEyrRnSIhFazN7mpjSpAs967GgRnPBgAiPeDz7-anAkleiPeLqHu0gjdLfJ-adFzCF7_6kBuGuaWxFyCr-ZInKo-pfIbqn31l6ynV_1H4uy_zlfRl63X4kJtuZi6kw1PAHD_rJDEF74nVY2Ml29HWNwMYvxc3iP9ONcVp79qy8nW5eL9A8GZeoi-M5KrawYK9S16c2DFzsooboJP8othiSj6hhIwj-fNTZvKdyxQ2X_DiqsF7jlF1aObcPsrGieOML3WknQB_zb_dNL0Gi7zFq7NE4nTyFkNqmRYTrtz7Itg9_U88JlhLLJSXfVp63Y66mk7tFUS7j7YUElqUw_UaqRQrZmzXQH3qsjtaTtK35QshfYi60dBplOB5Vq_KsGKtroHj2QMBKDyqfBS_82Kscoz728M0aQLCW5x4UvivZz88eSaEFBmDYfl1BsvnNyUIWF9xrh85eqRGLmeTQOO4UjWA68ox_TpEtu3O4wU5YBHw0sr99eu1OlF6q5BSYw-tymQDBrUmsvUueyi4ja6154ehsW4qcZUHrFDf5BKtCdcVTAcd_SK6nnv9ffxshJq2xfM0WfWBg5wVF4qKVQFKg==&slots=HSR_CB&position=49&beaconIssued=2022-08-10T13:48:35',
            clickTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Cl?testVersionOverride=Buttercup&rank=9&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAECMwoN3DlUQq35yJMrGRDTL-NnYNcnnU3IAka8MdwLTqo2KfQvJINJ651PstVRbfT-41Xfmqo_IlEM6X-TJP0HldWUG5GkMg25gZgEN-LrDB9hXNTJE6CrjQcy5L3dZ1Hs4xa85SwYf4sj4c3BTnC49u57KLn1irOW9MXNi5L_qVICBwV0fOcKlvQdiq5x1koQufvzfmcdCMiRX0TrNQnY59swNgIK4MKH_4qFt6PaAe4tFIUsCr5R-aEf8-5ecOagVeEZIof637epBRK_YQDNXPzg4qD9HA7GkZWzBVcr-TnBX9A_NduOwlXmT3eonxvGyODAec90vC1RuNbuDhjoMJ7BUb4OKpLZu9MuSvv202pb0p__dUjIRgNYKuCE695DRdrufkHOg1Gan__J_NzE8ZKu892u3WRe3jx8Q4HF4c6cJ93CmoE_n3YdiOj6j5wgckpt0fcALh6jYb9KMpfOvrqzUvaJdQGYnv-s5WzjSdoHRhakqH71yzaP5s-TL2i0sMObFPJGkHw_Y_8POBqrA82tmZOfTT8az8IUvSOY0RcEyrRnSIhFazN7mpjSpAs967GgRnPBgAiPeDz7-anAkleiPeLqHu0gjdLfJ-adFzCF7_6kBuGuaWxFyCr-ZInKo-pfIbqn31l6ynV_1H4uy_zlfRl63X4kJtuZi6kw1PAHD_rJDEF74nVY2Ml29HWNwMYvxc3iP9ONcVp79qy8nW5eL9A8GZeoi-M5KrawYK9S16c2DFzsooboJP8othiSj6hhIwj-fNTZvKdyxQ2X_DiqsF7jlF1aObcPsrGieOML3WknQB_zb_dNL0Gi7zFq7NE4nTyFkNqmRYTrtz7Itg9_U88JlhLLJSXfVp63Y66mk7tFUS7j7YUElqUw_UaqRQrZmzXQH3qsjtaTtK35QshfYi60dBplOB5Vq_KsGKtroHj2QMBKDyqfBS_82Kscoz728M0aQLCW5x4UvivZz88eSaEFBmDYfl1BsvnNyUIWF9xrh85eqRGLmeTQOO4UjWA68ox_TpEtu3O4wU5YBHw0sr99eu1OlF6q5BSYw-tymQDBrUmsvUueyi4ja6154ehsW4qcZUHrFDf5BKtCdcVTAcd_SK6nnv9ffxshJq2xfM0WfWBg5wVF4qKVQFKg==&slots=HSR_CB&position=49&beaconIssued=2022-08-10T13:48:35',
            details:
              "Enjoy spacious rooms minutes from the airport's terminals with easy access to Central London. On-site restaurant and sports bar.",
            detailsHeadline: 'Comfortable rooms close to airport',
            hotelImage:
              'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/20000/12700/12649/d3c41d71_b.jpg',
            impressionTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Impr?testVersionOverride=Buttercup&rank=9&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAECMwoN3DlUQq35yJMrGRDTL-NnYNcnnU3IAka8MdwLTqo2KfQvJINJ651PstVRbfT-41Xfmqo_IlEM6X-TJP0HldWUG5GkMg25gZgEN-LrDB9hXNTJE6CrjQcy5L3dZ1Hs4xa85SwYf4sj4c3BTnC49u57KLn1irOW9MXNi5L_qVICBwV0fOcKlvQdiq5x1koQufvzfmcdCMiRX0TrNQnY59swNgIK4MKH_4qFt6PaAe4tFIUsCr5R-aEf8-5ecOagVeEZIof637epBRK_YQDNXPzg4qD9HA7GkZWzBVcr-TnBX9A_NduOwlXmT3eonxvGyODAec90vC1RuNbuDhjoMJ7BUb4OKpLZu9MuSvv202pb0p__dUjIRgNYKuCE695DRdrufkHOg1Gan__J_NzE8ZKu892u3WRe3jx8Q4HF4c6cJ93CmoE_n3YdiOj6j5wgckpt0fcALh6jYb9KMpfOvrqzUvaJdQGYnv-s5WzjSdoHRhakqH71yzaP5s-TL2i0sMObFPJGkHw_Y_8POBqrA82tmZOfTT8az8IUvSOY0RcEyrRnSIhFazN7mpjSpAs967GgRnPBgAiPeDz7-anAkleiPeLqHu0gjdLfJ-adFzCF7_6kBuGuaWxFyCr-ZInKo-pfIbqn31l6ynV_1H4uy_zlfRl63X4kJtuZi6kw1PAHD_rJDEF74nVY2Ml29HWNwMYvxc3iP9ONcVp79qy8nW5eL9A8GZeoi-M5KrawYK9S16c2DFzsooboJP8othiSj6hhIwj-fNTZvKdyxQ2X_DiqsF7jlF1aObcPsrGieOML3WknQB_zb_dNL0Gi7zFq7NE4nTyFkNqmRYTrtz7Itg9_U88JlhLLJSXfVp63Y66mk7tFUS7j7YUElqUw_UaqRQrZmzXQH3qsjtaTtK35QshfYi60dBplOB5Vq_KsGKtroHj2QMBKDyqfBS_82Kscoz728M0aQLCW5x4UvivZz88eSaEFBmDYfl1BsvnNyUIWF9xrh85eqRGLmeTQOO4UjWA68ox_TpEtu3O4wU5YBHw0sr99eu1OlF6q5BSYw-tymQDBrUmsvUueyi4ja6154ehsW4qcZUHrFDf5BKtCdcVTAcd_SK6nnv9ffxshJq2xfM0WfWBg5wVF4qKVQFKg==&slots=HSR_CB&position=49&beaconIssued=2022-08-10T13:48:35',
            trackingData:
              'AAAAECMwoN3DlUQq35yJMrGRDTL-NnYNcnnU3IAka8MdwLTqo2KfQvJINJ651PstVRbfT-41Xfmqo_IlEM6X-TJP0HldWUG5GkMg25gZgEN-LrDB9hXNTJE6CrjQcy5L3dZ1Hs4xa85SwYf4sj4c3BTnC49u57KLn1irOW9MXNi5L_qVICBwV0fOcKlvQdiq5x1koQufvzfmcdCMiRX0TrNQnY59swNgIK4MKH_4qFt6PaAe4tFIUsCr5R-aEf8-5ecOagVeEZIof637epBRK_YQDNXPzg4qD9HA7GkZWzBVcr-TnBX9A_NduOwlXmT3eonxvGyODAec90vC1RuNbuDhjoMJ7BUb4OKpLZu9MuSvv202pb0p__dUjIRgNYKuCE695DRdrufkHOg1Gan__J_NzE8ZKu892u3WRe3jx8Q4HF4c6cJ93CmoE_n3YdiOj6j5wgckpt0fcALh6jYb9KMpfOvrqzUvaJdQGYnv-s5WzjSdoHRhakqH71yzaP5s-TL2i0sMObFPJGkHw_Y_8POBqrA82tmZOfTT8az8IUvSOY0RcEyrRnSIhFazN7mpjSpAs967GgRnPBgAiPeDz7-anAkleiPeLqHu0gjdLfJ-adFzCF7_6kBuGuaWxFyCr-ZInKo-pfIbqn31l6ynV_1H4uy_zlfRl63X4kJtuZi6kw1PAHD_rJDEF74nVY2Ml29HWNwMYvxc3iP9ONcVp79qy8nW5eL9A8GZeoi-M5KrawYK9S16c2DFzsooboJP8othiSj6hhIwj-fNTZvKdyxQ2X_DiqsF7jlF1aObcPsrGieOML3WknQB_zb_dNL0Gi7zFq7NE4nTyFkNqmRYTrtz7Itg9_U88JlhLLJSXfVp63Y66mk7tFUS7j7YUElqUw_UaqRQrZmzXQH3qsjtaTtK35QshfYi60dBplOB5Vq_KsGKtroHj2QMBKDyqfBS_82Kscoz728M0aQLCW5x4UvivZz88eSaEFBmDYfl1BsvnNyUIWF9xrh85eqRGLmeTQOO4UjWA68ox_TpEtu3O4wU5YBHw0sr99eu1OlF6q5BSYw-tymQDBrUmsvUueyi4ja6154ehsW4qcZUHrFDf5BKtCdcVTAcd_SK6nnv9ffxshJq2xfM0WfWBg5wVF4qKVQFKg==',
            brand: null,
            clickRedirectLinkoffTrackingUrl: null,
            logo: null,
            lotagline: null,
            rating: '0',
            slots: 'HSR_CB',
            vanityUrl: null,
            rank: '9',
            position: '49',
            __typename: 'SponsoredListing',
          },
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Sheraton Skyline Hotel London Heathrow',
            images: [
              {
                image: {
                  url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/20000/12700/12649/d3c41d71_b.jpg',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: {
                  url: 'https://images.trvl-media.com/hotels/1000000/20000/12700/12649/cdca1b0b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                imageId: '688611004',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/20000/12700/12649/60967cc7.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '688611006',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/20000/12700/12649/fe7ee8ac.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '63746248',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/20000/12700/12649/9f5a22f9.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lounge',
                  __typename: 'Image',
                },
                subjectId: 82001,
                fallbackImage: null,
                imageId: '63766104',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£169',
            type: 'HOTEL',
            latLong: {
              latitude: 51.480827,
              longitude: -0.437133,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'Hayes',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/12649',
            removeUrl: '/api/ucs/shortlist/remove/12649',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '12649',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '53791563',
          name: 'The Morton Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/54000000/53800000/53791600/53791563/f8dd252b_b.jpg',
              __typename: 'Image',
            },
            fallbackImage: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/54000000/53800000/53791600/53791563/f8dd252b.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: {
              text: 'Ad',
              theme_temp: 'PROMOTED',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£209',
                      accessibilityLabel: 'The price is £209',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£209',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£209',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.4,
            localizedScore: '4.4',
            total: 199,
            localizedTotal: '199 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.4 / 5 (199 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.4 out of 5 Excellent (199 reviews)',
              value: '4.4/5 Excellent (199 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-THE-MORTON-HOTEL.h53791563.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316625&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6251519&trackingData=AAAAEO56tJEgkTW2RyZbhsOaYfFDMXSU7jyuVfpnUblrHhbIGkemjhO4psWSBE3Gh57kP9vCNRNC4b2rYFQmhy5RNRImzyBLb8l6fTvwTDWv8Ll3wvAjaqAvaCYDVNBU7pseKWzubQWJxZw2THQqdsZQ3gBF13QCWsBl6QxbP_2tK5BHed_iCwSDMdBPRprbKLETVPkFi6ql06SaFsL6qap0WWIWsi71Ra_Cfrx_0kL_LN1fJvRa818eWhl-jBWKnw4MGgR3wbY0HC80cnuUMLew_JNaWzaUQ4i_MkosUzCPhLW5-SeuruEIHOaWrGR9WsbbIu4FWuuEfUoO5KmZTBcuZ5Y8vKnERpd5HmYTlv5uy-HydP3o28__woONSSXlGdSa6IM3wOsndEgQuFIsw9FVcpeTB-PGkGdLIUrSb14_2x1paaxMHYd0U2OWlcf67wGKa9eWb7O38J6OSXoW42cFoKkiQ_8S8pLrvct5FtBCZ9ZHv9FzFXCHef0dX1aSFM0iBpPCrEeBNx7paqxUqWIuVJsnoef9vL54BBE2Tlec-_8amCSa0KFCTViUSm-FRADiJ8FSd-AqJA1k-tf9zQve0M9_mREuOLkU__1FdPiU75S6OgX5TxTSp_6BSuJzAgDYpnR7S9_oJgvWovJZ4QKkgCMwQy9bA5APMVAvcrBC8f8T0kPcuxKP2C5xrGA8L3pyyqT_cyoasN1PjWiaZ77je_V74lnzRvYc8_2GZbJgBB7wQ_iFyMWkOnhr7BL8PhKgt51QpuJWQi2_VIxF3UyuB39C3IeHjXdASqiN3pVwxZHcsPXHVFPOqwXxpKcUMfQse6_UXTEey7kbAt5cBBHna8d6RjtKfCYaE4yoE9HQi5yH3c9TltDArtVYGPYv4BLk16UJAlTv0G1Nnyva3nMVZJiYEQz30FOHbwPnMCS-VSKIXEkrwenbolOpAaSN0crjAsWISzFfn8Iv1Z0C_Ez4z1DUqfOcqt5zww3RP7F6YXdES9eQ14NdXXFG3DgkzuoS1Z5zzomHslqFDK_ZyTwB1pYRxHZjYTGFMFrVJdLTnqNCMAPH7zc3kQLUoljkCOzATqcq7b8vw4PMxV7mz5ZNZZ4z5JzqDopdRVmCz6M1-yZAmhMhA42c67ERhN0QgGQFZNsbqgZPt0rCzpuSlHgcs50%3D&rank=10&testVersionOverride=Buttercup&slots=HSR_D&position=50&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=209&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=315451799&selectedRatePlan=383671147',
              relativePath:
                '/London-Hotels-THE-MORTON-HOTEL.h53791563.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316625&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6251519&trackingData=AAAAEO56tJEgkTW2RyZbhsOaYfFDMXSU7jyuVfpnUblrHhbIGkemjhO4psWSBE3Gh57kP9vCNRNC4b2rYFQmhy5RNRImzyBLb8l6fTvwTDWv8Ll3wvAjaqAvaCYDVNBU7pseKWzubQWJxZw2THQqdsZQ3gBF13QCWsBl6QxbP_2tK5BHed_iCwSDMdBPRprbKLETVPkFi6ql06SaFsL6qap0WWIWsi71Ra_Cfrx_0kL_LN1fJvRa818eWhl-jBWKnw4MGgR3wbY0HC80cnuUMLew_JNaWzaUQ4i_MkosUzCPhLW5-SeuruEIHOaWrGR9WsbbIu4FWuuEfUoO5KmZTBcuZ5Y8vKnERpd5HmYTlv5uy-HydP3o28__woONSSXlGdSa6IM3wOsndEgQuFIsw9FVcpeTB-PGkGdLIUrSb14_2x1paaxMHYd0U2OWlcf67wGKa9eWb7O38J6OSXoW42cFoKkiQ_8S8pLrvct5FtBCZ9ZHv9FzFXCHef0dX1aSFM0iBpPCrEeBNx7paqxUqWIuVJsnoef9vL54BBE2Tlec-_8amCSa0KFCTViUSm-FRADiJ8FSd-AqJA1k-tf9zQve0M9_mREuOLkU__1FdPiU75S6OgX5TxTSp_6BSuJzAgDYpnR7S9_oJgvWovJZ4QKkgCMwQy9bA5APMVAvcrBC8f8T0kPcuxKP2C5xrGA8L3pyyqT_cyoasN1PjWiaZ77je_V74lnzRvYc8_2GZbJgBB7wQ_iFyMWkOnhr7BL8PhKgt51QpuJWQi2_VIxF3UyuB39C3IeHjXdASqiN3pVwxZHcsPXHVFPOqwXxpKcUMfQse6_UXTEey7kbAt5cBBHna8d6RjtKfCYaE4yoE9HQi5yH3c9TltDArtVYGPYv4BLk16UJAlTv0G1Nnyva3nMVZJiYEQz30FOHbwPnMCS-VSKIXEkrwenbolOpAaSN0crjAsWISzFfn8Iv1Z0C_Ez4z1DUqfOcqt5zww3RP7F6YXdES9eQ14NdXXFG3DgkzuoS1Z5zzomHslqFDK_ZyTwB1pYRxHZjYTGFMFrVJdLTnqNCMAPH7zc3kQLUoljkCOzATqcq7b8vw4PMxV7mz5ZNZZ4z5JzqDopdRVmCz6M1-yZAmhMhA42c67ERhN0QgGQFZNsbqgZPt0rCzpuSlHgcs50%3D&rank=10&testVersionOverride=Buttercup&slots=HSR_D&position=50&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=209&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=315451799&selectedRatePlan=383671147',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:50',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: {
            id: '653517',
            clickRedirectTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/ClRedirect?testVersionOverride=Buttercup&destinationUrl=&rank=10&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEO56tJEgkTW2RyZbhsOaYfFDMXSU7jyuVfpnUblrHhbIGkemjhO4psWSBE3Gh57kP9vCNRNC4b2rYFQmhy5RNRImzyBLb8l6fTvwTDWv8Ll3wvAjaqAvaCYDVNBU7pseKWzubQWJxZw2THQqdsZQ3gBF13QCWsBl6QxbP_2tK5BHed_iCwSDMdBPRprbKLETVPkFi6ql06SaFsL6qap0WWIWsi71Ra_Cfrx_0kL_LN1fJvRa818eWhl-jBWKnw4MGgR3wbY0HC80cnuUMLew_JNaWzaUQ4i_MkosUzCPhLW5-SeuruEIHOaWrGR9WsbbIu4FWuuEfUoO5KmZTBcuZ5Y8vKnERpd5HmYTlv5uy-HydP3o28__woONSSXlGdSa6IM3wOsndEgQuFIsw9FVcpeTB-PGkGdLIUrSb14_2x1paaxMHYd0U2OWlcf67wGKa9eWb7O38J6OSXoW42cFoKkiQ_8S8pLrvct5FtBCZ9ZHv9FzFXCHef0dX1aSFM0iBpPCrEeBNx7paqxUqWIuVJsnoef9vL54BBE2Tlec-_8amCSa0KFCTViUSm-FRADiJ8FSd-AqJA1k-tf9zQve0M9_mREuOLkU__1FdPiU75S6OgX5TxTSp_6BSuJzAgDYpnR7S9_oJgvWovJZ4QKkgCMwQy9bA5APMVAvcrBC8f8T0kPcuxKP2C5xrGA8L3pyyqT_cyoasN1PjWiaZ77je_V74lnzRvYc8_2GZbJgBB7wQ_iFyMWkOnhr7BL8PhKgt51QpuJWQi2_VIxF3UyuB39C3IeHjXdASqiN3pVwxZHcsPXHVFPOqwXxpKcUMfQse6_UXTEey7kbAt5cBBHna8d6RjtKfCYaE4yoE9HQi5yH3c9TltDArtVYGPYv4BLk16UJAlTv0G1Nnyva3nMVZJiYEQz30FOHbwPnMCS-VSKIXEkrwenbolOpAaSN0crjAsWISzFfn8Iv1Z0C_Ez4z1DUqfOcqt5zww3RP7F6YXdES9eQ14NdXXFG3DgkzuoS1Z5zzomHslqFDK_ZyTwB1pYRxHZjYTGFMFrVJdLTnqNCMAPH7zc3kQLUoljkCOzATqcq7b8vw4PMxV7mz5ZNZZ4z5JzqDopdRVmCz6M1-yZAmhMhA42c67ERhN0QgGQFZNsbqgZPt0rCzpuSlHgcs50=&slots=HSR_D&position=50&beaconIssued=2022-08-10T13:48:35',
            clickTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Cl?testVersionOverride=Buttercup&rank=10&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEO56tJEgkTW2RyZbhsOaYfFDMXSU7jyuVfpnUblrHhbIGkemjhO4psWSBE3Gh57kP9vCNRNC4b2rYFQmhy5RNRImzyBLb8l6fTvwTDWv8Ll3wvAjaqAvaCYDVNBU7pseKWzubQWJxZw2THQqdsZQ3gBF13QCWsBl6QxbP_2tK5BHed_iCwSDMdBPRprbKLETVPkFi6ql06SaFsL6qap0WWIWsi71Ra_Cfrx_0kL_LN1fJvRa818eWhl-jBWKnw4MGgR3wbY0HC80cnuUMLew_JNaWzaUQ4i_MkosUzCPhLW5-SeuruEIHOaWrGR9WsbbIu4FWuuEfUoO5KmZTBcuZ5Y8vKnERpd5HmYTlv5uy-HydP3o28__woONSSXlGdSa6IM3wOsndEgQuFIsw9FVcpeTB-PGkGdLIUrSb14_2x1paaxMHYd0U2OWlcf67wGKa9eWb7O38J6OSXoW42cFoKkiQ_8S8pLrvct5FtBCZ9ZHv9FzFXCHef0dX1aSFM0iBpPCrEeBNx7paqxUqWIuVJsnoef9vL54BBE2Tlec-_8amCSa0KFCTViUSm-FRADiJ8FSd-AqJA1k-tf9zQve0M9_mREuOLkU__1FdPiU75S6OgX5TxTSp_6BSuJzAgDYpnR7S9_oJgvWovJZ4QKkgCMwQy9bA5APMVAvcrBC8f8T0kPcuxKP2C5xrGA8L3pyyqT_cyoasN1PjWiaZ77je_V74lnzRvYc8_2GZbJgBB7wQ_iFyMWkOnhr7BL8PhKgt51QpuJWQi2_VIxF3UyuB39C3IeHjXdASqiN3pVwxZHcsPXHVFPOqwXxpKcUMfQse6_UXTEey7kbAt5cBBHna8d6RjtKfCYaE4yoE9HQi5yH3c9TltDArtVYGPYv4BLk16UJAlTv0G1Nnyva3nMVZJiYEQz30FOHbwPnMCS-VSKIXEkrwenbolOpAaSN0crjAsWISzFfn8Iv1Z0C_Ez4z1DUqfOcqt5zww3RP7F6YXdES9eQ14NdXXFG3DgkzuoS1Z5zzomHslqFDK_ZyTwB1pYRxHZjYTGFMFrVJdLTnqNCMAPH7zc3kQLUoljkCOzATqcq7b8vw4PMxV7mz5ZNZZ4z5JzqDopdRVmCz6M1-yZAmhMhA42c67ERhN0QgGQFZNsbqgZPt0rCzpuSlHgcs50=&slots=HSR_D&position=50&beaconIssued=2022-08-10T13:48:35',
            details:
              'Situated just minutes from the British Museum and Covent Garden, with stylish rooms overlooking Russell Square.',
            detailsHeadline: 'Boutique hotel in the heart of London',
            hotelImage:
              'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/54000000/53800000/53791600/53791563/f8dd252b_b.jpg',
            impressionTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Impr?testVersionOverride=Buttercup&rank=10&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEO56tJEgkTW2RyZbhsOaYfFDMXSU7jyuVfpnUblrHhbIGkemjhO4psWSBE3Gh57kP9vCNRNC4b2rYFQmhy5RNRImzyBLb8l6fTvwTDWv8Ll3wvAjaqAvaCYDVNBU7pseKWzubQWJxZw2THQqdsZQ3gBF13QCWsBl6QxbP_2tK5BHed_iCwSDMdBPRprbKLETVPkFi6ql06SaFsL6qap0WWIWsi71Ra_Cfrx_0kL_LN1fJvRa818eWhl-jBWKnw4MGgR3wbY0HC80cnuUMLew_JNaWzaUQ4i_MkosUzCPhLW5-SeuruEIHOaWrGR9WsbbIu4FWuuEfUoO5KmZTBcuZ5Y8vKnERpd5HmYTlv5uy-HydP3o28__woONSSXlGdSa6IM3wOsndEgQuFIsw9FVcpeTB-PGkGdLIUrSb14_2x1paaxMHYd0U2OWlcf67wGKa9eWb7O38J6OSXoW42cFoKkiQ_8S8pLrvct5FtBCZ9ZHv9FzFXCHef0dX1aSFM0iBpPCrEeBNx7paqxUqWIuVJsnoef9vL54BBE2Tlec-_8amCSa0KFCTViUSm-FRADiJ8FSd-AqJA1k-tf9zQve0M9_mREuOLkU__1FdPiU75S6OgX5TxTSp_6BSuJzAgDYpnR7S9_oJgvWovJZ4QKkgCMwQy9bA5APMVAvcrBC8f8T0kPcuxKP2C5xrGA8L3pyyqT_cyoasN1PjWiaZ77je_V74lnzRvYc8_2GZbJgBB7wQ_iFyMWkOnhr7BL8PhKgt51QpuJWQi2_VIxF3UyuB39C3IeHjXdASqiN3pVwxZHcsPXHVFPOqwXxpKcUMfQse6_UXTEey7kbAt5cBBHna8d6RjtKfCYaE4yoE9HQi5yH3c9TltDArtVYGPYv4BLk16UJAlTv0G1Nnyva3nMVZJiYEQz30FOHbwPnMCS-VSKIXEkrwenbolOpAaSN0crjAsWISzFfn8Iv1Z0C_Ez4z1DUqfOcqt5zww3RP7F6YXdES9eQ14NdXXFG3DgkzuoS1Z5zzomHslqFDK_ZyTwB1pYRxHZjYTGFMFrVJdLTnqNCMAPH7zc3kQLUoljkCOzATqcq7b8vw4PMxV7mz5ZNZZ4z5JzqDopdRVmCz6M1-yZAmhMhA42c67ERhN0QgGQFZNsbqgZPt0rCzpuSlHgcs50=&slots=HSR_D&position=50&beaconIssued=2022-08-10T13:48:35',
            trackingData:
              'AAAAEO56tJEgkTW2RyZbhsOaYfFDMXSU7jyuVfpnUblrHhbIGkemjhO4psWSBE3Gh57kP9vCNRNC4b2rYFQmhy5RNRImzyBLb8l6fTvwTDWv8Ll3wvAjaqAvaCYDVNBU7pseKWzubQWJxZw2THQqdsZQ3gBF13QCWsBl6QxbP_2tK5BHed_iCwSDMdBPRprbKLETVPkFi6ql06SaFsL6qap0WWIWsi71Ra_Cfrx_0kL_LN1fJvRa818eWhl-jBWKnw4MGgR3wbY0HC80cnuUMLew_JNaWzaUQ4i_MkosUzCPhLW5-SeuruEIHOaWrGR9WsbbIu4FWuuEfUoO5KmZTBcuZ5Y8vKnERpd5HmYTlv5uy-HydP3o28__woONSSXlGdSa6IM3wOsndEgQuFIsw9FVcpeTB-PGkGdLIUrSb14_2x1paaxMHYd0U2OWlcf67wGKa9eWb7O38J6OSXoW42cFoKkiQ_8S8pLrvct5FtBCZ9ZHv9FzFXCHef0dX1aSFM0iBpPCrEeBNx7paqxUqWIuVJsnoef9vL54BBE2Tlec-_8amCSa0KFCTViUSm-FRADiJ8FSd-AqJA1k-tf9zQve0M9_mREuOLkU__1FdPiU75S6OgX5TxTSp_6BSuJzAgDYpnR7S9_oJgvWovJZ4QKkgCMwQy9bA5APMVAvcrBC8f8T0kPcuxKP2C5xrGA8L3pyyqT_cyoasN1PjWiaZ77je_V74lnzRvYc8_2GZbJgBB7wQ_iFyMWkOnhr7BL8PhKgt51QpuJWQi2_VIxF3UyuB39C3IeHjXdASqiN3pVwxZHcsPXHVFPOqwXxpKcUMfQse6_UXTEey7kbAt5cBBHna8d6RjtKfCYaE4yoE9HQi5yH3c9TltDArtVYGPYv4BLk16UJAlTv0G1Nnyva3nMVZJiYEQz30FOHbwPnMCS-VSKIXEkrwenbolOpAaSN0crjAsWISzFfn8Iv1Z0C_Ez4z1DUqfOcqt5zww3RP7F6YXdES9eQ14NdXXFG3DgkzuoS1Z5zzomHslqFDK_ZyTwB1pYRxHZjYTGFMFrVJdLTnqNCMAPH7zc3kQLUoljkCOzATqcq7b8vw4PMxV7mz5ZNZZ4z5JzqDopdRVmCz6M1-yZAmhMhA42c67ERhN0QgGQFZNsbqgZPt0rCzpuSlHgcs50=',
            brand: null,
            clickRedirectLinkoffTrackingUrl: null,
            logo: null,
            lotagline: null,
            rating: '0',
            slots: 'HSR_D',
            vanityUrl: null,
            rank: '10',
            position: '50',
            __typename: 'SponsoredListing',
          },
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Morton Hotel',
            images: [
              {
                image: {
                  url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/54000000/53800000/53791600/53791563/f8dd252b_b.jpg',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: {
                  url: 'https://images.trvl-media.com/hotels/54000000/53800000/53791600/53791563/f8dd252b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                imageId: '449710882',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/54000000/53800000/53791600/53791563/fd819ba1.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Property entrance',
                  __typename: 'Image',
                },
                subjectId: 91002,
                fallbackImage: null,
                imageId: '449711766',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/54000000/53800000/53791600/53791563/f4ee938c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Living area',
                  __typename: 'Image',
                },
                subjectId: 22005,
                fallbackImage: null,
                imageId: '449711805',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/54000000/53800000/53791600/53791563/ccc6486b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lounge',
                  __typename: 'Image',
                },
                subjectId: 82001,
                fallbackImage: null,
                imageId: '449710784',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£209',
            type: 'HOTEL',
            latLong: {
              latitude: 51.52309,
              longitude: -0.125745,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/53791563',
            removeUrl: '/api/ucs/shortlist/remove/53791563',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '53791563',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '2651',
          name: 'Park International Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/10000/2700/2651/f06b257a.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£153',
                      accessibilityLabel: 'The price is £153',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£153',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£153',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4,
            localizedScore: '4.0',
            total: 1001,
            localizedTotal: '1,001 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.0 / 5 (1,001 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.0 out of 5 Very good (1,001 reviews)',
              value: '4.0/5 Very good (1,001 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Park-International-Hotel.h2651.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316629&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382947&price=0%2C300&sort=RECOMMENDED&top_dp=153&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=315598428&selectedRatePlan=384107808',
              relativePath:
                '/London-Hotels-Park-International-Hotel.h2651.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316629&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382947&price=0%2C300&sort=RECOMMENDED&top_dp=153&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=315598428&selectedRatePlan=384107808',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:51',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Park International Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/2700/2651/f06b257a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '565071920',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/2700/2651/e32eeb52.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '70546145',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/2700/2651/26c7c6ef.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '61647430',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/2700/2651/5d45af99.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '61647261',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£153',
            type: 'HOTEL',
            latLong: {
              latitude: 51.494722,
              longitude: -0.186617,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/2651',
            removeUrl: '/api/ucs/shortlist/remove/2651',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '2651',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '5813',
          name: 'Millennium Hotel London Knightsbridge',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/10000/5900/5813/389c00c4.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£280',
                      accessibilityLabel: 'The price is £280',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£280',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£280',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.6,
            localizedScore: '3.6',
            total: 992,
            localizedTotal: '992 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.6 / 5 (992 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.6 out of 5 Good (992 reviews)',
              value: '3.6/5 Good (992 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Millennium-Hotel-London-Knightsbridge.h5813.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316632&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382803&price=0%2C300&sort=RECOMMENDED&top_dp=280&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=24264&selectedRatePlan=25086',
              relativePath:
                '/London-Hotels-Millennium-Hotel-London-Knightsbridge.h5813.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316632&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382803&price=0%2C300&sort=RECOMMENDED&top_dp=280&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=24264&selectedRatePlan=25086',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:52',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Millennium Hotel London Knightsbridge',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/5900/5813/389c00c4.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '230476493',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/5900/5813/8718a73d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 91008,
                fallbackImage: null,
                imageId: '392639527',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/5900/5813/556ba815.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '469136976',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/5900/5813/92d808b5.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lounge',
                  __typename: 'Image',
                },
                subjectId: 82001,
                fallbackImage: null,
                imageId: '49598653',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£280',
            type: 'HOTEL',
            latLong: {
              latitude: 51.49995,
              longitude: -0.159786,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/5813',
            removeUrl: '/api/ucs/shortlist/remove/5813',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '5813',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '16150',
          name: 'Radisson Blu Edwardian Hampshire Hotel, London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/20000/16200/16150/1385e5dc.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£288',
                      accessibilityLabel: 'The price is £288',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£288',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£288',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.5,
            localizedScore: '4.5',
            total: 1000,
            localizedTotal: '1,000 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.5 / 5 (1,000 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.5 out of 5 Wonderful (1,000 reviews)',
              value: '4.5/5 Wonderful (1,000 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Radisson-Blu-Edwardian-Hampshire-Hotel.h16150.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316622&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6054504&price=0%2C300&sort=RECOMMENDED&top_dp=288&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314243361&selectedRatePlan=382751129',
              relativePath:
                '/London-Hotels-Radisson-Blu-Edwardian-Hampshire-Hotel.h16150.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316622&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6054504&price=0%2C300&sort=RECOMMENDED&top_dp=288&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314243361&selectedRatePlan=382751129',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:53',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Radisson Blu Edwardian Hampshire Hotel, London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/20000/16200/16150/1385e5dc.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '377114738',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/20000/16200/16150/13508b62.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 91008,
                fallbackImage: null,
                imageId: '542788308',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/20000/16200/16150/0f0ef746.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '377115050',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/20000/16200/16150/04761dcb.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '561658944',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£288',
            type: 'HOTEL',
            latLong: {
              latitude: 51.510032,
              longitude: -0.129663,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'Soho',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/16150',
            removeUrl: '/api/ucs/shortlist/remove/16150',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '16150',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '76382087',
          name: 'citizenM London Victoria Station',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/77000000/76390000/76382100/76382087/83b6e1a7.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£199',
                      accessibilityLabel: 'The price is £199',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£199',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£199',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.8,
            localizedScore: '4.8',
            total: 20,
            localizedTotal: '20 reviews',
            superlative: 'Exceptional',
            localizedSubtitle: '4.8 / 5 (20 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.8 out of 5 Exceptional (20 reviews)',
              value: '4.8/5 Exceptional (20 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-CitizenM-London-Victoria-Station.h76382087.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316622&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382341&price=0%2C300&sort=RECOMMENDED&top_dp=199&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=316518765&selectedRatePlan=386195783',
              relativePath:
                '/London-Hotels-CitizenM-London-Victoria-Station.h76382087.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316622&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382341&price=0%2C300&sort=RECOMMENDED&top_dp=199&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=316518765&selectedRatePlan=386195783',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:54',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for citizenM London Victoria Station',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/77000000/76390000/76382100/76382087/83b6e1a7.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '702569781',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/77000000/76390000/76382100/76382087/7d78a4b0.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '697828950',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/77000000/76390000/76382100/76382087/abdc50db.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '674374202',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/77000000/76390000/76382100/76382087/d84617e9.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '697830548',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£199',
            type: 'HOTEL',
            latLong: {
              latitude: 51.495215,
              longitude: -0.141534,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/76382087',
            removeUrl: '/api/ucs/shortlist/remove/76382087',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '76382087',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '3551',
          name: 'The Piccadilly London West End',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/10000/3600/3551/0f3a4393.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£286',
                      accessibilityLabel: 'The price is £286',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£286',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£286',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.1,
            localizedScore: '4.1',
            total: 1000,
            localizedTotal: '1,000 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.1 / 5 (1,000 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.1 out of 5 Very good (1,000 reviews)',
              value: '4.1/5 Very good (1,000 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Piccadilly-London-West-End.h3551.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316623&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6004177&price=0%2C300&sort=RECOMMENDED&top_dp=286&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=318096253&selectedRatePlan=386811246',
              relativePath:
                '/London-Hotels-The-Piccadilly-London-West-End.h3551.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316623&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6004177&price=0%2C300&sort=RECOMMENDED&top_dp=286&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=318096253&selectedRatePlan=386811246',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:55',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Piccadilly London West End',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/3600/3551/0f3a4393.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '48307503',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/3600/3551/62560c91.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property',
                  __typename: 'Image',
                },
                subjectId: 91001,
                fallbackImage: null,
                imageId: '29418713',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/3600/3551/3bc2c542.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '379866020',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/3600/3551/db2c3084.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lounge',
                  __typename: 'Image',
                },
                subjectId: 82001,
                fallbackImage: null,
                imageId: '45819873',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£286',
            type: 'HOTEL',
            latLong: {
              latitude: 51.512055,
              longitude: -0.131827,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/3551',
            removeUrl: '/api/ucs/shortlist/remove/3551',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '3551',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '5040114',
          name: 'Point A Hotel London Liverpool Street',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/6000000/5050000/5040200/5040114/5d94df2e.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£185',
                      accessibilityLabel: 'The price is £185',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£185',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£185',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.2,
            localizedScore: '4.2',
            total: 1001,
            localizedTotal: '1,001 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.2 / 5 (1,001 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.2 out of 5 Very good (1,001 reviews)',
              value: '4.2/5 Very good (1,001 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Point-A-Hotel-London-Liverpool-Street.h5040114.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316630&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144900&price=0%2C300&sort=RECOMMENDED&top_dp=185&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201903259&selectedRatePlan=209770588',
              relativePath:
                '/London-Hotels-Point-A-Hotel-London-Liverpool-Street.h5040114.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316630&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144900&price=0%2C300&sort=RECOMMENDED&top_dp=185&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201903259&selectedRatePlan=209770588',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:56',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Point A Hotel London Liverpool Street',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5050000/5040200/5040114/5d94df2e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '31138823',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5050000/5040200/5040114/1110c1a6.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '83729120',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5050000/5040200/5040114/c5ecd2e1.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '306559761',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5050000/5040200/5040114/60f8753e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Dining',
                  __typename: 'Image',
                },
                subjectId: 81000,
                fallbackImage: null,
                imageId: '431508587',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£185',
            type: 'HOTEL',
            latLong: {
              latitude: 51.520974,
              longitude: -0.077724,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/5040114',
            removeUrl: '/api/ucs/shortlist/remove/5040114',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '5040114',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '5244458',
          name: 'citizenM London Bankside',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/6000000/5250000/5244500/5244458/c66bbaca.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£184',
                      accessibilityLabel: 'The price is £184',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£184',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£184',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.6,
            localizedScore: '4.6',
            total: 1001,
            localizedTotal: '1,001 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.6 / 5 (1,001 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.6 out of 5 Wonderful (1,001 reviews)',
              value: '4.6/5 Wonderful (1,001 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-CitizenM-London-Bankside.h5244458.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316629&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381681&price=0%2C300&sort=RECOMMENDED&top_dp=184&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201172123&selectedRatePlan=205555802',
              relativePath:
                '/London-Hotels-CitizenM-London-Bankside.h5244458.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316629&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381681&price=0%2C300&sort=RECOMMENDED&top_dp=184&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201172123&selectedRatePlan=205555802',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:57',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for citizenM London Bankside',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5250000/5244500/5244458/c66bbaca.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '425066397',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5250000/5244500/5244458/785c0584.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Garden',
                  __typename: 'Image',
                },
                subjectId: 91005,
                fallbackImage: null,
                imageId: '425066387',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5250000/5244500/5244458/b044e531.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '425066388',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5250000/5244500/5244458/6fd32e64.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '425066381',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£184',
            type: 'HOTEL',
            latLong: {
              latitude: 51.505178,
              longitude: -0.098215,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/5244458',
            removeUrl: '/api/ucs/shortlist/remove/5244458',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '5244458',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '54993',
          name: 'Bedford Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/60000/55000/54993/9b9bf97e_b.jpg',
              __typename: 'Image',
            },
            fallbackImage: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54993/9b9bf97e.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: {
              text: 'Ad',
              theme_temp: 'PROMOTED',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£194',
                      accessibilityLabel: 'The price is £194',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£194',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£194',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.3,
            localizedScore: '4.3',
            total: 852,
            localizedTotal: '852 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.3 / 5 (852 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.3 out of 5 Excellent (852 reviews)',
              value: '4.3/5 Excellent (852 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Bedford.h54993.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316622&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&trackingData=AAAAELy0OIhyJpx4nK3CYQ19NmQAFhN1DsgqVXKjuIo4wFj57GVn8kY6bG5bfyixIV688CNGQ4jSX6fPeOP9I7fyxX7mFCMyocNSan2HMsgzVlaixmgTxWa-WYiyoCOrSEpmYn9LEApD4CJ3Lx7abk_8mohygqFQeK70VGtPddf_YFFJHfJew1xz0E30EdtMumanjMpTBjwkNrxO7-mOtIGT0Hgq4kofg_42jcJHZ2W06iiko4QFso3m4SWqiiQ9i2wUlg-OO3F1OANzpvVtejCN0GIrHaT0c_si8BzM9Jm0XfXdtm5Pt1KMrKkPGrao07OY264mg57Cz5Q4cMu-CcCBJSi-TlaNY1rYRC2tAFGQGCIvj8nVMYthoKtYdrHLwo4EulNNq2ipKzPl11t7e4tyRbtr2tOX01-ftSdx5U7CCJCu3KfyyTyt4KFcT2BesxpoOnztqPbZtXMrKw6NnSWCFS4lsLFncmzfCd41TvPXy0GHdmOYiYs6TJNkaCyOZ08pet7hyI8PMkiyDNa_YBEvMchYmfZ9tPPbzy-fYhafeIevnmhT3Wn6U2CUSqHt67MzTokV2XOa2sdOQxR35mtT_AHa3VwOOMkUz6T6eM5M_HzcGd7Fsna5-nb7g8xNktEua2aRaIAkT1MnwJfea3tLdCUybvsw1W93cBGidaI-4QCenGWhcoQ9SMH9sXebiBfcgfoLOdW_ci7_2nm2vmYYPkf5al5YYZw4Z5CsZ8eS63URrf6I8Zu2QVuyxfGXg_S4flLHHLcQxxegC9stuTkbkYWDOY6AGjazpcu9S6uw_2M-0lSdqHHJsTicAIE_U4fV6sQ2mk3hWmfPDKhvMeUTPFu0DtkJ193gsSpDOWYGTFJ0D7ffgJiW77R5L9MwfwdD9KIWLOk4iKN-gUXV5magJV7c1Yt1BGMDplMfqnbjZwgU2ZGJSlFrD9wZaJX3NcHn_2pb3HpNkjeHwPA41Q65KqdLjhsyIrZXvKEzOaPXbVKnHCcsqmvzK2xQG_RM3vxqH_kUt_ncJdA5qd14LZy9pSzo_iwdBnaqzuvCnbX6c4GJ37_BSh67-H-dvDfJNoRP7i3rXu535Jo0WyOkML_WJtbjnBf5JaxTf1YZIXJLHxtBnOsDp9DEsxtidnQzsU3XcCluz4D2cjqQJISrfxpHpSA%3D&rank=11&testVersionOverride=Buttercup&slots=HSR_E&position=58&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=194&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=226203031&selectedRatePlan=385819776',
              relativePath:
                '/London-Hotels-Bedford.h54993.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316622&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&trackingData=AAAAELy0OIhyJpx4nK3CYQ19NmQAFhN1DsgqVXKjuIo4wFj57GVn8kY6bG5bfyixIV688CNGQ4jSX6fPeOP9I7fyxX7mFCMyocNSan2HMsgzVlaixmgTxWa-WYiyoCOrSEpmYn9LEApD4CJ3Lx7abk_8mohygqFQeK70VGtPddf_YFFJHfJew1xz0E30EdtMumanjMpTBjwkNrxO7-mOtIGT0Hgq4kofg_42jcJHZ2W06iiko4QFso3m4SWqiiQ9i2wUlg-OO3F1OANzpvVtejCN0GIrHaT0c_si8BzM9Jm0XfXdtm5Pt1KMrKkPGrao07OY264mg57Cz5Q4cMu-CcCBJSi-TlaNY1rYRC2tAFGQGCIvj8nVMYthoKtYdrHLwo4EulNNq2ipKzPl11t7e4tyRbtr2tOX01-ftSdx5U7CCJCu3KfyyTyt4KFcT2BesxpoOnztqPbZtXMrKw6NnSWCFS4lsLFncmzfCd41TvPXy0GHdmOYiYs6TJNkaCyOZ08pet7hyI8PMkiyDNa_YBEvMchYmfZ9tPPbzy-fYhafeIevnmhT3Wn6U2CUSqHt67MzTokV2XOa2sdOQxR35mtT_AHa3VwOOMkUz6T6eM5M_HzcGd7Fsna5-nb7g8xNktEua2aRaIAkT1MnwJfea3tLdCUybvsw1W93cBGidaI-4QCenGWhcoQ9SMH9sXebiBfcgfoLOdW_ci7_2nm2vmYYPkf5al5YYZw4Z5CsZ8eS63URrf6I8Zu2QVuyxfGXg_S4flLHHLcQxxegC9stuTkbkYWDOY6AGjazpcu9S6uw_2M-0lSdqHHJsTicAIE_U4fV6sQ2mk3hWmfPDKhvMeUTPFu0DtkJ193gsSpDOWYGTFJ0D7ffgJiW77R5L9MwfwdD9KIWLOk4iKN-gUXV5magJV7c1Yt1BGMDplMfqnbjZwgU2ZGJSlFrD9wZaJX3NcHn_2pb3HpNkjeHwPA41Q65KqdLjhsyIrZXvKEzOaPXbVKnHCcsqmvzK2xQG_RM3vxqH_kUt_ncJdA5qd14LZy9pSzo_iwdBnaqzuvCnbX6c4GJ37_BSh67-H-dvDfJNoRP7i3rXu535Jo0WyOkML_WJtbjnBf5JaxTf1YZIXJLHxtBnOsDp9DEsxtidnQzsU3XcCluz4D2cjqQJISrfxpHpSA%3D&rank=11&testVersionOverride=Buttercup&slots=HSR_E&position=58&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=194&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=226203031&selectedRatePlan=385819776',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:58',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: {
            id: '682073',
            clickRedirectTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/ClRedirect?testVersionOverride=Buttercup&destinationUrl=&rank=11&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAELy0OIhyJpx4nK3CYQ19NmQAFhN1DsgqVXKjuIo4wFj57GVn8kY6bG5bfyixIV688CNGQ4jSX6fPeOP9I7fyxX7mFCMyocNSan2HMsgzVlaixmgTxWa-WYiyoCOrSEpmYn9LEApD4CJ3Lx7abk_8mohygqFQeK70VGtPddf_YFFJHfJew1xz0E30EdtMumanjMpTBjwkNrxO7-mOtIGT0Hgq4kofg_42jcJHZ2W06iiko4QFso3m4SWqiiQ9i2wUlg-OO3F1OANzpvVtejCN0GIrHaT0c_si8BzM9Jm0XfXdtm5Pt1KMrKkPGrao07OY264mg57Cz5Q4cMu-CcCBJSi-TlaNY1rYRC2tAFGQGCIvj8nVMYthoKtYdrHLwo4EulNNq2ipKzPl11t7e4tyRbtr2tOX01-ftSdx5U7CCJCu3KfyyTyt4KFcT2BesxpoOnztqPbZtXMrKw6NnSWCFS4lsLFncmzfCd41TvPXy0GHdmOYiYs6TJNkaCyOZ08pet7hyI8PMkiyDNa_YBEvMchYmfZ9tPPbzy-fYhafeIevnmhT3Wn6U2CUSqHt67MzTokV2XOa2sdOQxR35mtT_AHa3VwOOMkUz6T6eM5M_HzcGd7Fsna5-nb7g8xNktEua2aRaIAkT1MnwJfea3tLdCUybvsw1W93cBGidaI-4QCenGWhcoQ9SMH9sXebiBfcgfoLOdW_ci7_2nm2vmYYPkf5al5YYZw4Z5CsZ8eS63URrf6I8Zu2QVuyxfGXg_S4flLHHLcQxxegC9stuTkbkYWDOY6AGjazpcu9S6uw_2M-0lSdqHHJsTicAIE_U4fV6sQ2mk3hWmfPDKhvMeUTPFu0DtkJ193gsSpDOWYGTFJ0D7ffgJiW77R5L9MwfwdD9KIWLOk4iKN-gUXV5magJV7c1Yt1BGMDplMfqnbjZwgU2ZGJSlFrD9wZaJX3NcHn_2pb3HpNkjeHwPA41Q65KqdLjhsyIrZXvKEzOaPXbVKnHCcsqmvzK2xQG_RM3vxqH_kUt_ncJdA5qd14LZy9pSzo_iwdBnaqzuvCnbX6c4GJ37_BSh67-H-dvDfJNoRP7i3rXu535Jo0WyOkML_WJtbjnBf5JaxTf1YZIXJLHxtBnOsDp9DEsxtidnQzsU3XcCluz4D2cjqQJISrfxpHpSA=&slots=HSR_E&position=58&beaconIssued=2022-08-10T13:48:35',
            clickTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Cl?testVersionOverride=Buttercup&rank=11&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAELy0OIhyJpx4nK3CYQ19NmQAFhN1DsgqVXKjuIo4wFj57GVn8kY6bG5bfyixIV688CNGQ4jSX6fPeOP9I7fyxX7mFCMyocNSan2HMsgzVlaixmgTxWa-WYiyoCOrSEpmYn9LEApD4CJ3Lx7abk_8mohygqFQeK70VGtPddf_YFFJHfJew1xz0E30EdtMumanjMpTBjwkNrxO7-mOtIGT0Hgq4kofg_42jcJHZ2W06iiko4QFso3m4SWqiiQ9i2wUlg-OO3F1OANzpvVtejCN0GIrHaT0c_si8BzM9Jm0XfXdtm5Pt1KMrKkPGrao07OY264mg57Cz5Q4cMu-CcCBJSi-TlaNY1rYRC2tAFGQGCIvj8nVMYthoKtYdrHLwo4EulNNq2ipKzPl11t7e4tyRbtr2tOX01-ftSdx5U7CCJCu3KfyyTyt4KFcT2BesxpoOnztqPbZtXMrKw6NnSWCFS4lsLFncmzfCd41TvPXy0GHdmOYiYs6TJNkaCyOZ08pet7hyI8PMkiyDNa_YBEvMchYmfZ9tPPbzy-fYhafeIevnmhT3Wn6U2CUSqHt67MzTokV2XOa2sdOQxR35mtT_AHa3VwOOMkUz6T6eM5M_HzcGd7Fsna5-nb7g8xNktEua2aRaIAkT1MnwJfea3tLdCUybvsw1W93cBGidaI-4QCenGWhcoQ9SMH9sXebiBfcgfoLOdW_ci7_2nm2vmYYPkf5al5YYZw4Z5CsZ8eS63URrf6I8Zu2QVuyxfGXg_S4flLHHLcQxxegC9stuTkbkYWDOY6AGjazpcu9S6uw_2M-0lSdqHHJsTicAIE_U4fV6sQ2mk3hWmfPDKhvMeUTPFu0DtkJ193gsSpDOWYGTFJ0D7ffgJiW77R5L9MwfwdD9KIWLOk4iKN-gUXV5magJV7c1Yt1BGMDplMfqnbjZwgU2ZGJSlFrD9wZaJX3NcHn_2pb3HpNkjeHwPA41Q65KqdLjhsyIrZXvKEzOaPXbVKnHCcsqmvzK2xQG_RM3vxqH_kUt_ncJdA5qd14LZy9pSzo_iwdBnaqzuvCnbX6c4GJ37_BSh67-H-dvDfJNoRP7i3rXu535Jo0WyOkML_WJtbjnBf5JaxTf1YZIXJLHxtBnOsDp9DEsxtidnQzsU3XcCluz4D2cjqQJISrfxpHpSA=&slots=HSR_E&position=58&beaconIssued=2022-08-10T13:48:35',
            details:
              'A tranquil haven in the beating heart of central London with a modern restaurant & bar. Close to Covent Garden & Theatreland.',
            detailsHeadline: 'Intimate hotel with stunning garden',
            hotelImage:
              'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/60000/55000/54993/9b9bf97e_b.jpg',
            impressionTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Impr?testVersionOverride=Buttercup&rank=11&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAELy0OIhyJpx4nK3CYQ19NmQAFhN1DsgqVXKjuIo4wFj57GVn8kY6bG5bfyixIV688CNGQ4jSX6fPeOP9I7fyxX7mFCMyocNSan2HMsgzVlaixmgTxWa-WYiyoCOrSEpmYn9LEApD4CJ3Lx7abk_8mohygqFQeK70VGtPddf_YFFJHfJew1xz0E30EdtMumanjMpTBjwkNrxO7-mOtIGT0Hgq4kofg_42jcJHZ2W06iiko4QFso3m4SWqiiQ9i2wUlg-OO3F1OANzpvVtejCN0GIrHaT0c_si8BzM9Jm0XfXdtm5Pt1KMrKkPGrao07OY264mg57Cz5Q4cMu-CcCBJSi-TlaNY1rYRC2tAFGQGCIvj8nVMYthoKtYdrHLwo4EulNNq2ipKzPl11t7e4tyRbtr2tOX01-ftSdx5U7CCJCu3KfyyTyt4KFcT2BesxpoOnztqPbZtXMrKw6NnSWCFS4lsLFncmzfCd41TvPXy0GHdmOYiYs6TJNkaCyOZ08pet7hyI8PMkiyDNa_YBEvMchYmfZ9tPPbzy-fYhafeIevnmhT3Wn6U2CUSqHt67MzTokV2XOa2sdOQxR35mtT_AHa3VwOOMkUz6T6eM5M_HzcGd7Fsna5-nb7g8xNktEua2aRaIAkT1MnwJfea3tLdCUybvsw1W93cBGidaI-4QCenGWhcoQ9SMH9sXebiBfcgfoLOdW_ci7_2nm2vmYYPkf5al5YYZw4Z5CsZ8eS63URrf6I8Zu2QVuyxfGXg_S4flLHHLcQxxegC9stuTkbkYWDOY6AGjazpcu9S6uw_2M-0lSdqHHJsTicAIE_U4fV6sQ2mk3hWmfPDKhvMeUTPFu0DtkJ193gsSpDOWYGTFJ0D7ffgJiW77R5L9MwfwdD9KIWLOk4iKN-gUXV5magJV7c1Yt1BGMDplMfqnbjZwgU2ZGJSlFrD9wZaJX3NcHn_2pb3HpNkjeHwPA41Q65KqdLjhsyIrZXvKEzOaPXbVKnHCcsqmvzK2xQG_RM3vxqH_kUt_ncJdA5qd14LZy9pSzo_iwdBnaqzuvCnbX6c4GJ37_BSh67-H-dvDfJNoRP7i3rXu535Jo0WyOkML_WJtbjnBf5JaxTf1YZIXJLHxtBnOsDp9DEsxtidnQzsU3XcCluz4D2cjqQJISrfxpHpSA=&slots=HSR_E&position=58&beaconIssued=2022-08-10T13:48:35',
            trackingData:
              'AAAAELy0OIhyJpx4nK3CYQ19NmQAFhN1DsgqVXKjuIo4wFj57GVn8kY6bG5bfyixIV688CNGQ4jSX6fPeOP9I7fyxX7mFCMyocNSan2HMsgzVlaixmgTxWa-WYiyoCOrSEpmYn9LEApD4CJ3Lx7abk_8mohygqFQeK70VGtPddf_YFFJHfJew1xz0E30EdtMumanjMpTBjwkNrxO7-mOtIGT0Hgq4kofg_42jcJHZ2W06iiko4QFso3m4SWqiiQ9i2wUlg-OO3F1OANzpvVtejCN0GIrHaT0c_si8BzM9Jm0XfXdtm5Pt1KMrKkPGrao07OY264mg57Cz5Q4cMu-CcCBJSi-TlaNY1rYRC2tAFGQGCIvj8nVMYthoKtYdrHLwo4EulNNq2ipKzPl11t7e4tyRbtr2tOX01-ftSdx5U7CCJCu3KfyyTyt4KFcT2BesxpoOnztqPbZtXMrKw6NnSWCFS4lsLFncmzfCd41TvPXy0GHdmOYiYs6TJNkaCyOZ08pet7hyI8PMkiyDNa_YBEvMchYmfZ9tPPbzy-fYhafeIevnmhT3Wn6U2CUSqHt67MzTokV2XOa2sdOQxR35mtT_AHa3VwOOMkUz6T6eM5M_HzcGd7Fsna5-nb7g8xNktEua2aRaIAkT1MnwJfea3tLdCUybvsw1W93cBGidaI-4QCenGWhcoQ9SMH9sXebiBfcgfoLOdW_ci7_2nm2vmYYPkf5al5YYZw4Z5CsZ8eS63URrf6I8Zu2QVuyxfGXg_S4flLHHLcQxxegC9stuTkbkYWDOY6AGjazpcu9S6uw_2M-0lSdqHHJsTicAIE_U4fV6sQ2mk3hWmfPDKhvMeUTPFu0DtkJ193gsSpDOWYGTFJ0D7ffgJiW77R5L9MwfwdD9KIWLOk4iKN-gUXV5magJV7c1Yt1BGMDplMfqnbjZwgU2ZGJSlFrD9wZaJX3NcHn_2pb3HpNkjeHwPA41Q65KqdLjhsyIrZXvKEzOaPXbVKnHCcsqmvzK2xQG_RM3vxqH_kUt_ncJdA5qd14LZy9pSzo_iwdBnaqzuvCnbX6c4GJ37_BSh67-H-dvDfJNoRP7i3rXu535Jo0WyOkML_WJtbjnBf5JaxTf1YZIXJLHxtBnOsDp9DEsxtidnQzsU3XcCluz4D2cjqQJISrfxpHpSA=',
            brand: null,
            clickRedirectLinkoffTrackingUrl: null,
            logo: null,
            lotagline: null,
            rating: '0',
            slots: 'HSR_E',
            vanityUrl: null,
            rank: '11',
            position: '58',
            __typename: 'SponsoredListing',
          },
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Bedford Hotel',
            images: [
              {
                image: {
                  url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/1000000/60000/55000/54993/9b9bf97e_b.jpg',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54993/9b9bf97e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                imageId: '449687638',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54993/b7c7212c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Garden',
                  __typename: 'Image',
                },
                subjectId: 91005,
                fallbackImage: null,
                imageId: '449693080',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54993/1ac4cf8d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '449691165',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54993/e8d8223e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '449687585',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£194',
            type: 'HOTEL',
            latLong: {
              latitude: 51.520759,
              longitude: -0.123539,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/54993',
            removeUrl: '/api/ucs/shortlist/remove/54993',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '54993',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '74700787',
          name: 'Sonder The Henry',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/75000000/74710000/74700800/74700787/4c4faf41_b.jpg',
              __typename: 'Image',
            },
            fallbackImage: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/75000000/74710000/74700800/74700787/4c4faf41.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: null,
            tertiary: {
              text: 'Ad',
              theme_temp: 'PROMOTED',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£218',
                      accessibilityLabel: 'The price is £218',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£218',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£218',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.6,
            localizedScore: '4.6',
            total: 11,
            localizedTotal: '11 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.6 / 5 (11 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.6 out of 5 Wonderful (11 reviews)',
              value: '4.6/5 Wonderful (11 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Sonder-The-Henry.h74700787.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316622&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382417&trackingData=AAAAEId9H3jMYF5zMsHoKCCJhAim2BqybNNwDaCpEZEm1PiBeQrl0hje4h8nETVD0187Hd-Y1ukcbrfUks5CKM-Aa8MJ3G96CfRUdaZWxBxhy02idzLloc9W5ADqbwp9Q1K99clOW79YkbDBfbgAM2Id3a29WYuCwJN8cSXbDO9e0W8RSz4727c_zV6TTuGiIFBh_qLw4QaHQFur7aFuDVhcCtErUaYPQKzgJvm_3ryj78ZhOfmSOhapWEzAnCag8TkSt0mCZXjOj1SuNuC9r14Zpkf5aedWspCYTj_HGLWp-Ci1H2LEtXRIcbP_GTfxLZ_vTHVddCJHSkcKkrramfnvRRBtP3G0CaWvgvr2XNQOJhfCE5gqFV94HueT5g_5mdZUfJk_oqN0dY74kZRvhXSqKq5CElTEbBcnfOk9hT0IhPMqVtxQ4gTKbdG829GP5qz50jgfo1_Y6SPuSKvqaB3Zp-WeddWcoFBfqZh_IidKj0rRHwAZZKRwm3PP9RZw4RZheRxkmLyBina8PlwXhm9k0ULNR2Q9aw2z4Ld1-8auOXQM98_6ISXdnNUuaZ9bz3FSJGzl5cf0p-EA4U6xiztu15F-JB_bacrqtuos3QWwqDB63PGQUGgHGTeV7jCT5K8PY1Rgn9cgOIaa3hUU220e8Uxmp_ofkRZxGZN5uzr87Qya7c6I69JwZMb5MYWriYpeh_8GUydyXaJW-UBCadM_TWBuSDkRoyJ8hZvIfgXQy2HfExMHi8oNdOK_6TUo47Zi8Vm2dl26plsBV6wYS4IAfbVUxWjqbIStbOpnmSJrm3grceKQ_phBK8oGcTLAkWRZqxMZdBPJ51MGLjVi_yNDe4oU6wQ1y-_uzhs-vyl3-wofmTiqhM-C_y_auToF1reQFOGiR7zWuoIhHrQdCdE2UBk1DVOJOMosBL315zCjjrYQVbKjpfLVAOiY0PR_ImdA2whxxFnc2zhkWLBUMBQTfyT-HEuliwHatL4N0cgBowrs3R65rezb5xdXQGfVQukYKQS102IHa_yme3-VBP6NsonNpdTzjKpkFZRfYYa9fSA20rMpzGJjy7Kj72EDoqLUITbq02K5_7N5gzeJJIt-4eQ0080w6TTdy3TqsY8s85jiys709rYC0r-egic33Sf8iw%3D%3D&rank=12&testVersionOverride=Buttercup&slots=&position=59&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=218&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=316046222&selectedRatePlan=385313431',
              relativePath:
                '/London-Hotels-Sonder-The-Henry.h74700787.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316622&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382417&trackingData=AAAAEId9H3jMYF5zMsHoKCCJhAim2BqybNNwDaCpEZEm1PiBeQrl0hje4h8nETVD0187Hd-Y1ukcbrfUks5CKM-Aa8MJ3G96CfRUdaZWxBxhy02idzLloc9W5ADqbwp9Q1K99clOW79YkbDBfbgAM2Id3a29WYuCwJN8cSXbDO9e0W8RSz4727c_zV6TTuGiIFBh_qLw4QaHQFur7aFuDVhcCtErUaYPQKzgJvm_3ryj78ZhOfmSOhapWEzAnCag8TkSt0mCZXjOj1SuNuC9r14Zpkf5aedWspCYTj_HGLWp-Ci1H2LEtXRIcbP_GTfxLZ_vTHVddCJHSkcKkrramfnvRRBtP3G0CaWvgvr2XNQOJhfCE5gqFV94HueT5g_5mdZUfJk_oqN0dY74kZRvhXSqKq5CElTEbBcnfOk9hT0IhPMqVtxQ4gTKbdG829GP5qz50jgfo1_Y6SPuSKvqaB3Zp-WeddWcoFBfqZh_IidKj0rRHwAZZKRwm3PP9RZw4RZheRxkmLyBina8PlwXhm9k0ULNR2Q9aw2z4Ld1-8auOXQM98_6ISXdnNUuaZ9bz3FSJGzl5cf0p-EA4U6xiztu15F-JB_bacrqtuos3QWwqDB63PGQUGgHGTeV7jCT5K8PY1Rgn9cgOIaa3hUU220e8Uxmp_ofkRZxGZN5uzr87Qya7c6I69JwZMb5MYWriYpeh_8GUydyXaJW-UBCadM_TWBuSDkRoyJ8hZvIfgXQy2HfExMHi8oNdOK_6TUo47Zi8Vm2dl26plsBV6wYS4IAfbVUxWjqbIStbOpnmSJrm3grceKQ_phBK8oGcTLAkWRZqxMZdBPJ51MGLjVi_yNDe4oU6wQ1y-_uzhs-vyl3-wofmTiqhM-C_y_auToF1reQFOGiR7zWuoIhHrQdCdE2UBk1DVOJOMosBL315zCjjrYQVbKjpfLVAOiY0PR_ImdA2whxxFnc2zhkWLBUMBQTfyT-HEuliwHatL4N0cgBowrs3R65rezb5xdXQGfVQukYKQS102IHa_yme3-VBP6NsonNpdTzjKpkFZRfYYa9fSA20rMpzGJjy7Kj72EDoqLUITbq02K5_7N5gzeJJIt-4eQ0080w6TTdy3TqsY8s85jiys709rYC0r-egic33Sf8iw%3D%3D&rank=12&testVersionOverride=Buttercup&slots=&position=59&beaconIssued=2022-08-10T13%3A48%3A35&price=0%2C300&sort=RECOMMENDED&top_dp=218&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=316046222&selectedRatePlan=385313431',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:59',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: {
            id: '675546',
            clickRedirectTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/ClRedirect?testVersionOverride=Buttercup&destinationUrl=&rank=12&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEId9H3jMYF5zMsHoKCCJhAim2BqybNNwDaCpEZEm1PiBeQrl0hje4h8nETVD0187Hd-Y1ukcbrfUks5CKM-Aa8MJ3G96CfRUdaZWxBxhy02idzLloc9W5ADqbwp9Q1K99clOW79YkbDBfbgAM2Id3a29WYuCwJN8cSXbDO9e0W8RSz4727c_zV6TTuGiIFBh_qLw4QaHQFur7aFuDVhcCtErUaYPQKzgJvm_3ryj78ZhOfmSOhapWEzAnCag8TkSt0mCZXjOj1SuNuC9r14Zpkf5aedWspCYTj_HGLWp-Ci1H2LEtXRIcbP_GTfxLZ_vTHVddCJHSkcKkrramfnvRRBtP3G0CaWvgvr2XNQOJhfCE5gqFV94HueT5g_5mdZUfJk_oqN0dY74kZRvhXSqKq5CElTEbBcnfOk9hT0IhPMqVtxQ4gTKbdG829GP5qz50jgfo1_Y6SPuSKvqaB3Zp-WeddWcoFBfqZh_IidKj0rRHwAZZKRwm3PP9RZw4RZheRxkmLyBina8PlwXhm9k0ULNR2Q9aw2z4Ld1-8auOXQM98_6ISXdnNUuaZ9bz3FSJGzl5cf0p-EA4U6xiztu15F-JB_bacrqtuos3QWwqDB63PGQUGgHGTeV7jCT5K8PY1Rgn9cgOIaa3hUU220e8Uxmp_ofkRZxGZN5uzr87Qya7c6I69JwZMb5MYWriYpeh_8GUydyXaJW-UBCadM_TWBuSDkRoyJ8hZvIfgXQy2HfExMHi8oNdOK_6TUo47Zi8Vm2dl26plsBV6wYS4IAfbVUxWjqbIStbOpnmSJrm3grceKQ_phBK8oGcTLAkWRZqxMZdBPJ51MGLjVi_yNDe4oU6wQ1y-_uzhs-vyl3-wofmTiqhM-C_y_auToF1reQFOGiR7zWuoIhHrQdCdE2UBk1DVOJOMosBL315zCjjrYQVbKjpfLVAOiY0PR_ImdA2whxxFnc2zhkWLBUMBQTfyT-HEuliwHatL4N0cgBowrs3R65rezb5xdXQGfVQukYKQS102IHa_yme3-VBP6NsonNpdTzjKpkFZRfYYa9fSA20rMpzGJjy7Kj72EDoqLUITbq02K5_7N5gzeJJIt-4eQ0080w6TTdy3TqsY8s85jiys709rYC0r-egic33Sf8iw==&slots=&position=59&beaconIssued=2022-08-10T13:48:35',
            clickTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Cl?testVersionOverride=Buttercup&rank=12&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEId9H3jMYF5zMsHoKCCJhAim2BqybNNwDaCpEZEm1PiBeQrl0hje4h8nETVD0187Hd-Y1ukcbrfUks5CKM-Aa8MJ3G96CfRUdaZWxBxhy02idzLloc9W5ADqbwp9Q1K99clOW79YkbDBfbgAM2Id3a29WYuCwJN8cSXbDO9e0W8RSz4727c_zV6TTuGiIFBh_qLw4QaHQFur7aFuDVhcCtErUaYPQKzgJvm_3ryj78ZhOfmSOhapWEzAnCag8TkSt0mCZXjOj1SuNuC9r14Zpkf5aedWspCYTj_HGLWp-Ci1H2LEtXRIcbP_GTfxLZ_vTHVddCJHSkcKkrramfnvRRBtP3G0CaWvgvr2XNQOJhfCE5gqFV94HueT5g_5mdZUfJk_oqN0dY74kZRvhXSqKq5CElTEbBcnfOk9hT0IhPMqVtxQ4gTKbdG829GP5qz50jgfo1_Y6SPuSKvqaB3Zp-WeddWcoFBfqZh_IidKj0rRHwAZZKRwm3PP9RZw4RZheRxkmLyBina8PlwXhm9k0ULNR2Q9aw2z4Ld1-8auOXQM98_6ISXdnNUuaZ9bz3FSJGzl5cf0p-EA4U6xiztu15F-JB_bacrqtuos3QWwqDB63PGQUGgHGTeV7jCT5K8PY1Rgn9cgOIaa3hUU220e8Uxmp_ofkRZxGZN5uzr87Qya7c6I69JwZMb5MYWriYpeh_8GUydyXaJW-UBCadM_TWBuSDkRoyJ8hZvIfgXQy2HfExMHi8oNdOK_6TUo47Zi8Vm2dl26plsBV6wYS4IAfbVUxWjqbIStbOpnmSJrm3grceKQ_phBK8oGcTLAkWRZqxMZdBPJ51MGLjVi_yNDe4oU6wQ1y-_uzhs-vyl3-wofmTiqhM-C_y_auToF1reQFOGiR7zWuoIhHrQdCdE2UBk1DVOJOMosBL315zCjjrYQVbKjpfLVAOiY0PR_ImdA2whxxFnc2zhkWLBUMBQTfyT-HEuliwHatL4N0cgBowrs3R65rezb5xdXQGfVQukYKQS102IHa_yme3-VBP6NsonNpdTzjKpkFZRfYYa9fSA20rMpzGJjy7Kj72EDoqLUITbq02K5_7N5gzeJJIt-4eQ0080w6TTdy3TqsY8s85jiys709rYC0r-egic33Sf8iw==&slots=&position=59&beaconIssued=2022-08-10T13:48:35',
            details:
              'Stylish rooms in an elegant space with Victorian-era exterior. Just a short walk to Queensway, Hyde Park, and Paddington.',
            detailsHeadline: 'Steps from Kensington Palace Gardens',
            hotelImage:
              'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/75000000/74710000/74700800/74700787/4c4faf41_b.jpg',
            impressionTrackingUrl:
              'https://www.expedia.co.uk/taps/v1/Impr?testVersionOverride=Buttercup&rank=12&candidateHmGuid=d14a2d50-f943-40dd-a010-0934a9c8c278&trackingData=AAAAEId9H3jMYF5zMsHoKCCJhAim2BqybNNwDaCpEZEm1PiBeQrl0hje4h8nETVD0187Hd-Y1ukcbrfUks5CKM-Aa8MJ3G96CfRUdaZWxBxhy02idzLloc9W5ADqbwp9Q1K99clOW79YkbDBfbgAM2Id3a29WYuCwJN8cSXbDO9e0W8RSz4727c_zV6TTuGiIFBh_qLw4QaHQFur7aFuDVhcCtErUaYPQKzgJvm_3ryj78ZhOfmSOhapWEzAnCag8TkSt0mCZXjOj1SuNuC9r14Zpkf5aedWspCYTj_HGLWp-Ci1H2LEtXRIcbP_GTfxLZ_vTHVddCJHSkcKkrramfnvRRBtP3G0CaWvgvr2XNQOJhfCE5gqFV94HueT5g_5mdZUfJk_oqN0dY74kZRvhXSqKq5CElTEbBcnfOk9hT0IhPMqVtxQ4gTKbdG829GP5qz50jgfo1_Y6SPuSKvqaB3Zp-WeddWcoFBfqZh_IidKj0rRHwAZZKRwm3PP9RZw4RZheRxkmLyBina8PlwXhm9k0ULNR2Q9aw2z4Ld1-8auOXQM98_6ISXdnNUuaZ9bz3FSJGzl5cf0p-EA4U6xiztu15F-JB_bacrqtuos3QWwqDB63PGQUGgHGTeV7jCT5K8PY1Rgn9cgOIaa3hUU220e8Uxmp_ofkRZxGZN5uzr87Qya7c6I69JwZMb5MYWriYpeh_8GUydyXaJW-UBCadM_TWBuSDkRoyJ8hZvIfgXQy2HfExMHi8oNdOK_6TUo47Zi8Vm2dl26plsBV6wYS4IAfbVUxWjqbIStbOpnmSJrm3grceKQ_phBK8oGcTLAkWRZqxMZdBPJ51MGLjVi_yNDe4oU6wQ1y-_uzhs-vyl3-wofmTiqhM-C_y_auToF1reQFOGiR7zWuoIhHrQdCdE2UBk1DVOJOMosBL315zCjjrYQVbKjpfLVAOiY0PR_ImdA2whxxFnc2zhkWLBUMBQTfyT-HEuliwHatL4N0cgBowrs3R65rezb5xdXQGfVQukYKQS102IHa_yme3-VBP6NsonNpdTzjKpkFZRfYYa9fSA20rMpzGJjy7Kj72EDoqLUITbq02K5_7N5gzeJJIt-4eQ0080w6TTdy3TqsY8s85jiys709rYC0r-egic33Sf8iw==&slots=&position=59&beaconIssued=2022-08-10T13:48:35',
            trackingData:
              'AAAAEId9H3jMYF5zMsHoKCCJhAim2BqybNNwDaCpEZEm1PiBeQrl0hje4h8nETVD0187Hd-Y1ukcbrfUks5CKM-Aa8MJ3G96CfRUdaZWxBxhy02idzLloc9W5ADqbwp9Q1K99clOW79YkbDBfbgAM2Id3a29WYuCwJN8cSXbDO9e0W8RSz4727c_zV6TTuGiIFBh_qLw4QaHQFur7aFuDVhcCtErUaYPQKzgJvm_3ryj78ZhOfmSOhapWEzAnCag8TkSt0mCZXjOj1SuNuC9r14Zpkf5aedWspCYTj_HGLWp-Ci1H2LEtXRIcbP_GTfxLZ_vTHVddCJHSkcKkrramfnvRRBtP3G0CaWvgvr2XNQOJhfCE5gqFV94HueT5g_5mdZUfJk_oqN0dY74kZRvhXSqKq5CElTEbBcnfOk9hT0IhPMqVtxQ4gTKbdG829GP5qz50jgfo1_Y6SPuSKvqaB3Zp-WeddWcoFBfqZh_IidKj0rRHwAZZKRwm3PP9RZw4RZheRxkmLyBina8PlwXhm9k0ULNR2Q9aw2z4Ld1-8auOXQM98_6ISXdnNUuaZ9bz3FSJGzl5cf0p-EA4U6xiztu15F-JB_bacrqtuos3QWwqDB63PGQUGgHGTeV7jCT5K8PY1Rgn9cgOIaa3hUU220e8Uxmp_ofkRZxGZN5uzr87Qya7c6I69JwZMb5MYWriYpeh_8GUydyXaJW-UBCadM_TWBuSDkRoyJ8hZvIfgXQy2HfExMHi8oNdOK_6TUo47Zi8Vm2dl26plsBV6wYS4IAfbVUxWjqbIStbOpnmSJrm3grceKQ_phBK8oGcTLAkWRZqxMZdBPJ51MGLjVi_yNDe4oU6wQ1y-_uzhs-vyl3-wofmTiqhM-C_y_auToF1reQFOGiR7zWuoIhHrQdCdE2UBk1DVOJOMosBL315zCjjrYQVbKjpfLVAOiY0PR_ImdA2whxxFnc2zhkWLBUMBQTfyT-HEuliwHatL4N0cgBowrs3R65rezb5xdXQGfVQukYKQS102IHa_yme3-VBP6NsonNpdTzjKpkFZRfYYa9fSA20rMpzGJjy7Kj72EDoqLUITbq02K5_7N5gzeJJIt-4eQ0080w6TTdy3TqsY8s85jiys709rYC0r-egic33Sf8iw==',
            brand: null,
            clickRedirectLinkoffTrackingUrl: null,
            logo: null,
            lotagline: null,
            rating: '0',
            slots: null,
            vanityUrl: null,
            rank: '12',
            position: '59',
            __typename: 'SponsoredListing',
          },
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Sonder The Henry',
            images: [
              {
                image: {
                  url: 'https://a.travel-assets.com/media/meso_cm/PAPI/Images/hotels/75000000/74710000/74700800/74700787/4c4faf41_b.jpg',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: {
                  url: 'https://images.trvl-media.com/hotels/75000000/74710000/74700800/74700787/4c4faf41.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                imageId: '663224304',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/75000000/74710000/74700800/74700787/574cb57e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '668163217',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/75000000/74710000/74700800/74700787/7a379ee4.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '663228129',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/75000000/74710000/74700800/74700787/ea9734be.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '668163216',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£218',
            type: 'HOTEL',
            latLong: {
              latitude: 51.512435,
              longitude: -0.183512,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/74700787',
            removeUrl: '/api/ucs/shortlist/remove/74700787',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '74700787',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '54993',
          name: 'Bedford Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54993/9b9bf97e.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£194',
                      accessibilityLabel: 'The price is £194',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£194',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£194',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.3,
            localizedScore: '4.3',
            total: 852,
            localizedTotal: '852 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.3 / 5 (852 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.3 out of 5 Excellent (852 reviews)',
              value: '4.3/5 Excellent (852 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Bedford.h54993.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316620&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&price=0%2C300&sort=RECOMMENDED&top_dp=194&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=226203031&selectedRatePlan=385819776',
              relativePath:
                '/London-Hotels-Bedford.h54993.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316620&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&price=0%2C300&sort=RECOMMENDED&top_dp=194&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=226203031&selectedRatePlan=385819776',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:60',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Bedford Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54993/9b9bf97e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '449687638',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54993/b7c7212c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Garden',
                  __typename: 'Image',
                },
                subjectId: 91005,
                fallbackImage: null,
                imageId: '449693080',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54993/1ac4cf8d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '449691165',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/60000/55000/54993/e8d8223e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '449687585',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£194',
            type: 'HOTEL',
            latLong: {
              latitude: 51.520759,
              longitude: -0.123539,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/54993',
            removeUrl: '/api/ucs/shortlist/remove/54993',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '54993',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '801796',
          name: 'Park Plaza Victoria London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/810000/801800/801796/a10392a3.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£274',
                      accessibilityLabel: 'The price is £274',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£274',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£274',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.4,
            localizedScore: '4.4',
            total: 1000,
            localizedTotal: '1,000 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.4 / 5 (1,000 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.4 out of 5 Excellent (1,000 reviews)',
              value: '4.4/5 Excellent (1,000 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Park-Plaza-Victoria-London.h801796.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316621&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382732&price=0%2C300&sort=RECOMMENDED&top_dp=274&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314307584&selectedRatePlan=382952199',
              relativePath:
                '/London-Hotels-Park-Plaza-Victoria-London.h801796.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316621&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382732&price=0%2C300&sort=RECOMMENDED&top_dp=274&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314307584&selectedRatePlan=382952199',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:61',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Park Plaza Victoria London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/810000/801800/801796/a10392a3.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '377585416',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/810000/801800/801796/ff81f9e6.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior detail',
                  __typename: 'Image',
                },
                subjectId: 91023,
                fallbackImage: null,
                imageId: '28598600',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/810000/801800/801796/9dc8585b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '377585454',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/810000/801800/801796/0e3ea61d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '377083365',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£274',
            type: 'HOTEL',
            latLong: {
              latitude: 51.494272,
              longitude: -0.141008,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/801796',
            removeUrl: '/api/ucs/shortlist/remove/801796',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '801796',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '12084011',
          name: 'The Resident Victoria',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/13000000/12090000/12084100/12084011/363aafea.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: null,
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£209',
                      accessibilityLabel: 'The price is £209',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£209',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£209',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.7,
            localizedScore: '4.7',
            total: 1002,
            localizedTotal: '1,002 reviews',
            superlative: 'Exceptional',
            localizedSubtitle: '4.7 / 5 (1,002 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.7 out of 5 Exceptional (1,002 reviews)',
              value: '4.7/5 Exceptional (1,002 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Resident-Victoria.h12084011.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316620&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381276&price=0%2C300&sort=RECOMMENDED&top_dp=209&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201262166&selectedRatePlan=209087564',
              relativePath:
                '/London-Hotels-The-Resident-Victoria.h12084011.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316620&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381276&price=0%2C300&sort=RECOMMENDED&top_dp=209&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201262166&selectedRatePlan=209087564',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:62',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Resident Victoria',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/13000000/12090000/12084100/12084011/363aafea.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '459243090',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/13000000/12090000/12084100/12084011/26c406de.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '457868276',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/13000000/12090000/12084100/12084011/540072fc.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '459243091',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/13000000/12090000/12084100/12084011/f0c5a746.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '459243105',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£209',
            type: 'HOTEL',
            latLong: {
              latitude: 51.499054,
              longitude: -0.142667,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/12084011',
            removeUrl: '/api/ucs/shortlist/remove/12084011',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '12084011',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '1949',
          name: 'Britannia The International Hotel London, Canary Wharf',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/10000/2000/1949/fb4cc039.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£79',
                      accessibilityLabel: 'The price is £79',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£79',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£79',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.1,
            localizedScore: '3.1',
            total: 1219,
            localizedTotal: '1,219 reviews',
            superlative: null,
            localizedSubtitle: '3.1 / 5 (1,219 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: null,
              value: '3.1/5 ${superlative}',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Britannia-The-International-Hotel-London.h1949.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316622&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248621533024574&price=0%2C300&sort=RECOMMENDED&top_dp=79&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201210982&selectedRatePlan=209571458',
              relativePath:
                '/London-Hotels-Britannia-The-International-Hotel-London.h1949.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316622&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248621533024574&price=0%2C300&sort=RECOMMENDED&top_dp=79&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201210982&selectedRatePlan=209571458',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:63',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Britannia The International Hotel London, Canary Wharf',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/2000/1949/fb4cc039.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '18065042',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/2000/1949/c5be8177.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '28979819',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/2000/1949/a8d66969.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '28982208',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/2000/1949/5983da8f.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '28979560',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£79',
            type: 'HOTEL',
            latLong: {
              latitude: 51.501736,
              longitude: -0.023381,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/1949',
            removeUrl: '/api/ucs/shortlist/remove/1949',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '1949',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '17150967',
          name: 'Point A Hotel London Shoreditch',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/18000000/17160000/17151000/17150967/bcb2c6e8.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£132',
                      accessibilityLabel: 'The price is £132',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£132',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£132',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.2,
            localizedScore: '4.2',
            total: 995,
            localizedTotal: '995 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.2 / 5 (995 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.2 out of 5 Very good (995 reviews)',
              value: '4.2/5 Very good (995 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Point-A-Hotel-London-Shoreditch.h17150967.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316623&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179542&price=0%2C300&sort=RECOMMENDED&top_dp=132&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201803523&selectedRatePlan=209171972',
              relativePath:
                '/London-Hotels-Point-A-Hotel-London-Shoreditch.h17150967.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316623&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179542&price=0%2C300&sort=RECOMMENDED&top_dp=132&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201803523&selectedRatePlan=209171972',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:64',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Point A Hotel London Shoreditch',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/18000000/17160000/17151000/17150967/bcb2c6e8.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '30989808',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/18000000/17160000/17151000/17150967/d5018309.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '314683854',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/18000000/17160000/17151000/17150967/81e6111e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '269924395',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/18000000/17160000/17151000/17150967/7a6c2ded.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '265896915',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£132',
            type: 'HOTEL',
            latLong: {
              latitude: 51.52249,
              longitude: -0.08426,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/17150967',
            removeUrl: '/api/ucs/shortlist/remove/17150967',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '17150967',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '28126',
          name: 'Caesar Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/30000/28200/28126/baef1d1a.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: '17% off',
              theme_temp: 'DEAL_GENERIC',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'STRIKEOUT',
                    price: {
                      formatted: '£185',
                      accessibilityLabel: 'The price was £185',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: {
                      content: [
                        'This price is the standard rate on our site as provided by the property based on your search.',
                      ],
                      primaryUIButton: {
                        accessibility: null,
                        primary: 'Close',
                        __typename: 'UIPrimaryButton',
                      },
                      __typename: 'LodgingPlainDialog',
                    },
                  },
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£154',
                      accessibilityLabel: 'The price is £154',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£154',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: {
              formatted: '£185',
              __typename: 'Money',
            },
            disclaimer: {
              value: 'This price is the standard rate on our site as provided by the property based on your search.',
              __typename: 'LodgingPlainMessage',
            },
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£154',
                  __typename: 'Money',
                },
                strikeOut: {
                  formatted: '£185',
                  __typename: 'Money',
                },
                loyaltyPrice: null,
                disclaimer: {
                  value:
                    'This price is the standard rate on our site as provided by the property based on your search.',
                  __typename: 'LodgingPlainMessage',
                },
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.4,
            localizedScore: '4.4',
            total: 1001,
            localizedTotal: '1,001 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.4 / 5 (1,001 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.4 out of 5 Excellent (1,001 reviews)',
              value: '4.4/5 Excellent (1,001 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Caesar-Hotel.h28126.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316623&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382417&price=0%2C300&sort=RECOMMENDED&top_dp=154&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=18551&selectedRatePlan=236291024',
              relativePath:
                '/London-Hotels-Caesar-Hotel.h28126.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316623&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382417&price=0%2C300&sort=RECOMMENDED&top_dp=154&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=18551&selectedRatePlan=236291024',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:65',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Caesar Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/28200/28126/baef1d1a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '422709612',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/28200/28126/70405287.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Property entrance',
                  __typename: 'Image',
                },
                subjectId: 91002,
                fallbackImage: null,
                imageId: '33743898',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/28200/28126/724f07f3.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bathroom',
                  __typename: 'Image',
                },
                subjectId: 23000,
                fallbackImage: null,
                imageId: '625597005',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/28200/28126/82f9fd4f.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '16937761',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£154',
            type: 'HOTEL',
            latLong: {
              latitude: 51.513538,
              longitude: -0.182624,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/28126',
            removeUrl: '/api/ucs/shortlist/remove/28126',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '28126',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '28799662',
          name: 'Hard Rock Hotel London',
          propertyImage: {
            image: {
              description: 'Lobby',
              url: 'https://images.trvl-media.com/hotels/29000000/28800000/28799700/28799662/7560922b.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£288',
                      accessibilityLabel: 'The price is £288',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£288',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£288',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4,
            localizedScore: '4.0',
            total: 1003,
            localizedTotal: '1,003 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.0 / 5 (1,003 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.0 out of 5 Very good (1,003 reviews)',
              value: '4.0/5 Very good (1,003 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Hard-Rock-Hotel-London.h28799662.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316623&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383215&price=0%2C300&sort=RECOMMENDED&top_dp=288&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=DBL.AS&selectedRatePlan=20220818%7C20220819%7CW%7C164%7C6573%7CDBL.AS%7CBARROPROMOCL%7CRO%7C%7C1%7E2%7E0%7C%7CN%7C%7CB2C',
              relativePath:
                '/London-Hotels-Hard-Rock-Hotel-London.h28799662.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316623&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383215&price=0%2C300&sort=RECOMMENDED&top_dp=288&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=DBL.AS&selectedRatePlan=20220818%7C20220819%7CW%7C164%7C6573%7CDBL.AS%7CBARROPROMOCL%7CRO%7C%7C1%7E2%7E0%7C%7CN%7C%7CB2C',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:66',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Hard Rock Hotel London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/29000000/28800000/28799700/28799662/b44fe7cd.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '82937693',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/29000000/28800000/28799700/28799662/542b34ba.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '468065397',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/29000000/28800000/28799700/28799662/c433cc92.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '82927247',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/29000000/28800000/28799700/28799662/68d15c31.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Restaurant',
                  __typename: 'Image',
                },
                subjectId: 81003,
                fallbackImage: null,
                imageId: '82937019',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£288',
            type: 'HOTEL',
            latLong: {
              latitude: 51.51394,
              longitude: -0.1592,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/28799662',
            removeUrl: '/api/ucs/shortlist/remove/28799662',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '28799662',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '15921793',
          name: 'citizenM London Shoreditch',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/16000000/15930000/15921800/15921793/c5b62e1c.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£159',
                      accessibilityLabel: 'The price is £159',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£159',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£159',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.6,
            localizedScore: '4.6',
            total: 999,
            localizedTotal: '999 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.6 / 5 (999 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.6 out of 5 Wonderful (999 reviews)',
              value: '4.6/5 Wonderful (999 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-CitizenM-London-Shoreditch.h15921793.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316625&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179542&price=0%2C300&sort=RECOMMENDED&top_dp=159&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201654870&selectedRatePlan=208260852',
              relativePath:
                '/London-Hotels-CitizenM-London-Shoreditch.h15921793.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316625&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179542&price=0%2C300&sort=RECOMMENDED&top_dp=159&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201654870&selectedRatePlan=208260852',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:67',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for citizenM London Shoreditch',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/16000000/15930000/15921800/15921793/c5b62e1c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '425529877',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/16000000/15930000/15921800/15921793/6ef6c1dd.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '425564016',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/16000000/15930000/15921800/15921793/208b7473.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bathroom',
                  __typename: 'Image',
                },
                subjectId: 23000,
                fallbackImage: null,
                imageId: '425529870',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/16000000/15930000/15921800/15921793/85b2a242.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lounge',
                  __typename: 'Image',
                },
                subjectId: 82001,
                fallbackImage: null,
                imageId: '425529881',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£159',
            type: 'HOTEL',
            latLong: {
              latitude: 51.523885,
              longitude: -0.07776,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/15921793',
            removeUrl: '/api/ucs/shortlist/remove/15921793',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '15921793',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '8466215',
          name: 'Sea Containers London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/9000000/8470000/8466300/8466215/68467637.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£276',
                      accessibilityLabel: 'The price is £276',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£276',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£276',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.6,
            localizedScore: '4.6',
            total: 1000,
            localizedTotal: '1,000 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.6 / 5 (1,000 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.6 out of 5 Wonderful (1,000 reviews)',
              value: '4.6/5 Wonderful (1,000 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Sea-Containers-London.h8466215.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316624&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6054506&price=0%2C300&sort=RECOMMENDED&top_dp=276&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=217512808&selectedRatePlan=270071096',
              relativePath:
                '/London-Hotels-Sea-Containers-London.h8466215.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316624&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6054506&price=0%2C300&sort=RECOMMENDED&top_dp=276&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=217512808&selectedRatePlan=270071096',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:68',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Sea Containers London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/9000000/8470000/8466300/8466215/68467637.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '92618243',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/9000000/8470000/8466300/8466215/fb45ddb0.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 91008,
                fallbackImage: null,
                imageId: '91136913',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/9000000/8470000/8466300/8466215/214111f2.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '82945669',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/9000000/8470000/8466300/8466215/e3988b27.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '92618271',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£276',
            type: 'HOTEL',
            latLong: {
              latitude: 51.507928,
              longitude: -0.106875,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/8466215',
            removeUrl: '/api/ucs/shortlist/remove/8466215',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '8466215',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '1585328',
          name: 'The Grand at Trafalgar Square',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/2000000/1590000/1585400/1585328/8b27c4c2.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£272',
                      accessibilityLabel: 'The price is £272',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£272',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£272',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.3,
            localizedScore: '4.3',
            total: 1000,
            localizedTotal: '1,000 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.3 / 5 (1,000 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.3 out of 5 Excellent (1,000 reviews)',
              value: '4.3/5 Excellent (1,000 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Grand-At-Trafalgar-Square.h1585328.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316630&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381276&price=0%2C300&sort=RECOMMENDED&top_dp=272&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200257621&selectedRatePlan=211015430',
              relativePath:
                '/London-Hotels-The-Grand-At-Trafalgar-Square.h1585328.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316630&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381276&price=0%2C300&sort=RECOMMENDED&top_dp=272&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200257621&selectedRatePlan=211015430',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:69',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Grand at Trafalgar Square',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1590000/1585400/1585328/8b27c4c2.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '24675648',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1590000/1585400/1585328/e398ed85.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '458885859',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1590000/1585400/1585328/6d805ad6.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Restaurant',
                  __typename: 'Image',
                },
                subjectId: 81003,
                fallbackImage: null,
                imageId: '23141848',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1590000/1585400/1585328/ee18951e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lobby',
                  __typename: 'Image',
                },
                subjectId: 10001,
                fallbackImage: null,
                imageId: '328187262',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£272',
            type: 'HOTEL',
            latLong: {
              latitude: 51.507125,
              longitude: -0.125934,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/1585328',
            removeUrl: '/api/ucs/shortlist/remove/1585328',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '1585328',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '175675',
          name: 'Royal Eagle Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/180000/175700/175675/f3228da3.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£268',
                      accessibilityLabel: 'The price is £268',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£268',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£268',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.3,
            localizedScore: '3.3',
            total: 886,
            localizedTotal: '886 reviews',
            superlative: null,
            localizedSubtitle: '3.3 / 5 (886 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: null,
              value: '3.3/5 ${superlative}',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Royal-Eagle-Hotel.h175675.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316627&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179512&price=0%2C300&sort=RECOMMENDED&top_dp=268&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=277108&selectedRatePlan=201461600',
              relativePath:
                '/London-Hotels-Royal-Eagle-Hotel.h175675.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316627&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179512&price=0%2C300&sort=RECOMMENDED&top_dp=268&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=277108&selectedRatePlan=201461600',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:70',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Royal Eagle Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/180000/175700/175675/f3228da3.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '67361152',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/180000/175700/175675/aab4c3ae.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '100349385',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/180000/175700/175675/9be0b034.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'View from room',
                  __typename: 'Image',
                },
                subjectId: 22013,
                fallbackImage: null,
                imageId: '18178375',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/180000/175700/175675/15bd91b4.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Dining',
                  __typename: 'Image',
                },
                subjectId: 81000,
                fallbackImage: null,
                imageId: '422409969',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£268',
            type: 'HOTEL',
            latLong: {
              latitude: 51.514189,
              longitude: -0.178147,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/175675',
            removeUrl: '/api/ucs/shortlist/remove/175675',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '175675',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '7049006',
          name: 'Dorsett Shepherds Bush',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/8000000/7050000/7049100/7049006/cde50bae.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'STRIKEOUT',
                    price: {
                      formatted: '£157',
                      accessibilityLabel: 'The price was £157',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: {
                      content: [
                        'This price is the standard rate on our site as provided by the property based on your search.',
                      ],
                      primaryUIButton: {
                        accessibility: null,
                        primary: 'Close',
                        __typename: 'UIPrimaryButton',
                      },
                      __typename: 'LodgingPlainDialog',
                    },
                  },
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£123',
                      accessibilityLabel: 'The price is £123',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£123',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: {
              formatted: '£157',
              __typename: 'Money',
            },
            disclaimer: {
              value: 'This price is the standard rate on our site as provided by the property based on your search.',
              __typename: 'LodgingPlainMessage',
            },
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£123',
                  __typename: 'Money',
                },
                strikeOut: {
                  formatted: '£157',
                  __typename: 'Money',
                },
                loyaltyPrice: null,
                disclaimer: {
                  value:
                    'This price is the standard rate on our site as provided by the property based on your search.',
                  __typename: 'LodgingPlainMessage',
                },
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.2,
            localizedScore: '4.2',
            total: 1001,
            localizedTotal: '1,001 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.2 / 5 (1,001 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.2 out of 5 Very good (1,001 reviews)',
              value: '4.2/5 Very good (1,001 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Dorsett-Shepherds-Bush.h7049006.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316627&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144899&price=0%2C300&sort=RECOMMENDED&top_dp=123&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200505918&selectedRatePlan=385945556',
              relativePath:
                '/London-Hotels-Dorsett-Shepherds-Bush.h7049006.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316627&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144899&price=0%2C300&sort=RECOMMENDED&top_dp=123&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200505918&selectedRatePlan=385945556',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:71',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Dorsett Shepherds Bush',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/8000000/7050000/7049100/7049006/cde50bae.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '50167848',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/8000000/7050000/7049100/7049006/fe9edefa.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '674304161',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/8000000/7050000/7049100/7049006/cda236ce.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Restaurant',
                  __typename: 'Image',
                },
                subjectId: 81003,
                fallbackImage: null,
                imageId: '674304172',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/8000000/7050000/7049100/7049006/b58a4b70.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lobby',
                  __typename: 'Image',
                },
                subjectId: 10001,
                fallbackImage: null,
                imageId: '679404551',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£123',
            type: 'HOTEL',
            latLong: {
              latitude: 51.503997,
              longitude: -0.224204,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/7049006',
            removeUrl: '/api/ucs/shortlist/remove/7049006',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '7049006',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '10939',
          name: 'The Clermont London, Victoria',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/20000/11000/10939/1b8cf8a7.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: '25% off',
              theme_temp: 'DEAL_GENERIC',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'STRIKEOUT',
                    price: {
                      formatted: '£379',
                      accessibilityLabel: 'The price was £379',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: {
                      content: [
                        'This price is the standard rate on our site as provided by the property based on your search.',
                      ],
                      primaryUIButton: {
                        accessibility: null,
                        primary: 'Close',
                        __typename: 'UIPrimaryButton',
                      },
                      __typename: 'LodgingPlainDialog',
                    },
                  },
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£284',
                      accessibilityLabel: 'The price is £284',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£284',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: {
              formatted: '£379',
              __typename: 'Money',
            },
            disclaimer: {
              value: 'This price is the standard rate on our site as provided by the property based on your search.',
              __typename: 'LodgingPlainMessage',
            },
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£284',
                  __typename: 'Money',
                },
                strikeOut: {
                  formatted: '£379',
                  __typename: 'Money',
                },
                loyaltyPrice: null,
                disclaimer: {
                  value:
                    'This price is the standard rate on our site as provided by the property based on your search.',
                  __typename: 'LodgingPlainMessage',
                },
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.2,
            localizedScore: '4.2',
            total: 1001,
            localizedTotal: '1,001 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.2 / 5 (1,001 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.2 out of 5 Very good (1,001 reviews)',
              value: '4.2/5 Very good (1,001 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Clermont-London.h10939.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316627&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382732&price=0%2C300&sort=RECOMMENDED&top_dp=284&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314127568&selectedRatePlan=382429064',
              relativePath:
                '/London-Hotels-The-Clermont-London.h10939.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316627&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382732&price=0%2C300&sort=RECOMMENDED&top_dp=284&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314127568&selectedRatePlan=382429064',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:72',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Clermont London, Victoria',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/20000/11000/10939/1b8cf8a7.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '614672601',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/20000/11000/10939/93d3ac1b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '115611205',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/20000/11000/10939/114b5f32.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '543167076',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/20000/11000/10939/14045f9a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lounge',
                  __typename: 'Image',
                },
                subjectId: 82001,
                fallbackImage: null,
                imageId: '586258455',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£284',
            type: 'HOTEL',
            latLong: {
              latitude: 51.495818,
              longitude: -0.145172,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/10939',
            removeUrl: '/api/ucs/shortlist/remove/10939',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '10939',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '608',
          name: 'Radisson Blu Edwardian Grafton Hotel, London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/10000/700/608/05e71b8c.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£225',
                      accessibilityLabel: 'The price is £225',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£225',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£225',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.2,
            localizedScore: '4.2',
            total: 1000,
            localizedTotal: '1,000 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.2 / 5 (1,000 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.2 out of 5 Very good (1,000 reviews)',
              value: '4.2/5 Very good (1,000 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Radisson-Blu-Edwardian-Grafton-Hotel.h608.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316626&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144889&price=0%2C300&sort=RECOMMENDED&top_dp=225&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314243428&selectedRatePlan=382751259',
              relativePath:
                '/London-Hotels-Radisson-Blu-Edwardian-Grafton-Hotel.h608.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316626&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144889&price=0%2C300&sort=RECOMMENDED&top_dp=225&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314243428&selectedRatePlan=382751259',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:73',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Radisson Blu Edwardian Grafton Hotel, London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/700/608/05e71b8c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '681109513',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/700/608/cb48aba7.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '688135715',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/700/608/2750267b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '681109518',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/700/608/7812d3f6.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '617270248',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£225',
            type: 'HOTEL',
            latLong: {
              latitude: 51.52432,
              longitude: -0.13766,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/608',
            removeUrl: '/api/ucs/shortlist/remove/608',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '608',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '527232',
          name: 'Park Grand Paddington Court',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/530000/527300/527232/d4ef3b59.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: '11% off',
              theme_temp: 'DEAL_GENERIC',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'STRIKEOUT',
                    price: {
                      formatted: '£169',
                      accessibilityLabel: 'The price was £169',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: {
                      content: [
                        'This price is the standard rate on our site as provided by the property based on your search.',
                      ],
                      primaryUIButton: {
                        accessibility: null,
                        primary: 'Close',
                        __typename: 'UIPrimaryButton',
                      },
                      __typename: 'LodgingPlainDialog',
                    },
                  },
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£151',
                      accessibilityLabel: 'The price is £151',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£151',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: {
              formatted: '£169',
              __typename: 'Money',
            },
            disclaimer: {
              value: 'This price is the standard rate on our site as provided by the property based on your search.',
              __typename: 'LodgingPlainMessage',
            },
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£151',
                  __typename: 'Money',
                },
                strikeOut: {
                  formatted: '£169',
                  __typename: 'Money',
                },
                loyaltyPrice: null,
                disclaimer: {
                  value:
                    'This price is the standard rate on our site as provided by the property based on your search.',
                  __typename: 'LodgingPlainMessage',
                },
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.7,
            localizedScore: '3.7',
            total: 1004,
            localizedTotal: '1,004 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.7 / 5 (1,004 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.7 out of 5 Good (1,004 reviews)',
              value: '3.7/5 Good (1,004 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Park-Grand-Paddington-Court.h527232.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316625&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382417&price=0%2C300&sort=RECOMMENDED&top_dp=151&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201192112&selectedRatePlan=205634815',
              relativePath:
                '/London-Hotels-Park-Grand-Paddington-Court.h527232.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316625&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382417&price=0%2C300&sort=RECOMMENDED&top_dp=151&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201192112&selectedRatePlan=205634815',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:74',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Park Grand Paddington Court',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/530000/527300/527232/d4ef3b59.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '371575312',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/530000/527300/527232/928f14a7.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property',
                  __typename: 'Image',
                },
                subjectId: 91001,
                fallbackImage: null,
                imageId: '278893868',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/530000/527300/527232/f321673e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '371574924',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/530000/527300/527232/466f8473.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '371582371',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£151',
            type: 'HOTEL',
            latLong: {
              latitude: 51.513543,
              longitude: -0.179775,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/527232',
            removeUrl: '/api/ucs/shortlist/remove/527232',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '527232',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '1402870',
          name: 'Grand Royale London Hyde Park',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/2000000/1410000/1402900/1402870/995ed73d.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: '10% off',
              theme_temp: 'DEAL_GENERIC',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'STRIKEOUT',
                    price: {
                      formatted: '£168',
                      accessibilityLabel: 'The price was £168',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: {
                      content: [
                        'This price is the standard rate on our site as provided by the property based on your search.',
                      ],
                      primaryUIButton: {
                        accessibility: null,
                        primary: 'Close',
                        __typename: 'UIPrimaryButton',
                      },
                      __typename: 'LodgingPlainDialog',
                    },
                  },
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£151',
                      accessibilityLabel: 'The price is £151',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£151',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: {
              formatted: '£168',
              __typename: 'Money',
            },
            disclaimer: {
              value: 'This price is the standard rate on our site as provided by the property based on your search.',
              __typename: 'LodgingPlainMessage',
            },
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£151',
                  __typename: 'Money',
                },
                strikeOut: {
                  formatted: '£168',
                  __typename: 'Money',
                },
                loyaltyPrice: null,
                disclaimer: {
                  value:
                    'This price is the standard rate on our site as provided by the property based on your search.',
                  __typename: 'LodgingPlainMessage',
                },
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.7,
            localizedScore: '3.7',
            total: 999,
            localizedTotal: '999 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.7 / 5 (999 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.7 out of 5 Good (999 reviews)',
              value: '3.7/5 Good (999 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Grand-Royale-London-Hyde-Park.h1402870.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316625&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382417&price=0%2C300&sort=RECOMMENDED&top_dp=151&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200345812&selectedRatePlan=202111002',
              relativePath:
                '/London-Hotels-Grand-Royale-London-Hyde-Park.h1402870.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316625&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382417&price=0%2C300&sort=RECOMMENDED&top_dp=151&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200345812&selectedRatePlan=202111002',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:75',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Grand Royale London Hyde Park',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1410000/1402900/1402870/995ed73d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '282565451',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1410000/1402900/1402870/d55b4cbb.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property',
                  __typename: 'Image',
                },
                subjectId: 91001,
                fallbackImage: null,
                imageId: '370560427',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1410000/1402900/1402870/57dc49b2.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '370552656',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1410000/1402900/1402870/c75c006c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '370560428',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£151',
            type: 'HOTEL',
            latLong: {
              latitude: 51.511055,
              longitude: -0.186078,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/1402870',
            removeUrl: '/api/ucs/shortlist/remove/1402870',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '1402870',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '7238',
          name: 'Central Park Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/10000/7300/7238/d0c7069c.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£170',
                      accessibilityLabel: 'The price is £170',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£170',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£170',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.4,
            localizedScore: '3.4',
            total: 993,
            localizedTotal: '993 reviews',
            superlative: null,
            localizedSubtitle: '3.4 / 5 (993 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: null,
              value: '3.4/5 ${superlative}',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Central-Park-Hotel.h7238.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316633&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382417&price=0%2C300&sort=RECOMMENDED&top_dp=170&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=23016&selectedRatePlan=201461545',
              relativePath:
                '/London-Hotels-Central-Park-Hotel.h7238.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316633&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382417&price=0%2C300&sort=RECOMMENDED&top_dp=170&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=23016&selectedRatePlan=201461545',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:76',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Central Park Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/7300/7238/d0c7069c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '442660827',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/7300/7238/80d0c2b3.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property',
                  __typename: 'Image',
                },
                subjectId: 91001,
                fallbackImage: null,
                imageId: '14916398',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/7300/7238/141c842d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '14915848',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/7300/7238/e3e5bc16.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '6573967',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£170',
            type: 'HOTEL',
            latLong: {
              latitude: 51.51127,
              longitude: -0.18515,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/7238',
            removeUrl: '/api/ucs/shortlist/remove/7238',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '7238',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '17452353',
          name: 'Mondrian London Shoreditch ',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/18000000/17460000/17452400/17452353/2e96d994.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£263',
                      accessibilityLabel: 'The price is £263',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£263',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£263',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.5,
            localizedScore: '4.5',
            total: 601,
            localizedTotal: '601 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.5 / 5 (601 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.5 out of 5 Wonderful (601 reviews)',
              value: '4.5/5 Wonderful (601 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Mondrian-London-Shoreditch.h17452353.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316630&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179542&price=0%2C300&sort=RECOMMENDED&top_dp=263&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314452978&selectedRatePlan=383473442',
              relativePath:
                '/London-Hotels-Mondrian-London-Shoreditch.h17452353.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316630&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179542&price=0%2C300&sort=RECOMMENDED&top_dp=263&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=314452978&selectedRatePlan=383473442',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:77',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Mondrian London Shoreditch ',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/18000000/17460000/17452400/17452353/2e96d994.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '605107240',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/18000000/17460000/17452400/17452353/b93c3321.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '605107247',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/18000000/17460000/17452400/17452353/be7c31fb.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '605107301',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/18000000/17460000/17452400/17452353/96048dc5.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '605107379',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£263',
            type: 'HOTEL',
            latLong: {
              latitude: 51.52336,
              longitude: -0.08096,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/17452353',
            removeUrl: '/api/ucs/shortlist/remove/17452353',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '17452353',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '75708014',
          name: 'AMANO Covent Garden',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/76000000/75710000/75708100/75708014/0a28553f.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£231',
                      accessibilityLabel: 'The price is £231',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£231',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£231',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.8,
            localizedScore: '3.8',
            total: 106,
            localizedTotal: '106 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.8 / 5 (106 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.8 out of 5 Good (106 reviews)',
              value: '3.8/5 Good (106 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-AMANO-Covent-Garden.h75708014.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316632&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248625846408347&price=0%2C300&sort=RECOMMENDED&top_dp=231&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=316177934&selectedRatePlan=385571397',
              relativePath:
                '/London-Hotels-AMANO-Covent-Garden.h75708014.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316632&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248625846408347&price=0%2C300&sort=RECOMMENDED&top_dp=231&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=316177934&selectedRatePlan=385571397',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:78',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for AMANO Covent Garden',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/76000000/75710000/75708100/75708014/0a28553f.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '655694221',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/76000000/75710000/75708100/75708014/3da19489.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property',
                  __typename: 'Image',
                },
                subjectId: 91001,
                fallbackImage: null,
                imageId: '655693654',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/76000000/75710000/75708100/75708014/26bbebda.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 22007,
                fallbackImage: null,
                imageId: '655694217',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/76000000/75710000/75708100/75708014/d8848351.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '655694218',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£231',
            type: 'HOTEL',
            latLong: {
              latitude: 51.513692,
              longitude: -0.120383,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'Covent Garden',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/75708014',
            removeUrl: '/api/ucs/shortlist/remove/75708014',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '75708014',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '5221423',
          name: 'Point A Hotel - Paddington',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/6000000/5230000/5221500/5221423/7a5eddca.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£180',
                      accessibilityLabel: 'The price is £180',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£180',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£180',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.1,
            localizedScore: '4.1',
            total: 1002,
            localizedTotal: '1,002 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.1 / 5 (1,002 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.1 out of 5 Very good (1,002 reviews)',
              value: '4.1/5 Very good (1,002 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Point-A-Hotel-Paddington.h5221423.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316633&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800049&price=0%2C300&sort=RECOMMENDED&top_dp=180&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201922891&selectedRatePlan=209742538',
              relativePath:
                '/London-Hotels-Point-A-Hotel-Paddington.h5221423.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316633&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800049&price=0%2C300&sort=RECOMMENDED&top_dp=180&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201922891&selectedRatePlan=209742538',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:79',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Point A Hotel - Paddington',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5230000/5221500/5221423/7a5eddca.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '449738206',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5230000/5221500/5221423/a38eb28c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '83725720',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5230000/5221500/5221423/741cc6b0.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '449738323',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/6000000/5230000/5221500/5221423/331a0843.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Restaurant',
                  __typename: 'Image',
                },
                subjectId: 81003,
                fallbackImage: null,
                imageId: '449738209',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£180',
            type: 'HOTEL',
            latLong: {
              latitude: 51.518206,
              longitude: -0.170869,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'Paddington',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/5221423',
            removeUrl: '/api/ucs/shortlist/remove/5221423',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '5221423',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '2270848',
          name: 'Residence Inn by Marriott London Kensington',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/3000000/2280000/2270900/2270848/c0e76cc7.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£191',
                      accessibilityLabel: 'The price is £191',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£191',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£191',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4,
            localizedScore: '4.0',
            total: 910,
            localizedTotal: '910 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.0 / 5 (910 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.0 out of 5 Very good (910 reviews)',
              value: '4.0/5 Very good (910 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Residence-Inn-By-Marriott-London-Kensington.h2270848.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316632&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383075&price=0%2C300&sort=RECOMMENDED&top_dp=191&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=212701212&selectedRatePlan=238296892',
              relativePath:
                '/London-Hotels-Residence-Inn-By-Marriott-London-Kensington.h2270848.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316632&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383075&price=0%2C300&sort=RECOMMENDED&top_dp=191&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=212701212&selectedRatePlan=238296892',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:80',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Residence Inn by Marriott London Kensington',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/3000000/2280000/2270900/2270848/c0e76cc7.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '601184115',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/3000000/2280000/2270900/2270848/72b8cc53.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 91008,
                fallbackImage: null,
                imageId: '77551791',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/3000000/2280000/2270900/2270848/69830d72.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '59713388',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/3000000/2280000/2270900/2270848/fa53ef57.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '601184119',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£191',
            type: 'HOTEL',
            latLong: {
              latitude: 51.493651,
              longitude: -0.20159,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/2270848',
            removeUrl: '/api/ucs/shortlist/remove/2270848',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '2270848',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '470265',
          name: 'Sanderson London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/480000/470300/470265/e9560c3a.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£298',
                      accessibilityLabel: 'The price is £298',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£298',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£298',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.5,
            localizedScore: '4.5',
            total: 699,
            localizedTotal: '699 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.5 / 5 (699 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.5 out of 5 Wonderful (699 reviews)',
              value: '4.5/5 Wonderful (699 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Sanderson-London.h470265.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316632&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144889&price=0%2C300&sort=RECOMMENDED&top_dp=298&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200722332&selectedRatePlan=206981649',
              relativePath:
                '/London-Hotels-Sanderson-London.h470265.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316632&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144889&price=0%2C300&sort=RECOMMENDED&top_dp=298&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200722332&selectedRatePlan=206981649',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:81',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Sanderson London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/480000/470300/470265/e9560c3a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '325626370',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/480000/470300/470265/6406f75f.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bathroom',
                  __typename: 'Image',
                },
                subjectId: 23000,
                fallbackImage: null,
                imageId: '95524726',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/480000/470300/470265/2f1e8e54.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '73418260',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/480000/470300/470265/1f414737.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Breakfast area',
                  __typename: 'Image',
                },
                subjectId: 81001,
                fallbackImage: null,
                imageId: '52216668',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£298',
            type: 'HOTEL',
            latLong: {
              latitude: 51.517489,
              longitude: -0.136927,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/470265',
            removeUrl: '/api/ucs/shortlist/remove/470265',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '470265',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '1058226',
          name: 'One Hundred Shoreditch',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/2000000/1060000/1058300/1058226/56f89d79.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£249',
                      accessibilityLabel: 'The price is £249',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£249',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£249',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.6,
            localizedScore: '4.6',
            total: 73,
            localizedTotal: '73 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.6 / 5 (73 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.6 out of 5 Wonderful (73 reviews)',
              value: '4.6/5 Wonderful (73 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Ace-Hotel-London-Shoreditch.h1058226.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316628&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=3000662715&price=0%2C300&sort=RECOMMENDED&top_dp=249&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=316125136&selectedRatePlan=385469149',
              relativePath:
                '/London-Hotels-Ace-Hotel-London-Shoreditch.h1058226.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316628&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=3000662715&price=0%2C300&sort=RECOMMENDED&top_dp=249&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=316125136&selectedRatePlan=385469149',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:82',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for One Hundred Shoreditch',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1060000/1058300/1058226/56f89d79.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '657890545',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1060000/1058300/1058226/c1fb4c2b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '667106581',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1060000/1058300/1058226/abb17d3f.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '653964834',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1060000/1058300/1058226/f6afc96a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '653979380',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£249',
            type: 'HOTEL',
            latLong: {
              latitude: 51.525695,
              longitude: -0.077675,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/1058226',
            removeUrl: '/api/ucs/shortlist/remove/1058226',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '1058226',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '62755',
          name: 'The Resident Kensington',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/70000/62800/62755/814b2d2e.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: {
              text: 'VIP Access',
              theme_temp: 'VIP',
              icon_temp: null,
              mark: null,
              __typename: 'Badge',
            },
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£168',
                      accessibilityLabel: 'The price is £168',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£168',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£168',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.6,
            localizedScore: '4.6',
            total: 998,
            localizedTotal: '998 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.6 / 5 (998 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.6 out of 5 Wonderful (998 reviews)',
              value: '4.6/5 Wonderful (998 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: 'VIP Access',
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Resident-Kensington.h62755.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316628&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248626912740751&price=0%2C300&sort=RECOMMENDED&top_dp=168&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200150872&selectedRatePlan=209086470',
              relativePath:
                '/London-Hotels-The-Resident-Kensington.h62755.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316628&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248626912740751&price=0%2C300&sort=RECOMMENDED&top_dp=168&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200150872&selectedRatePlan=209086470',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:83',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Resident Kensington',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/70000/62800/62755/814b2d2e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '459107079',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/70000/62800/62755/6946f989.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '445652208',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/70000/62800/62755/a5adda8d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '459107075',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/70000/62800/62755/c204bf58.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '459107080',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£168',
            type: 'HOTEL',
            latLong: {
              latitude: 51.493099,
              longitude: -0.189989,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/62755',
            removeUrl: '/api/ucs/shortlist/remove/62755',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '62755',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '22262',
          name: 'Holiday Inn London-Bloomsbury Hotel, an IHG Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/30000/22300/22262/31feefb4.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£206',
                      accessibilityLabel: 'The price is £206',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£206',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£206',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.1,
            localizedScore: '4.1',
            total: 992,
            localizedTotal: '992 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.1 / 5 (992 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.1 out of 5 Very good (992 reviews)',
              value: '4.1/5 Very good (992 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Holiday-Inn-London-Bloomsbury-Hotel.h22262.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316631&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&price=0%2C300&sort=RECOMMENDED&top_dp=206&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200696432&selectedRatePlan=381158084',
              relativePath:
                '/London-Hotels-Holiday-Inn-London-Bloomsbury-Hotel.h22262.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316631&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&price=0%2C300&sort=RECOMMENDED&top_dp=206&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200696432&selectedRatePlan=381158084',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:84',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Holiday Inn London-Bloomsbury Hotel, an IHG Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/22300/22262/31feefb4.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '71569506',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/22300/22262/cf66e749.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 91008,
                fallbackImage: null,
                imageId: '582132374',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/22300/22262/14854679.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '105090459',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/30000/22300/22262/8f1da4cb.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '71569470',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£206',
            type: 'HOTEL',
            latLong: {
              latitude: 51.524088,
              longitude: -0.125074,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/22262',
            removeUrl: '/api/ucs/shortlist/remove/22262',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '22262',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '9080289',
          name: 'Point A Hotel - London, Canary Wharf',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/10000000/9090000/9080300/9080289/5cb26f19.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£100',
                      accessibilityLabel: 'The price is £100',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£100',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£100',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.3,
            localizedScore: '4.3',
            total: 1001,
            localizedTotal: '1,001 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.3 / 5 (1,001 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.3 out of 5 Excellent (1,001 reviews)',
              value: '4.3/5 Excellent (1,001 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Point-A-Hotel-London.h9080289.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316631&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179523&price=0%2C300&sort=RECOMMENDED&top_dp=100&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201898538&selectedRatePlan=209632089',
              relativePath:
                '/London-Hotels-Point-A-Hotel-London.h9080289.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316631&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=179523&price=0%2C300&sort=RECOMMENDED&top_dp=100&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201898538&selectedRatePlan=209632089',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:85',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Point A Hotel - London, Canary Wharf',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/10000000/9090000/9080300/9080289/5cb26f19.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '74372281',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/10000000/9090000/9080300/9080289/31456f8c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '74372396',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/10000000/9090000/9080300/9080289/29115bb1.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'View from room',
                  __typename: 'Image',
                },
                subjectId: 22013,
                fallbackImage: null,
                imageId: '222112360',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/10000000/9090000/9080300/9080289/ce0d0ade.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lobby sitting area',
                  __typename: 'Image',
                },
                subjectId: 10003,
                fallbackImage: null,
                imageId: '74372516',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£100',
            type: 'HOTEL',
            latLong: {
              latitude: 51.5071,
              longitude: -0.025264,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'Canary Wharf',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/9080289',
            removeUrl: '/api/ucs/shortlist/remove/9080289',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '9080289',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '8704',
          name: 'Thistle London Marble Arch',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/10000/8800/8704/0ac7888c.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£277',
                      accessibilityLabel: 'The price is £277',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£277',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£277',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.2,
            localizedScore: '4.2',
            total: 1000,
            localizedTotal: '1,000 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.2 / 5 (1,000 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.2 out of 5 Very good (1,000 reviews)',
              value: '4.2/5 Very good (1,000 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Amba-Hotel-Marble-Arch.h8704.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316630&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383215&price=0%2C300&sort=RECOMMENDED&top_dp=277&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201221419&selectedRatePlan=210436725',
              relativePath:
                '/London-Hotels-Amba-Hotel-Marble-Arch.h8704.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316630&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383215&price=0%2C300&sort=RECOMMENDED&top_dp=277&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201221419&selectedRatePlan=210436725',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:86',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Thistle London Marble Arch',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/8800/8704/0ac7888c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '488413746',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/8800/8704/c9739d3a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property – evening/night',
                  __typename: 'Image',
                },
                subjectId: 91003,
                fallbackImage: null,
                imageId: '676894452',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/8800/8704/657bcdde.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '495104216',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/10000/8800/8704/dc264060.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '495104045',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£277',
            type: 'HOTEL',
            latLong: {
              latitude: 51.514461,
              longitude: -0.156714,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/8704',
            removeUrl: '/api/ucs/shortlist/remove/8704',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '8704',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '9236409',
          name: 'Montcalm East, Autograph Collection',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/10000000/9240000/9236500/9236409/007495f9.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£249',
                      accessibilityLabel: 'The price is £249',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£249',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£249',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.3,
            localizedScore: '4.3',
            total: 1000,
            localizedTotal: '1,000 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.3 / 5 (1,000 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.3 out of 5 Excellent (1,000 reviews)',
              value: '4.3/5 Excellent (1,000 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Montcalm-East.h9236409.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316627&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381271&price=0%2C300&sort=RECOMMENDED&top_dp=249&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=229814527&selectedRatePlan=272304540',
              relativePath:
                '/London-Hotels-Montcalm-East.h9236409.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316627&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381271&price=0%2C300&sort=RECOMMENDED&top_dp=249&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=229814527&selectedRatePlan=272304540',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:87',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Montcalm East, Autograph Collection',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/10000000/9240000/9236500/9236409/007495f9.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '648260083',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/10000000/9240000/9236500/9236409/581fdb0b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '657882010',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/10000000/9240000/9236500/9236409/9f37d041.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Indoor pool',
                  __typename: 'Image',
                },
                subjectId: 30002,
                fallbackImage: null,
                imageId: '648260073',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/10000000/9240000/9236500/9236409/2fad978c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '648260049',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£249',
            type: 'HOTEL',
            latLong: {
              latitude: 51.527535,
              longitude: -0.089007,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/9236409',
            removeUrl: '/api/ucs/shortlist/remove/9236409',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '9236409',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '201089',
          name: 'Fraser Suites Queens Gate',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/210000/201100/201089/c069d162.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£205',
                      accessibilityLabel: 'The price is £205',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£205',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£205',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.3,
            localizedScore: '4.3',
            total: 878,
            localizedTotal: '878 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.3 / 5 (878 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.3 out of 5 Excellent (878 reviews)',
              value: '4.3/5 Excellent (878 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Fraser-Suites-Queens-Gate.h201089.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316629&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383193&price=0%2C300&sort=RECOMMENDED&top_dp=205&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=315598405&selectedRatePlan=384107717',
              relativePath:
                '/London-Hotels-Fraser-Suites-Queens-Gate.h201089.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316629&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383193&price=0%2C300&sort=RECOMMENDED&top_dp=205&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=315598405&selectedRatePlan=384107717',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:88',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'kitchen',
              name: 'Kitchen',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Fraser Suites Queens Gate',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/210000/201100/201089/c069d162.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '68577404',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/210000/201100/201089/c85ffce0.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '556348215',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/210000/201100/201089/e96c7ce9.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '88006350',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/210000/201100/201089/6e7d376a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lounge',
                  __typename: 'Image',
                },
                subjectId: 82001,
                fallbackImage: null,
                imageId: '68577484',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£205',
            type: 'HOTEL',
            latLong: {
              latitude: 51.495314,
              longitude: -0.18101,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/201089',
            removeUrl: '/api/ucs/shortlist/remove/201089',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '201089',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '535667',
          name: 'Pullman London St Pancras',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/540000/535700/535667/1d5eb539.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£278',
                      accessibilityLabel: 'The price is £278',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£278',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£278',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.5,
            localizedScore: '4.5',
            total: 996,
            localizedTotal: '996 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.5 / 5 (996 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.5 out of 5 Wonderful (996 reviews)',
              value: '4.5/5 Wonderful (996 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Pullman-London-St-Pancras.h535667.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316633&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381123&price=0%2C300&sort=RECOMMENDED&top_dp=278&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200528420&selectedRatePlan=202795219',
              relativePath:
                '/London-Hotels-Pullman-London-St-Pancras.h535667.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316633&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381123&price=0%2C300&sort=RECOMMENDED&top_dp=278&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200528420&selectedRatePlan=202795219',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:89',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Pullman London St Pancras',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/540000/535700/535667/1d5eb539.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '99421092',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/540000/535700/535667/dc1e4606.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '509299786',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/540000/535700/535667/338aa35b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '101388991',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/540000/535700/535667/1ba8872e.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '388054315',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£278',
            type: 'HOTEL',
            latLong: {
              latitude: 51.528764,
              longitude: -0.127697,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/535667',
            removeUrl: '/api/ucs/shortlist/remove/535667',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '535667',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '1486728',
          name: 'Clayton Hotel Chiswick',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/2000000/1490000/1486800/1486728/da77f965.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£125',
                      accessibilityLabel: 'The price is £125',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£125',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£125',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.4,
            localizedScore: '4.4',
            total: 997,
            localizedTotal: '997 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.4 / 5 (997 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.4 out of 5 Excellent (997 reviews)',
              value: '4.4/5 Excellent (997 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Clayton-Hotel-Chiswick.h1486728.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316633&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382688&price=0%2C300&sort=RECOMMENDED&top_dp=125&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=290613&selectedRatePlan=859128',
              relativePath:
                '/London-Hotels-Clayton-Hotel-Chiswick.h1486728.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316633&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976382688&price=0%2C300&sort=RECOMMENDED&top_dp=125&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=290613&selectedRatePlan=859128',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:90',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Clayton Hotel Chiswick',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1490000/1486800/1486728/da77f965.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '68627708',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1490000/1486800/1486728/baa8e309.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '115750777',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1490000/1486800/1486728/abfb5f2d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '24064766',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/2000000/1490000/1486800/1486728/00a0a742.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '115750782',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£125',
            type: 'HOTEL',
            latLong: {
              latitude: 51.492313,
              longitude: -0.279105,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/1486728',
            removeUrl: '/api/ucs/shortlist/remove/1486728',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '1486728',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '34358751',
          name: 'nhow London',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/35000000/34360000/34358800/34358751/ff952cc2.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£246',
                      accessibilityLabel: 'The price is £246',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£246',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£246',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.7,
            localizedScore: '4.7',
            total: 358,
            localizedTotal: '358 reviews',
            superlative: 'Exceptional',
            localizedSubtitle: '4.7 / 5 (358 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.7 out of 5 Exceptional (358 reviews)',
              value: '4.7/5 Exceptional (358 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Nhow-London.h34358751.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316628&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381271&price=0%2C300&sort=RECOMMENDED&top_dp=246&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=220541129&selectedRatePlan=290163042',
              relativePath:
                '/London-Hotels-Nhow-London.h34358751.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316628&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976381271&price=0%2C300&sort=RECOMMENDED&top_dp=246&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=220541129&selectedRatePlan=290163042',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:91',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for nhow London',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/35000000/34360000/34358800/34358751/ff952cc2.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '697842333',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/35000000/34360000/34358800/34358751/5326c04d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '697842343',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/35000000/34360000/34358800/34358751/eabb2df2.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '697842423',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/35000000/34360000/34358800/34358751/235666ea.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Breakfast area',
                  __typename: 'Image',
                },
                subjectId: 81001,
                fallbackImage: null,
                imageId: '697842488',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£246',
            type: 'HOTEL',
            latLong: {
              latitude: 51.529478,
              longitude: -0.097253,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/34358751',
            removeUrl: '/api/ucs/shortlist/remove/34358751',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '34358751',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '2156327',
          name: 'Novotel London Paddington',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/3000000/2160000/2156400/2156327/9c162ec9.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£220',
                      accessibilityLabel: 'The price is £220',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£220',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£220',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.3,
            localizedScore: '4.3',
            total: 998,
            localizedTotal: '998 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.3 / 5 (998 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.3 out of 5 Excellent (998 reviews)',
              value: '4.3/5 Excellent (998 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Novotel-London-Paddington.h2156327.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316630&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800049&price=0%2C300&sort=RECOMMENDED&top_dp=220&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200008974&selectedRatePlan=200040659',
              relativePath:
                '/London-Hotels-Novotel-London-Paddington.h2156327.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316630&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800049&price=0%2C300&sort=RECOMMENDED&top_dp=220&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=200008974&selectedRatePlan=200040659',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:92',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Novotel London Paddington',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/3000000/2160000/2156400/2156327/9c162ec9.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '420148505',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/3000000/2160000/2156400/2156327/ae9face3.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '420148474',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/3000000/2160000/2156400/2156327/3c81b370.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Indoor pool',
                  __typename: 'Image',
                },
                subjectId: 30002,
                fallbackImage: null,
                imageId: '21853020',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/3000000/2160000/2156400/2156327/ebd44adc.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '420148536',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£220',
            type: 'HOTEL',
            latLong: {
              latitude: 51.519293,
              longitude: -0.18254,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'Paddington',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/2156327',
            removeUrl: '/api/ucs/shortlist/remove/2156327',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '2156327',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '37631981',
          name: 'Point A Kensington Olympia',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/38000000/37640000/37632000/37631981/a0f1643c.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£96',
                      accessibilityLabel: 'The price is £96',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£96',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£96',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.1,
            localizedScore: '4.1',
            total: 650,
            localizedTotal: '650 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.1 / 5 (650 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.1 out of 5 Very good (650 reviews)',
              value: '4.1/5 Very good (650 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Point-A-Kensington-Olympia.h37631981.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316626&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383075&price=0%2C300&sort=RECOMMENDED&top_dp=96&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=221153521&selectedRatePlan=294218111',
              relativePath:
                '/London-Hotels-Point-A-Kensington-Olympia.h37631981.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316626&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248635976383075&price=0%2C300&sort=RECOMMENDED&top_dp=96&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=221153521&selectedRatePlan=294218111',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:93',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Point A Kensington Olympia',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/38000000/37640000/37632000/37631981/a0f1643c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '90909289',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/38000000/37640000/37632000/37631981/07f84b93.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '665107682',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/38000000/37640000/37632000/37631981/4c8499e8.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '98449774',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/38000000/37640000/37632000/37631981/387d568b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Breakfast area',
                  __typename: 'Image',
                },
                subjectId: 81001,
                fallbackImage: null,
                imageId: '98450452',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£96',
            type: 'HOTEL',
            latLong: {
              latitude: 51.494074,
              longitude: -0.197823,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/37631981',
            removeUrl: '/api/ucs/shortlist/remove/37631981',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '37631981',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '16181347',
          name: 'Novotel London Canary Wharf Hotel',
          propertyImage: {
            image: {
              description: 'Interior entrance',
              url: 'https://images.trvl-media.com/hotels/17000000/16190000/16181400/16181347/6da06cd3.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£214',
                      accessibilityLabel: 'The price is £214',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£214',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£214',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.5,
            localizedScore: '4.5',
            total: 1000,
            localizedTotal: '1,000 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.5 / 5 (1,000 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.5 out of 5 Wonderful (1,000 reviews)',
              value: '4.5/5 Wonderful (1,000 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Novotel-London-Canary-Wharf-Hotel.h16181347.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316627&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248621533024574&price=0%2C300&sort=RECOMMENDED&top_dp=214&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201708033&selectedRatePlan=208510924',
              relativePath:
                '/London-Hotels-Novotel-London-Canary-Wharf-Hotel.h16181347.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316627&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=553248621533024574&price=0%2C300&sort=RECOMMENDED&top_dp=214&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201708033&selectedRatePlan=208510924',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:94',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Novotel London Canary Wharf Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/17000000/16190000/16181400/16181347/a61210ce.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Terrace/patio',
                  __typename: 'Image',
                },
                subjectId: 91008,
                fallbackImage: null,
                imageId: '76917434',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/17000000/16190000/16181400/16181347/1509dc58.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Pool',
                  __typename: 'Image',
                },
                subjectId: 30000,
                fallbackImage: null,
                imageId: '542863268',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/17000000/16190000/16181400/16181347/372f70e3.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '542863538',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/17000000/16190000/16181400/16181347/13b88187.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '421591943',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£214',
            type: 'HOTEL',
            latLong: {
              latitude: 51.501325,
              longitude: -0.023264,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/16181347',
            removeUrl: '/api/ucs/shortlist/remove/16181347',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '16181347',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '36660267',
          name: 'The Collective Canary Wharf',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/37000000/36670000/36660300/36660267/ca6611bd.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£145',
                      accessibilityLabel: 'The price is £145',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£145',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£145',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.7,
            localizedScore: '3.7',
            total: 463,
            localizedTotal: '463 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.7 / 5 (463 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.7 out of 5 Good (463 reviews)',
              value: '3.7/5 Good (463 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Collective-Canary-Wharf.h36660267.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316625&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=3000687021&price=0%2C300&sort=RECOMMENDED&top_dp=145&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=221152547&selectedRatePlan=294218215',
              relativePath:
                '/London-Hotels-The-Collective-Canary-Wharf.h36660267.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316625&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=3000687021&price=0%2C300&sort=RECOMMENDED&top_dp=145&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=221152547&selectedRatePlan=294218215',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:95',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Collective Canary Wharf',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/37000000/36670000/36660300/36660267/ca6611bd.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '619096746',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/37000000/36670000/36660300/36660267/49f8dd99.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '563565534',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/37000000/36670000/36660300/36660267/7fd75659.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Pool',
                  __typename: 'Image',
                },
                subjectId: 30000,
                fallbackImage: null,
                imageId: '619096861',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/37000000/36670000/36660300/36660267/926694ac.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '104561719',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£145',
            type: 'HOTEL',
            latLong: {
              latitude: 51.497592,
              longitude: -0.01542,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/36660267',
            removeUrl: '/api/ucs/shortlist/remove/36660267',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '36660267',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '83245150',
          name: 'City Sleeper at Royal National Hotel',
          propertyImage: {
            image: {
              description: 'Interior entrance',
              url: 'https://images.trvl-media.com/hotels/84000000/83250000/83245200/83245150/40aa6be7.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£165',
                      accessibilityLabel: 'The price is £165',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£165',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£165',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 0,
            localizedScore: null,
            total: 0,
            localizedTotal: null,
            superlative: null,
            localizedSubtitle: null,
            localizedSubtitleA11y: {
              accessibilityLabel: null,
              value: '',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-City-Sleeper-At-Royal-National-Hotel.h83245150.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316632&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&price=0%2C300&sort=RECOMMENDED&top_dp=165&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=319875468&selectedRatePlan=387063573',
              relativePath:
                '/London-Hotels-City-Sleeper-At-Royal-National-Hotel.h83245150.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316632&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800052&price=0%2C300&sort=RECOMMENDED&top_dp=165&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=319875468&selectedRatePlan=387063573',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:96',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
              {
                message: 'Reserve now, pay later',
                theme: 'SUCCESS',
                type: 'PAY_LATER',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for City Sleeper at Royal National Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/84000000/83250000/83245200/83245150/fe3463bf.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Property entrance',
                  __typename: 'Image',
                },
                subjectId: 91002,
                fallbackImage: null,
                imageId: '701149613',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/84000000/83250000/83245200/83245150/bb40c463.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '701150929',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/84000000/83250000/83245200/83245150/1373ba47.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Breakfast area',
                  __typename: 'Image',
                },
                subjectId: 81001,
                fallbackImage: null,
                imageId: '701137911',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/84000000/83250000/83245200/83245150/85de5a67.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lobby sitting area',
                  __typename: 'Image',
                },
                subjectId: 10003,
                fallbackImage: null,
                imageId: '701149381',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£165',
            type: 'HOTEL',
            latLong: {
              latitude: 51.523469,
              longitude: -0.127314,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/83245150',
            removeUrl: '/api/ucs/shortlist/remove/83245150',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '83245150',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '8765476',
          name: 'Motel One London - Tower Hill',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/9000000/8770000/8765500/8765476/995ac9c9.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£149',
                      accessibilityLabel: 'The price is £149',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£149',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£149',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.5,
            localizedScore: '4.5',
            total: 999,
            localizedTotal: '999 reviews',
            superlative: 'Wonderful',
            localizedSubtitle: '4.5 / 5 (999 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.5 out of 5 Wonderful (999 reviews)',
              value: '4.5/5 Wonderful (999 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Motel-One-London-Tower-Hill.h8765476.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316631&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144911&price=0%2C300&sort=RECOMMENDED&top_dp=149&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201771221&selectedRatePlan=208845562',
              relativePath:
                '/London-Hotels-Motel-One-London-Tower-Hill.h8765476.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316631&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144911&price=0%2C300&sort=RECOMMENDED&top_dp=149&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=201771221&selectedRatePlan=208845562',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:97',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [
              {
                message: 'Fully refundable',
                theme: 'SUCCESS',
                type: 'FREE_CANCEL',
                mark: null,
                __typename: 'OfferSummaryMessage',
              },
            ],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Motel One London - Tower Hill',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/9000000/8770000/8765500/8765476/995ac9c9.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '537978804',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/9000000/8770000/8765500/8765476/49b21a6d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '537978558',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/9000000/8770000/8765500/8765476/dd4edd05.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '537979269',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/9000000/8770000/8765500/8765476/w2838h1803x21y21-327ed7d8.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Lounge',
                  __typename: 'Image',
                },
                subjectId: 82001,
                fallbackImage: null,
                imageId: '562262240',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£149',
            type: 'HOTEL',
            latLong: {
              latitude: 51.51247,
              longitude: -0.075576,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/8765476',
            removeUrl: '/api/ucs/shortlist/remove/8765476',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '8765476',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '901179',
          name: 'The Chilworth London Paddington',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/910000/901200/901179/fd4cc714.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£237',
                      accessibilityLabel: 'The price is £237',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£237',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£237',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4,
            localizedScore: '4.0',
            total: 998,
            localizedTotal: '998 reviews',
            superlative: 'Very good',
            localizedSubtitle: '4.0 / 5 (998 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.0 out of 5 Very good (998 reviews)',
              value: '4.0/5 Very good (998 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-The-Chilworth-London-Paddington.h901179.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316633&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800049&price=0%2C300&sort=RECOMMENDED&top_dp=237&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=213300593&selectedRatePlan=242012965',
              relativePath:
                '/London-Hotels-The-Chilworth-London-Paddington.h901179.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316633&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=800049&price=0%2C300&sort=RECOMMENDED&top_dp=237&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=213300593&selectedRatePlan=242012965',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:98',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for The Chilworth London Paddington',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/910000/901200/901179/fd4cc714.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '47380009',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/910000/901200/901179/aab668ec.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '379861861',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/910000/901200/901179/4247c7d8.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '25478062',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/910000/901200/901179/596d0767.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Dining',
                  __typename: 'Image',
                },
                subjectId: 81000,
                fallbackImage: null,
                imageId: '47379987',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£237',
            type: 'HOTEL',
            latLong: {
              latitude: 51.515113,
              longitude: -0.178296,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'Paddington',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/901179',
            removeUrl: '/api/ucs/shortlist/remove/901179',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '901179',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '582065',
          name: 'Novotel London Tower Bridge',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/590000/582100/582065/45b9bb87.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: null,
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£178',
                      accessibilityLabel: 'The price is £178',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£178',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: null,
            disclaimer: null,
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£178',
                  __typename: 'Money',
                },
                strikeOut: null,
                loyaltyPrice: null,
                disclaimer: null,
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 4.4,
            localizedScore: '4.4',
            total: 1003,
            localizedTotal: '1,003 reviews',
            superlative: 'Excellent',
            localizedSubtitle: '4.4 / 5 (1,003 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '4.4 out of 5 Excellent (1,003 reviews)',
              value: '4.4/5 Excellent (1,003 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Novotel-London-Tower-Bridge.h582065.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316629&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144911&price=0%2C300&sort=RECOMMENDED&top_dp=178&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=210907450&selectedRatePlan=226194452',
              relativePath:
                '/London-Hotels-Novotel-London-Tower-Bridge.h582065.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316629&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144911&price=0%2C300&sort=RECOMMENDED&top_dp=178&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=210907450&selectedRatePlan=226194452',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:99',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Novotel London Tower Bridge',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/590000/582100/582065/45b9bb87.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '81166644',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/590000/582100/582065/03af481b.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Exterior',
                  __typename: 'Image',
                },
                subjectId: 91024,
                fallbackImage: null,
                imageId: '81166614',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/590000/582100/582065/ce4f489c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Room',
                  __typename: 'Image',
                },
                subjectId: 21001,
                fallbackImage: null,
                imageId: '62665069',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/590000/582100/582065/593d8804.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '62664035',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£178',
            type: 'HOTEL',
            latLong: {
              latitude: 51.510786,
              longitude: -0.077317,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/582065',
            removeUrl: '/api/ucs/shortlist/remove/582065',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '582065',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
        {
          __typename: 'Property',
          id: '890843',
          name: 'Fitzrovia Hotel',
          propertyImage: {
            image: {
              description: 'Primary image',
              url: 'https://images.trvl-media.com/hotels/1000000/900000/890900/890843/e12e4f8a.jpg?impolicy=resizecrop&rw=1200&ra=fit',
              __typename: 'Image',
            },
            fallbackImage: null,
            __typename: 'PropertyImage',
          },
          offerBadge: {
            primary: null,
            secondary: {
              text: 'Member Price available',
              theme_temp: 'DEAL_MEMBER',
              icon_temp: {
                id: 'mod',
                description: 'mod',
                title: '',
                __typename: 'Icon',
              },
              mark: null,
              __typename: 'Badge',
            },
            tertiary: null,
            __typename: 'OfferBadge',
          },
          price: {
            displayMessages: [
              {
                lineItems: [
                  {
                    __typename: 'DisplayPrice',
                    role: 'STRIKEOUT',
                    price: {
                      formatted: '£286',
                      accessibilityLabel: 'The price was £286',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: {
                      content: [
                        'This price is the standard rate on our site as provided by the property based on your search.',
                      ],
                      primaryUIButton: {
                        accessibility: null,
                        primary: 'Close',
                        __typename: 'UIPrimaryButton',
                      },
                      __typename: 'LodgingPlainDialog',
                    },
                  },
                  {
                    __typename: 'DisplayPrice',
                    role: 'LEAD',
                    price: {
                      formatted: '£258',
                      accessibilityLabel: 'The price is £258',
                      __typename: 'FormattedMoney',
                    },
                    disclaimer: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
              {
                lineItems: [
                  {
                    __typename: 'LodgingEnrichedMessage',
                    value: 'includes taxes & fees',
                    state: null,
                  },
                ],
                __typename: 'PriceDisplayMessage',
              },
            ],
            lead: {
              formatted: '£258',
              __typename: 'Money',
            },
            strikeOutType: 'STANDALONE',
            strikeOut: {
              formatted: '£286',
              __typename: 'Money',
            },
            disclaimer: {
              value: 'This price is the standard rate on our site as provided by the property based on your search.',
              __typename: 'LodgingPlainMessage',
            },
            roomNightMessage: 'for 1 night',
            priceMessages: [
              {
                value: 'for 1 night',
                __typename: 'LodgingPlainMessage',
              },
            ],
            marketingFeeDetails: null,
            options: [
              {
                leadingCaption: null,
                displayPrice: {
                  formatted: '£258',
                  __typename: 'Money',
                },
                strikeOut: {
                  formatted: '£286',
                  __typename: 'Money',
                },
                loyaltyPrice: null,
                disclaimer: {
                  value:
                    'This price is the standard rate on our site as provided by the property based on your search.',
                  __typename: 'LodgingPlainMessage',
                },
                __typename: 'PropertyPriceOption',
              },
            ],
            __typename: 'PropertyPrice',
          },
          reviews: {
            scoreDenominator: 5,
            score: 3.9,
            localizedScore: '3.9',
            total: 992,
            localizedTotal: '992 reviews',
            superlative: 'Good',
            localizedSubtitle: '3.9 / 5 (992 reviews)',
            localizedSubtitleA11y: {
              accessibilityLabel: '3.9 out of 5 Good (992 reviews)',
              value: '3.9/5 Good (992 reviews)',
              __typename: 'LodgingEnrichedMessage',
            },
            mark: null,
            __typename: 'PropertyReviewsSummary',
          },
          destinationInfo: {
            distanceFromMessaging: null,
            __typename: 'PropertyDestinationInfo',
          },
          vipMessaging: null,
          propertyDetailsLink: {
            uri: {
              value:
                'https://www.expedia.co.uk/London-Hotels-Fitzrovia-Hotel.h890843.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316617&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144889&price=0%2C300&sort=RECOMMENDED&top_dp=258&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=149870&selectedRatePlan=256175171',
              relativePath:
                '/London-Hotels-Fitzrovia-Hotel.h890843.Hotel-Information?chkin=2022-08-18&chkout=2022-08-19&x_pwa=1&rfrr=HSR&pwa_ts=1660139316617&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jby51ay9Ib3RlbC1TZWFyY2g%3D&useRewards=true&rm1=a2&regionId=178279&destination=London+%28and+vicinity%29%2C+England%2C+United+Kingdom&destType=MARKET&neighborhoodId=6144889&price=0%2C300&sort=RECOMMENDED&top_dp=258&top_cur=GBP&semdtl=&userIntent=&selectedRoomType=149870&selectedRatePlan=256175171',
              __typename: 'HttpURI',
            },
            clientSideAnalytics: {
              referrerId: 'HOT.SR:HotelModule:100',
              linkName: 'View selected property',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'LodgingLink',
          },
          sponsoredListing: null,
          amenities: [
            {
              icon: 'pool',
              name: 'Pool',
              __typename: 'PropertyAmenityValue',
            },
          ],
          star: null,
          starRatingIcon: 'STAR',
          availability: {
            available: true,
            text: null,
            theme: 'URGENT',
            __typename: 'PropertyAvailability',
          },
          offerSummary: {
            messages: [],
            __typename: 'OfferSummary',
          },
          legalDisclaimer: null,
          imageGallery: {
            accessibilityLabel: 'Photo gallery for Fitzrovia Hotel',
            images: [
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/900000/890900/890843/e12e4f8a.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Primary image',
                  __typename: 'Image',
                },
                subjectId: 3,
                fallbackImage: null,
                imageId: '586012695',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/900000/890900/890843/ae6d604c.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Front of property – evening/night',
                  __typename: 'Image',
                },
                subjectId: 91003,
                fallbackImage: null,
                imageId: '425778242',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/900000/890900/890843/14fa11f2.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'View from room',
                  __typename: 'Image',
                },
                subjectId: 22013,
                fallbackImage: null,
                imageId: '586014482',
                __typename: 'PropertyImage',
              },
              {
                image: {
                  url: 'https://images.trvl-media.com/hotels/1000000/900000/890900/890843/4218de3d.jpg?impolicy=resizecrop&rw=455&ra=fit',
                  description: 'Bar (on property)',
                  __typename: 'Image',
                },
                subjectId: 82000,
                fallbackImage: null,
                imageId: '25836395',
                __typename: 'PropertyImage',
              },
            ],
            __typename: 'PropertyImageGallery',
          },
          mapMarker: {
            icon: 'HOTEL',
            label: '£258',
            type: 'HOTEL',
            latLong: {
              latitude: 51.521723,
              longitude: -0.142777,
              __typename: 'Coordinates',
            },
            clientSideAnalytics: {
              referrerId: 'Module.Map.HotelMarkerSelect',
              linkName: 'User selecting a hotel marker on the PWA HSR map',
              __typename: 'ClientSideAnalytics',
            },
            __typename: 'MapMarker',
          },
          neighborhood: {
            name: 'London',
            __typename: 'Region',
          },
          pinnedDetails: null,
          recentlyViewed: null,
          featuredMessages: [],
          supportingMessages: null,
          shortList: {
            favorited: false,
            saveUrl: '/api/ucs/shortlist/save/890843',
            removeUrl: '/api/ucs/shortlist/remove/890843',
            metaData: {
              chkIn: '20220818',
              chkOut: '20220819',
              hotelId: '890843',
              roomConfiguration: '2',
              __typename: 'ShortListMetaData',
            },
            __typename: 'ShortList',
          },
          highlightedPropertyDetails: [],
          propertySource: null,
          dataAttributes: null,
          listingFooter: null,
        },
      ],
      summary: {
        resultsSummary: [
          {
            __typename: 'LodgingPlainMessage',
            value: '10,000+ properties',
          },
          {
            __typename: 'LodgingLinkMessage',
            value: 'What we are paid impacts our sort order',
            label: 'Opens in a new window',
            link: {
              url: 'https://www.expedia.co.uk/service/#/article/19366',
              referrerId: 'HOT.HSR.RecommendedSort.FAQlink',
              __typename: 'LodgingLink',
            },
            icon: {
              id: 'info_outline',
              __typename: 'Icon',
            },
          },
        ],
        pricedHotelSize: 100,
        region: {
          name: 'London (and vicinity), England, United Kingdom',
          id: '178279',
          __typename: 'Region',
        },
        resultSectionHeadings: null,
        loyaltyInfo: null,
        matchedPropertiesSize: 10000,
        resultsHeading:
          'Properties in London (and vicinity), England, United Kingdom. August 18, 2022 through August 19, 2022',
        __typename: 'PropertyResultsSummary',
      },
      navigationTabs: null,
      map: {
        bounds: {
          northeast: {
            latitude: 51.531908,
            longitude: -0.062005,
            __typename: 'Coordinates',
          },
          southwest: {
            latitude: 51.482587,
            longitude: -0.450547,
            __typename: 'Coordinates',
          },
          __typename: 'Bounds',
        },
        center: {
          latitude: 51.507247500000005,
          longitude: -0.256276,
          __typename: 'Coordinates',
        },
        markers: [],
        staticMapSrc:
          'https://maps.googleapis.com/maps/api/staticmap',
        title: 'London (and vicinity), England, United Kingdom',
        subtitle: null,
        zoom: 14,
        messagingModel: null,
        __typename: 'PropertySearchMap',
      },
      legalDisclaimer: null,
      shoppingContext: {
        multiItem: null,
        __typename: 'ShoppingContext',
      },
      multiItemSearchContext: null,
      errorResponse: null,
      dialogErrorResponse: null,
      clickstream: {
        searchResultsViewed: null,
        __typename: 'SearchClickstreamEvents',
      },
      __typename: 'PropertySearchResults',
    },
  },
  extensions: {
    trace: {
      'Trace-ID': '758065aa-a82a-4aa7-99e0-a084594fca04',
      'Message-ID': '00000000-0000-0000-43a5-27c4070f24db',
    },
    analytics: [
      {
        traceId: '758065aa-a82a-4aa7-99e0-a084594fca04',
        adobeMappedData: {
          eVar45: 'price:0,price:300,neighborhood:178279',
          ipaddress: '27.111.209.200',
          server: 'www.expedia.co.uk',
          eVar6: '1',
          prop60: '320-491',
          eVar5: '8',
          eVar4: '178279',
          eVar48: 'London (and vicinity)',
          eVar47: 'HOT|1R|A2|C0|I0|L0',
          eVar2: 'hotels',
          channel: 'hotels',
          resolution: '800x1280',
          pageName: 'page.Hotel-Search',
          products:
            ';Hotel:1886693;;;;eVar32=1|eVar39=AD|eVar30=133|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:62769;;;;eVar32=2|eVar39=AD-ETP|eVar30=130|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:46218383;;;;eVar32=3|eVar39=AD-ETP|eVar30=160|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:470865;;;;eVar32=4|eVar39=AD-ETP|eVar30=428.4-278.46|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:55001;;;;eVar32=5|eVar39=AD-ETP|eVar30=135|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:3113039;;;;eVar32=6|eVar39=ETP|eVar30=269|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:179;;;;eVar32=7|eVar39=NONE|eVar30=250|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:12703815;;;;eVar32=8|eVar39=NONE|eVar30=216.44|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:55001;;;;eVar32=9|eVar39=ETP|eVar30=135|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:42297074;;;;eVar32=10|eVar39=NONE|eVar30=133|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:83245150;;;;eVar32=11|eVar39=AD-ETP|eVar30=165|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:34928032;;;;eVar32=12|eVar39=NONE|eVar30=229|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:2479;;;;eVar32=13|eVar39=NONE|eVar30=200.01-150.01|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:17684778;;;;eVar32=14|eVar39=NONE|eVar30=184.5|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:24000156;;;;eVar32=15|eVar39=NONE|eVar30=204|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:470865;;;;eVar32=16|eVar39=ETP|eVar30=428.4-278.46|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:559690;;;;eVar32=17|eVar39=NONE|eVar30=192.67|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:4190769;;;;eVar32=18|eVar39=ETP|eVar30=195|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:14736047;;;;eVar32=19|eVar39=ETP|eVar30=149|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:48296903;;;;eVar32=20|eVar39=NONE|eVar30=231.01-196.35|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:1584661;;;;eVar32=21|eVar39=NONE|eVar30=272.46|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:1183908;;;;eVar32=22|eVar39=ETP|eVar30=219|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:9745;;;;eVar32=23|eVar39=NONE|eVar30=257.61|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:54987;;;;eVar32=24|eVar39=ETP|eVar30=300|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:54995;;;;eVar32=25|eVar39=ETP|eVar30=150|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:559689;;;;eVar32=26|eVar39=NONE|eVar30=181.26|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:4735824;;;;eVar32=27|eVar39=NONE|eVar30=226.86|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:530052;;;;eVar32=28|eVar39=ETP|eVar30=189|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:1742184;;;;eVar32=29|eVar39=ETP|eVar30=269|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:32872139;;;;eVar32=30|eVar39=ETP|eVar30=269|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:26145;;;;eVar32=31|eVar39=NONE|eVar30=110.16|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:914179;;;;eVar32=32|eVar39=AD|eVar30=237.3|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:54995;;;;eVar32=33|eVar39=AD-ETP|eVar30=150|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:1524786;;;;eVar32=34|eVar39=ETP|eVar30=249|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:4836998;;;;eVar32=35|eVar39=NONE|eVar30=220.81-174.99|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:614;;;;eVar32=36|eVar39=NONE|eVar30=175|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:83096424;;;;eVar32=37|eVar39=NONE|eVar30=143.1|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:428403;;;;eVar32=38|eVar39=NONE|eVar30=155.39-138.89|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:5173526;;;;eVar32=39|eVar39=NONE|eVar30=165.77|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:523228;;;;eVar32=40|eVar39=NONE|eVar30=141|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:15118004;;;;eVar32=41|eVar39=ETP|eVar30=219|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:579374;;;;eVar32=42|eVar39=ETP|eVar30=279|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:16534146;;;;eVar32=43|eVar39=NONE|eVar30=206|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:30455872;;;;eVar32=44|eVar39=ETP|eVar30=189|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:1457972;;;;eVar32=45|eVar39=ETP|eVar30=239|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:9789;;;;eVar32=46|eVar39=NONE|eVar30=159.3|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:523223;;;;eVar32=47|eVar39=NONE|eVar30=187.11|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:21688;;;;eVar32=48|eVar39=NONE|eVar30=204|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:12649;;;;eVar32=49|eVar39=AD|eVar30=169.15|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:53791563;;;;eVar32=50|eVar39=AD-ETP|eVar30=209|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:2651;;;;eVar32=51|eVar39=NONE|eVar30=152.95|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:5813;;;;eVar32=52|eVar39=NONE|eVar30=280|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:16150;;;;eVar32=53|eVar39=NONE|eVar30=288.15|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:76382087;;;;eVar32=54|eVar39=ETP|eVar30=199|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:3551;;;;eVar32=55|eVar39=NONE|eVar30=286|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:5040114;;;;eVar32=56|eVar39=NONE|eVar30=185|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:5244458;;;;eVar32=57|eVar39=ETP|eVar30=184|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:54993;;;;eVar32=58|eVar39=AD|eVar30=193.99|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:74700787;;;;eVar32=59|eVar39=AD|eVar30=218.4|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:54993;;;;eVar32=60|eVar39=NONE|eVar30=193.99|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:801796;;;;eVar32=61|eVar39=ETP|eVar30=274|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:12084011;;;;eVar32=62|eVar39=NONE|eVar30=209|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:1949;;;;eVar32=63|eVar39=ETP|eVar30=79|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:17150967;;;;eVar32=64|eVar39=NONE|eVar30=132.1|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:28126;;;;eVar32=65|eVar39=NONE|eVar30=185.36-154|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:28799662;;;;eVar32=66|eVar39=NONE|eVar30=288.32|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:15921793;;;;eVar32=67|eVar39=ETP|eVar30=159|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:8466215;;;;eVar32=68|eVar39=ETP|eVar30=276|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:1585328;;;;eVar32=69|eVar39=NONE|eVar30=272.46|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:175675;;;;eVar32=70|eVar39=NONE|eVar30=268.36|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:7049006;;;;eVar32=71|eVar39=NONE|eVar30=156.61-122.62|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:10939;;;;eVar32=72|eVar39=NONE|eVar30=379-284.24|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:608;;;;eVar32=73|eVar39=NONE|eVar30=225.25|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:527232;;;;eVar32=74|eVar39=NONE|eVar30=168.8-150.99|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:1402870;;;;eVar32=75|eVar39=ETP|eVar30=168-151.2|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:7238;;;;eVar32=76|eVar39=NONE|eVar30=170|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:17452353;;;;eVar32=77|eVar39=NONE|eVar30=263.19|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:75708014;;;;eVar32=78|eVar39=ETP|eVar30=231|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:5221423;;;;eVar32=79|eVar39=NONE|eVar30=180|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:2270848;;;;eVar32=80|eVar39=NONE|eVar30=191.2|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:470265;;;;eVar32=81|eVar39=NONE|eVar30=297.84|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:1058226;;;;eVar32=82|eVar39=ETP|eVar30=249|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:62755;;;;eVar32=83|eVar39=NONE|eVar30=168|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:22262;;;;eVar32=84|eVar39=NONE|eVar30=205.99|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:9080289;;;;eVar32=85|eVar39=NONE|eVar30=99.62|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:8704;;;;eVar32=86|eVar39=NONE|eVar30=276.74|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:9236409;;;;eVar32=87|eVar39=ETP|eVar30=249|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:201089;;;;eVar32=88|eVar39=VR|eVar30=205|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:535667;;;;eVar32=89|eVar39=NONE|eVar30=278.08|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:1486728;;;;eVar32=90|eVar39=ETP|eVar30=125|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:34358751;;;;eVar32=91|eVar39=NONE|eVar30=246|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:2156327;;;;eVar32=92|eVar39=NONE|eVar30=220.42|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:37631981;;;;eVar32=93|eVar39=NONE|eVar30=96|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:16181347;;;;eVar32=94|eVar39=NONE|eVar30=213.91|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:36660267;;;;eVar32=95|eVar39=NONE|eVar30=144.99|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:83245150;;;;eVar32=96|eVar39=ETP|eVar30=165|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:8765476;;;;eVar32=97|eVar39=NONE|eVar30=149|eVar41=:true:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:901179;;;;eVar32=98|eVar39=NONE|eVar30=237.3|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:582065;;;;eVar32=99|eVar39=NONE|eVar30=177.66|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE,;Hotel:890843;;;;eVar32=100|eVar39=NONE|eVar30=286.25-257.63|eVar41=:false:CreditCardReq|eVar91=NONE|eVar100=NONE',
          eVar70: '3-0',
          prop11: '-1',
          prop32: '7ca6c9ce-4d1a-43f9-93a3-6e4ac8234df2|1643003906|expedia.com.tw',
          prop10: '758065aa-a82a-4aa7-99e0-a084594fca04',
          prop13: '-1',
          prop12: 'd14a2d50-f943-40dd-a010-0934a9c8c278',
          eVar50: 'web',
          events: 'event10,event161,event12,event51',
          prop14: 'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855',
          eVar56: 'notRewardsMember',
          eVar18: 'D=pageName',
          userAgent:
            'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36',
          prop6: '2022-08-19',
          prop5: '2022-08-18',
          prop2: 'hotels.20',
          list1:
            'expedia.43991.128669.0|expedia.44204.0.0|expedia.44203.129796.0|expedia.44252.129503.0|expedia.44037.130153.1|expedia.43612.129497.2|expedia.43747.129574.1|expedia.43550.0.0|expedia.43549.129874.3|expedia.43270.129141.0|expedia.42970.127803.0|expedia.43241.0.0|expedia.42976.125426.1|expedia.42975.124629.0|expedia.42974.123984.1|expedia.42973.124182.1|expedia.42876.124673.0|expedia.42825.0.0|expedia.42881.0.0|expedia.42742.0.0|expedia.42741.0.0|expedia.42446.0.0|expedia.42444.123988.0|expedia.42443.124730.1|expedia.42386.0.0|expedia.41459.124676.1|expedia.42084.0.0|expedia.41908.0.0|expedia.41904.0.0|expedia.41785.0.0|expedia.42086.0.0|expedia.41540.0.0|expedia.41468.0.0|expedia.41461.125179.0|expedia.41352.126443.1|expedia.38427.115718.4|expedia.39197.113900.0|expedia.37929.118924.1|expedia.37643.107701.1|expedia.35688.118923.0|expedia.35658.0.0|expedia.33944.97957.0|expedia.29139.79064.1|expedia.30417.0.0|expedia.31632.86724.1|expedia.33755.125330.0|expedia.4748.0.0|expedia.4881.0.0|expedia.4882.111396.0|expedia.4883.93935.0|expedia.4884.0.0|expedia.4885.0.0|expedia.4886.108471.1|expedia.4887.0.0|expedia.4888.0.0|expedia.4889.0.0|expedia.4890.77369.0|expedia.8099.0.0|expedia.9311.90366.0|expedia.9312.0.0|expedia.9313.0.0|expedia.9314.98982.0|expedia.9315.0.0|expedia.9870.0.0|expedia.11201.0.0|expedia.24485.62632.0|expedia.25007.0.0|expedia.25013.0.0|expedia.25014.0.0|expedia.25106.64514.1|expedia.25131.127319.1|expedia.25562.66767.1|expedia.26131.73292.1|expedia.27478.73935.1|expedia.27652.72146.1|expedia.27833.72381.1|expedia.27909.0.0|expedia.28091.77394.0|expedia.28457.116283.1|expedia.29210.0.0|expedia.29144.0.0|expedia.29936.98146.0|expedia.29955.119696.0|expedia.29785.81833.0|expedia.30017.82158.1|expedia.30281.98551.1|expedia.30293.0.0|expedia.30703.0.0|expedia.30840.0.0|expedia.25805.77012.1|expedia.31877.99559.1|expedia.32423.0.0|expedia.32446.89832.1|expedia.32603.0.0|expedia.32484.115725.0|expedia.32643.97027.0|expedia.32693.94376.1|expedia.32694.94168.0|expedia.32758.95889.1|expedia.32940.0.0|expedia.32042.110211.1|expedia.33016.120649.1|expedia.33163.0.0|expedia.34033.0.0|expedia.33807.0.0|expedia.34086.100414.1|expedia.33917.0.0|expedia.33715.107458.1|expedia.34963.106654.0|expedia.35017.103819.0|expedia.29708.0.0|expedia.34849.0.0|expedia.35108.103475.0|expedia.36130.101920.0|expedia.36239.104399.1|expedia.36247.0.0|expedia.36983.104829.1|expedia.35714.107457.1|expedia.37823.0.0|expedia.37910.0.0|expedia.31349.0.0|expedia.38215.108478.1|expedia.37949.0.0|expedia.38305.0.0|expedia.38587.116434.1|expedia.38589.112711.1|expedia.39170.0.0|expedia.38156.0.0|expedia.39493.0.0|expedia.40246.0.0|expedia.39675.0.0|expedia.40412.0.0|expedia.40615.0.0|expedia.40793.0.0|expedia.39776.117827.1|expedia.41467.0.0|expedia.41592.118871.1|expedia.41610.122278.1|expedia.41616.0.0|expedia.42547.121915.1|expedia.42610.0.0|expedia.43282.125844.1|expedia.43378.128601.1|expedia.43440.0.0|expedia.43575.130296.0|expedia.44083.0.0|expedia.31936.102311.0|expedia.24862.62756.1|expedia.39772.0.0|expedia.41258.0.0|expedia.41699.124243.1|expedia.42551.123268.1|expedia.44051.130263.0|expedia.43013.0.0|expedia.43671.130369.1|expedia.43631.0.0|expedia.44419.129924.0|expedia.42685.122500.0|expedia.38093.0.0|expedia.33661.111511.0|expedia.28826.0.0|expedia.44103.129328.0|expedia.37054.106171.0|expedia.34924.103991.0|expedia.43541.129706.1|expedia.44316.129588.0|expedia.32453.0.0|expedia.42683.0.0|expedia.42930.130244.2|expedia.42930.130244.2|expedia.42956.129244.1|expedia.38567.109318.0|expedia.40833.0.0|expedia.43375.0.0|expedia.42639.0.0|expedia.43887.130320.0|expedia.32599.0.0|expedia.44000.129691.0|expedia.43854.0.0|expedia.44011.0.0|expedia.43262.0.0|expedia.37797.0.0|expedia.37135.116139.1|expedia.43758.130095.1|expedia.40747.0.0|expedia.43129.129342.0',
          prop1: '12304',
          referrer: 'https://www.expedia.co.uk/sports/liverpoolfc',
          eVar80:
            'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36',
          pageURL: 'https://experience-api-lodging-search.kmc-default.lshop.prod.exp-aws.net/graphql',
          prop68: 'HOTMIP.N.MDEALS.N.CDEALS.N.VBP.N.FO.N',
          prop46: '24:99|81:0|82:1|83:0|84:0|85:0|86:0|87:0|88:0|89:0|90:0|91:0|93:0|95:0|99:0|102:0|103:0|104:0|105:0',
          currencyCode: 'GBP',
          eVar40: 'NoPartnerTier',
          eVar61: 'expedia.co.uk',
        },
        creationTimestamp: 1660139316937,
        context: {
          pageIdentity: {
            lineOfBusiness: 'H',
            pageIdentifier: 'page.Hotel-Search',
            funnelLocation: 20,
          },
          tealiumAccountDetailsPWA: {
            tealiumAccountName: 'expedia',
            tealiumProfileName: 'pwa-bex',
          },
          beaconOffConfig: {
            settings: {
              adobeSuiteAccount: '',
              sendToAdobeClientSide: true,
              sendToAdobeServerSide: false,
              sendToS3: false,
              adobeSuiteUrl: '',
            },
            rulesMatched: '',
            bucketing: {
              experimentInstance: '99990',
              bucketValue: 0,
              experimentId: '99991',
            },
            error:
              'No rule found for traceId=758065aa-a82a-4aa7-99e0-a084594fca04 and duaid=d14a2d50-f943-40dd-a010-0934a9c8c278. Using sendToAdobeClientSide=true',
          },
          tealiumAccountDetails: {
            tealiumAccountName: 'expedia',
            tealiumProfileName: 'main',
          },
          entryPageView: false,
          beaconEnabled: true,
          newVisit: false,
        },
        tealiumUtagData: {
          lineOfBusiness: 'hotels',
          siteCountryCode: 'GB',
          country: 'United Kingdom',
          loggedUser: -1,
          language: 'en',
          roomNights: 1,
          pageName: 'page.Hotel-Search',
          xLineOfBusiness: 'HOTEL',
          checkOutDate: '2022-08-19',
          context: {
            traceId: '758065aaa82a4aa799e0a084594fca04',
            site: {
              companyCode: '10111',
              tpid: 3,
              eapid: 0,
              brandId: 'expedia',
              operatingUnitId: '1002',
              siteId: 3,
              siteName: 'www.expedia.co.uk',
              jurisdictionCode: 'GBR',
              managementUnitCode: '1050',
              defaultCountry: 'GB',
            },
            tests: [
              {
                bucketValue: 0,
                experimentId: 43991,
              },
              {
                bucketValue: 0,
                experimentId: 44204,
              },
              {
                bucketValue: 0,
                experimentId: 44203,
              },
              {
                bucketValue: 0,
                experimentId: 44252,
              },
              {
                bucketValue: 1,
                experimentId: 44037,
              },
              {
                bucketValue: 2,
                experimentId: 43612,
              },
              {
                bucketValue: 1,
                experimentId: 43747,
              },
              {
                bucketValue: 0,
                experimentId: 43550,
              },
              {
                bucketValue: 3,
                experimentId: 43549,
              },
              {
                bucketValue: 0,
                experimentId: 43270,
              },
              {
                bucketValue: 0,
                experimentId: 42970,
              },
              {
                bucketValue: 0,
                experimentId: 43241,
              },
              {
                bucketValue: 1,
                experimentId: 42976,
              },
              {
                bucketValue: 0,
                experimentId: 42975,
              },
              {
                bucketValue: 1,
                experimentId: 42974,
              },
              {
                bucketValue: 1,
                experimentId: 42973,
              },
              {
                bucketValue: 0,
                experimentId: 42876,
              },
              {
                bucketValue: 0,
                experimentId: 42825,
              },
              {
                bucketValue: 0,
                experimentId: 42881,
              },
              {
                bucketValue: 0,
                experimentId: 42742,
              },
              {
                bucketValue: 0,
                experimentId: 42741,
              },
              {
                bucketValue: 0,
                experimentId: 42446,
              },
              {
                bucketValue: 0,
                experimentId: 42444,
              },
              {
                bucketValue: 1,
                experimentId: 42443,
              },
              {
                bucketValue: 0,
                experimentId: 42386,
              },
              {
                bucketValue: 1,
                experimentId: 41459,
              },
              {
                bucketValue: 0,
                experimentId: 42084,
              },
              {
                bucketValue: 0,
                experimentId: 41908,
              },
              {
                bucketValue: 0,
                experimentId: 41904,
              },
              {
                bucketValue: 0,
                experimentId: 41785,
              },
              {
                bucketValue: 0,
                experimentId: 42086,
              },
              {
                bucketValue: 0,
                experimentId: 41540,
              },
              {
                bucketValue: 0,
                experimentId: 41468,
              },
              {
                bucketValue: 0,
                experimentId: 41461,
              },
              {
                bucketValue: 1,
                experimentId: 41352,
              },
              {
                bucketValue: 4,
                experimentId: 38427,
              },
              {
                bucketValue: 0,
                experimentId: 39197,
              },
              {
                bucketValue: 1,
                experimentId: 37929,
              },
              {
                bucketValue: 1,
                experimentId: 37643,
              },
              {
                bucketValue: 0,
                experimentId: 35688,
              },
              {
                bucketValue: 0,
                experimentId: 35658,
              },
              {
                bucketValue: 0,
                experimentId: 33944,
              },
              {
                bucketValue: 1,
                experimentId: 29139,
              },
              {
                bucketValue: 0,
                experimentId: 30417,
              },
              {
                bucketValue: 1,
                experimentId: 31632,
              },
              {
                bucketValue: 0,
                experimentId: 33755,
              },
              {
                bucketValue: 0,
                experimentId: 4748,
              },
              {
                bucketValue: 0,
                experimentId: 4881,
              },
              {
                bucketValue: 0,
                experimentId: 4882,
              },
              {
                bucketValue: 0,
                experimentId: 4883,
              },
              {
                bucketValue: 0,
                experimentId: 4884,
              },
              {
                bucketValue: 0,
                experimentId: 4885,
              },
              {
                bucketValue: 1,
                experimentId: 4886,
              },
              {
                bucketValue: 0,
                experimentId: 4887,
              },
              {
                bucketValue: 0,
                experimentId: 4888,
              },
              {
                bucketValue: 0,
                experimentId: 4889,
              },
              {
                bucketValue: 0,
                experimentId: 4890,
              },
              {
                bucketValue: 0,
                experimentId: 8099,
              },
              {
                bucketValue: 0,
                experimentId: 9311,
              },
              {
                bucketValue: 0,
                experimentId: 9312,
              },
              {
                bucketValue: 0,
                experimentId: 9313,
              },
              {
                bucketValue: 0,
                experimentId: 9314,
              },
              {
                bucketValue: 0,
                experimentId: 9315,
              },
              {
                bucketValue: 0,
                experimentId: 9870,
              },
              {
                bucketValue: 0,
                experimentId: 11201,
              },
              {
                bucketValue: 0,
                experimentId: 24485,
              },
              {
                bucketValue: 0,
                experimentId: 25007,
              },
              {
                bucketValue: 0,
                experimentId: 25013,
              },
              {
                bucketValue: 0,
                experimentId: 25014,
              },
              {
                bucketValue: 1,
                experimentId: 25106,
              },
              {
                bucketValue: 1,
                experimentId: 25131,
              },
              {
                bucketValue: 1,
                experimentId: 25562,
              },
              {
                bucketValue: 1,
                experimentId: 26131,
              },
              {
                bucketValue: 1,
                experimentId: 27478,
              },
              {
                bucketValue: 1,
                experimentId: 27652,
              },
              {
                bucketValue: 1,
                experimentId: 27833,
              },
              {
                bucketValue: 0,
                experimentId: 27909,
              },
              {
                bucketValue: 0,
                experimentId: 28091,
              },
              {
                bucketValue: 1,
                experimentId: 28457,
              },
              {
                bucketValue: 0,
                experimentId: 29210,
              },
              {
                bucketValue: 0,
                experimentId: 29144,
              },
              {
                bucketValue: 0,
                experimentId: 29936,
              },
              {
                bucketValue: 0,
                experimentId: 29955,
              },
              {
                bucketValue: 0,
                experimentId: 29785,
              },
              {
                bucketValue: 1,
                experimentId: 30017,
              },
              {
                bucketValue: 1,
                experimentId: 30281,
              },
              {
                bucketValue: 0,
                experimentId: 30293,
              },
              {
                bucketValue: 0,
                experimentId: 30703,
              },
              {
                bucketValue: 0,
                experimentId: 30840,
              },
              {
                bucketValue: 1,
                experimentId: 25805,
              },
              {
                bucketValue: 1,
                experimentId: 31877,
              },
              {
                bucketValue: 0,
                experimentId: 32423,
              },
              {
                bucketValue: 1,
                experimentId: 32446,
              },
              {
                bucketValue: 0,
                experimentId: 32603,
              },
              {
                bucketValue: 0,
                experimentId: 32484,
              },
              {
                bucketValue: 0,
                experimentId: 32643,
              },
              {
                bucketValue: 1,
                experimentId: 32693,
              },
              {
                bucketValue: 0,
                experimentId: 32694,
              },
              {
                bucketValue: 1,
                experimentId: 32758,
              },
              {
                bucketValue: 0,
                experimentId: 32940,
              },
              {
                bucketValue: 1,
                experimentId: 32042,
              },
              {
                bucketValue: 1,
                experimentId: 33016,
              },
              {
                bucketValue: 0,
                experimentId: 33163,
              },
              {
                bucketValue: 0,
                experimentId: 34033,
              },
              {
                bucketValue: 0,
                experimentId: 33807,
              },
              {
                bucketValue: 1,
                experimentId: 34086,
              },
              {
                bucketValue: 0,
                experimentId: 33917,
              },
              {
                bucketValue: 1,
                experimentId: 33715,
              },
              {
                bucketValue: 0,
                experimentId: 34963,
              },
              {
                bucketValue: 0,
                experimentId: 35017,
              },
              {
                bucketValue: 0,
                experimentId: 29708,
              },
              {
                bucketValue: 0,
                experimentId: 34849,
              },
              {
                bucketValue: 0,
                experimentId: 35108,
              },
              {
                bucketValue: 0,
                experimentId: 36130,
              },
              {
                bucketValue: 1,
                experimentId: 36239,
              },
              {
                bucketValue: 0,
                experimentId: 36247,
              },
              {
                bucketValue: 1,
                experimentId: 36983,
              },
              {
                bucketValue: 1,
                experimentId: 35714,
              },
              {
                bucketValue: 0,
                experimentId: 37823,
              },
              {
                bucketValue: 0,
                experimentId: 37910,
              },
              {
                bucketValue: 0,
                experimentId: 31349,
              },
              {
                bucketValue: 1,
                experimentId: 38215,
              },
              {
                bucketValue: 0,
                experimentId: 37949,
              },
              {
                bucketValue: 0,
                experimentId: 38305,
              },
              {
                bucketValue: 1,
                experimentId: 38587,
              },
              {
                bucketValue: 1,
                experimentId: 38589,
              },
              {
                bucketValue: 0,
                experimentId: 39170,
              },
              {
                bucketValue: 0,
                experimentId: 38156,
              },
              {
                bucketValue: 0,
                experimentId: 39493,
              },
              {
                bucketValue: 0,
                experimentId: 40246,
              },
              {
                bucketValue: 0,
                experimentId: 39675,
              },
              {
                bucketValue: 0,
                experimentId: 40412,
              },
              {
                bucketValue: 0,
                experimentId: 40615,
              },
              {
                bucketValue: 0,
                experimentId: 40793,
              },
              {
                bucketValue: 1,
                experimentId: 39776,
              },
              {
                bucketValue: 0,
                experimentId: 41467,
              },
              {
                bucketValue: 1,
                experimentId: 41592,
              },
              {
                bucketValue: 1,
                experimentId: 41610,
              },
              {
                bucketValue: 0,
                experimentId: 41616,
              },
              {
                bucketValue: 1,
                experimentId: 42547,
              },
              {
                bucketValue: 0,
                experimentId: 42610,
              },
              {
                bucketValue: 1,
                experimentId: 43282,
              },
              {
                bucketValue: 1,
                experimentId: 43378,
              },
              {
                bucketValue: 0,
                experimentId: 43440,
              },
              {
                bucketValue: 0,
                experimentId: 43575,
              },
              {
                bucketValue: 0,
                experimentId: 44083,
              },
              {
                bucketValue: 0,
                experimentId: 31936,
              },
              {
                bucketValue: 1,
                experimentId: 24862,
              },
              {
                bucketValue: 0,
                experimentId: 39772,
              },
              {
                bucketValue: 0,
                experimentId: 41258,
              },
              {
                bucketValue: 1,
                experimentId: 41699,
              },
              {
                bucketValue: 1,
                experimentId: 42551,
              },
              {
                bucketValue: 0,
                experimentId: 44051,
              },
              {
                bucketValue: 0,
                experimentId: 43013,
              },
              {
                bucketValue: 1,
                experimentId: 43671,
              },
              {
                bucketValue: 0,
                experimentId: 43631,
              },
              {
                bucketValue: 0,
                experimentId: 44419,
              },
              {
                bucketValue: 0,
                experimentId: 42685,
              },
              {
                bucketValue: 0,
                experimentId: 38093,
              },
              {
                bucketValue: 0,
                experimentId: 33661,
              },
              {
                bucketValue: 0,
                experimentId: 28826,
              },
              {
                bucketValue: 0,
                experimentId: 44103,
              },
              {
                bucketValue: 0,
                experimentId: 37054,
              },
              {
                bucketValue: 0,
                experimentId: 34924,
              },
              {
                bucketValue: 1,
                experimentId: 43541,
              },
              {
                bucketValue: 0,
                experimentId: 44316,
              },
              {
                bucketValue: 0,
                experimentId: 32453,
              },
              {
                bucketValue: 0,
                experimentId: 42683,
              },
              {
                bucketValue: 2,
                experimentId: 42930,
              },
              {
                bucketValue: 2,
                experimentId: 42930,
              },
              {
                bucketValue: 1,
                experimentId: 42956,
              },
              {
                bucketValue: 0,
                experimentId: 38567,
              },
              {
                bucketValue: 0,
                experimentId: 40833,
              },
              {
                bucketValue: 0,
                experimentId: 43375,
              },
              {
                bucketValue: 0,
                experimentId: 42639,
              },
              {
                bucketValue: 0,
                experimentId: 43887,
              },
              {
                bucketValue: 0,
                experimentId: 32599,
              },
              {
                bucketValue: 0,
                experimentId: 44000,
              },
              {
                bucketValue: 0,
                experimentId: 43854,
              },
              {
                bucketValue: 0,
                experimentId: 44011,
              },
              {
                bucketValue: 0,
                experimentId: 43262,
              },
              {
                bucketValue: 0,
                experimentId: 37797,
              },
              {
                bucketValue: 1,
                experimentId: 37135,
              },
              {
                bucketValue: 1,
                experimentId: 43758,
              },
              {
                bucketValue: 0,
                experimentId: 40747,
              },
              {
                bucketValue: 0,
                experimentId: 43129,
              },
            ],
            requestId: '758065aa-a82a-4aa7-99e0-a084594fca04',
            hopScotchSessionId: '147d9c5c-c410-4c60-a73d-b10bc9b274e6',
            clientInfo: {
              deviceCharacteristics: {
                brandName: 'Chrome',
                deviceOs: 'Windows NT',
                mobileBrowserVersion: '104',
                resolutionHeight: 800,
                mobile: false,
                deviceOsVersion: '10.0',
                mobileBrowser: 'Chrome',
                physicalScreenHeight: 175,
                modelName: '104',
                tablet: false,
                resolutionWidth: 1280,
                wirelessDevice: false,
                physicalScreenWidth: 280,
              },
              os: 'Windows NT',
              ipAddress: '27.111.209.200',
              fingerprintId: '',
              userAgent:
                'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36',
              ua: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36',
              requestMadeByBot: false,
              coords: {
                country: 'sg',
                city: 'singapore',
                latitude: 1.29,
                state: '',
                longitude: 103.86,
              },
            },
            sessionId: '147d9c5c-c410-4c60-a73d-b10bc9b274e6',
            user: {
              xVisitorId: 'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855',
              guid: 'd14a2d50-f943-40dd-a010-0934a9c8c278',
              registered: false,
              tuid: -1,
              expUserProfileId: -1,
              softAccount: false,
            },
          },
          numChildren: 0,
          state: 'Greater London',
          guestRating: 4.4,
          brand: 'expedia',
          lobDomain: 'HOTEL',
          tpid: 3,
          inventoryType: 'MERCHANT',
          gaUserId: -1,
          membershipTier: '',
          Geo: {
            country: 'sg',
            city: 'singapore',
            latitude: 1.29,
            state: '',
            longitude: 103.86,
          },
          hotelBrand: 'Mama Shelter',
          lengthOfStay: 1,
          domain: 'HOTEL',
          guid: 'd14a2d50-f943-40dd-a010-0934a9c8c278',
          hotelType: 'MERCHANT',
          city: 'London (and vicinity), England, United Kingdom',
          tc_vars: {
            property_city_name: 'London (and vicinity), England, United Kingdom',
            search_destination_id: '178279',
            point_of_sale_eg_pos_id: 'EXPEDIA_GB',
            hotel_product_property_name: 'Mama Shelter London - Shoreditch',
            language: 'en',
            hotel_product_third_property_id: 46218383,
            search_request_gaia_id: '178279',
            point_of_sale_eg_brand_name: 'expedia',
            device_information_device_type: 'DESKTOP',
            search_request_number_of_children: 0,
            timestamps_received_at: '2022-08-10T13:48:36.698167264Z',
            number_of_room_nights: 1,
            host: 'www.expedia.co.uk',
            hotel_product_star_rating: 4,
            point_of_sale: 'Unknown',
            is_EU_POS: true,
            event_page_name_detailed: 'page.Hotel-Search',
            product_list_lodging_product_property_name: 'Mama Shelter London - Shoreditch',
            default_domain: 'www.expedia.co.uk',
            product_list_inventory_source: 'MERCHANT',
            hotel_product_first_three_property_ids: [1886693, 62769, 46218383],
            identifiers_event_trace_id: '758065aaa82a4aa799e0a084594fca04',
            search_request_booking_window: 8,
            event_page_funnel_location: 'SEARCH_RESULTS',
            referrer_url_encoded: 'https%3A%2F%2Fwww.expedia.co.uk%2Fsports%2Fliverpoolfc',
            search_request_trip_duration: 1,
            request_request_url: 'https://experience-api-lodging-search.kmc-default.lshop.prod.exp-aws.net/graphql',
            hotel_product_property_brand_id: 4713,
            line_of_business: 'hotels',
            event_page_name: 'page.Hotel-Search',
            domain: 'HOTEL',
            product_list_product_id: 1886693,
            search_request_trip_end_date: '2022-08-19',
            gaia_state: 'Greater London',
            product_list_lodging_product_property_brand_id: 4713,
            product_list_rating_star_rating: 4,
            city: 'London (and vicinity), England, United Kingdom',
            hotel_product_second_property_id: 62769,
            identifiers_session_id: '147d9c5c-c410-4c60-a73d-b10bc9b274e6',
            identifiers_tpid: 3,
            identifiers_site_id: 3,
            travel_dates: '2022-08-18|2022-08-19',
            point_of_sale_site_currency_code: 'GBP',
            identifiers_device_user_agent_id: 'd14a2d50-f943-40dd-a010-0934a9c8c278',
            product_list_pricing_price_total_price_amount: 133,
            point_of_sale_locale: 'GB',
            user_brand_customer_id: -1,
            booking_product_line: 'H',
            marketing_same_session_marketing_code: 'SEO.U.Dark',
            event_page_product_line: 'HOTEL',
            search_request_gaia_city: 'London (and vicinity)',
            hotel_product_first_property_id: 1886693,
            search_request_number_of_adults: 2,
            environment: 'prod',
            search_request_number_of_rooms: 1,
            search_request_travel_dates: '20220818|20220819',
            search_request_trip_start_date: '2022-08-18',
            destination_airport_code: '178279',
            user_loyalty_member_tier: '',
            referrer_url: 'https://www.expedia.co.uk/sports/liverpoolfc',
          },
          siteName: 'www.expedia.co.uk',
          numberOfRooms: 1,
          locale: 'en_GB',
          expUserProfileId: -1,
          checkInDate: '2022-08-18',
          eapid: 0,
          qualtricsBucketValue: 0,
          funnelLocation: 'SEARCH_RESULTS',
          destinationName: 'London (and vicinity), England, United Kingdom',
          bookingWindow: 8,
          tc_context: {
            tcContainerUrl: 'https://cdn.tagcommander.com/6035/tc_bex_prod.js',
            enabled: true,
          },
          starRating: 4,
          numAdults: 2,
          pageInfo: {
            isDealsModulePresent: true,
            lineOfBusiness: 'hotels',
            requestURL: 'https://experience-api-lodging-search.kmc-default.lshop.prod.exp-aws.net/graphql',
            funnelLocation: 'SEARCH_RESULTS',
            currency: 'GBP',
            language: 'en',
            pageName: 'page.Hotel-Search',
            events: 'DatedSearch,Hotel3PIInventory,SearchResultsProduct,SearchResultsHotel',
            authInfo: {
              rewardsStatus: {
                programName: 'Expedia Rewards',
                confirmedPoints: 0,
                membershipTier: '',
              },
            },
            xLineOfBusiness: 'HOTEL',
          },
          numberOfGuests: 2,
          tuid: -1,
          hotelId: 1886693,
          hotelName: 'Mama Shelter London - Shoreditch',
          regionId: '',
          confirmedPoints: 0,
          siteId: 3,
          currencyCode: 'GBP',
          entity: {
            hotels: {
              results: {
                results: [
                  {
                    vacationRental: false,
                    hotelId: 1886693,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 265,
                      guestRating: 4.4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 62769,
                    starRating: 3,
                    reviewSummary: {
                      totalReviews: 187,
                      guestRating: 3.7,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 46218383,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 119,
                      guestRating: 3.9,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 470865,
                    starRating: 5,
                    reviewSummary: {
                      totalReviews: 1002,
                      guestRating: 4.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 55001,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 2732,
                      guestRating: 3.8,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 3113039,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 2088,
                      guestRating: 4.2,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 179,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 2102,
                      guestRating: 4.2,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 12703815,
                    starRating: 5,
                    reviewSummary: {
                      totalReviews: 1002,
                      guestRating: 4.4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 55001,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 2732,
                      guestRating: 3.8,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 42297074,
                    starRating: 3,
                    reviewSummary: {
                      totalReviews: 1334,
                      guestRating: 3.9,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 83245150,
                    starRating: 4,
                  },
                  {
                    vacationRental: false,
                    hotelId: 34928032,
                    starRating: 5,
                    reviewSummary: {
                      totalReviews: 549,
                      guestRating: 4.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 2479,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 2786,
                      guestRating: 4.2,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 17684778,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1000,
                      guestRating: 4.3,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 24000156,
                    starRating: 3.5,
                    reviewSummary: {
                      totalReviews: 1003,
                      guestRating: 4.1,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 470865,
                    starRating: 5,
                    reviewSummary: {
                      totalReviews: 1002,
                      guestRating: 4.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 559690,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 997,
                      guestRating: 4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 4190769,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1428,
                      guestRating: 4.1,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 14736047,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1000,
                      guestRating: 4.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 48296903,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 345,
                      guestRating: 4.4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 1584661,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1001,
                      guestRating: 4.3,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 1183908,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1059,
                      guestRating: 4.1,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 9745,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1140,
                      guestRating: 4.4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 54987,
                    starRating: 5,
                    reviewSummary: {
                      totalReviews: 998,
                      guestRating: 4.5,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 54995,
                    starRating: 3.5,
                    reviewSummary: {
                      totalReviews: 1365,
                      guestRating: 4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 559689,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1000,
                      guestRating: 4.1,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 4735824,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1000,
                      guestRating: 4.3,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 530052,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1081,
                      guestRating: 4.1,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 1742184,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1183,
                      guestRating: 4.5,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 32872139,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 337,
                      guestRating: 4.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 26145,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1482,
                      guestRating: 3.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 914179,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 258,
                      guestRating: 4.2,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 54995,
                    starRating: 3.5,
                    reviewSummary: {
                      totalReviews: 1365,
                      guestRating: 4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 1524786,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 576,
                      guestRating: 4.5,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 4836998,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1003,
                      guestRating: 4.7,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 614,
                    starRating: 3,
                    reviewSummary: {
                      totalReviews: 2180,
                      guestRating: 3.8,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 83096424,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1,
                      guestRating: 5,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 428403,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1001,
                      guestRating: 3.7,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 5173526,
                    starRating: 2.5,
                    reviewSummary: {
                      totalReviews: 1253,
                      guestRating: 4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 523228,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1002,
                      guestRating: 3.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 15118004,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1142,
                      guestRating: 4.3,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 579374,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 333,
                      guestRating: 4.4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 16534146,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 661,
                      guestRating: 4.1,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 30455872,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1012,
                      guestRating: 4.5,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 1457972,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 999,
                      guestRating: 3.9,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 9789,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1073,
                      guestRating: 3.7,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 523223,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1001,
                      guestRating: 4.2,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 21688,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1002,
                      guestRating: 4.5,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 12649,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1001,
                      guestRating: 4.1,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 53791563,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 199,
                      guestRating: 4.4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 2651,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1001,
                      guestRating: 4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 5813,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 992,
                      guestRating: 3.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 16150,
                    starRating: 5,
                    reviewSummary: {
                      totalReviews: 1000,
                      guestRating: 4.5,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 76382087,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 20,
                      guestRating: 4.8,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 3551,
                    starRating: 5,
                    reviewSummary: {
                      totalReviews: 1000,
                      guestRating: 4.1,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 5040114,
                    starRating: 3.5,
                    reviewSummary: {
                      totalReviews: 1001,
                      guestRating: 4.2,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 5244458,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1001,
                      guestRating: 4.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 54993,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 852,
                      guestRating: 4.3,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 74700787,
                    starRating: 3.5,
                    reviewSummary: {
                      totalReviews: 11,
                      guestRating: 4.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 54993,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 852,
                      guestRating: 4.3,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 801796,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1000,
                      guestRating: 4.4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 12084011,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1002,
                      guestRating: 4.7,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 1949,
                    starRating: 3.5,
                    reviewSummary: {
                      totalReviews: 1219,
                      guestRating: 3.1,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 17150967,
                    starRating: 3.5,
                    reviewSummary: {
                      totalReviews: 995,
                      guestRating: 4.2,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 28126,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1001,
                      guestRating: 4.4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 28799662,
                    starRating: 4.5,
                    reviewSummary: {
                      totalReviews: 1003,
                      guestRating: 4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 15921793,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 999,
                      guestRating: 4.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 8466215,
                    starRating: 5,
                    reviewSummary: {
                      totalReviews: 1000,
                      guestRating: 4.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 1585328,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1000,
                      guestRating: 4.3,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 175675,
                    starRating: 3,
                    reviewSummary: {
                      totalReviews: 886,
                      guestRating: 3.3,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 7049006,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1001,
                      guestRating: 4.2,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 10939,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1001,
                      guestRating: 4.2,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 608,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1000,
                      guestRating: 4.2,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 527232,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1004,
                      guestRating: 3.7,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 1402870,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 999,
                      guestRating: 3.7,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 7238,
                    starRating: 3,
                    reviewSummary: {
                      totalReviews: 993,
                      guestRating: 3.4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 17452353,
                    starRating: 5,
                    reviewSummary: {
                      totalReviews: 601,
                      guestRating: 4.5,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 75708014,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 106,
                      guestRating: 3.8,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 5221423,
                    starRating: 3.5,
                    reviewSummary: {
                      totalReviews: 1002,
                      guestRating: 4.1,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 2270848,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 910,
                      guestRating: 4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 470265,
                    starRating: 5,
                    reviewSummary: {
                      totalReviews: 699,
                      guestRating: 4.5,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 1058226,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 73,
                      guestRating: 4.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 62755,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 998,
                      guestRating: 4.6,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 22262,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 992,
                      guestRating: 4.1,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 9080289,
                    starRating: 3,
                    reviewSummary: {
                      totalReviews: 1001,
                      guestRating: 4.3,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 8704,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1000,
                      guestRating: 4.2,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 9236409,
                    starRating: 5,
                    reviewSummary: {
                      totalReviews: 1000,
                      guestRating: 4.3,
                    },
                  },
                  {
                    vacationRental: true,
                    hotelId: 201089,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 878,
                      guestRating: 4.3,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 535667,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 996,
                      guestRating: 4.5,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 1486728,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 997,
                      guestRating: 4.4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 34358751,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 358,
                      guestRating: 4.7,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 2156327,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 998,
                      guestRating: 4.3,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 37631981,
                    starRating: 3.5,
                    reviewSummary: {
                      totalReviews: 650,
                      guestRating: 4.1,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 16181347,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1000,
                      guestRating: 4.5,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 36660267,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 463,
                      guestRating: 3.7,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 83245150,
                    starRating: 4,
                  },
                  {
                    vacationRental: false,
                    hotelId: 8765476,
                    reviewSummary: {
                      totalReviews: 999,
                      guestRating: 4.5,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 901179,
                    starRating: 5,
                    reviewSummary: {
                      totalReviews: 998,
                      guestRating: 4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 582065,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 1003,
                      guestRating: 4.4,
                    },
                  },
                  {
                    vacationRental: false,
                    hotelId: 890843,
                    starRating: 4,
                    reviewSummary: {
                      totalReviews: 992,
                      guestRating: 3.9,
                    },
                  },
                ],
              },
            },
            productTypes: ['HOTEL'],
          },
        },
        version: '7.0.5',
        applicationName: 'experience-api-lodging-search',
      },
    ],
  },
};
